webpackJsonp(["main"],{

/***/ "../../../node_modules/autosize/dist/autosize.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Autosize 4.0.0
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
		factory(exports, module);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod.exports, mod);
		global.autosize = mod.exports;
	}
})(this, function (exports, module) {
	'use strict';

	var map = typeof Map === "function" ? new Map() : (function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			'delete': function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	})();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function (name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = ta.clientWidth;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			var originalHeight = ta.style.height;
			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = '';

			var endHeight = ta.scrollHeight + heightOffset;

			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				ta.style.height = originalHeight;
				return;
			}

			ta.style.height = endHeight + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight !== styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = (function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map['delete'](ta);
		}).bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function (el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function (el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	module.exports = autosize;
});

/***/ }),

/***/ "../../../node_modules/clipboard/lib/clipboard-action.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__("../../../node_modules/select/src/select.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),

/***/ "../../../node_modules/clipboard/lib/clipboard.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__("../../../node_modules/clipboard/lib/clipboard-action.js"), __webpack_require__("../../../node_modules/tiny-emitter/index.js"), __webpack_require__("../../../node_modules/good-listener/src/listen.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),

/***/ "../../../node_modules/delegate/src/closest.js":
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (element.matches(selector)) return element;
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ "../../../node_modules/delegate/src/delegate.js":
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__("../../../node_modules/delegate/src/closest.js");

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ "../../../node_modules/document-register-element/build/document-register-element.node.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*!

Copyright (C) 2014-2016 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
// global window Object
// optional polyfill info
//    'auto' used by default, everything is feature detected
//    'force' use the polyfill even if not fully needed
function installCustomElements(window, polyfill) {'use strict';

  // DO NOT USE THIS FILE DIRECTLY, IT WON'T WORK
  // THIS IS A PROJECT BASED ON A BUILD SYSTEM
  // THIS FILE IS JUST WRAPPED UP RESULTING IN
  // build/document-register-element.node.js

  var
    document = window.document,
    Object = window.Object
  ;

  var htmlClass = (function (info) {
    // (C) Andrea Giammarchi - @WebReflection - MIT Style
    var
      catchClass = /^[A-Z]+[a-z]/,
      filterBy = function (re) {
        var arr = [], tag;
        for (tag in register) {
          if (re.test(tag)) arr.push(tag);
        }
        return arr;
      },
      add = function (Class, tag) {
        tag = tag.toLowerCase();
        if (!(tag in register)) {
          register[Class] = (register[Class] || []).concat(tag);
          register[tag] = (register[tag.toUpperCase()] = Class);
        }
      },
      register = (Object.create || Object)(null),
      htmlClass = {},
      i, section, tags, Class
    ;
    for (section in info) {
      for (Class in info[section]) {
        tags = info[section][Class];
        register[Class] = tags;
        for (i = 0; i < tags.length; i++) {
          register[tags[i].toLowerCase()] =
          register[tags[i].toUpperCase()] = Class;
        }
      }
    }
    htmlClass.get = function get(tagOrClass) {
      return typeof tagOrClass === 'string' ?
        (register[tagOrClass] || (catchClass.test(tagOrClass) ? [] : '')) :
        filterBy(tagOrClass);
    };
    htmlClass.set = function set(tag, Class) {
      return (catchClass.test(tag) ?
        add(tag, Class) :
        add(Class, tag)
      ), htmlClass;
    };
    return htmlClass;
  }({
    "collections": {
      "HTMLAllCollection": [
        "all"
      ],
      "HTMLCollection": [
        "forms"
      ],
      "HTMLFormControlsCollection": [
        "elements"
      ],
      "HTMLOptionsCollection": [
        "options"
      ]
    },
    "elements": {
      "Element": [
        "element"
      ],
      "HTMLAnchorElement": [
        "a"
      ],
      "HTMLAppletElement": [
        "applet"
      ],
      "HTMLAreaElement": [
        "area"
      ],
      "HTMLAttachmentElement": [
        "attachment"
      ],
      "HTMLAudioElement": [
        "audio"
      ],
      "HTMLBRElement": [
        "br"
      ],
      "HTMLBaseElement": [
        "base"
      ],
      "HTMLBodyElement": [
        "body"
      ],
      "HTMLButtonElement": [
        "button"
      ],
      "HTMLCanvasElement": [
        "canvas"
      ],
      "HTMLContentElement": [
        "content"
      ],
      "HTMLDListElement": [
        "dl"
      ],
      "HTMLDataElement": [
        "data"
      ],
      "HTMLDataListElement": [
        "datalist"
      ],
      "HTMLDetailsElement": [
        "details"
      ],
      "HTMLDialogElement": [
        "dialog"
      ],
      "HTMLDirectoryElement": [
        "dir"
      ],
      "HTMLDivElement": [
        "div"
      ],
      "HTMLDocument": [
        "document"
      ],
      "HTMLElement": [
        "element",
        "abbr",
        "address",
        "article",
        "aside",
        "b",
        "bdi",
        "bdo",
        "cite",
        "code",
        "command",
        "dd",
        "dfn",
        "dt",
        "em",
        "figcaption",
        "figure",
        "footer",
        "header",
        "i",
        "kbd",
        "mark",
        "nav",
        "noscript",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "small",
        "strong",
        "sub",
        "summary",
        "sup",
        "u",
        "var",
        "wbr"
      ],
      "HTMLEmbedElement": [
        "embed"
      ],
      "HTMLFieldSetElement": [
        "fieldset"
      ],
      "HTMLFontElement": [
        "font"
      ],
      "HTMLFormElement": [
        "form"
      ],
      "HTMLFrameElement": [
        "frame"
      ],
      "HTMLFrameSetElement": [
        "frameset"
      ],
      "HTMLHRElement": [
        "hr"
      ],
      "HTMLHeadElement": [
        "head"
      ],
      "HTMLHeadingElement": [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
      ],
      "HTMLHtmlElement": [
        "html"
      ],
      "HTMLIFrameElement": [
        "iframe"
      ],
      "HTMLImageElement": [
        "img"
      ],
      "HTMLInputElement": [
        "input"
      ],
      "HTMLKeygenElement": [
        "keygen"
      ],
      "HTMLLIElement": [
        "li"
      ],
      "HTMLLabelElement": [
        "label"
      ],
      "HTMLLegendElement": [
        "legend"
      ],
      "HTMLLinkElement": [
        "link"
      ],
      "HTMLMapElement": [
        "map"
      ],
      "HTMLMarqueeElement": [
        "marquee"
      ],
      "HTMLMediaElement": [
        "media"
      ],
      "HTMLMenuElement": [
        "menu"
      ],
      "HTMLMenuItemElement": [
        "menuitem"
      ],
      "HTMLMetaElement": [
        "meta"
      ],
      "HTMLMeterElement": [
        "meter"
      ],
      "HTMLModElement": [
        "del",
        "ins"
      ],
      "HTMLOListElement": [
        "ol"
      ],
      "HTMLObjectElement": [
        "object"
      ],
      "HTMLOptGroupElement": [
        "optgroup"
      ],
      "HTMLOptionElement": [
        "option"
      ],
      "HTMLOutputElement": [
        "output"
      ],
      "HTMLParagraphElement": [
        "p"
      ],
      "HTMLParamElement": [
        "param"
      ],
      "HTMLPictureElement": [
        "picture"
      ],
      "HTMLPreElement": [
        "pre"
      ],
      "HTMLProgressElement": [
        "progress"
      ],
      "HTMLQuoteElement": [
        "blockquote",
        "q",
        "quote"
      ],
      "HTMLScriptElement": [
        "script"
      ],
      "HTMLSelectElement": [
        "select"
      ],
      "HTMLShadowElement": [
        "shadow"
      ],
      "HTMLSlotElement": [
        "slot"
      ],
      "HTMLSourceElement": [
        "source"
      ],
      "HTMLSpanElement": [
        "span"
      ],
      "HTMLStyleElement": [
        "style"
      ],
      "HTMLTableCaptionElement": [
        "caption"
      ],
      "HTMLTableCellElement": [
        "td",
        "th"
      ],
      "HTMLTableColElement": [
        "col",
        "colgroup"
      ],
      "HTMLTableElement": [
        "table"
      ],
      "HTMLTableRowElement": [
        "tr"
      ],
      "HTMLTableSectionElement": [
        "thead",
        "tbody",
        "tfoot"
      ],
      "HTMLTemplateElement": [
        "template"
      ],
      "HTMLTextAreaElement": [
        "textarea"
      ],
      "HTMLTimeElement": [
        "time"
      ],
      "HTMLTitleElement": [
        "title"
      ],
      "HTMLTrackElement": [
        "track"
      ],
      "HTMLUListElement": [
        "ul"
      ],
      "HTMLUnknownElement": [
        "unknown",
        "vhgroupv",
        "vkeygen"
      ],
      "HTMLVideoElement": [
        "video"
      ]
    },
    "nodes": {
      "Attr": [
        "node"
      ],
      "Audio": [
        "audio"
      ],
      "CDATASection": [
        "node"
      ],
      "CharacterData": [
        "node"
      ],
      "Comment": [
        "#comment"
      ],
      "Document": [
        "#document"
      ],
      "DocumentFragment": [
        "#document-fragment"
      ],
      "DocumentType": [
        "node"
      ],
      "HTMLDocument": [
        "#document"
      ],
      "Image": [
        "img"
      ],
      "Option": [
        "option"
      ],
      "ProcessingInstruction": [
        "node"
      ],
      "ShadowRoot": [
        "#shadow-root"
      ],
      "Text": [
        "#text"
      ],
      "XMLDocument": [
        "xml"
      ]
    }
  }));
  
  
    
  // passed at runtime, configurable
  // via nodejs module
  if (!polyfill) polyfill = 'auto';
  
  var
    // V0 polyfill entry
    REGISTER_ELEMENT = 'registerElement',
  
    // IE < 11 only + old WebKit for attributes + feature detection
    EXPANDO_UID = '__' + REGISTER_ELEMENT + (window.Math.random() * 10e4 >> 0),
  
    // shortcuts and costants
    ADD_EVENT_LISTENER = 'addEventListener',
    ATTACHED = 'attached',
    CALLBACK = 'Callback',
    DETACHED = 'detached',
    EXTENDS = 'extends',
  
    ATTRIBUTE_CHANGED_CALLBACK = 'attributeChanged' + CALLBACK,
    ATTACHED_CALLBACK = ATTACHED + CALLBACK,
    CONNECTED_CALLBACK = 'connected' + CALLBACK,
    DISCONNECTED_CALLBACK = 'disconnected' + CALLBACK,
    CREATED_CALLBACK = 'created' + CALLBACK,
    DETACHED_CALLBACK = DETACHED + CALLBACK,
  
    ADDITION = 'ADDITION',
    MODIFICATION = 'MODIFICATION',
    REMOVAL = 'REMOVAL',
  
    DOM_ATTR_MODIFIED = 'DOMAttrModified',
    DOM_CONTENT_LOADED = 'DOMContentLoaded',
    DOM_SUBTREE_MODIFIED = 'DOMSubtreeModified',
  
    PREFIX_TAG = '<',
    PREFIX_IS = '=',
  
    // valid and invalid node names
    validName = /^[A-Z][A-Z0-9]*(?:-[A-Z0-9]+)+$/,
    invalidNames = [
      'ANNOTATION-XML',
      'COLOR-PROFILE',
      'FONT-FACE',
      'FONT-FACE-SRC',
      'FONT-FACE-URI',
      'FONT-FACE-FORMAT',
      'FONT-FACE-NAME',
      'MISSING-GLYPH'
    ],
  
    // registered types and their prototypes
    types = [],
    protos = [],
  
    // to query subnodes
    query = '',
  
    // html shortcut used to feature detect
    documentElement = document.documentElement,
  
    // ES5 inline helpers || basic patches
    indexOf = types.indexOf || function (v) {
      for(var i = this.length; i-- && this[i] !== v;){}
      return i;
    },
  
    // other helpers / shortcuts
    OP = Object.prototype,
    hOP = OP.hasOwnProperty,
    iPO = OP.isPrototypeOf,
  
    defineProperty = Object.defineProperty,
    empty = [],
    gOPD = Object.getOwnPropertyDescriptor,
    gOPN = Object.getOwnPropertyNames,
    gPO = Object.getPrototypeOf,
    sPO = Object.setPrototypeOf,
  
    // jshint proto: true
    hasProto = !!Object.__proto__,
  
    // V1 helpers
    fixGetClass = false,
    DRECEV1 = '__dreCEv1',
    customElements = window.customElements,
    usableCustomElements = polyfill !== 'force' && !!(
      customElements &&
      customElements.define &&
      customElements.get &&
      customElements.whenDefined
    ),
    Dict = Object.create || Object,
    Map = window.Map || function Map() {
      var K = [], V = [], i;
      return {
        get: function (k) {
          return V[indexOf.call(K, k)];
        },
        set: function (k, v) {
          i = indexOf.call(K, k);
          if (i < 0) V[K.push(k) - 1] = v;
          else V[i] = v;
        }
      };
    },
    Promise = window.Promise || function (fn) {
      var
        notify = [],
        done = false,
        p = {
          'catch': function () {
            return p;
          },
          'then': function (cb) {
            notify.push(cb);
            if (done) setTimeout(resolve, 1);
            return p;
          }
        }
      ;
      function resolve(value) {
        done = true;
        while (notify.length) notify.shift()(value);
      }
      fn(resolve);
      return p;
    },
    justCreated = false,
    constructors = Dict(null),
    waitingList = Dict(null),
    nodeNames = new Map(),
    secondArgument = String,
  
    // used to create unique instances
    create = Object.create || function Bridge(proto) {
      // silly broken polyfill probably ever used but short enough to work
      return proto ? ((Bridge.prototype = proto), new Bridge()) : this;
    },
  
    // will set the prototype if possible
    // or copy over all properties
    setPrototype = sPO || (
      hasProto ?
        function (o, p) {
          o.__proto__ = p;
          return o;
        } : (
      (gOPN && gOPD) ?
        (function(){
          function setProperties(o, p) {
            for (var
              key,
              names = gOPN(p),
              i = 0, length = names.length;
              i < length; i++
            ) {
              key = names[i];
              if (!hOP.call(o, key)) {
                defineProperty(o, key, gOPD(p, key));
              }
            }
          }
          return function (o, p) {
            do {
              setProperties(o, p);
            } while ((p = gPO(p)) && !iPO.call(p, o));
            return o;
          };
        }()) :
        function (o, p) {
          for (var key in p) {
            o[key] = p[key];
          }
          return o;
        }
    )),
  
    // DOM shortcuts and helpers, if any
  
    MutationObserver = window.MutationObserver ||
                       window.WebKitMutationObserver,
  
    HTMLElementPrototype = (
      window.HTMLElement ||
      window.Element ||
      window.Node
    ).prototype,
  
    IE8 = !iPO.call(HTMLElementPrototype, documentElement),
  
    safeProperty = IE8 ? function (o, k, d) {
      o[k] = d.value;
      return o;
    } : defineProperty,
  
    isValidNode = IE8 ?
      function (node) {
        return node.nodeType === 1;
      } :
      function (node) {
        return iPO.call(HTMLElementPrototype, node);
      },
  
    targets = IE8 && [],
  
    attachShadow = HTMLElementPrototype.attachShadow,
    cloneNode = HTMLElementPrototype.cloneNode,
    dispatchEvent = HTMLElementPrototype.dispatchEvent,
    getAttribute = HTMLElementPrototype.getAttribute,
    hasAttribute = HTMLElementPrototype.hasAttribute,
    removeAttribute = HTMLElementPrototype.removeAttribute,
    setAttribute = HTMLElementPrototype.setAttribute,
  
    // replaced later on
    createElement = document.createElement,
    patchedCreateElement = createElement,
  
    // shared observer for all attributes
    attributesObserver = MutationObserver && {
      attributes: true,
      characterData: true,
      attributeOldValue: true
    },
  
    // useful to detect only if there's no MutationObserver
    DOMAttrModified = MutationObserver || function(e) {
      doesNotSupportDOMAttrModified = false;
      documentElement.removeEventListener(
        DOM_ATTR_MODIFIED,
        DOMAttrModified
      );
    },
  
    // will both be used to make DOMNodeInserted asynchronous
    asapQueue,
    asapTimer = 0,
  
    // internal flags
    setListener = false,
    doesNotSupportDOMAttrModified = true,
    dropDomContentLoaded = true,
  
    // needed for the innerHTML helper
    notFromInnerHTMLHelper = true,
  
    // optionally defined later on
    onSubtreeModified,
    callDOMAttrModified,
    getAttributesMirror,
    observer,
    observe,
  
    // based on setting prototype capability
    // will check proto or the expando attribute
    // in order to setup the node once
    patchIfNotAlready,
    patch
  ;
  
  // only if needed
  if (!(REGISTER_ELEMENT in document)) {
  
    if (sPO || hasProto) {
        patchIfNotAlready = function (node, proto) {
          if (!iPO.call(proto, node)) {
            setupNode(node, proto);
          }
        };
        patch = setupNode;
    } else {
        patchIfNotAlready = function (node, proto) {
          if (!node[EXPANDO_UID]) {
            node[EXPANDO_UID] = Object(true);
            setupNode(node, proto);
          }
        };
        patch = patchIfNotAlready;
    }
  
    if (IE8) {
      doesNotSupportDOMAttrModified = false;
      (function (){
        var
          descriptor = gOPD(HTMLElementPrototype, ADD_EVENT_LISTENER),
          addEventListener = descriptor.value,
          patchedRemoveAttribute = function (name) {
            var e = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true});
            e.attrName = name;
            e.prevValue = getAttribute.call(this, name);
            e.newValue = null;
            e[REMOVAL] = e.attrChange = 2;
            removeAttribute.call(this, name);
            dispatchEvent.call(this, e);
          },
          patchedSetAttribute = function (name, value) {
            var
              had = hasAttribute.call(this, name),
              old = had && getAttribute.call(this, name),
              e = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true})
            ;
            setAttribute.call(this, name, value);
            e.attrName = name;
            e.prevValue = had ? old : null;
            e.newValue = value;
            if (had) {
              e[MODIFICATION] = e.attrChange = 1;
            } else {
              e[ADDITION] = e.attrChange = 0;
            }
            dispatchEvent.call(this, e);
          },
          onPropertyChange = function (e) {
            // jshint eqnull:true
            var
              node = e.currentTarget,
              superSecret = node[EXPANDO_UID],
              propertyName = e.propertyName,
              event
            ;
            if (superSecret.hasOwnProperty(propertyName)) {
              superSecret = superSecret[propertyName];
              event = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true});
              event.attrName = superSecret.name;
              event.prevValue = superSecret.value || null;
              event.newValue = (superSecret.value = node[propertyName] || null);
              if (event.prevValue == null) {
                event[ADDITION] = event.attrChange = 0;
              } else {
                event[MODIFICATION] = event.attrChange = 1;
              }
              dispatchEvent.call(node, event);
            }
          }
        ;
        descriptor.value = function (type, handler, capture) {
          if (
            type === DOM_ATTR_MODIFIED &&
            this[ATTRIBUTE_CHANGED_CALLBACK] &&
            this.setAttribute !== patchedSetAttribute
          ) {
            this[EXPANDO_UID] = {
              className: {
                name: 'class',
                value: this.className
              }
            };
            this.setAttribute = patchedSetAttribute;
            this.removeAttribute = patchedRemoveAttribute;
            addEventListener.call(this, 'propertychange', onPropertyChange);
          }
          addEventListener.call(this, type, handler, capture);
        };
        defineProperty(HTMLElementPrototype, ADD_EVENT_LISTENER, descriptor);
      }());
    } else if (!MutationObserver) {
      documentElement[ADD_EVENT_LISTENER](DOM_ATTR_MODIFIED, DOMAttrModified);
      documentElement.setAttribute(EXPANDO_UID, 1);
      documentElement.removeAttribute(EXPANDO_UID);
      if (doesNotSupportDOMAttrModified) {
        onSubtreeModified = function (e) {
          var
            node = this,
            oldAttributes,
            newAttributes,
            key
          ;
          if (node === e.target) {
            oldAttributes = node[EXPANDO_UID];
            node[EXPANDO_UID] = (newAttributes = getAttributesMirror(node));
            for (key in newAttributes) {
              if (!(key in oldAttributes)) {
                // attribute was added
                return callDOMAttrModified(
                  0,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  ADDITION
                );
              } else if (newAttributes[key] !== oldAttributes[key]) {
                // attribute was changed
                return callDOMAttrModified(
                  1,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  MODIFICATION
                );
              }
            }
            // checking if it has been removed
            for (key in oldAttributes) {
              if (!(key in newAttributes)) {
                // attribute removed
                return callDOMAttrModified(
                  2,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  REMOVAL
                );
              }
            }
          }
        };
        callDOMAttrModified = function (
          attrChange,
          currentTarget,
          attrName,
          prevValue,
          newValue,
          action
        ) {
          var e = {
            attrChange: attrChange,
            currentTarget: currentTarget,
            attrName: attrName,
            prevValue: prevValue,
            newValue: newValue
          };
          e[action] = attrChange;
          onDOMAttrModified(e);
        };
        getAttributesMirror = function (node) {
          for (var
            attr, name,
            result = {},
            attributes = node.attributes,
            i = 0, length = attributes.length;
            i < length; i++
          ) {
            attr = attributes[i];
            name = attr.name;
            if (name !== 'setAttribute') {
              result[name] = attr.value;
            }
          }
          return result;
        };
      }
    }
  
    // set as enumerable, writable and configurable
    document[REGISTER_ELEMENT] = function registerElement(type, options) {
      upperType = type.toUpperCase();
      if (!setListener) {
        // only first time document.registerElement is used
        // we need to set this listener
        // setting it by default might slow down for no reason
        setListener = true;
        if (MutationObserver) {
          observer = (function(attached, detached){
            function checkEmAll(list, callback) {
              for (var i = 0, length = list.length; i < length; callback(list[i++])){}
            }
            return new MutationObserver(function (records) {
              for (var
                current, node, newValue,
                i = 0, length = records.length; i < length; i++
              ) {
                current = records[i];
                if (current.type === 'childList') {
                  checkEmAll(current.addedNodes, attached);
                  checkEmAll(current.removedNodes, detached);
                } else {
                  node = current.target;
                  if (notFromInnerHTMLHelper &&
                      node[ATTRIBUTE_CHANGED_CALLBACK] &&
                      current.attributeName !== 'style') {
                    newValue = getAttribute.call(node, current.attributeName);
                    if (newValue !== current.oldValue) {
                      node[ATTRIBUTE_CHANGED_CALLBACK](
                        current.attributeName,
                        current.oldValue,
                        newValue
                      );
                    }
                  }
                }
              }
            });
          }(executeAction(ATTACHED), executeAction(DETACHED)));
          observe = function (node) {
            observer.observe(
              node,
              {
                childList: true,
                subtree: true
              }
            );
            return node;
          };
          observe(document);
          if (attachShadow) {
            HTMLElementPrototype.attachShadow = function () {
              return observe(attachShadow.apply(this, arguments));
            };
          }
        } else {
          asapQueue = [];
          document[ADD_EVENT_LISTENER]('DOMNodeInserted', onDOMNode(ATTACHED));
          document[ADD_EVENT_LISTENER]('DOMNodeRemoved', onDOMNode(DETACHED));
        }
  
        document[ADD_EVENT_LISTENER](DOM_CONTENT_LOADED, onReadyStateChange);
        document[ADD_EVENT_LISTENER]('readystatechange', onReadyStateChange);
  
        HTMLElementPrototype.cloneNode = function (deep) {
          var
            node = cloneNode.call(this, !!deep),
            i = getTypeIndex(node)
          ;
          if (-1 < i) patch(node, protos[i]);
          if (deep) loopAndSetup(node.querySelectorAll(query));
          return node;
        };
      }
  
      if (-2 < (
        indexOf.call(types, PREFIX_IS + upperType) +
        indexOf.call(types, PREFIX_TAG + upperType)
      )) {
        throwTypeError(type);
      }
  
      if (!validName.test(upperType) || -1 < indexOf.call(invalidNames, upperType)) {
        throw new Error('The type ' + type + ' is invalid');
      }
  
      var
        constructor = function () {
          return extending ?
            document.createElement(nodeName, upperType) :
            document.createElement(nodeName);
        },
        opt = options || OP,
        extending = hOP.call(opt, EXTENDS),
        nodeName = extending ? options[EXTENDS].toUpperCase() : upperType,
        upperType,
        i
      ;
  
      if (extending && -1 < (
        indexOf.call(types, PREFIX_TAG + nodeName)
      )) {
        throwTypeError(nodeName);
      }
  
      i = types.push((extending ? PREFIX_IS : PREFIX_TAG) + upperType) - 1;
  
      query = query.concat(
        query.length ? ',' : '',
        extending ? nodeName + '[is="' + type.toLowerCase() + '"]' : nodeName
      );
  
      constructor.prototype = (
        protos[i] = hOP.call(opt, 'prototype') ?
          opt.prototype :
          create(HTMLElementPrototype)
      );
  
      loopAndVerify(
        document.querySelectorAll(query),
        ATTACHED
      );
  
      return constructor;
    };
  
    document.createElement = (patchedCreateElement = function (localName, typeExtension) {
      var
        is = getIs(typeExtension),
        node = is ?
          createElement.call(document, localName, secondArgument(is)) :
          createElement.call(document, localName),
        name = '' + localName,
        i = indexOf.call(
          types,
          (is ? PREFIX_IS : PREFIX_TAG) +
          (is || name).toUpperCase()
        ),
        setup = -1 < i
      ;
      if (is) {
        node.setAttribute('is', is = is.toLowerCase());
        if (setup) {
          setup = isInQSA(name.toUpperCase(), is);
        }
      }
      notFromInnerHTMLHelper = !document.createElement.innerHTMLHelper;
      if (setup) patch(node, protos[i]);
      return node;
    });
  
  }
  
  function ASAP() {
    var queue = asapQueue.splice(0, asapQueue.length);
    asapTimer = 0;
    while (queue.length) {
      queue.shift().call(
        null, queue.shift()
      );
    }
  }
  
  function loopAndVerify(list, action) {
    for (var i = 0, length = list.length; i < length; i++) {
      verifyAndSetupAndAction(list[i], action);
    }
  }
  
  function loopAndSetup(list) {
    for (var i = 0, length = list.length, node; i < length; i++) {
      node = list[i];
      patch(node, protos[getTypeIndex(node)]);
    }
  }
  
  function executeAction(action) {
    return function (node) {
      if (isValidNode(node)) {
        verifyAndSetupAndAction(node, action);
        loopAndVerify(
          node.querySelectorAll(query),
          action
        );
      }
    };
  }
  
  function getTypeIndex(target) {
    var
      is = getAttribute.call(target, 'is'),
      nodeName = target.nodeName.toUpperCase(),
      i = indexOf.call(
        types,
        is ?
            PREFIX_IS + is.toUpperCase() :
            PREFIX_TAG + nodeName
      )
    ;
    return is && -1 < i && !isInQSA(nodeName, is) ? -1 : i;
  }
  
  function isInQSA(name, type) {
    return -1 < query.indexOf(name + '[is="' + type + '"]');
  }
  
  function onDOMAttrModified(e) {
    var
      node = e.currentTarget,
      attrChange = e.attrChange,
      attrName = e.attrName,
      target = e.target,
      addition = e[ADDITION] || 2,
      removal = e[REMOVAL] || 3
    ;
    if (notFromInnerHTMLHelper &&
        (!target || target === node) &&
        node[ATTRIBUTE_CHANGED_CALLBACK] &&
        attrName !== 'style' && (
          e.prevValue !== e.newValue ||
          // IE9, IE10, and Opera 12 gotcha
          e.newValue === '' && (
            attrChange === addition ||
            attrChange === removal
          )
    )) {
      node[ATTRIBUTE_CHANGED_CALLBACK](
        attrName,
        attrChange === addition ? null : e.prevValue,
        attrChange === removal ? null : e.newValue
      );
    }
  }
  
  function onDOMNode(action) {
    var executor = executeAction(action);
    return function (e) {
      asapQueue.push(executor, e.target);
      if (asapTimer) clearTimeout(asapTimer);
      asapTimer = setTimeout(ASAP, 1);
    };
  }
  
  function onReadyStateChange(e) {
    if (dropDomContentLoaded) {
      dropDomContentLoaded = false;
      e.currentTarget.removeEventListener(DOM_CONTENT_LOADED, onReadyStateChange);
    }
    loopAndVerify(
      (e.target || document).querySelectorAll(query),
      e.detail === DETACHED ? DETACHED : ATTACHED
    );
    if (IE8) purge();
  }
  
  function patchedSetAttribute(name, value) {
    // jshint validthis:true
    var self = this;
    setAttribute.call(self, name, value);
    onSubtreeModified.call(self, {target: self});
  }
  
  function setupNode(node, proto) {
    setPrototype(node, proto);
    if (observer) {
      observer.observe(node, attributesObserver);
    } else {
      if (doesNotSupportDOMAttrModified) {
        node.setAttribute = patchedSetAttribute;
        node[EXPANDO_UID] = getAttributesMirror(node);
        node[ADD_EVENT_LISTENER](DOM_SUBTREE_MODIFIED, onSubtreeModified);
      }
      node[ADD_EVENT_LISTENER](DOM_ATTR_MODIFIED, onDOMAttrModified);
    }
    if (node[CREATED_CALLBACK] && notFromInnerHTMLHelper) {
      node.created = true;
      node[CREATED_CALLBACK]();
      node.created = false;
    }
  }
  
  function purge() {
    for (var
      node,
      i = 0,
      length = targets.length;
      i < length; i++
    ) {
      node = targets[i];
      if (!documentElement.contains(node)) {
        length--;
        targets.splice(i--, 1);
        verifyAndSetupAndAction(node, DETACHED);
      }
    }
  }
  
  function throwTypeError(type) {
    throw new Error('A ' + type + ' type is already registered');
  }
  
  function verifyAndSetupAndAction(node, action) {
    var
      fn,
      i = getTypeIndex(node)
    ;
    if (-1 < i) {
      patchIfNotAlready(node, protos[i]);
      i = 0;
      if (action === ATTACHED && !node[ATTACHED]) {
        node[DETACHED] = false;
        node[ATTACHED] = true;
        i = 1;
        if (IE8 && indexOf.call(targets, node) < 0) {
          targets.push(node);
        }
      } else if (action === DETACHED && !node[DETACHED]) {
        node[ATTACHED] = false;
        node[DETACHED] = true;
        i = 1;
      }
      if (i && (fn = node[action + CALLBACK])) fn.call(node);
    }
  }
  
  
  
  // V1 in da House!
  function CustomElementRegistry() {}
  
  CustomElementRegistry.prototype = {
    constructor: CustomElementRegistry,
    // a workaround for the stubborn WebKit
    define: usableCustomElements ?
      function (name, Class, options) {
        if (options) {
          CERDefine(name, Class, options);
        } else {
          var NAME = name.toUpperCase();
          constructors[NAME] = {
            constructor: Class,
            create: [NAME]
          };
          nodeNames.set(Class, NAME);
          customElements.define(name, Class);
        }
      } :
      CERDefine,
    get: usableCustomElements ?
      function (name) {
        return customElements.get(name) || get(name);
      } :
      get,
    whenDefined: usableCustomElements ?
      function (name) {
        return Promise.race([
          customElements.whenDefined(name),
          whenDefined(name)
        ]);
      } :
      whenDefined
  };
  
  function CERDefine(name, Class, options) {
    var
      is = options && options[EXTENDS] || '',
      CProto = Class.prototype,
      proto = create(CProto),
      attributes = Class.observedAttributes || empty,
      definition = {prototype: proto}
    ;
    // TODO: is this needed at all since it's inherited?
    // defineProperty(proto, 'constructor', {value: Class});
    safeProperty(proto, CREATED_CALLBACK, {
        value: function () {
          if (justCreated) justCreated = false;
          else if (!this[DRECEV1]) {
            this[DRECEV1] = true;
            new Class(this);
            if (CProto[CREATED_CALLBACK])
              CProto[CREATED_CALLBACK].call(this);
            var info = constructors[nodeNames.get(Class)];
            if (!usableCustomElements || info.create.length > 1) {
              notifyAttributes(this);
            }
          }
      }
    });
    safeProperty(proto, ATTRIBUTE_CHANGED_CALLBACK, {
      value: function (name) {
        if (-1 < indexOf.call(attributes, name))
          CProto[ATTRIBUTE_CHANGED_CALLBACK].apply(this, arguments);
      }
    });
    if (CProto[CONNECTED_CALLBACK]) {
      safeProperty(proto, ATTACHED_CALLBACK, {
        value: CProto[CONNECTED_CALLBACK]
      });
    }
    if (CProto[DISCONNECTED_CALLBACK]) {
      safeProperty(proto, DETACHED_CALLBACK, {
        value: CProto[DISCONNECTED_CALLBACK]
      });
    }
    if (is) definition[EXTENDS] = is;
    name = name.toUpperCase();
    constructors[name] = {
      constructor: Class,
      create: is ? [is, secondArgument(name)] : [name]
    };
    nodeNames.set(Class, name);
    document[REGISTER_ELEMENT](name.toLowerCase(), definition);
    whenDefined(name);
    waitingList[name].r();
  }
  
  function get(name) {
    var info = constructors[name.toUpperCase()];
    return info && info.constructor;
  }
  
  function getIs(options) {
    return typeof options === 'string' ?
        options : (options && options.is || '');
  }
  
  function notifyAttributes(self) {
    var
      callback = self[ATTRIBUTE_CHANGED_CALLBACK],
      attributes = callback ? self.attributes : empty,
      i = attributes.length,
      attribute
    ;
    while (i--) {
      attribute =  attributes[i]; // || attributes.item(i);
      callback.call(
        self,
        attribute.name || attribute.nodeName,
        null,
        attribute.value || attribute.nodeValue
      );
    }
  }
  
  function whenDefined(name) {
    name = name.toUpperCase();
    if (!(name in waitingList)) {
      waitingList[name] = {};
      waitingList[name].p = new Promise(function (resolve) {
        waitingList[name].r = resolve;
      });
    }
    return waitingList[name].p;
  }
  
  function polyfillV1() {
    if (customElements) delete window.customElements;
    defineProperty(window, 'customElements', {
      configurable: true,
      value: new CustomElementRegistry()
    });
    defineProperty(window, 'CustomElementRegistry', {
      configurable: true,
      value: CustomElementRegistry
    });
    for (var
      patchClass = function (name) {
        var Class = window[name];
        if (Class) {
          window[name] = function CustomElementsV1(self) {
            var info, isNative;
            if (!self) self = this;
            if (!self[DRECEV1]) {
              justCreated = true;
              info = constructors[nodeNames.get(self.constructor)];
              isNative = usableCustomElements && info.create.length === 1;
              self = isNative ?
                Reflect.construct(Class, empty, info.constructor) :
                document.createElement.apply(document, info.create);
              self[DRECEV1] = true;
              justCreated = false;
              if (!isNative) notifyAttributes(self);
            }
            return self;
          };
          window[name].prototype = Class.prototype;
          try {
            Class.prototype.constructor = window[name];
          } catch(WebKit) {
            fixGetClass = true;
            defineProperty(Class, DRECEV1, {value: window[name]});
          }
        }
      },
      Classes = htmlClass.get(/^HTML[A-Z]*[a-z]/),
      i = Classes.length;
      i--;
      patchClass(Classes[i])
    ) {}
    (document.createElement = function (name, options) {
      var is = getIs(options);
      return is ?
        patchedCreateElement.call(this, name, secondArgument(is)) :
        patchedCreateElement.call(this, name);
    });
  }
  
  // if customElements is not there at all
  if (!customElements || polyfill === 'force') polyfillV1();
  else {
    // if available test extends work as expected
    try {
      (function (DRE, options, name) {
        options[EXTENDS] = 'a';
        DRE.prototype = create(HTMLAnchorElement.prototype);
        DRE.prototype.constructor = DRE;
        window.customElements.define(name, DRE, options);
        if (
          getAttribute.call(document.createElement('a', {is: name}), 'is') !== name ||
          (usableCustomElements && getAttribute.call(new DRE(), 'is') !== name)
        ) {
          throw options;
        }
      }(
        function DRE() {
          return Reflect.construct(HTMLAnchorElement, [], DRE);
        },
        {},
        'document-register-element-a'
      ));
    } catch(o_O) {
      // or force the polyfill if not
      // and keep internal original reference
      polyfillV1();
    }
  }
  
  try {
    createElement.call(document, 'a', 'a');
  } catch(FireFox) {
    secondArgument = function (is) {
      return {is: is};
    };
  }
  
}

module.exports = installCustomElements;
installCustomElements(global);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../../../node_modules/fuzzaldrin-plus/lib/filter.js":
/***/ (function(module, exports, __webpack_require__) {

(function() {
  var Query, pathScorer, pluckCandidates, scorer, sortCandidates;

  scorer = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/scorer.js");

  pathScorer = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/pathScorer.js");

  Query = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/query.js");

  pluckCandidates = function(a) {
    return a.candidate;
  };

  sortCandidates = function(a, b) {
    return b.score - a.score;
  };

  module.exports = function(candidates, query, options) {
    var bKey, candidate, key, maxInners, maxResults, score, scoreProvider, scoredCandidates, spotLeft, string, usePathScoring, _i, _len;
    scoredCandidates = [];
    key = options.key, maxResults = options.maxResults, maxInners = options.maxInners, usePathScoring = options.usePathScoring;
    spotLeft = (maxInners != null) && maxInners > 0 ? maxInners : candidates.length + 1;
    bKey = key != null;
    scoreProvider = usePathScoring ? pathScorer : scorer;
    for (_i = 0, _len = candidates.length; _i < _len; _i++) {
      candidate = candidates[_i];
      string = bKey ? candidate[key] : candidate;
      if (!string) {
        continue;
      }
      score = scoreProvider.score(string, query, options);
      if (score > 0) {
        scoredCandidates.push({
          candidate: candidate,
          score: score
        });
        if (!--spotLeft) {
          break;
        }
      }
    }
    scoredCandidates.sort(sortCandidates);
    candidates = scoredCandidates.map(pluckCandidates);
    if (maxResults != null) {
      candidates = candidates.slice(0, maxResults);
    }
    return candidates;
  };

}).call(this);


/***/ }),

/***/ "../../../node_modules/fuzzaldrin-plus/lib/fuzzaldrin.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {(function() {
  var Query, defaultPathSeparator, filter, matcher, parseOptions, pathScorer, preparedQueryCache, scorer;

  filter = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/filter.js");

  matcher = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/matcher.js");

  scorer = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/scorer.js");

  pathScorer = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/pathScorer.js");

  Query = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/query.js");

  preparedQueryCache = null;

  defaultPathSeparator = (typeof process !== "undefined" && process !== null ? process.platform : void 0) === "win32" ? '\\' : '/';

  module.exports = {
    filter: function(candidates, query, options) {
      if (options == null) {
        options = {};
      }
      if (!((query != null ? query.length : void 0) && (candidates != null ? candidates.length : void 0))) {
        return [];
      }
      options = parseOptions(options, query);
      return filter(candidates, query, options);
    },
    score: function(string, query, options) {
      if (options == null) {
        options = {};
      }
      if (!((string != null ? string.length : void 0) && (query != null ? query.length : void 0))) {
        return 0;
      }
      options = parseOptions(options, query);
      if (options.usePathScoring) {
        return pathScorer.score(string, query, options);
      } else {
        return scorer.score(string, query, options);
      }
    },
    match: function(string, query, options) {
      var _i, _ref, _results;
      if (options == null) {
        options = {};
      }
      if (!string) {
        return [];
      }
      if (!query) {
        return [];
      }
      if (string === query) {
        return (function() {
          _results = [];
          for (var _i = 0, _ref = string.length; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--){ _results.push(_i); }
          return _results;
        }).apply(this);
      }
      options = parseOptions(options, query);
      return matcher.match(string, query, options);
    },
    wrap: function(string, query, options) {
      if (options == null) {
        options = {};
      }
      if (!string) {
        return [];
      }
      if (!query) {
        return [];
      }
      options = parseOptions(options, query);
      return matcher.wrap(string, query, options);
    },
    prepareQuery: function(query, options) {
      if (options == null) {
        options = {};
      }
      options = parseOptions(options, query);
      return options.preparedQuery;
    }
  };

  parseOptions = function(options, query) {
    if (options.allowErrors == null) {
      options.allowErrors = false;
    }
    if (options.usePathScoring == null) {
      options.usePathScoring = true;
    }
    if (options.useExtensionBonus == null) {
      options.useExtensionBonus = false;
    }
    if (options.pathSeparator == null) {
      options.pathSeparator = defaultPathSeparator;
    }
    if (options.optCharRegEx == null) {
      options.optCharRegEx = null;
    }
    if (options.wrap == null) {
      options.wrap = null;
    }
    if (options.preparedQuery == null) {
      options.preparedQuery = preparedQueryCache && preparedQueryCache.query === query ? preparedQueryCache : (preparedQueryCache = new Query(query, options));
    }
    return options;
  };

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/process/browser.js")))

/***/ }),

/***/ "../../../node_modules/fuzzaldrin-plus/lib/matcher.js":
/***/ (function(module, exports, __webpack_require__) {

(function() {
  var basenameMatch, computeMatch, isMatch, isWordStart, match, mergeMatches, scoreAcronyms, scoreCharacter, scoreConsecutives, _ref;

  _ref = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/scorer.js"), isMatch = _ref.isMatch, isWordStart = _ref.isWordStart, scoreConsecutives = _ref.scoreConsecutives, scoreCharacter = _ref.scoreCharacter, scoreAcronyms = _ref.scoreAcronyms;

  exports.match = match = function(string, query, options) {
    var allowErrors, baseMatches, matches, pathSeparator, preparedQuery, string_lw;
    allowErrors = options.allowErrors, preparedQuery = options.preparedQuery, pathSeparator = options.pathSeparator;
    if (!(allowErrors || isMatch(string, preparedQuery.core_lw, preparedQuery.core_up))) {
      return [];
    }
    string_lw = string.toLowerCase();
    matches = computeMatch(string, string_lw, preparedQuery);
    if (matches.length === 0) {
      return matches;
    }
    if (string.indexOf(pathSeparator) > -1) {
      baseMatches = basenameMatch(string, string_lw, preparedQuery, pathSeparator);
      matches = mergeMatches(matches, baseMatches);
    }
    return matches;
  };

  exports.wrap = function(string, query, options) {
    var matchIndex, matchPos, matchPositions, output, strPos, tagClass, tagClose, tagOpen, _ref1;
    if ((options.wrap != null)) {
      _ref1 = options.wrap, tagClass = _ref1.tagClass, tagOpen = _ref1.tagOpen, tagClose = _ref1.tagClose;
    }
    if (tagClass == null) {
      tagClass = 'highlight';
    }
    if (tagOpen == null) {
      tagOpen = '<strong class="' + tagClass + '">';
    }
    if (tagClose == null) {
      tagClose = '</strong>';
    }
    if (string === query) {
      return tagOpen + string + tagClose;
    }
    matchPositions = match(string, query, options);
    if (matchPositions.length === 0) {
      return string;
    }
    output = '';
    matchIndex = -1;
    strPos = 0;
    while (++matchIndex < matchPositions.length) {
      matchPos = matchPositions[matchIndex];
      if (matchPos > strPos) {
        output += string.substring(strPos, matchPos);
        strPos = matchPos;
      }
      while (++matchIndex < matchPositions.length) {
        if (matchPositions[matchIndex] === matchPos + 1) {
          matchPos++;
        } else {
          matchIndex--;
          break;
        }
      }
      matchPos++;
      if (matchPos > strPos) {
        output += tagOpen;
        output += string.substring(strPos, matchPos);
        output += tagClose;
        strPos = matchPos;
      }
    }
    if (strPos <= string.length - 1) {
      output += string.substring(strPos);
    }
    return output;
  };

  basenameMatch = function(subject, subject_lw, preparedQuery, pathSeparator) {
    var basePos, depth, end;
    end = subject.length - 1;
    while (subject[end] === pathSeparator) {
      end--;
    }
    basePos = subject.lastIndexOf(pathSeparator, end);
    if (basePos === -1) {
      return [];
    }
    depth = preparedQuery.depth;
    while (depth-- > 0) {
      basePos = subject.lastIndexOf(pathSeparator, basePos - 1);
      if (basePos === -1) {
        return [];
      }
    }
    basePos++;
    end++;
    return computeMatch(subject.slice(basePos, end), subject_lw.slice(basePos, end), preparedQuery, basePos);
  };

  mergeMatches = function(a, b) {
    var ai, bj, i, j, m, n, out;
    m = a.length;
    n = b.length;
    if (n === 0) {
      return a.slice();
    }
    if (m === 0) {
      return b.slice();
    }
    i = -1;
    j = 0;
    bj = b[j];
    out = [];
    while (++i < m) {
      ai = a[i];
      while (bj <= ai && ++j < n) {
        if (bj < ai) {
          out.push(bj);
        }
        bj = b[j];
      }
      out.push(ai);
    }
    while (j < n) {
      out.push(b[j++]);
    }
    return out;
  };

  computeMatch = function(subject, subject_lw, preparedQuery, offset) {
    var DIAGONAL, LEFT, STOP, UP, acro_score, align, backtrack, csc_diag, csc_row, csc_score, i, j, m, matches, move, n, pos, query, query_lw, score, score_diag, score_row, score_up, si_lw, start, trace;
    if (offset == null) {
      offset = 0;
    }
    query = preparedQuery.query;
    query_lw = preparedQuery.query_lw;
    m = subject.length;
    n = query.length;
    acro_score = scoreAcronyms(subject, subject_lw, query, query_lw).score;
    score_row = new Array(n);
    csc_row = new Array(n);
    STOP = 0;
    UP = 1;
    LEFT = 2;
    DIAGONAL = 3;
    trace = new Array(m * n);
    pos = -1;
    j = -1;
    while (++j < n) {
      score_row[j] = 0;
      csc_row[j] = 0;
    }
    i = -1;
    while (++i < m) {
      score = 0;
      score_up = 0;
      csc_diag = 0;
      si_lw = subject_lw[i];
      j = -1;
      while (++j < n) {
        csc_score = 0;
        align = 0;
        score_diag = score_up;
        if (query_lw[j] === si_lw) {
          start = isWordStart(i, subject, subject_lw);
          csc_score = csc_diag > 0 ? csc_diag : scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
          align = score_diag + scoreCharacter(i, j, start, acro_score, csc_score);
        }
        score_up = score_row[j];
        csc_diag = csc_row[j];
        if (score > score_up) {
          move = LEFT;
        } else {
          score = score_up;
          move = UP;
        }
        if (align > score) {
          score = align;
          move = DIAGONAL;
        } else {
          csc_score = 0;
        }
        score_row[j] = score;
        csc_row[j] = csc_score;
        trace[++pos] = score > 0 ? move : STOP;
      }
    }
    i = m - 1;
    j = n - 1;
    pos = i * n + j;
    backtrack = true;
    matches = [];
    while (backtrack && i >= 0 && j >= 0) {
      switch (trace[pos]) {
        case UP:
          i--;
          pos -= n;
          break;
        case LEFT:
          j--;
          pos--;
          break;
        case DIAGONAL:
          matches.push(i + offset);
          j--;
          i--;
          pos -= n + 1;
          break;
        default:
          backtrack = false;
      }
    }
    matches.reverse();
    return matches;
  };

}).call(this);


/***/ }),

/***/ "../../../node_modules/fuzzaldrin-plus/lib/pathScorer.js":
/***/ (function(module, exports, __webpack_require__) {

(function() {
  var computeScore, countDir, file_coeff, getExtension, getExtensionScore, isMatch, scorePath, scoreSize, tau_depth, _ref;

  _ref = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/scorer.js"), isMatch = _ref.isMatch, computeScore = _ref.computeScore, scoreSize = _ref.scoreSize;

  tau_depth = 13;

  file_coeff = 1.2;

  exports.score = function(string, query, options) {
    var allowErrors, preparedQuery, score, string_lw;
    preparedQuery = options.preparedQuery, allowErrors = options.allowErrors;
    if (!(allowErrors || isMatch(string, preparedQuery.core_lw, preparedQuery.core_up))) {
      return 0;
    }
    string_lw = string.toLowerCase();
    score = computeScore(string, string_lw, preparedQuery);
    score = scorePath(string, string_lw, score, options);
    return Math.ceil(score);
  };

  scorePath = function(subject, subject_lw, fullPathScore, options) {
    var alpha, basePathScore, basePos, depth, end, extAdjust, fileLength, pathSeparator, preparedQuery, useExtensionBonus;
    if (fullPathScore === 0) {
      return 0;
    }
    preparedQuery = options.preparedQuery, useExtensionBonus = options.useExtensionBonus, pathSeparator = options.pathSeparator;
    end = subject.length - 1;
    while (subject[end] === pathSeparator) {
      end--;
    }
    basePos = subject.lastIndexOf(pathSeparator, end);
    fileLength = end - basePos;
    extAdjust = 1.0;
    if (useExtensionBonus) {
      extAdjust += getExtensionScore(subject_lw, preparedQuery.ext, basePos, end, 2);
      fullPathScore *= extAdjust;
    }
    if (basePos === -1) {
      return fullPathScore;
    }
    depth = preparedQuery.depth;
    while (basePos > -1 && depth-- > 0) {
      basePos = subject.lastIndexOf(pathSeparator, basePos - 1);
    }
    basePathScore = basePos === -1 ? fullPathScore : extAdjust * computeScore(subject.slice(basePos + 1, end + 1), subject_lw.slice(basePos + 1, end + 1), preparedQuery);
    alpha = 0.5 * tau_depth / (tau_depth + countDir(subject, end + 1, pathSeparator));
    return alpha * basePathScore + (1 - alpha) * fullPathScore * scoreSize(0, file_coeff * fileLength);
  };

  exports.countDir = countDir = function(path, end, pathSeparator) {
    var count, i;
    if (end < 1) {
      return 0;
    }
    count = 0;
    i = -1;
    while (++i < end && path[i] === pathSeparator) {
      continue;
    }
    while (++i < end) {
      if (path[i] === pathSeparator) {
        count++;
        while (++i < end && path[i] === pathSeparator) {
          continue;
        }
      }
    }
    return count;
  };

  exports.getExtension = getExtension = function(str) {
    var pos;
    pos = str.lastIndexOf(".");
    if (pos < 0) {
      return "";
    } else {
      return str.substr(pos + 1);
    }
  };

  getExtensionScore = function(candidate, ext, startPos, endPos, maxDepth) {
    var m, matched, n, pos;
    if (!ext.length) {
      return 0;
    }
    pos = candidate.lastIndexOf(".", endPos);
    if (!(pos > startPos)) {
      return 0;
    }
    n = ext.length;
    m = endPos - pos;
    if (m < n) {
      n = m;
      m = ext.length;
    }
    pos++;
    matched = -1;
    while (++matched < n) {
      if (candidate[pos + matched] !== ext[matched]) {
        break;
      }
    }
    if (matched === 0 && maxDepth > 0) {
      return 0.9 * getExtensionScore(candidate, ext, startPos, pos - 2, maxDepth - 1);
    }
    return matched / m;
  };

}).call(this);


/***/ }),

/***/ "../../../node_modules/fuzzaldrin-plus/lib/query.js":
/***/ (function(module, exports, __webpack_require__) {

(function() {
  var Query, coreChars, countDir, getCharCodes, getExtension, opt_char_re, truncatedUpperCase, _ref;

  _ref = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/pathScorer.js"), countDir = _ref.countDir, getExtension = _ref.getExtension;

  module.exports = Query = (function() {
    function Query(query, _arg) {
      var optCharRegEx, pathSeparator, _ref1;
      _ref1 = _arg != null ? _arg : {}, optCharRegEx = _ref1.optCharRegEx, pathSeparator = _ref1.pathSeparator;
      if (!(query && query.length)) {
        return null;
      }
      this.query = query;
      this.query_lw = query.toLowerCase();
      this.core = coreChars(query, optCharRegEx);
      this.core_lw = this.core.toLowerCase();
      this.core_up = truncatedUpperCase(this.core);
      this.depth = countDir(query, query.length, pathSeparator);
      this.ext = getExtension(this.query_lw);
      this.charCodes = getCharCodes(this.query_lw);
    }

    return Query;

  })();

  opt_char_re = /[ _\-:\/\\]/g;

  coreChars = function(query, optCharRegEx) {
    if (optCharRegEx == null) {
      optCharRegEx = opt_char_re;
    }
    return query.replace(optCharRegEx, '');
  };

  truncatedUpperCase = function(str) {
    var char, upper, _i, _len;
    upper = "";
    for (_i = 0, _len = str.length; _i < _len; _i++) {
      char = str[_i];
      upper += char.toUpperCase()[0];
    }
    return upper;
  };

  getCharCodes = function(str) {
    var charCodes, i, len;
    len = str.length;
    i = -1;
    charCodes = [];
    while (++i < len) {
      charCodes[str.charCodeAt(i)] = true;
    }
    return charCodes;
  };

}).call(this);


/***/ }),

/***/ "../../../node_modules/fuzzaldrin-plus/lib/scorer.js":
/***/ (function(module, exports) {

(function() {
  var AcronymResult, computeScore, emptyAcronymResult, isAcronymFullWord, isMatch, isSeparator, isWordEnd, isWordStart, miss_coeff, pos_bonus, scoreAcronyms, scoreCharacter, scoreConsecutives, scoreExact, scoreExactMatch, scorePattern, scorePosition, scoreSize, tau_size, wm;

  wm = 150;

  pos_bonus = 20;

  tau_size = 85;

  miss_coeff = 0.75;

  exports.score = function(string, query, options) {
    var allowErrors, preparedQuery, score, string_lw;
    preparedQuery = options.preparedQuery, allowErrors = options.allowErrors;
    if (!(allowErrors || isMatch(string, preparedQuery.core_lw, preparedQuery.core_up))) {
      return 0;
    }
    string_lw = string.toLowerCase();
    score = computeScore(string, string_lw, preparedQuery);
    return Math.ceil(score);
  };

  exports.isMatch = isMatch = function(subject, query_lw, query_up) {
    var i, j, m, n, qj_lw, qj_up, si;
    m = subject.length;
    n = query_lw.length;
    if (!m || n > m) {
      return false;
    }
    i = -1;
    j = -1;
    while (++j < n) {
      qj_lw = query_lw.charCodeAt(j);
      qj_up = query_up.charCodeAt(j);
      while (++i < m) {
        si = subject.charCodeAt(i);
        if (si === qj_lw || si === qj_up) {
          break;
        }
      }
      if (i === m) {
        return false;
      }
    }
    return true;
  };

  exports.computeScore = computeScore = function(subject, subject_lw, preparedQuery) {
    var acro, acro_score, align, csc_diag, csc_row, csc_score, csc_should_rebuild, i, j, m, miss_budget, miss_left, n, pos, query, query_lw, record_miss, score, score_diag, score_row, score_up, si_lw, start, sz;
    query = preparedQuery.query;
    query_lw = preparedQuery.query_lw;
    m = subject.length;
    n = query.length;
    acro = scoreAcronyms(subject, subject_lw, query, query_lw);
    acro_score = acro.score;
    if (acro.count === n) {
      return scoreExact(n, m, acro_score, acro.pos);
    }
    pos = subject_lw.indexOf(query_lw);
    if (pos > -1) {
      return scoreExactMatch(subject, subject_lw, query, query_lw, pos, n, m);
    }
    score_row = new Array(n);
    csc_row = new Array(n);
    sz = scoreSize(n, m);
    miss_budget = Math.ceil(miss_coeff * n) + 5;
    miss_left = miss_budget;
    csc_should_rebuild = true;
    j = -1;
    while (++j < n) {
      score_row[j] = 0;
      csc_row[j] = 0;
    }
    i = -1;
    while (++i < m) {
      si_lw = subject_lw[i];
      if (!si_lw.charCodeAt(0) in preparedQuery.charCodes) {
        if (csc_should_rebuild) {
          j = -1;
          while (++j < n) {
            csc_row[j] = 0;
          }
          csc_should_rebuild = false;
        }
        continue;
      }
      score = 0;
      score_diag = 0;
      csc_diag = 0;
      record_miss = true;
      csc_should_rebuild = true;
      j = -1;
      while (++j < n) {
        score_up = score_row[j];
        if (score_up > score) {
          score = score_up;
        }
        csc_score = 0;
        if (query_lw[j] === si_lw) {
          start = isWordStart(i, subject, subject_lw);
          csc_score = csc_diag > 0 ? csc_diag : scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
          align = score_diag + scoreCharacter(i, j, start, acro_score, csc_score);
          if (align > score) {
            score = align;
            miss_left = miss_budget;
          } else {
            if (record_miss && --miss_left <= 0) {
              return Math.max(score, score_row[n - 1]) * sz;
            }
            record_miss = false;
          }
        }
        score_diag = score_up;
        csc_diag = csc_row[j];
        csc_row[j] = csc_score;
        score_row[j] = score;
      }
    }
    score = score_row[n - 1];
    return score * sz;
  };

  exports.isWordStart = isWordStart = function(pos, subject, subject_lw) {
    var curr_s, prev_s;
    if (pos === 0) {
      return true;
    }
    curr_s = subject[pos];
    prev_s = subject[pos - 1];
    return isSeparator(prev_s) || (curr_s !== subject_lw[pos] && prev_s === subject_lw[pos - 1]);
  };

  exports.isWordEnd = isWordEnd = function(pos, subject, subject_lw, len) {
    var curr_s, next_s;
    if (pos === len - 1) {
      return true;
    }
    curr_s = subject[pos];
    next_s = subject[pos + 1];
    return isSeparator(next_s) || (curr_s === subject_lw[pos] && next_s !== subject_lw[pos + 1]);
  };

  isSeparator = function(c) {
    return c === ' ' || c === '.' || c === '-' || c === '_' || c === '/' || c === '\\';
  };

  scorePosition = function(pos) {
    var sc;
    if (pos < pos_bonus) {
      sc = pos_bonus - pos;
      return 100 + sc * sc;
    } else {
      return Math.max(100 + pos_bonus - pos, 0);
    }
  };

  exports.scoreSize = scoreSize = function(n, m) {
    return tau_size / (tau_size + Math.abs(m - n));
  };

  scoreExact = function(n, m, quality, pos) {
    return 2 * n * (wm * quality + scorePosition(pos)) * scoreSize(n, m);
  };

  exports.scorePattern = scorePattern = function(count, len, sameCase, start, end) {
    var bonus, sz;
    sz = count;
    bonus = 6;
    if (sameCase === count) {
      bonus += 2;
    }
    if (start) {
      bonus += 3;
    }
    if (end) {
      bonus += 1;
    }
    if (count === len) {
      if (start) {
        if (sameCase === len) {
          sz += 2;
        } else {
          sz += 1;
        }
      }
      if (end) {
        bonus += 1;
      }
    }
    return sameCase + sz * (sz + bonus);
  };

  exports.scoreCharacter = scoreCharacter = function(i, j, start, acro_score, csc_score) {
    var posBonus;
    posBonus = scorePosition(i);
    if (start) {
      return posBonus + wm * ((acro_score > csc_score ? acro_score : csc_score) + 10);
    }
    return posBonus + wm * csc_score;
  };

  exports.scoreConsecutives = scoreConsecutives = function(subject, subject_lw, query, query_lw, i, j, startOfWord) {
    var k, m, mi, n, nj, sameCase, sz;
    m = subject.length;
    n = query.length;
    mi = m - i;
    nj = n - j;
    k = mi < nj ? mi : nj;
    sameCase = 0;
    sz = 0;
    if (query[j] === subject[i]) {
      sameCase++;
    }
    while (++sz < k && query_lw[++j] === subject_lw[++i]) {
      if (query[j] === subject[i]) {
        sameCase++;
      }
    }
    if (sz === 1) {
      return 1 + 2 * sameCase;
    }
    return scorePattern(sz, n, sameCase, startOfWord, isWordEnd(i, subject, subject_lw, m));
  };

  exports.scoreExactMatch = scoreExactMatch = function(subject, subject_lw, query, query_lw, pos, n, m) {
    var end, i, pos2, sameCase, start;
    start = isWordStart(pos, subject, subject_lw);
    if (!start) {
      pos2 = subject_lw.indexOf(query_lw, pos + 1);
      if (pos2 > -1) {
        start = isWordStart(pos2, subject, subject_lw);
        if (start) {
          pos = pos2;
        }
      }
    }
    i = -1;
    sameCase = 0;
    while (++i < n) {
      if (query[pos + i] === subject[i]) {
        sameCase++;
      }
    }
    end = isWordEnd(pos + n - 1, subject, subject_lw, m);
    return scoreExact(n, m, scorePattern(n, n, sameCase, start, end), pos);
  };

  AcronymResult = (function() {
    function AcronymResult(score, pos, count) {
      this.score = score;
      this.pos = pos;
      this.count = count;
    }

    return AcronymResult;

  })();

  emptyAcronymResult = new AcronymResult(0, 0.1, 0);

  exports.scoreAcronyms = scoreAcronyms = function(subject, subject_lw, query, query_lw) {
    var count, fullWord, i, j, m, n, qj_lw, sameCase, score, sepCount, sumPos;
    m = subject.length;
    n = query.length;
    if (!(m > 1 && n > 1)) {
      return emptyAcronymResult;
    }
    count = 0;
    sepCount = 0;
    sumPos = 0;
    sameCase = 0;
    i = -1;
    j = -1;
    while (++j < n) {
      qj_lw = query_lw[j];
      if (isSeparator(qj_lw)) {
        i = subject_lw.indexOf(qj_lw, i + 1);
        if (i > -1) {
          sepCount++;
          continue;
        } else {
          break;
        }
      }
      while (++i < m) {
        if (qj_lw === subject_lw[i] && isWordStart(i, subject, subject_lw)) {
          if (query[j] === subject[i]) {
            sameCase++;
          }
          sumPos += i;
          count++;
          break;
        }
      }
      if (i === m) {
        break;
      }
    }
    if (count < 2) {
      return emptyAcronymResult;
    }
    fullWord = count === n ? isAcronymFullWord(subject, subject_lw, query, count) : false;
    score = scorePattern(count, n, sameCase, true, fullWord);
    return new AcronymResult(score, sumPos / count, count + sepCount);
  };

  isAcronymFullWord = function(subject, subject_lw, query, nbAcronymInQuery) {
    var count, i, m, n;
    m = subject.length;
    n = query.length;
    count = 0;
    if (m > 12 * n) {
      return false;
    }
    i = -1;
    while (++i < m) {
      if (isWordStart(i, subject, subject_lw) && ++count > nbAcronymInQuery) {
        return false;
      }
    }
    return true;
  };

}).call(this);


/***/ }),

/***/ "../../../node_modules/good-listener/src/is.js":
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ "../../../node_modules/good-listener/src/listen.js":
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__("../../../node_modules/good-listener/src/is.js");
var delegate = __webpack_require__("../../../node_modules/delegate/src/delegate.js");

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ "../../../node_modules/jed/jed.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @preserve jed.js https://github.com/SlexAxton/Jed
 */
/*
-----------
A gettext compatible i18n library for modern JavaScript Applications

by Alex Sexton - AlexSexton [at] gmail - @SlexAxton

MIT License

A jQuery Foundation project - requires CLA to contribute -
https://contribute.jquery.org/CLA/



Jed offers the entire applicable GNU gettext spec'd set of
functions, but also offers some nicer wrappers around them.
The api for gettext was written for a language with no function
overloading, so Jed allows a little more of that.

Many thanks to Joshua I. Miller - unrtst@cpan.org - who wrote
gettext.js back in 2008. I was able to vet a lot of my ideas
against his. I also made sure Jed passed against his tests
in order to offer easy upgrades -- jsgettext.berlios.de
*/
(function (root, undef) {

  // Set up some underscore-style functions, if you already have
  // underscore, feel free to delete this section, and use it
  // directly, however, the amount of functions used doesn't
  // warrant having underscore as a full dependency.
  // Underscore 1.3.0 was used to port and is licensed
  // under the MIT License by Jeremy Ashkenas.
  var ArrayProto    = Array.prototype,
      ObjProto      = Object.prototype,
      slice         = ArrayProto.slice,
      hasOwnProp    = ObjProto.hasOwnProperty,
      nativeForEach = ArrayProto.forEach,
      breaker       = {};

  // We're not using the OOP style _ so we don't need the
  // extra level of indirection. This still means that you
  // sub out for real `_` though.
  var _ = {
    forEach : function( obj, iterator, context ) {
      var i, l, key;
      if ( obj === null ) {
        return;
      }

      if ( nativeForEach && obj.forEach === nativeForEach ) {
        obj.forEach( iterator, context );
      }
      else if ( obj.length === +obj.length ) {
        for ( i = 0, l = obj.length; i < l; i++ ) {
          if ( i in obj && iterator.call( context, obj[i], i, obj ) === breaker ) {
            return;
          }
        }
      }
      else {
        for ( key in obj) {
          if ( hasOwnProp.call( obj, key ) ) {
            if ( iterator.call (context, obj[key], key, obj ) === breaker ) {
              return;
            }
          }
        }
      }
    },
    extend : function( obj ) {
      this.forEach( slice.call( arguments, 1 ), function ( source ) {
        for ( var prop in source ) {
          obj[prop] = source[prop];
        }
      });
      return obj;
    }
  };
  // END Miniature underscore impl

  // Jed is a constructor function
  var Jed = function ( options ) {
    // Some minimal defaults
    this.defaults = {
      "locale_data" : {
        "messages" : {
          "" : {
            "domain"       : "messages",
            "lang"         : "en",
            "plural_forms" : "nplurals=2; plural=(n != 1);"
          }
          // There are no default keys, though
        }
      },
      // The default domain if one is missing
      "domain" : "messages",
      // enable debug mode to log untranslated strings to the console
      "debug" : false
    };

    // Mix in the sent options with the default options
    this.options = _.extend( {}, this.defaults, options );
    this.textdomain( this.options.domain );

    if ( options.domain && ! this.options.locale_data[ this.options.domain ] ) {
      throw new Error('Text domain set to non-existent domain: `' + options.domain + '`');
    }
  };

  // The gettext spec sets this character as the default
  // delimiter for context lookups.
  // e.g.: context\u0004key
  // If your translation company uses something different,
  // just change this at any time and it will use that instead.
  Jed.context_delimiter = String.fromCharCode( 4 );

  function getPluralFormFunc ( plural_form_string ) {
    return Jed.PF.compile( plural_form_string || "nplurals=2; plural=(n != 1);");
  }

  function Chain( key, i18n ){
    this._key = key;
    this._i18n = i18n;
  }

  // Create a chainable api for adding args prettily
  _.extend( Chain.prototype, {
    onDomain : function ( domain ) {
      this._domain = domain;
      return this;
    },
    withContext : function ( context ) {
      this._context = context;
      return this;
    },
    ifPlural : function ( num, pkey ) {
      this._val = num;
      this._pkey = pkey;
      return this;
    },
    fetch : function ( sArr ) {
      if ( {}.toString.call( sArr ) != '[object Array]' ) {
        sArr = [].slice.call(arguments, 0);
      }
      return ( sArr && sArr.length ? Jed.sprintf : function(x){ return x; } )(
        this._i18n.dcnpgettext(this._domain, this._context, this._key, this._pkey, this._val),
        sArr
      );
    }
  });

  // Add functions to the Jed prototype.
  // These will be the functions on the object that's returned
  // from creating a `new Jed()`
  // These seem redundant, but they gzip pretty well.
  _.extend( Jed.prototype, {
    // The sexier api start point
    translate : function ( key ) {
      return new Chain( key, this );
    },

    textdomain : function ( domain ) {
      if ( ! domain ) {
        return this._textdomain;
      }
      this._textdomain = domain;
    },

    gettext : function ( key ) {
      return this.dcnpgettext.call( this, undef, undef, key );
    },

    dgettext : function ( domain, key ) {
     return this.dcnpgettext.call( this, domain, undef, key );
    },

    dcgettext : function ( domain , key /*, category */ ) {
      // Ignores the category anyways
      return this.dcnpgettext.call( this, domain, undef, key );
    },

    ngettext : function ( skey, pkey, val ) {
      return this.dcnpgettext.call( this, undef, undef, skey, pkey, val );
    },

    dngettext : function ( domain, skey, pkey, val ) {
      return this.dcnpgettext.call( this, domain, undef, skey, pkey, val );
    },

    dcngettext : function ( domain, skey, pkey, val/*, category */) {
      return this.dcnpgettext.call( this, domain, undef, skey, pkey, val );
    },

    pgettext : function ( context, key ) {
      return this.dcnpgettext.call( this, undef, context, key );
    },

    dpgettext : function ( domain, context, key ) {
      return this.dcnpgettext.call( this, domain, context, key );
    },

    dcpgettext : function ( domain, context, key/*, category */) {
      return this.dcnpgettext.call( this, domain, context, key );
    },

    npgettext : function ( context, skey, pkey, val ) {
      return this.dcnpgettext.call( this, undef, context, skey, pkey, val );
    },

    dnpgettext : function ( domain, context, skey, pkey, val ) {
      return this.dcnpgettext.call( this, domain, context, skey, pkey, val );
    },

    // The most fully qualified gettext function. It has every option.
    // Since it has every option, we can use it from every other method.
    // This is the bread and butter.
    // Technically there should be one more argument in this function for 'Category',
    // but since we never use it, we might as well not waste the bytes to define it.
    dcnpgettext : function ( domain, context, singular_key, plural_key, val ) {
      // Set some defaults

      plural_key = plural_key || singular_key;

      // Use the global domain default if one
      // isn't explicitly passed in
      domain = domain || this._textdomain;

      var fallback;

      // Handle special cases

      // No options found
      if ( ! this.options ) {
        // There's likely something wrong, but we'll return the correct key for english
        // We do this by instantiating a brand new Jed instance with the default set
        // for everything that could be broken.
        fallback = new Jed();
        return fallback.dcnpgettext.call( fallback, undefined, undefined, singular_key, plural_key, val );
      }

      // No translation data provided
      if ( ! this.options.locale_data ) {
        throw new Error('No locale data provided.');
      }

      if ( ! this.options.locale_data[ domain ] ) {
        throw new Error('Domain `' + domain + '` was not found.');
      }

      if ( ! this.options.locale_data[ domain ][ "" ] ) {
        throw new Error('No locale meta information provided.');
      }

      // Make sure we have a truthy key. Otherwise we might start looking
      // into the empty string key, which is the options for the locale
      // data.
      if ( ! singular_key ) {
        throw new Error('No translation key found.');
      }

      var key  = context ? context + Jed.context_delimiter + singular_key : singular_key,
          locale_data = this.options.locale_data,
          dict = locale_data[ domain ],
          defaultConf = (locale_data.messages || this.defaults.locale_data.messages)[""],
          pluralForms = dict[""].plural_forms || dict[""]["Plural-Forms"] || dict[""]["plural-forms"] || defaultConf.plural_forms || defaultConf["Plural-Forms"] || defaultConf["plural-forms"],
          val_list,
          res;

      var val_idx;
      if (val === undefined) {
        // No value passed in; assume singular key lookup.
        val_idx = 0;

      } else {
        // Value has been passed in; use plural-forms calculations.

        // Handle invalid numbers, but try casting strings for good measure
        if ( typeof val != 'number' ) {
          val = parseInt( val, 10 );

          if ( isNaN( val ) ) {
            throw new Error('The number that was passed in is not a number.');
          }
        }

        val_idx = getPluralFormFunc(pluralForms)(val);
      }

      // Throw an error if a domain isn't found
      if ( ! dict ) {
        throw new Error('No domain named `' + domain + '` could be found.');
      }

      val_list = dict[ key ];

      // If there is no match, then revert back to
      // english style singular/plural with the keys passed in.
      if ( ! val_list || val_idx > val_list.length ) {
        if (this.options.missing_key_callback) {
          this.options.missing_key_callback(key, domain);
        }
        res = [ singular_key, plural_key ];

        // collect untranslated strings
        if (this.options.debug===true) {
          console.log(res[ getPluralFormFunc(pluralForms)( val ) ]);
        }
        return res[ getPluralFormFunc()( val ) ];
      }

      res = val_list[ val_idx ];

      // This includes empty strings on purpose
      if ( ! res  ) {
        res = [ singular_key, plural_key ];
        return res[ getPluralFormFunc()( val ) ];
      }
      return res;
    }
  });


  // We add in sprintf capabilities for post translation value interolation
  // This is not internally used, so you can remove it if you have this
  // available somewhere else, or want to use a different system.

  // We _slightly_ modify the normal sprintf behavior to more gracefully handle
  // undefined values.

  /**
   sprintf() for JavaScript 0.7-beta1
   http://www.diveintojavascript.com/projects/javascript-sprintf

   Copyright (c) Alexandru Marasteanu <alexaholic [at) gmail (dot] com>
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:
       * Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.
       * Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in the
         documentation and/or other materials provided with the distribution.
       * Neither the name of sprintf() for JavaScript nor the
         names of its contributors may be used to endorse or promote products
         derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
   ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
   WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
   DISCLAIMED. IN NO EVENT SHALL Alexandru Marasteanu BE LIABLE FOR ANY
   DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
   (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
   LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
   ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
   (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
  var sprintf = (function() {
    function get_type(variable) {
      return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase();
    }
    function str_repeat(input, multiplier) {
      for (var output = []; multiplier > 0; output[--multiplier] = input) {/* do nothing */}
      return output.join('');
    }

    var str_format = function() {
      if (!str_format.cache.hasOwnProperty(arguments[0])) {
        str_format.cache[arguments[0]] = str_format.parse(arguments[0]);
      }
      return str_format.format.call(null, str_format.cache[arguments[0]], arguments);
    };

    str_format.format = function(parse_tree, argv) {
      var cursor = 1, tree_length = parse_tree.length, node_type = '', arg, output = [], i, k, match, pad, pad_character, pad_length;
      for (i = 0; i < tree_length; i++) {
        node_type = get_type(parse_tree[i]);
        if (node_type === 'string') {
          output.push(parse_tree[i]);
        }
        else if (node_type === 'array') {
          match = parse_tree[i]; // convenience purposes only
          if (match[2]) { // keyword argument
            arg = argv[cursor];
            for (k = 0; k < match[2].length; k++) {
              if (!arg.hasOwnProperty(match[2][k])) {
                throw(sprintf('[sprintf] property "%s" does not exist', match[2][k]));
              }
              arg = arg[match[2][k]];
            }
          }
          else if (match[1]) { // positional argument (explicit)
            arg = argv[match[1]];
          }
          else { // positional argument (implicit)
            arg = argv[cursor++];
          }

          if (/[^s]/.test(match[8]) && (get_type(arg) != 'number')) {
            throw(sprintf('[sprintf] expecting number but found %s', get_type(arg)));
          }

          // Jed EDIT
          if ( typeof arg == 'undefined' || arg === null ) {
            arg = '';
          }
          // Jed EDIT

          switch (match[8]) {
            case 'b': arg = arg.toString(2); break;
            case 'c': arg = String.fromCharCode(arg); break;
            case 'd': arg = parseInt(arg, 10); break;
            case 'e': arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential(); break;
            case 'f': arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg); break;
            case 'o': arg = arg.toString(8); break;
            case 's': arg = ((arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg); break;
            case 'u': arg = Math.abs(arg); break;
            case 'x': arg = arg.toString(16); break;
            case 'X': arg = arg.toString(16).toUpperCase(); break;
          }
          arg = (/[def]/.test(match[8]) && match[3] && arg >= 0 ? '+'+ arg : arg);
          pad_character = match[4] ? match[4] == '0' ? '0' : match[4].charAt(1) : ' ';
          pad_length = match[6] - String(arg).length;
          pad = match[6] ? str_repeat(pad_character, pad_length) : '';
          output.push(match[5] ? arg + pad : pad + arg);
        }
      }
      return output.join('');
    };

    str_format.cache = {};

    str_format.parse = function(fmt) {
      var _fmt = fmt, match = [], parse_tree = [], arg_names = 0;
      while (_fmt) {
        if ((match = /^[^\x25]+/.exec(_fmt)) !== null) {
          parse_tree.push(match[0]);
        }
        else if ((match = /^\x25{2}/.exec(_fmt)) !== null) {
          parse_tree.push('%');
        }
        else if ((match = /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(_fmt)) !== null) {
          if (match[2]) {
            arg_names |= 1;
            var field_list = [], replacement_field = match[2], field_match = [];
            if ((field_match = /^([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
              field_list.push(field_match[1]);
              while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                if ((field_match = /^\.([a-z_][a-z_\d]*)/i.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                }
                else if ((field_match = /^\[(\d+)\]/.exec(replacement_field)) !== null) {
                  field_list.push(field_match[1]);
                }
                else {
                  throw('[sprintf] huh?');
                }
              }
            }
            else {
              throw('[sprintf] huh?');
            }
            match[2] = field_list;
          }
          else {
            arg_names |= 2;
          }
          if (arg_names === 3) {
            throw('[sprintf] mixing positional and named placeholders is not (yet) supported');
          }
          parse_tree.push(match);
        }
        else {
          throw('[sprintf] huh?');
        }
        _fmt = _fmt.substring(match[0].length);
      }
      return parse_tree;
    };

    return str_format;
  })();

  var vsprintf = function(fmt, argv) {
    argv.unshift(fmt);
    return sprintf.apply(null, argv);
  };

  Jed.parse_plural = function ( plural_forms, n ) {
    plural_forms = plural_forms.replace(/n/g, n);
    return Jed.parse_expression(plural_forms);
  };

  Jed.sprintf = function ( fmt, args ) {
    if ( {}.toString.call( args ) == '[object Array]' ) {
      return vsprintf( fmt, [].slice.call(args) );
    }
    return sprintf.apply(this, [].slice.call(arguments) );
  };

  Jed.prototype.sprintf = function () {
    return Jed.sprintf.apply(this, arguments);
  };
  // END sprintf Implementation

  // Start the Plural forms section
  // This is a full plural form expression parser. It is used to avoid
  // running 'eval' or 'new Function' directly against the plural
  // forms.
  //
  // This can be important if you get translations done through a 3rd
  // party vendor. I encourage you to use this instead, however, I
  // also will provide a 'precompiler' that you can use at build time
  // to output valid/safe function representations of the plural form
  // expressions. This means you can build this code out for the most
  // part.
  Jed.PF = {};

  Jed.PF.parse = function ( p ) {
    var plural_str = Jed.PF.extractPluralExpr( p );
    return Jed.PF.parser.parse.call(Jed.PF.parser, plural_str);
  };

  Jed.PF.compile = function ( p ) {
    // Handle trues and falses as 0 and 1
    function imply( val ) {
      return (val === true ? 1 : val ? val : 0);
    }

    var ast = Jed.PF.parse( p );
    return function ( n ) {
      return imply( Jed.PF.interpreter( ast )( n ) );
    };
  };

  Jed.PF.interpreter = function ( ast ) {
    return function ( n ) {
      var res;
      switch ( ast.type ) {
        case 'GROUP':
          return Jed.PF.interpreter( ast.expr )( n );
        case 'TERNARY':
          if ( Jed.PF.interpreter( ast.expr )( n ) ) {
            return Jed.PF.interpreter( ast.truthy )( n );
          }
          return Jed.PF.interpreter( ast.falsey )( n );
        case 'OR':
          return Jed.PF.interpreter( ast.left )( n ) || Jed.PF.interpreter( ast.right )( n );
        case 'AND':
          return Jed.PF.interpreter( ast.left )( n ) && Jed.PF.interpreter( ast.right )( n );
        case 'LT':
          return Jed.PF.interpreter( ast.left )( n ) < Jed.PF.interpreter( ast.right )( n );
        case 'GT':
          return Jed.PF.interpreter( ast.left )( n ) > Jed.PF.interpreter( ast.right )( n );
        case 'LTE':
          return Jed.PF.interpreter( ast.left )( n ) <= Jed.PF.interpreter( ast.right )( n );
        case 'GTE':
          return Jed.PF.interpreter( ast.left )( n ) >= Jed.PF.interpreter( ast.right )( n );
        case 'EQ':
          return Jed.PF.interpreter( ast.left )( n ) == Jed.PF.interpreter( ast.right )( n );
        case 'NEQ':
          return Jed.PF.interpreter( ast.left )( n ) != Jed.PF.interpreter( ast.right )( n );
        case 'MOD':
          return Jed.PF.interpreter( ast.left )( n ) % Jed.PF.interpreter( ast.right )( n );
        case 'VAR':
          return n;
        case 'NUM':
          return ast.val;
        default:
          throw new Error("Invalid Token found.");
      }
    };
  };

  Jed.PF.extractPluralExpr = function ( p ) {
    // trim first
    p = p.replace(/^\s\s*/, '').replace(/\s\s*$/, '');

    if (! /;\s*$/.test(p)) {
      p = p.concat(';');
    }

    var nplurals_re = /nplurals\=(\d+);/,
        plural_re = /plural\=(.*);/,
        nplurals_matches = p.match( nplurals_re ),
        res = {},
        plural_matches;

    // Find the nplurals number
    if ( nplurals_matches.length > 1 ) {
      res.nplurals = nplurals_matches[1];
    }
    else {
      throw new Error('nplurals not found in plural_forms string: ' + p );
    }

    // remove that data to get to the formula
    p = p.replace( nplurals_re, "" );
    plural_matches = p.match( plural_re );

    if (!( plural_matches && plural_matches.length > 1 ) ) {
      throw new Error('`plural` expression not found: ' + p);
    }
    return plural_matches[ 1 ];
  };

  /* Jison generated parser */
  Jed.PF.parser = (function(){

var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"expressions":3,"e":4,"EOF":5,"?":6,":":7,"||":8,"&&":9,"<":10,"<=":11,">":12,">=":13,"!=":14,"==":15,"%":16,"(":17,")":18,"n":19,"NUMBER":20,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",6:"?",7:":",8:"||",9:"&&",10:"<",11:"<=",12:">",13:">=",14:"!=",15:"==",16:"%",17:"(",18:")",19:"n",20:"NUMBER"},
productions_: [0,[3,2],[4,5],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,1],[4,1]],
performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

var $0 = $$.length - 1;
switch (yystate) {
case 1: return { type : 'GROUP', expr: $$[$0-1] };
break;
case 2:this.$ = { type: 'TERNARY', expr: $$[$0-4], truthy : $$[$0-2], falsey: $$[$0] };
break;
case 3:this.$ = { type: "OR", left: $$[$0-2], right: $$[$0] };
break;
case 4:this.$ = { type: "AND", left: $$[$0-2], right: $$[$0] };
break;
case 5:this.$ = { type: 'LT', left: $$[$0-2], right: $$[$0] };
break;
case 6:this.$ = { type: 'LTE', left: $$[$0-2], right: $$[$0] };
break;
case 7:this.$ = { type: 'GT', left: $$[$0-2], right: $$[$0] };
break;
case 8:this.$ = { type: 'GTE', left: $$[$0-2], right: $$[$0] };
break;
case 9:this.$ = { type: 'NEQ', left: $$[$0-2], right: $$[$0] };
break;
case 10:this.$ = { type: 'EQ', left: $$[$0-2], right: $$[$0] };
break;
case 11:this.$ = { type: 'MOD', left: $$[$0-2], right: $$[$0] };
break;
case 12:this.$ = { type: 'GROUP', expr: $$[$0-1] };
break;
case 13:this.$ = { type: 'VAR' };
break;
case 14:this.$ = { type: 'NUM', val: Number(yytext) };
break;
}
},
table: [{3:1,4:2,17:[1,3],19:[1,4],20:[1,5]},{1:[3]},{5:[1,6],6:[1,7],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16]},{4:17,17:[1,3],19:[1,4],20:[1,5]},{5:[2,13],6:[2,13],7:[2,13],8:[2,13],9:[2,13],10:[2,13],11:[2,13],12:[2,13],13:[2,13],14:[2,13],15:[2,13],16:[2,13],18:[2,13]},{5:[2,14],6:[2,14],7:[2,14],8:[2,14],9:[2,14],10:[2,14],11:[2,14],12:[2,14],13:[2,14],14:[2,14],15:[2,14],16:[2,14],18:[2,14]},{1:[2,1]},{4:18,17:[1,3],19:[1,4],20:[1,5]},{4:19,17:[1,3],19:[1,4],20:[1,5]},{4:20,17:[1,3],19:[1,4],20:[1,5]},{4:21,17:[1,3],19:[1,4],20:[1,5]},{4:22,17:[1,3],19:[1,4],20:[1,5]},{4:23,17:[1,3],19:[1,4],20:[1,5]},{4:24,17:[1,3],19:[1,4],20:[1,5]},{4:25,17:[1,3],19:[1,4],20:[1,5]},{4:26,17:[1,3],19:[1,4],20:[1,5]},{4:27,17:[1,3],19:[1,4],20:[1,5]},{6:[1,7],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[1,28]},{6:[1,7],7:[1,29],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16]},{5:[2,3],6:[2,3],7:[2,3],8:[2,3],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,3]},{5:[2,4],6:[2,4],7:[2,4],8:[2,4],9:[2,4],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,4]},{5:[2,5],6:[2,5],7:[2,5],8:[2,5],9:[2,5],10:[2,5],11:[2,5],12:[2,5],13:[2,5],14:[2,5],15:[2,5],16:[1,16],18:[2,5]},{5:[2,6],6:[2,6],7:[2,6],8:[2,6],9:[2,6],10:[2,6],11:[2,6],12:[2,6],13:[2,6],14:[2,6],15:[2,6],16:[1,16],18:[2,6]},{5:[2,7],6:[2,7],7:[2,7],8:[2,7],9:[2,7],10:[2,7],11:[2,7],12:[2,7],13:[2,7],14:[2,7],15:[2,7],16:[1,16],18:[2,7]},{5:[2,8],6:[2,8],7:[2,8],8:[2,8],9:[2,8],10:[2,8],11:[2,8],12:[2,8],13:[2,8],14:[2,8],15:[2,8],16:[1,16],18:[2,8]},{5:[2,9],6:[2,9],7:[2,9],8:[2,9],9:[2,9],10:[2,9],11:[2,9],12:[2,9],13:[2,9],14:[2,9],15:[2,9],16:[1,16],18:[2,9]},{5:[2,10],6:[2,10],7:[2,10],8:[2,10],9:[2,10],10:[2,10],11:[2,10],12:[2,10],13:[2,10],14:[2,10],15:[2,10],16:[1,16],18:[2,10]},{5:[2,11],6:[2,11],7:[2,11],8:[2,11],9:[2,11],10:[2,11],11:[2,11],12:[2,11],13:[2,11],14:[2,11],15:[2,11],16:[2,11],18:[2,11]},{5:[2,12],6:[2,12],7:[2,12],8:[2,12],9:[2,12],10:[2,12],11:[2,12],12:[2,12],13:[2,12],14:[2,12],15:[2,12],16:[2,12],18:[2,12]},{4:30,17:[1,3],19:[1,4],20:[1,5]},{5:[2,2],6:[1,7],7:[2,2],8:[1,8],9:[1,9],10:[1,10],11:[1,11],12:[1,12],13:[1,13],14:[1,14],15:[1,15],16:[1,16],18:[2,2]}],
defaultActions: {6:[2,1]},
parseError: function parseError(str, hash) {
    throw new Error(str);
},
parse: function parse(input) {
    var self = this,
        stack = [0],
        vstack = [null], // semantic value stack
        lstack = [], // location stack
        table = this.table,
        yytext = '',
        yylineno = 0,
        yyleng = 0,
        recovering = 0,
        TERROR = 2,
        EOF = 1;

    //this.reductionCount = this.shiftCount = 0;

    this.lexer.setInput(input);
    this.lexer.yy = this.yy;
    this.yy.lexer = this.lexer;
    if (typeof this.lexer.yylloc == 'undefined')
        this.lexer.yylloc = {};
    var yyloc = this.lexer.yylloc;
    lstack.push(yyloc);

    if (typeof this.yy.parseError === 'function')
        this.parseError = this.yy.parseError;

    function popStack (n) {
        stack.length = stack.length - 2*n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }

    function lex() {
        var token;
        token = self.lexer.lex() || 1; // $end = 1
        // if token isn't its numeric value, convert
        if (typeof token !== 'number') {
            token = self.symbols_[token] || token;
        }
        return token;
    }

    var symbol, preErrorSymbol, state, action, a, r, yyval={},p,len,newState, expected;
    while (true) {
        // retreive state number from top of stack
        state = stack[stack.length-1];

        // use default actions if available
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol == null)
                symbol = lex();
            // read action for current state and first input
            action = table[state] && table[state][symbol];
        }

        // handle parse error
        _handle_error:
        if (typeof action === 'undefined' || !action.length || !action[0]) {

            if (!recovering) {
                // Report error
                expected = [];
                for (p in table[state]) if (this.terminals_[p] && p > 2) {
                    expected.push("'"+this.terminals_[p]+"'");
                }
                var errStr = '';
                if (this.lexer.showPosition) {
                    errStr = 'Parse error on line '+(yylineno+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+expected.join(', ') + ", got '" + this.terminals_[symbol]+ "'";
                } else {
                    errStr = 'Parse error on line '+(yylineno+1)+": Unexpected " +
                                  (symbol == 1 /*EOF*/ ? "end of input" :
                                              ("'"+(this.terminals_[symbol] || symbol)+"'"));
                }
                this.parseError(errStr,
                    {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
            }

            // just recovered from another error
            if (recovering == 3) {
                if (symbol == EOF) {
                    throw new Error(errStr || 'Parsing halted.');
                }

                // discard current lookahead and grab another
                yyleng = this.lexer.yyleng;
                yytext = this.lexer.yytext;
                yylineno = this.lexer.yylineno;
                yyloc = this.lexer.yylloc;
                symbol = lex();
            }

            // try to recover from error
            while (1) {
                // check for error recovery rule in this state
                if ((TERROR.toString()) in table[state]) {
                    break;
                }
                if (state == 0) {
                    throw new Error(errStr || 'Parsing halted.');
                }
                popStack(1);
                state = stack[stack.length-1];
            }

            preErrorSymbol = symbol; // save the lookahead token
            symbol = TERROR;         // insert generic error symbol as new lookahead
            state = stack[stack.length-1];
            action = table[state] && table[state][TERROR];
            recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
        }

        // this shouldn't happen, unless resolve defaults are off
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: '+state+', token: '+symbol);
        }

        switch (action[0]) {

            case 1: // shift
                //this.shiftCount++;

                stack.push(symbol);
                vstack.push(this.lexer.yytext);
                lstack.push(this.lexer.yylloc);
                stack.push(action[1]); // push state
                symbol = null;
                if (!preErrorSymbol) { // normal execution/no error
                    yyleng = this.lexer.yyleng;
                    yytext = this.lexer.yytext;
                    yylineno = this.lexer.yylineno;
                    yyloc = this.lexer.yylloc;
                    if (recovering > 0)
                        recovering--;
                } else { // error just occurred, resume old lookahead f/ before error
                    symbol = preErrorSymbol;
                    preErrorSymbol = null;
                }
                break;

            case 2: // reduce
                //this.reductionCount++;

                len = this.productions_[action[1]][1];

                // perform semantic action
                yyval.$ = vstack[vstack.length-len]; // default to $$ = $1
                // default location, uses first token for firsts, last for lasts
                yyval._$ = {
                    first_line: lstack[lstack.length-(len||1)].first_line,
                    last_line: lstack[lstack.length-1].last_line,
                    first_column: lstack[lstack.length-(len||1)].first_column,
                    last_column: lstack[lstack.length-1].last_column
                };
                r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);

                if (typeof r !== 'undefined') {
                    return r;
                }

                // pop off stack
                if (len) {
                    stack = stack.slice(0,-1*len*2);
                    vstack = vstack.slice(0, -1*len);
                    lstack = lstack.slice(0, -1*len);
                }

                stack.push(this.productions_[action[1]][0]);    // push nonterminal (reduce)
                vstack.push(yyval.$);
                lstack.push(yyval._$);
                // goto new state = table[STATE][NONTERMINAL]
                newState = table[stack[stack.length-2]][stack[stack.length-1]];
                stack.push(newState);
                break;

            case 3: // accept
                return true;
        }

    }

    return true;
}};/* Jison generated lexer */
var lexer = (function(){

var lexer = ({EOF:1,
parseError:function parseError(str, hash) {
        if (this.yy.parseError) {
            this.yy.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },
setInput:function (input) {
        this._input = input;
        this._more = this._less = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
        return this;
    },
input:function () {
        var ch = this._input[0];
        this.yytext+=ch;
        this.yyleng++;
        this.match+=ch;
        this.matched+=ch;
        var lines = ch.match(/\n/);
        if (lines) this.yylineno++;
        this._input = this._input.slice(1);
        return ch;
    },
unput:function (ch) {
        this._input = ch + this._input;
        return this;
    },
more:function () {
        this._more = true;
        return this;
    },
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
    },
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c+"^";
    },
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) this.done = true;

        var token,
            match,
            col,
            lines;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i=0;i < rules.length; i++) {
            match = this._input.match(this.rules[rules[i]]);
            if (match) {
                lines = match[0].match(/\n.*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {first_line: this.yylloc.last_line,
                               last_line: this.yylineno+1,
                               first_column: this.yylloc.last_column,
                               last_column: lines ? lines[lines.length-1].length-1 : this.yylloc.last_column + match[0].length}
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                this._more = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, rules[i],this.conditionStack[this.conditionStack.length-1]);
                if (token) return token;
                else return;
            }
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                    {text: "", token: null, line: this.yylineno});
        }
    },
lex:function lex() {
        var r = this.next();
        if (typeof r !== 'undefined') {
            return r;
        } else {
            return this.lex();
        }
    },
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },
popState:function popState() {
        return this.conditionStack.pop();
    },
_currentRules:function _currentRules() {
        return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
    },
topState:function () {
        return this.conditionStack[this.conditionStack.length-2];
    },
pushState:function begin(condition) {
        this.begin(condition);
    }});
lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {

var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* skip whitespace */
break;
case 1:return 20
break;
case 2:return 19
break;
case 3:return 8
break;
case 4:return 9
break;
case 5:return 6
break;
case 6:return 7
break;
case 7:return 11
break;
case 8:return 13
break;
case 9:return 10
break;
case 10:return 12
break;
case 11:return 14
break;
case 12:return 15
break;
case 13:return 16
break;
case 14:return 17
break;
case 15:return 18
break;
case 16:return 5
break;
case 17:return 'INVALID'
break;
}
};
lexer.rules = [/^\s+/,/^[0-9]+(\.[0-9]+)?\b/,/^n\b/,/^\|\|/,/^&&/,/^\?/,/^:/,/^<=/,/^>=/,/^</,/^>/,/^!=/,/^==/,/^%/,/^\(/,/^\)/,/^$/,/^./];
lexer.conditions = {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],"inclusive":true}};return lexer;})()
parser.lexer = lexer;
return parser;
})();
// End parser

  // Handle node, amd, and global systems
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = Jed;
    }
    exports.Jed = Jed;
  }
  else {
    if (typeof define === 'function' && define.amd) {
      define(function() {
        return Jed;
      });
    }
    // Leak a global regardless of module system
    root['Jed'] = Jed;
  }

})(this);


/***/ }),

/***/ "../../../node_modules/js-cookie/src/js.cookie.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				return (document.cookie = [
					key, '=', value,
					attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					attributes.path ? '; path=' + attributes.path : '',
					attributes.domain ? '; domain=' + attributes.domain : '',
					attributes.secure ? '; secure' : ''
				].join(''));
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "../../../node_modules/mousetrap/mousetrap.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2013 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.4.6
 * @url craig.is/killing/mice
 */
(function(window, document, undefined) {

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
            8: 'backspace',
            9: 'tab',
            13: 'enter',
            16: 'shift',
            17: 'ctrl',
            18: 'alt',
            20: 'capslock',
            27: 'esc',
            32: 'space',
            33: 'pageup',
            34: 'pagedown',
            35: 'end',
            36: 'home',
            37: 'left',
            38: 'up',
            39: 'right',
            40: 'down',
            45: 'ins',
            46: 'del',
            91: 'meta',
            93: 'meta',
            224: 'meta'
        },

        /**
         * mapping for special characters so they can support
         *
         * this dictionary is only used incase you want to bind a
         * keyup or keydown event to one of these keys
         *
         * @type {Object}
         */
        _KEYCODE_MAP = {
            106: '*',
            107: '+',
            109: '-',
            110: '.',
            111 : '/',
            186: ';',
            187: '=',
            188: ',',
            189: '-',
            190: '.',
            191: '/',
            192: '`',
            219: '[',
            220: '\\',
            221: ']',
            222: '\''
        },

        /**
         * this is a mapping of keys that require shift on a US keypad
         * back to the non shift equivelents
         *
         * this is so you can use keyup events with these keys
         *
         * note that this will only work reliably on US keyboards
         *
         * @type {Object}
         */
        _SHIFT_MAP = {
            '~': '`',
            '!': '1',
            '@': '2',
            '#': '3',
            '$': '4',
            '%': '5',
            '^': '6',
            '&': '7',
            '*': '8',
            '(': '9',
            ')': '0',
            '_': '-',
            '+': '=',
            ':': ';',
            '\"': '\'',
            '<': ',',
            '>': '.',
            '?': '/',
            '|': '\\'
        },

        /**
         * this is a list of special strings you can use to map
         * to modifier keys when you specify your keyboard shortcuts
         *
         * @type {Object}
         */
        _SPECIAL_ALIASES = {
            'option': 'alt',
            'command': 'meta',
            'return': 'enter',
            'escape': 'esc',
            'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
        },

        /**
         * variable to store the flipped version of _MAP from above
         * needed to check if we should use keypress or not when no action
         * is specified
         *
         * @type {Object|undefined}
         */
        _REVERSE_MAP,

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        _callbacks = {},

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        _directMap = {},

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        _sequenceLevels = {},

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        _resetTimer,

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        _ignoreNextKeyup = false,

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        _ignoreNextKeypress = false,

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        _nextExpectedAction = false;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {
        _MAP[i + 96] = i;
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * resets all sequence counters except for the ones passed in
     *
     * @param {Object} doNotReset
     * @returns void
     */
    function _resetSequences(doNotReset) {
        doNotReset = doNotReset || {};

        var activeSequences = false,
            key;

        for (key in _sequenceLevels) {
            if (doNotReset[key]) {
                activeSequences = true;
                continue;
            }
            _sequenceLevels[key] = 0;
        }

        if (!activeSequences) {
            _nextExpectedAction = false;
        }
    }

    /**
     * finds all callbacks that match based on the keycode, modifiers,
     * and action
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event|Object} e
     * @param {string=} sequenceName - name of the sequence we are looking for
     * @param {string=} combination
     * @param {number=} level
     * @returns {Array}
     */
    function _getMatches(character, modifiers, e, sequenceName, combination, level) {
        var i,
            callback,
            matches = [],
            action = e.type;

        // if there are no events related to this keycode
        if (!_callbacks[character]) {
            return [];
        }

        // if a modifier key is coming up on its own we should allow it
        if (action == 'keyup' && _isModifier(character)) {
            modifiers = [character];
        }

        // loop through all callbacks for the key that was pressed
        // and see if any of them match
        for (i = 0; i < _callbacks[character].length; ++i) {
            callback = _callbacks[character][i];

            // if a sequence name is not specified, but this is a sequence at
            // the wrong level then move onto the next match
            if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                continue;
            }

            // if the action we are looking for doesn't match the action we got
            // then we should keep going
            if (action != callback.action) {
                continue;
            }

            // if this is a keypress event and the meta key and control key
            // are not pressed that means that we need to only look at the
            // character, otherwise check the modifiers as well
            //
            // chrome will not fire a keypress if meta or control is down
            // safari will fire a keypress if meta or meta+shift is down
            // firefox will fire a keypress if meta or control is down
            if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {

                // when you bind a combination or sequence a second time it
                // should overwrite the first one.  if a sequenceName or
                // combination is specified in this call it does just that
                //
                // @todo make deleting its own method?
                var deleteCombo = !sequenceName && callback.combo == combination;
                var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                if (deleteCombo || deleteSequence) {
                    _callbacks[character].splice(i, 1);
                }

                matches.push(callback);
            }
        }

        return matches;
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * actually calls the callback function
     *
     * if your callback function returns false this will use the jquery
     * convention - prevent default and stop propogation on the event
     *
     * @param {Function} callback
     * @param {Event} e
     * @returns void
     */
    function _fireCallback(callback, e, combo, sequence) {

        // if this event should not happen stop here
        if (Mousetrap.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
            return;
        }

        if (callback(e, combo) === false) {
            _preventDefault(e);
            _stopPropagation(e);
        }
    }

    /**
     * handles a character key event
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event} e
     * @returns void
     */
    function _handleKey(character, modifiers, e) {
        var callbacks = _getMatches(character, modifiers, e),
            i,
            doNotReset = {},
            maxLevel = 0,
            processedSequenceCallback = false;

        // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
        for (i = 0; i < callbacks.length; ++i) {
            if (callbacks[i].seq) {
                maxLevel = Math.max(maxLevel, callbacks[i].level);
            }
        }

        // loop through matching callbacks for this key event
        for (i = 0; i < callbacks.length; ++i) {

            // fire for all sequence callbacks
            // this is because if for example you have multiple sequences
            // bound such as "g i" and "g t" they both need to fire the
            // callback for matching g cause otherwise you can only ever
            // match the first one
            if (callbacks[i].seq) {

                // only fire callbacks for the maxLevel to prevent
                // subsequences from also firing
                //
                // for example 'a option b' should not cause 'option b' to fire
                // even though 'option b' is part of the other sequence
                //
                // any sequences that do not match here will be discarded
                // below by the _resetSequences call
                if (callbacks[i].level != maxLevel) {
                    continue;
                }

                processedSequenceCallback = true;

                // keep a list of which sequences were matches for later
                doNotReset[callbacks[i].seq] = 1;
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                continue;
            }

            // if there were no sequence matches but we are still here
            // that means this is a regular match so we should fire that
            if (!processedSequenceCallback) {
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
        }

        // if the key you pressed matches the type of sequence without
        // being a modifier (ie "keyup" or "keypress") then we should
        // reset all sequences that were not matched by this event
        //
        // this is so, for example, if you have the sequence "h a t" and you
        // type "h e a r t" it does not match.  in this case the "e" will
        // cause the sequence to reset
        //
        // modifier keys are ignored because you can have a sequence
        // that contains modifiers such as "enter ctrl+space" and in most
        // cases the modifier key will be pressed before the next key
        //
        // also if you have a sequence such as "ctrl+b a" then pressing the
        // "b" key will trigger a "keypress" and a "keydown"
        //
        // the "keydown" is expected when there is a modifier, but the
        // "keypress" ends up matching the _nextExpectedAction since it occurs
        // after and that causes the sequence to reset
        //
        // we ignore keypresses in a sequence that directly follow a keydown
        // for the same character
        var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
        if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
            _resetSequences(doNotReset);
        }

        _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
    }

    /**
     * handles a keydown event
     *
     * @param {Event} e
     * @returns void
     */
    function _handleKeyEvent(e) {

        // normalize e.which for key events
        // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
        if (typeof e.which !== 'number') {
            e.which = e.keyCode;
        }

        var character = _characterFromEvent(e);

        // no character found then stop
        if (!character) {
            return;
        }

        // need to use === for the character check because the character can be 0
        if (e.type == 'keyup' && _ignoreNextKeyup === character) {
            _ignoreNextKeyup = false;
            return;
        }

        Mousetrap.handleKey(character, _eventModifiers(e), e);
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * called to set a 1 second timeout on the specified sequence
     *
     * this is so after each key press in the sequence you have 1 second
     * to press the next key before you have to start over
     *
     * @returns void
     */
    function _resetSequenceTimer() {
        clearTimeout(_resetTimer);
        _resetTimer = setTimeout(_resetSequences, 1000);
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * binds a key sequence to an event
     *
     * @param {string} combo - combo specified in bind call
     * @param {Array} keys
     * @param {Function} callback
     * @param {string=} action
     * @returns void
     */
    function _bindSequence(combo, keys, callback, action) {

        // start off by adding a sequence level record for this combination
        // and setting the level to 0
        _sequenceLevels[combo] = 0;

        /**
         * callback to increase the sequence level for this sequence and reset
         * all other sequences that were active
         *
         * @param {string} nextAction
         * @returns {Function}
         */
        function _increaseSequence(nextAction) {
            return function() {
                _nextExpectedAction = nextAction;
                ++_sequenceLevels[combo];
                _resetSequenceTimer();
            };
        }

        /**
         * wraps the specified callback inside of another function in order
         * to reset all sequence counters as soon as this sequence is done
         *
         * @param {Event} e
         * @returns void
         */
        function _callbackAndReset(e) {
            _fireCallback(callback, e, combo);

            // we should ignore the next key up if the action is key down
            // or keypress.  this is so if you finish a sequence and
            // release the key the final key will not trigger a keyup
            if (action !== 'keyup') {
                _ignoreNextKeyup = _characterFromEvent(e);
            }

            // weird race condition if a sequence ends with the key
            // another sequence begins with
            setTimeout(_resetSequences, 10);
        }

        // loop through keys one at a time and bind the appropriate callback
        // function.  for any key leading up to the final one it should
        // increase the sequence. after the final, it should reset all sequences
        //
        // if an action is specified in the original bind call then that will
        // be used throughout.  otherwise we will pass the action that the
        // next key in the sequence should match.  this allows a sequence
        // to mix and match keypress and keydown events depending on which
        // ones are better suited to the key provided
        for (var i = 0; i < keys.length; ++i) {
            var isFinal = i + 1 === keys.length;
            var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
            _bindSingle(keys[i], wrappedCallback, action, combo, i);
        }
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys,
            key,
            i,
            modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    /**
     * binds a single keyboard combination
     *
     * @param {string} combination
     * @param {Function} callback
     * @param {string=} action
     * @param {string=} sequenceName - name of sequence if part of sequence
     * @param {number=} level - what part of the sequence the command is
     * @returns void
     */
    function _bindSingle(combination, callback, action, sequenceName, level) {

        // store a direct mapped reference for use with Mousetrap.trigger
        _directMap[combination + ':' + action] = callback;

        // make sure multiple spaces in a row become a single space
        combination = combination.replace(/\s+/g, ' ');

        var sequence = combination.split(' '),
            info;

        // if this pattern is a sequence of keys then run through this method
        // to reprocess each pattern one key at a time
        if (sequence.length > 1) {
            _bindSequence(combination, sequence, callback, action);
            return;
        }

        info = _getKeyInfo(combination, action);

        // make sure to initialize array if this is the first time
        // a callback is added for this key
        _callbacks[info.key] = _callbacks[info.key] || [];

        // remove an existing match if there is one
        _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);

        // add this call back to the array
        // if it is a sequence put it at the beginning
        // if not put it at the end
        //
        // this is important because the way these are processed expects
        // the sequence ones to come first
        _callbacks[info.key][sequenceName ? 'unshift' : 'push']({
            callback: callback,
            modifiers: info.modifiers,
            action: info.action,
            seq: sequenceName,
            level: level,
            combo: combination
        });
    }

    /**
     * binds multiple combinations to the same callback
     *
     * @param {Array} combinations
     * @param {Function} callback
     * @param {string|undefined} action
     * @returns void
     */
    function _bindMultiple(combinations, callback, action) {
        for (var i = 0; i < combinations.length; ++i) {
            _bindSingle(combinations[i], callback, action);
        }
    }

    // start!
    _addEvent(document, 'keypress', _handleKeyEvent);
    _addEvent(document, 'keydown', _handleKeyEvent);
    _addEvent(document, 'keyup', _handleKeyEvent);

    var Mousetrap = {

        /**
         * binds an event to mousetrap
         *
         * can be a single key, a combination of keys separated with +,
         * an array of keys, or a sequence of keys separated by spaces
         *
         * be sure to list the modifier keys first to make sure that the
         * correct key ends up getting bound (the last key in the pattern)
         *
         * @param {string|Array} keys
         * @param {Function} callback
         * @param {string=} action - 'keypress', 'keydown', or 'keyup'
         * @returns void
         */
        bind: function(keys, callback, action) {
            keys = keys instanceof Array ? keys : [keys];
            _bindMultiple(keys, callback, action);
            return this;
        },

        /**
         * unbinds an event to mousetrap
         *
         * the unbinding sets the callback function of the specified key combo
         * to an empty function and deletes the corresponding key in the
         * _directMap dict.
         *
         * TODO: actually remove this from the _callbacks dictionary instead
         * of binding an empty function
         *
         * the keycombo+action has to be exactly the same as
         * it was defined in the bind method
         *
         * @param {string|Array} keys
         * @param {string} action
         * @returns void
         */
        unbind: function(keys, action) {
            return Mousetrap.bind(keys, function() {}, action);
        },

        /**
         * triggers an event that has already been bound
         *
         * @param {string} keys
         * @param {string=} action
         * @returns void
         */
        trigger: function(keys, action) {
            if (_directMap[keys + ':' + action]) {
                _directMap[keys + ':' + action]({}, keys);
            }
            return this;
        },

        /**
         * resets the library back to its initial state.  this is useful
         * if you want to clear out the current keyboard shortcuts and bind
         * new ones - for example if you switch to another page
         *
         * @returns void
         */
        reset: function() {
            _callbacks = {};
            _directMap = {};
            return this;
        },

       /**
        * should we stop this event before firing off callbacks
        *
        * @param {Event} e
        * @param {Element} element
        * @return {boolean}
        */
        stopCallback: function(e, element) {

            // if the element has the class "mousetrap" then no need to stop
            if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
                return false;
            }

            // stop for input, select, and textarea
            return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
        },

        /**
         * exposes _handleKey publicly so it can be overwritten by extensions
         */
        handleKey: _handleKey
    };

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (Mousetrap),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}) (window, document);


/***/ }),

/***/ "../../../node_modules/select/src/select.js":
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ "../../../node_modules/svg4everybody/dist/svg4everybody.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
     true ? // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return root.svg4everybody = factory();
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});

/***/ }),

/***/ "../../../node_modules/timeago.js/dist/timeago.min.js":
/***/ (function(module, exports) {

!function(t,e){"object"==typeof module&&module.exports?(module.exports=e(),module.exports.default=module.exports):t.timeago=e()}("undefined"!=typeof window?window:this,function(){function t(t){return t instanceof Date?t:isNaN(t)?/^\d+$/.test(t)?new Date(e(t)):(t=(t||"").trim().replace(/\.\d+/,"").replace(/-/,"/").replace(/-/,"/").replace(/(\d)T(\d)/,"$1 $2").replace(/Z/," UTC").replace(/([\+\-]\d\d)\:?(\d\d)/," $1$2"),new Date(t)):new Date(e(t))}function e(t){return parseInt(t)}function n(t,n,r){n=l[n]?n:l[r]?r:"en";for(var o=0,i=t<0?1:0,a=t=Math.abs(t);t>=p[o]&&o<h;o++)t/=p[o];return t=e(t),o*=2,t>(0===o?9:1)&&(o+=1),l[n](t,o,a)[i].replace("%s",t)}function r(e,n){return((n=n?t(n):new Date)-t(e))/1e3}function o(t){for(var e=1,n=0,r=Math.abs(t);t>=p[n]&&n<h;n++)t/=p[n],e*=p[n];return r%=e,r=r?e-r:e,Math.ceil(r)}function i(t){return a(t,"data-timeago")||a(t,"datetime")}function a(t,e){return t.getAttribute?t.getAttribute(e):t.attr?t.attr(e):void 0}function u(t,e){return t.setAttribute?t.setAttribute(m,e):t.attr?t.attr(m,e):void 0}function c(t,e){this.nowDate=t,this.defaultLocale=e||"en"}function d(t,e){return new c(t,e)}var f="second_minute_hour_day_week_month_year".split("_"),s="秒_分钟_小时_天_周_月_年".split("_"),l={en:function(t,e){if(0===e)return["just now","right now"];var n=f[parseInt(e/2)];return t>1&&(n+="s"),[t+" "+n+" ago","in "+t+" "+n]},zh_CN:function(t,e){if(0===e)return["刚刚","片刻后"];var n=s[parseInt(e/2)];return[t+n+"前",t+n+"后"]}},p=[60,60,24,7,365/7/12,12],h=6,m="data-tid",w={};return c.prototype.doRender=function(t,e,i){var a,c=r(e,this.nowDate),d=this;t.innerHTML=n(c,i,this.defaultLocale),w[a=setTimeout(function(){d.doRender(t,e,i),delete w[a]},Math.min(1e3*o(c),2147483647))]=0,u(t,a)},c.prototype.format=function(t,e){return n(r(t,this.nowDate),e,this.defaultLocale)},c.prototype.render=function(t,e){void 0===t.length&&(t=[t]);for(var n=0,r=t.length;n<r;n++)this.doRender(t[n],i(t[n]),e)},c.prototype.setLocale=function(t){this.defaultLocale=t},d.register=function(t,e){l[t]=e},d.cancel=function(t){var e;if(t)(e=a(t,m))&&(clearTimeout(e),delete w[e]);else{for(e in w)clearTimeout(e);w={}}},d});

/***/ }),

/***/ "../../../node_modules/tiny-emitter/index.js":
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),

/***/ "../../../node_modules/vue-loader/lib/runtime/component-normalizer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeComponent;
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  scriptExports = scriptExports || {}

  // ES6 modules interop
  var type = typeof scriptExports.default
  if (type === 'object' || type === 'function') {
    scriptExports = scriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "../../../vendor/assets/javascripts/date.format.js":
/***/ (function(module, exports, __webpack_require__) {

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */
 (function (global, factory) {
      true ? module.exports = factory() :
     typeof define === 'function' && define.amd ? define(factory) :
     (global.dateFormat = factory());
 }(this, (function () { 'use strict';
  var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
      timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
      timezoneClip = /[^-+\dA-Z]/g,
      pad = function (val, len) {
        val = String(val);
        len = len || 2;
        while (val.length < len) val = "0" + val;
        return val;
      };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
      var dF = dateFormat;

      // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
      if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }

      // Passing date through Date applies Date.parse, if necessary
      date = date ? new Date(date) : new Date;
      if (isNaN(date)) throw SyntaxError("invalid date");

      mask = String(dF.masks[mask] || mask || dF.masks["default"]);

      // Allow setting the utc argument via the mask
      if (mask.slice(0, 4) == "UTC:") {
        mask = mask.slice(4);
        utc = true;
      }

      var _ = utc ? "getUTC" : "get",
        d = date[_ + "Date"](),
        D = date[_ + "Day"](),
        m = date[_ + "Month"](),
        y = date[_ + "FullYear"](),
        H = date[_ + "Hours"](),
        M = date[_ + "Minutes"](),
        s = date[_ + "Seconds"](),
        L = date[_ + "Milliseconds"](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dF.i18n.dayNames[D],
          dddd: dF.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dF.i18n.monthNames[m],
          mmmm: dF.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(L > 99 ? Math.round(L / 10) : L),
          t:    H < 12 ? "a"  : "p",
          tt:   H < 12 ? "am" : "pm",
          T:    H < 12 ? "A"  : "P",
          TT:   H < 12 ? "AM" : "PM",
          Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
          o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };

      return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }();

  // Some common format strings
  dateFormat.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
  };

  // For convenience...
  Date.prototype.format = function (mask, utc) {
    return dateFormat(this, mask, utc);
  };

  return dateFormat;
})));


/***/ }),

/***/ "./api.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");




var Api = {
  groupsPath: '/api/:version/groups.json',
  groupPath: '/api/:version/groups/:id',
  namespacesPath: '/api/:version/namespaces.json',
  groupProjectsPath: '/api/:version/groups/:id/projects.json',
  projectsPath: '/api/:version/projects.json',
  projectPath: '/api/:version/projects/:id',
  projectLabelsPath: '/:namespace_path/:project_path/labels',
  mergeRequestPath: '/api/:version/projects/:id/merge_requests/:mrid',
  mergeRequestChangesPath: '/api/:version/projects/:id/merge_requests/:mrid/changes',
  mergeRequestVersionsPath: '/api/:version/projects/:id/merge_requests/:mrid/versions',
  groupLabelsPath: '/groups/:namespace_path/-/labels',
  licensePath: '/api/:version/templates/licenses/:key',
  gitignorePath: '/api/:version/templates/gitignores/:key',
  gitlabCiYmlPath: '/api/:version/templates/gitlab_ci_ymls/:key',
  dockerfilePath: '/api/:version/templates/dockerfiles/:key',
  issuableTemplatePath: '/:namespace_path/:project_path/templates/:type/:key',
  usersPath: '/api/:version/users.json',
  commitPath: '/api/:version/projects/:id/repository/commits',
  branchSinglePath: '/api/:version/projects/:id/repository/branches/:branch',
  createBranchPath: '/api/:version/projects/:id/repository/branches',

  group: function group(groupId, callback) {
    var url = Api.buildUrl(Api.groupPath).replace(':id', groupId);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref) {
      var data = _ref.data;

      callback(data);

      return data;
    });
  },


  // Return groups list. Filtered by query
  groups: function groups(query, options) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.noop;

    var url = Api.buildUrl(Api.groupsPath);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url, {
      params: Object.assign({
        search: query,
        per_page: 20
      }, options)
    }).then(function (_ref2) {
      var data = _ref2.data;

      callback(data);

      return data;
    });
  },


  // Return namespaces list. Filtered by query
  namespaces: function namespaces(query, callback) {
    var url = Api.buildUrl(Api.namespacesPath);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url, {
      params: {
        search: query,
        per_page: 20
      }
    }).then(function (_ref3) {
      var data = _ref3.data;
      return callback(data);
    });
  },


  // Return projects list. Filtered by query
  projects: function projects(query, options) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.noop;

    var url = Api.buildUrl(Api.projectsPath);
    var defaults = {
      search: query,
      per_page: 20,
      simple: true
    };

    if (gon.current_user_id) {
      defaults.membership = true;
    }

    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url, {
      params: Object.assign(defaults, options)
    }).then(function (_ref4) {
      var data = _ref4.data;

      callback(data);

      return data;
    });
  },


  // Return single project
  project: function project(projectPath) {
    var url = Api.buildUrl(Api.projectPath).replace(':id', encodeURIComponent(projectPath));

    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url);
  },


  // Return Merge Request for project
  mergeRequest: function mergeRequest(projectPath, mergeRequestId) {
    var url = Api.buildUrl(Api.mergeRequestPath).replace(':id', encodeURIComponent(projectPath)).replace(':mrid', mergeRequestId);

    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url);
  },
  mergeRequestChanges: function mergeRequestChanges(projectPath, mergeRequestId) {
    var url = Api.buildUrl(Api.mergeRequestChangesPath).replace(':id', encodeURIComponent(projectPath)).replace(':mrid', mergeRequestId);

    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url);
  },
  mergeRequestVersions: function mergeRequestVersions(projectPath, mergeRequestId) {
    var url = Api.buildUrl(Api.mergeRequestVersionsPath).replace(':id', encodeURIComponent(projectPath)).replace(':mrid', mergeRequestId);

    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url);
  },
  newLabel: function newLabel(namespacePath, projectPath, data, callback) {
    var url = void 0;

    if (projectPath) {
      url = Api.buildUrl(Api.projectLabelsPath).replace(':namespace_path', namespacePath).replace(':project_path', projectPath);
    } else {
      url = Api.buildUrl(Api.groupLabelsPath).replace(':namespace_path', namespacePath);
    }

    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].post(url, {
      label: data
    }).then(function (res) {
      return callback(res.data);
    }).catch(function (e) {
      return callback(e.response.data);
    });
  },


  // Return group projects list. Filtered by query
  groupProjects: function groupProjects(groupId, query, callback) {
    var url = Api.buildUrl(Api.groupProjectsPath).replace(':id', groupId);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url, {
      params: {
        search: query,
        per_page: 20
      }
    }).then(function (_ref5) {
      var data = _ref5.data;
      return callback(data);
    });
  },
  commitMultiple: function commitMultiple(id, data) {
    // see https://docs.gitlab.com/ce/api/commits.html#create-a-commit-with-multiple-files-and-actions
    var url = Api.buildUrl(Api.commitPath).replace(':id', encodeURIComponent(id));
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].post(url, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    });
  },
  branchSingle: function branchSingle(id, branch) {
    var url = Api.buildUrl(Api.branchSinglePath).replace(':id', encodeURIComponent(id)).replace(':branch', encodeURIComponent(branch));

    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url);
  },


  // Return text for a specific license
  licenseText: function licenseText(key, data, callback) {
    var url = Api.buildUrl(Api.licensePath).replace(':key', key);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url, {
      params: data
    }).then(function (res) {
      return callback(res.data);
    });
  },
  gitignoreText: function gitignoreText(key, callback) {
    var url = Api.buildUrl(Api.gitignorePath).replace(':key', key);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref6) {
      var data = _ref6.data;
      return callback(data);
    });
  },
  gitlabCiYml: function gitlabCiYml(key, callback) {
    var url = Api.buildUrl(Api.gitlabCiYmlPath).replace(':key', key);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref7) {
      var data = _ref7.data;
      return callback(data);
    });
  },
  dockerfileYml: function dockerfileYml(key, callback) {
    var url = Api.buildUrl(Api.dockerfilePath).replace(':key', key);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref8) {
      var data = _ref8.data;
      return callback(data);
    });
  },
  issueTemplate: function issueTemplate(namespacePath, projectPath, key, type, callback) {
    var url = Api.buildUrl(Api.issuableTemplatePath).replace(':key', encodeURIComponent(key)).replace(':type', type).replace(':project_path', projectPath).replace(':namespace_path', namespacePath);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref9) {
      var data = _ref9.data;
      return callback(null, data);
    }).catch(callback);
  },
  users: function users(query, options) {
    var url = Api.buildUrl(this.usersPath);
    return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(url, {
      params: Object.assign({
        search: query,
        per_page: 20
      }, options)
    });
  },
  buildUrl: function buildUrl(url) {
    var urlRoot = '';
    if (gon.relative_url_root != null) {
      urlRoot = gon.relative_url_root;
    }
    return urlRoot + url.replace(':version', gon.api_version);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),

/***/ "./awards_handler.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadAwardsHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_dom_utils__ = __webpack_require__("./lib/utils/dom_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */










var animationEndEventString = 'animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd';
var transitionEndEventString = 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd';
var requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.setTimeout;

var FROM_SENTENCE_REGEX = /(?:, and | and |, )/; // For separating lists produced by ruby's Array#toSentence

var categoryLabelMap = {
  activity: 'Activity',
  people: 'People',
  nature: 'Nature',
  food: 'Food',
  travel: 'Travel',
  objects: 'Objects',
  symbols: 'Symbols',
  flags: 'Flags'
};

var IS_VISIBLE = 'is-visible';
var IS_RENDERED = 'is-rendered';

var AwardsHandler = function () {
  function AwardsHandler(emoji) {
    var _this = this;

    _classCallCheck(this, AwardsHandler);

    this.emoji = emoji;
    this.eventListeners = [];
    // If the user shows intent let's pre-build the menu
    this.registerEventListener('one', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document), 'mouseenter focus', '.js-add-award', 'mouseenter focus', function () {
      var $menu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu');
      if ($menu.length === 0) {
        requestAnimationFrame(function () {
          _this.createEmojiMenu();
        });
      }
    });
    this.registerEventListener('on', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document), 'click', '.js-add-award', function (e) {
      e.stopPropagation();
      e.preventDefault();
      _this.showEmojiMenu(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget));
    });

    this.registerEventListener('on', __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html'), 'click', function (e) {
      var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
      if (!$target.closest('.emoji-menu').length) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-awards-block.current').removeClass('current');
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu').is(':visible')) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-award.is-active').removeClass('is-active');
          _this.hideMenuElement(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu'));
        }
      }
    });
    this.registerEventListener('on', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document), 'click', '.js-emoji-btn', function (e) {
      e.preventDefault();
      var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);
      var $glEmojiElement = $target.find('gl-emoji');
      var $spriteIconElement = $target.find('.icon');
      var emojiName = ($glEmojiElement.length ? $glEmojiElement : $spriteIconElement).data('name');

      $target.closest('.js-awards-block').addClass('current');
      _this.addAward(_this.getVotesBlock(), _this.getAwardUrl(), emojiName);
    });
  }

  _createClass(AwardsHandler, [{
    key: 'registerEventListener',
    value: function registerEventListener() {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      var _element$method;

      var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'on';
      var element = arguments[1];

      (_element$method = element[method]).call.apply(_element$method, [element].concat(args));
      this.eventListeners.push({
        element: element,
        args: args
      });
    }
  }, {
    key: 'showEmojiMenu',
    value: function showEmojiMenu($addBtn) {
      var _this2 = this;

      if ($addBtn.hasClass('js-note-emoji')) {
        $addBtn.closest('.note').find('.js-awards-block').addClass('current');
      } else {
        $addBtn.closest('.js-awards-block').addClass('current');
      }

      var $menu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu');
      var $thumbsBtn = $menu.find('[data-name="thumbsup"], [data-name="thumbsdown"]').parent();
      var $userAuthored = this.isUserAuthored($addBtn);
      if ($menu.length) {
        if ($menu.is('.is-visible')) {
          $addBtn.removeClass('is-active');
          this.hideMenuElement($menu);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-emoji-menu-search').blur();
        } else {
          $addBtn.addClass('is-active');
          this.positionMenu($menu, $addBtn);
          this.showMenuElement($menu);
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-emoji-menu-search').focus();
        }
      } else {
        $addBtn.addClass('is-loading is-active');
        this.createEmojiMenu(function () {
          var $createdMenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu');
          $addBtn.removeClass('is-loading');
          _this2.positionMenu($createdMenu, $addBtn);
          return setTimeout(function () {
            _this2.showMenuElement($createdMenu);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-emoji-menu-search').focus();
          }, 200);
        });
      }

      $thumbsBtn.toggleClass('disabled', $userAuthored);
      $thumbsBtn.prop('disabled', $userAuthored);
    }

    // Create the emoji menu with the first category of emojis.
    // Then render the remaining categories of emojis one by one to avoid jank.

  }, {
    key: 'createEmojiMenu',
    value: function createEmojiMenu(callback) {
      if (this.isCreatingEmojiMenu) {
        return;
      }
      this.isCreatingEmojiMenu = true;

      // Render the first category
      var categoryMap = this.emoji.getEmojiCategoryMap();
      var categoryNameKey = Object.keys(categoryMap)[0];
      var emojisInCategory = categoryMap[categoryNameKey];
      var firstCategory = this.renderCategory(categoryLabelMap[categoryNameKey], emojisInCategory);

      // Render the frequently used
      var frequentlyUsedEmojis = this.getFrequentlyUsedEmojis();
      var frequentlyUsedCatgegory = '';
      if (frequentlyUsedEmojis.length > 0) {
        frequentlyUsedCatgegory = this.renderCategory('Frequently used', frequentlyUsedEmojis, {
          menuListClass: 'frequent-emojis'
        });
      }

      var emojiMenuMarkup = '\n      <div class="emoji-menu">\n        <input type="text" name="emoji-menu-search" value="" class="js-emoji-menu-search emoji-search search-input form-control" placeholder="Search emoji" />\n\n        <div class="emoji-menu-content">\n          ' + frequentlyUsedCatgegory + '\n          ' + firstCategory + '\n        </div>\n      </div>\n    ';

      document.body.insertAdjacentHTML('beforeend', emojiMenuMarkup);

      this.addRemainingEmojiMenuCategories();
      this.setupSearch();
      if (callback) {
        callback();
      }
    }
  }, {
    key: 'addRemainingEmojiMenuCategories',
    value: function addRemainingEmojiMenuCategories() {
      var _this3 = this;

      if (this.isAddingRemainingEmojiMenuCategories) {
        return;
      }
      this.isAddingRemainingEmojiMenuCategories = true;

      var categoryMap = this.emoji.getEmojiCategoryMap();

      // Avoid the jank and render the remaining categories separately
      // This will take more time, but makes UI more responsive
      var menu = document.querySelector('.emoji-menu');
      var emojiContentElement = menu.querySelector('.emoji-menu-content');
      var remainingCategories = Object.keys(categoryMap).slice(1);
      var allCategoriesAddedPromise = remainingCategories.reduce(function (promiseChain, categoryNameKey) {
        return promiseChain.then(function () {
          return new Promise(function (resolve) {
            var emojisInCategory = categoryMap[categoryNameKey];
            var categoryMarkup = _this3.renderCategory(categoryLabelMap[categoryNameKey], emojisInCategory);
            requestAnimationFrame(function () {
              emojiContentElement.insertAdjacentHTML('beforeend', categoryMarkup);
              resolve();
            });
          });
        });
      }, Promise.resolve());

      allCategoriesAddedPromise.then(function () {
        // Used for tests
        // We check for the menu in case it was destroyed in the meantime
        if (menu) {
          menu.dispatchEvent(new CustomEvent('build-emoji-menu-finish'));
        }
      }).catch(function (err) {
        emojiContentElement.insertAdjacentHTML('beforeend', '<p>We encountered an error while adding the remaining categories</p>');
        throw new Error('Error occurred in addRemainingEmojiMenuCategories: ' + err.message);
      });
    }
  }, {
    key: 'renderCategory',
    value: function renderCategory(name, emojiList) {
      var _this4 = this;

      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return '\n      <h5 class="emoji-menu-title">\n        ' + name + '\n      </h5>\n      <ul class="clearfix emoji-menu-list ' + (opts.menuListClass || '') + '">\n        ' + emojiList.map(function (emojiName) {
        return '\n          <li class="emoji-menu-list-item">\n            <button class="emoji-menu-btn text-center js-emoji-btn" type="button">\n              ' + _this4.emoji.glEmojiTag(emojiName, {
          sprite: true
        }) + '\n            </button>\n          </li>\n        ';
      }).join('\n') + '\n      </ul>\n    ';
    }
  }, {
    key: 'positionMenu',
    value: function positionMenu($menu, $addBtn) {
      var position = $addBtn.data('position');
      // The menu could potentially be off-screen or in a hidden overflow element
      // So we position the element absolute in the body
      var css = {
        top: $addBtn.offset().top + $addBtn.outerHeight() + 'px'
      };
      if (position === 'right') {
        css.left = $addBtn.offset().left - $menu.outerWidth() + 20 + 'px';
        $menu.addClass('is-aligned-right');
      } else {
        css.left = $addBtn.offset().left + 'px';
        $menu.removeClass('is-aligned-right');
      }
      return $menu.css(css);
    }
  }, {
    key: 'addAward',
    value: function addAward(votesBlock, awardUrl, emoji, checkMutuality, callback) {
      var _this5 = this;

      var isMainAwardsBlock = votesBlock.closest('.js-noteable-awards').length;

      if (Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_dom_utils__["b" /* isInVueNoteablePage */])() && !isMainAwardsBlock) {
        var id = votesBlock.attr('id').replace('note_', '');

        this.hideMenuElement(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu'));

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-award.is-active').removeClass('is-active');
        var toggleAwardEvent = new CustomEvent('toggleAward', {
          detail: {
            awardName: emoji,
            noteId: id
          }
        });

        document.querySelector('.js-vue-notes-event').dispatchEvent(toggleAwardEvent);
      }

      var normalizedEmoji = this.emoji.normalizeEmojiName(emoji);
      var $emojiButton = this.findEmojiIcon(votesBlock, normalizedEmoji).parent();

      this.postEmoji($emojiButton, awardUrl, normalizedEmoji, function () {
        _this5.addAwardToEmojiBar(votesBlock, normalizedEmoji, checkMutuality);
        return typeof callback === 'function' ? callback() : undefined;
      });

      this.hideMenuElement(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu'));

      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-award.is-active').removeClass('is-active');
    }
  }, {
    key: 'addAwardToEmojiBar',
    value: function addAwardToEmojiBar(votesBlock, emoji, checkForMutuality) {
      if (checkForMutuality || checkForMutuality === null) {
        this.checkMutuality(votesBlock, emoji);
      }
      this.addEmojiToFrequentlyUsedList(emoji);
      var normalizedEmoji = this.emoji.normalizeEmojiName(emoji);
      var $emojiButton = this.findEmojiIcon(votesBlock, normalizedEmoji).parent();
      if ($emojiButton.length > 0) {
        if (this.isActive($emojiButton)) {
          this.decrementCounter($emojiButton, normalizedEmoji);
        } else {
          var counter = $emojiButton.find('.js-counter');
          counter.text(parseInt(counter.text(), 10) + 1);
          $emojiButton.addClass('active');
          this.addYouToUserList(votesBlock, normalizedEmoji);
          this.animateEmoji($emojiButton);
        }
      } else {
        votesBlock.removeClass('hidden');
        this.createEmoji(votesBlock, normalizedEmoji);
      }
    }
  }, {
    key: 'getVotesBlock',
    value: function getVotesBlock() {
      if (Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_dom_utils__["b" /* isInVueNoteablePage */])()) {
        var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-award.is-active').closest('.note.timeline-entry');

        if ($el.length) {
          return $el;
        }
      }

      var currentBlock = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-awards-block.current');
      var resultantVotesBlock = currentBlock;
      if (currentBlock.length === 0) {
        resultantVotesBlock = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-awards-block').eq(0);
      }

      return resultantVotesBlock;
    }
  }, {
    key: 'getAwardUrl',
    value: function getAwardUrl() {
      return this.getVotesBlock().data('awardUrl');
    }
  }, {
    key: 'checkMutuality',
    value: function checkMutuality(votesBlock, emoji) {
      var awardUrl = this.getAwardUrl();
      if (emoji === 'thumbsup' || emoji === 'thumbsdown') {
        var mutualVote = emoji === 'thumbsup' ? 'thumbsdown' : 'thumbsup';
        var $emojiButton = votesBlock.find('[data-name="' + mutualVote + '"]').parent();
        var isAlreadyVoted = $emojiButton.hasClass('active');
        if (isAlreadyVoted) {
          this.addAward(votesBlock, awardUrl, mutualVote, false);
        }
      }
    }
  }, {
    key: 'isActive',
    value: function isActive($emojiButton) {
      return $emojiButton.hasClass('active');
    }
  }, {
    key: 'isUserAuthored',
    value: function isUserAuthored($button) {
      return $button.hasClass('js-user-authored');
    }
  }, {
    key: 'decrementCounter',
    value: function decrementCounter($emojiButton, emoji) {
      var counter = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-counter', $emojiButton);
      var counterNumber = parseInt(counter.text(), 10);
      if (counterNumber > 1) {
        counter.text(counterNumber - 1);
        this.removeYouFromUserList($emojiButton);
      } else if (emoji === 'thumbsup' || emoji === 'thumbsdown') {
        $emojiButton.tooltip('destroy');
        counter.text('0');
        this.removeYouFromUserList($emojiButton);
        if ($emojiButton.parents('.note').length) {
          this.removeEmoji($emojiButton);
        }
      } else {
        this.removeEmoji($emojiButton);
      }
      return $emojiButton.removeClass('active');
    }
  }, {
    key: 'removeEmoji',
    value: function removeEmoji($emojiButton) {
      $emojiButton.tooltip('destroy');
      $emojiButton.remove();
      var $votesBlock = this.getVotesBlock();
      if ($votesBlock.find('.js-emoji-btn').length === 0) {
        $votesBlock.addClass('hidden');
      }
    }
  }, {
    key: 'getAwardTooltip',
    value: function getAwardTooltip($awardBlock) {
      return $awardBlock.attr('data-original-title') || $awardBlock.attr('data-title') || '';
    }
  }, {
    key: 'toSentence',
    value: function toSentence(list) {
      var sentence = void 0;
      if (list.length <= 2) {
        sentence = list.join(' and ');
      } else {
        sentence = list.slice(0, -1).join(', ') + ', and ' + list[list.length - 1];
      }

      return sentence;
    }
  }, {
    key: 'removeYouFromUserList',
    value: function removeYouFromUserList($emojiButton) {
      var awardBlock = $emojiButton;
      var originalTitle = this.getAwardTooltip(awardBlock);
      var authors = originalTitle.split(FROM_SENTENCE_REGEX);
      authors.splice(authors.indexOf('You'), 1);
      return awardBlock.closest('.js-emoji-btn').removeData('title').removeAttr('data-title').removeAttr('data-original-title').attr('title', this.toSentence(authors)).tooltip('fixTitle');
    }
  }, {
    key: 'addYouToUserList',
    value: function addYouToUserList(votesBlock, emoji) {
      var awardBlock = this.findEmojiIcon(votesBlock, emoji).parent();
      var origTitle = this.getAwardTooltip(awardBlock);
      var users = [];
      if (origTitle) {
        users = origTitle.trim().split(FROM_SENTENCE_REGEX);
      }
      users.unshift('You');
      return awardBlock.attr('title', this.toSentence(users)).tooltip('fixTitle');
    }
  }, {
    key: 'createAwardButtonForVotesBlock',
    value: function createAwardButtonForVotesBlock(votesBlock, emojiName) {
      var buttonHtml = '\n      <button class="btn award-control js-emoji-btn has-tooltip active" title="You" data-placement="bottom">\n        ' + this.emoji.glEmojiTag(emojiName) + '\n        <span class="award-control-text js-counter">1</span>\n      </button>\n    ';
      var $emojiButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(buttonHtml);
      $emojiButton.insertBefore(votesBlock.find('.js-award-holder')).find('.emoji-icon').data('name', emojiName);
      this.animateEmoji($emojiButton);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.award-control').tooltip();
      votesBlock.removeClass('current');
    }
  }, {
    key: 'animateEmoji',
    value: function animateEmoji($emoji) {
      var className = 'pulse animated once short';
      $emoji.addClass(className);

      this.registerEventListener('on', $emoji, animationEndEventString, function (e) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget).removeClass(className);
      });
    }
  }, {
    key: 'createEmoji',
    value: function createEmoji(votesBlock, emoji) {
      var _this6 = this;

      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu').length) {
        this.createAwardButtonForVotesBlock(votesBlock, emoji);
      }
      this.createEmojiMenu(function () {
        _this6.createAwardButtonForVotesBlock(votesBlock, emoji);
      });
    }
  }, {
    key: 'postEmoji',
    value: function postEmoji($emojiButton, awardUrl, emoji, callback) {
      if (this.isUserAuthored($emojiButton)) {
        this.userAuthored($emojiButton);
      } else {
        __WEBPACK_IMPORTED_MODULE_7__lib_utils_axios_utils__["a" /* default */].post(awardUrl, {
          name: emoji
        }).then(function (_ref) {
          var data = _ref.data;

          if (data.ok) {
            callback();
          }
        }).catch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__locale__["a" /* __ */])('Something went wrong on our end.'));
        });
      }
    }
  }, {
    key: 'findEmojiIcon',
    value: function findEmojiIcon(votesBlock, emoji) {
      return votesBlock.find('.js-emoji-btn [data-name="' + emoji + '"]');
    }
  }, {
    key: 'userAuthored',
    value: function userAuthored($emojiButton) {
      var oldTitle = this.getAwardTooltip($emojiButton);
      var newTitle = 'You cannot vote on your own issue, MR and note';
      Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_common_utils__["J" /* updateTooltipTitle */])($emojiButton, newTitle).tooltip('show');
      // Restore tooltip back to award list
      return setTimeout(function () {
        $emojiButton.tooltip('hide');
        Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_common_utils__["J" /* updateTooltipTitle */])($emojiButton, oldTitle);
      }, 2800);
    }
  }, {
    key: 'scrollToAwards',
    value: function scrollToAwards() {
      var options = {
        scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.awards').offset().top - 110
      };
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body, html').animate(options, 200);
    }
  }, {
    key: 'addEmojiToFrequentlyUsedList',
    value: function addEmojiToFrequentlyUsedList(emoji) {
      if (this.emoji.isEmojiNameValid(emoji)) {
        this.frequentlyUsedEmojis = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.uniq(this.getFrequentlyUsedEmojis().concat(emoji));
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('frequently_used_emojis', this.frequentlyUsedEmojis.join(','), { expires: 365 });
      }
    }
  }, {
    key: 'getFrequentlyUsedEmojis',
    value: function getFrequentlyUsedEmojis() {
      var _this7 = this;

      return this.frequentlyUsedEmojis || function () {
        var frequentlyUsedEmojis = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.uniq((__WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.get('frequently_used_emojis') || '').split(','));
        _this7.frequentlyUsedEmojis = frequentlyUsedEmojis.filter(function (inputName) {
          return _this7.emoji.isEmojiNameValid(inputName);
        });

        return _this7.frequentlyUsedEmojis;
      }();
    }
  }, {
    key: 'setupSearch',
    value: function setupSearch() {
      var _this8 = this;

      var $search = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-emoji-menu-search');

      this.registerEventListener('on', $search, 'input', function (e) {
        var term = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).val().trim();
        _this8.searchEmojis(term);
      });

      var $menu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu');
      this.registerEventListener('on', $menu, transitionEndEventString, function (e) {
        if (e.target === e.currentTarget) {
          // Clear the search
          _this8.searchEmojis('');
        }
      });
    }
  }, {
    key: 'searchEmojis',
    value: function searchEmojis(term) {
      var $search = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-emoji-menu-search');
      $search.val(term);

      // Clean previous search results
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('ul.emoji-menu-search, h5.emoji-search-title').remove();
      if (term.length > 0) {
        // Generate a search result block
        var h5 = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<h5 class="emoji-search-title"/>').text('Search results');
        var foundEmojis = this.findMatchingEmojiElements(term).show();
        var ul = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<ul>').addClass('emoji-menu-list emoji-menu-search').append(foundEmojis);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu-content ul, .emoji-menu-content h5').hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu-content').append(h5).append(ul);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu-content').children().show();
      }
    }
  }, {
    key: 'findMatchingEmojiElements',
    value: function findMatchingEmojiElements(query) {
      var emojiMatches = this.emoji.filterEmojiNamesByAlias(query);
      var $emojiElements = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu-list:not(.frequent-emojis) [data-name]');
      var $matchingElements = $emojiElements.filter(function (i, elm) {
        return emojiMatches.indexOf(elm.dataset.name) >= 0;
      });
      return $matchingElements.closest('li').clone();
    }

    /* showMenuElement and hideMenuElement are performance optimizations. We use
     * opacity to show/hide the emoji menu, because we can animate it. But opacity
     * leaves hidden elements in the render tree, which is unacceptable given the number
     * of emoji elements in the emoji menu (5k+). To get the best of both worlds, we separately
     * apply IS_RENDERED to add/remove the menu from the render tree and IS_VISIBLE to animate
     * the menu being opened and closed. */

  }, {
    key: 'showMenuElement',
    value: function showMenuElement($emojiMenu) {
      $emojiMenu.addClass(IS_RENDERED);

      // enqueues animation as a microtask, so it begins ASAP once IS_RENDERED added
      return Promise.resolve().then(function () {
        return $emojiMenu.addClass(IS_VISIBLE);
      });
    }
  }, {
    key: 'hideMenuElement',
    value: function hideMenuElement($emojiMenu) {
      $emojiMenu.on(transitionEndEventString, function (e) {
        if (e.currentTarget === e.target) {
          $emojiMenu.removeClass(IS_RENDERED).off(transitionEndEventString);
        }
      });

      $emojiMenu.removeClass(IS_VISIBLE);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.eventListeners.forEach(function (entry) {
        var _entry$element$off;

        (_entry$element$off = entry.element.off).call.apply(_entry$element$off, [entry.element].concat(_toConsumableArray(entry.args)));
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.emoji-menu').remove();
    }
  }]);

  return AwardsHandler;
}();

var awardsHandlerPromise = null;
function loadAwardsHandler() {
  var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!awardsHandlerPromise || reload) {
    awardsHandlerPromise = __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (Emoji) {
      return new AwardsHandler(Emoji);
    });
  }
  return awardsHandlerPromise;
}

/***/ }),

/***/ "./behaviors/bind_in_out.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BindInOut = function () {
  function BindInOut(bindIn, bindOut) {
    _classCallCheck(this, BindInOut);

    this.in = bindIn;
    this.out = bindOut;

    this.eventWrapper = {};
    this.eventType = /(INPUT|TEXTAREA)/.test(bindIn.tagName) ? 'keyup' : 'change';
  }

  _createClass(BindInOut, [{
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.updateOut = this.updateOut.bind(this);

      this.in.addEventListener(this.eventType, this.eventWrapper.updateOut);

      return this;
    }
  }, {
    key: 'updateOut',
    value: function updateOut() {
      this.out.textContent = this.in.value;

      return this;
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.in.removeEventListener(this.eventType, this.eventWrapper.updateOut);

      return this;
    }
  }], [{
    key: 'initAll',
    value: function initAll() {
      var ins = document.querySelectorAll('*[data-bind-in]');

      return [].map.call(ins, function (anIn) {
        return BindInOut.init(anIn);
      });
    }
  }, {
    key: 'init',
    value: function init(anIn, anOut) {
      var out = anOut || document.querySelector('*[data-bind-out="' + anIn.dataset.bindIn + '"]');

      if (!out) return null;

      var bindInOut = new BindInOut(anIn, out);

      return bindInOut.addEvents().updateOut();
    }
  }]);

  return BindInOut;
}();

/* harmony default export */ __webpack_exports__["a"] = (BindInOut);

/***/ }),

/***/ "./behaviors/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("../../../node_modules/autosize/dist/autosize.js");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./behaviors/autosize.js


document.addEventListener('DOMContentLoaded', function () {
  var autosizeEls = document.querySelectorAll('.js-autosize');

  autosize_default()(autosizeEls);
  autosize_default.a.update(autosizeEls);
});
// EXTERNAL MODULE: ./behaviors/bind_in_out.js
var bind_in_out = __webpack_require__("./behaviors/bind_in_out.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./syntax_highlight.js
var syntax_highlight = __webpack_require__("./syntax_highlight.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// CONCATENATED MODULE: ./behaviors/markdown/render_math.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





// Renders math using KaTeX in any element with the
// `js-render-math` class
//
// ### Example Markup
//
//   <code class="js-render-math"></div>
//

// Loop over all math elements and render math
function renderWithKaTeX(elements, katex) {
  elements.each(function katexElementsLoop() {
    var mathNode = jquery_default()('<span></span>');
    var $this = jquery_default()(this);

    var display = $this.attr('data-math-style') === 'display';
    try {
      katex.render($this.text(), mathNode.get(0), { displayMode: display, throwOnError: false });
      mathNode.insertAfter($this);
      $this.remove();
    } catch (err) {
      throw err;
    }
  });
}

function renderMath($els) {
  if (!$els.length) return;
  Promise.all([__webpack_require__.e/* import() */("katex").then(__webpack_require__.bind(null, "../../../node_modules/katex/dist/katex.js")), __webpack_require__.e/* import() */("katex").then(__webpack_require__.bind(null, "../../../node_modules/katex/dist/katex.min.css"))]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        katex = _ref2[0];

    renderWithKaTeX($els, katex);
  }).catch(function () {
    return Object(flash["a" /* default */])(Object(locale["a" /* __ */])('An error occurred while rendering KaTeX'));
  });
}
// CONCATENATED MODULE: ./behaviors/markdown/render_mermaid.js


// Renders diagrams and flowcharts from text using Mermaid in any element with the
// `js-render-mermaid` class.
//
// Example markup:
//
// <pre class="js-render-mermaid">
//  graph TD;
//    A-- > B;
//    A-- > C;
//    B-- > D;
//    C-- > D;
// </pre>
//

function renderMermaid($els) {
  if (!$els.length) return;

  __webpack_require__.e/* import() */("mermaid").then(__webpack_require__.bind(null, "../../../node_modules/blackst0ne-mermaid/dist/mermaid.core.js")).then(function (mermaid) {
    mermaid.initialize({
      // mermaid core options
      mermaid: {
        startOnLoad: false
      },
      // mermaidAPI options
      theme: 'neutral'
    });

    $els.each(function (i, el) {
      var source = el.textContent;

      // Remove any extra spans added by the backend syntax highlighting.
      Object.assign(el, { textContent: source });

      mermaid.init(undefined, el, function (id) {
        var svg = document.getElementById(id);

        svg.classList.add('mermaid');

        // pre > code > svg
        svg.closest('pre').replaceWith(svg);

        // We need to add the original source into the DOM to allow Copy-as-GFM
        // to access it.
        var sourceEl = document.createElement('text');
        sourceEl.classList.add('source');
        sourceEl.setAttribute('display', 'none');
        sourceEl.textContent = source;

        svg.appendChild(sourceEl);
      });
    });
  }).catch(function (err) {
    Object(flash["a" /* default */])('Can\'t load mermaid module: ' + err);
  });
}
// CONCATENATED MODULE: ./behaviors/markdown/render_gfm.js





// Render Gitlab flavoured Markdown
//
// Delegates to syntax highlight and render math & mermaid diagrams.
//
jquery_default.a.fn.renderGFM = function renderGFM() {
  Object(syntax_highlight["a" /* default */])(this.find('.js-syntax-highlight'));
  renderMath(this.find('.js-render-math'));
  renderMermaid(this.find('.js-render-mermaid'));
  return this;
};

jquery_default()(function () {
  return jquery_default()('body').renderGFM();
});
// EXTERNAL MODULE: ./behaviors/markdown/copy_as_gfm.js
var copy_as_gfm = __webpack_require__("./behaviors/markdown/copy_as_gfm.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/clipboard/lib/clipboard.js
var lib_clipboard = __webpack_require__("../../../node_modules/clipboard/lib/clipboard.js");
var clipboard_default = /*#__PURE__*/__webpack_require__.n(lib_clipboard);

// CONCATENATED MODULE: ./behaviors/copy_to_clipboard.js



function showTooltip(target, title) {
  var $target = jquery_default()(target);
  var originalTitle = $target.data('originalTitle');

  if (!$target.data('hideTooltip')) {
    $target.attr('title', title).tooltip('fixTitle').tooltip('show').attr('title', originalTitle).tooltip('fixTitle');
  }
}

function genericSuccess(e) {
  showTooltip(e.trigger, 'Copied');
  // Clear the selection and blur the trigger so it loses its border
  e.clearSelection();
  jquery_default()(e.trigger).blur();
}

/**
 * Safari > 10 doesn't support `execCommand`, so instead we inform the user to copy manually.
 * See http://clipboardjs.com/#browser-support
 */
function genericError(e) {
  var key = void 0;
  if (/Mac/i.test(navigator.userAgent)) {
    key = '&#8984;'; // Command
  } else {
    key = 'Ctrl';
  }
  showTooltip(e.trigger, 'Press ' + key + '-C to copy');
}

function initCopyToClipboard() {
  var clipboard = new clipboard_default.a('[data-clipboard-target], [data-clipboard-text]');
  clipboard.on('success', genericSuccess);
  clipboard.on('error', genericError);

  /**
   * This a workaround around ClipboardJS limitations to allow the context-specific copy/pasting
   * of plain text or GFM. The Ruby `clipboard_button` helper sneaks a JSON hash with `text` and
   * `gfm` keys into the `data-clipboard-text` attribute that ClipboardJS reads from.
   * When ClipboardJS creates a new `textarea` (directly inside `body`, with a `readonly`
   * attribute`), sets its value to the value of this data attribute, focusses on it, and finally
   * programmatically issues the 'Copy' command, this code intercepts the copy command/event at
   * the last minute to deconstruct this JSON hash and set the `text/plain` and `text/x-gfm` copy
   * data types to the intended values.
   */
  jquery_default()(document).on('copy', 'body > textarea[readonly]', function (e) {
    var clipboardData = e.originalEvent.clipboardData;
    if (!clipboardData) return;

    var text = e.target.value;

    var json = void 0;
    try {
      json = JSON.parse(text);
    } catch (ex) {
      return;
    }

    if (!json.text || !json.gfm) return;

    e.preventDefault();

    clipboardData.setData('text/plain', json.text);
    clipboardData.setData('text/x-gfm', json.gfm);
  });
}
// CONCATENATED MODULE: ./behaviors/details_behavior.js


jquery_default()(function () {
  jquery_default()('body').on('click', '.js-details-target', function target() {
    jquery_default()(this).closest('.js-details-container').toggleClass('open');
  });

  // Show details content. Hides link after click.
  //
  // %div
  //   %a.js-details-expand
  //   %div.js-details-content
  //
  jquery_default()('body').on('click', '.js-details-expand', function expand(e) {
    e.preventDefault();
    jquery_default()(this).next('.js-details-content').removeClass('hide');
    jquery_default()(this).hide();

    var truncatedItem = jquery_default()(this).siblings('.js-details-short');
    if (truncatedItem.length) {
      truncatedItem.addClass('hide');
    }
  });
});
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/document-register-element/build/document-register-element.node.js
var document_register_element_node = __webpack_require__("../../../node_modules/document-register-element/build/document-register-element.node.js");
var document_register_element_node_default = /*#__PURE__*/__webpack_require__.n(document_register_element_node);

// CONCATENATED MODULE: ./emoji/support/is_emoji_unicode_supported.js
// On Windows, flags render as two-letter country codes, see http://emojipedia.org/flags/
var flagACodePoint = 127462; // parseInt('1F1E6', 16)
var flagZCodePoint = 127487; // parseInt('1F1FF', 16)
function isFlagEmoji(emojiUnicode) {
  var cp = emojiUnicode.codePointAt(0);
  // Length 4 because flags are made of 2 characters which are surrogate pairs
  return emojiUnicode.length === 4 && cp >= flagACodePoint && cp <= flagZCodePoint;
}

// Tested on mac OS 10.12.6 and Windows 10 FCU, it renders as two separate characters
var baseFlagCodePoint = 127987; // parseInt('1F3F3', 16)
var rainbowCodePoint = 127752; // parseInt('1F308', 16)
function isRainbowFlagEmoji(emojiUnicode) {
  var characters = Array.from(emojiUnicode);
  // Length 4 because flags are made of 2 characters which are surrogate pairs
  return emojiUnicode.length === 4 && characters[0].codePointAt(0) === baseFlagCodePoint && characters[1].codePointAt(0) === rainbowCodePoint;
}

// Chrome <57 renders keycaps oddly
// See https://bugs.chromium.org/p/chromium/issues/detail?id=632294
// Same issue on Windows also fixed in Chrome 57, http://i.imgur.com/rQF7woO.png
function isKeycapEmoji(emojiUnicode) {
  return emojiUnicode.length === 3 && emojiUnicode[2] === '\u20E3';
}

// Check for a skin tone variation emoji which aren't always supported
var tone1 = 127995; // parseInt('1F3FB', 16)
var tone5 = 127999; // parseInt('1F3FF', 16)
function isSkinToneComboEmoji(emojiUnicode) {
  return emojiUnicode.length > 2 && Array.from(emojiUnicode).some(function (char) {
    var cp = char.codePointAt(0);
    return cp >= tone1 && cp <= tone5;
  });
}

// macOS supports most skin tone emoji's but
// doesn't support the skin tone versions of horse racing
var horseRacingCodePoint = 127943; // parseInt('1F3C7', 16)
function isHorceRacingSkinToneComboEmoji(emojiUnicode) {
  var firstCharacter = Array.from(emojiUnicode)[0];
  return firstCharacter && firstCharacter.codePointAt(0) === horseRacingCodePoint && isSkinToneComboEmoji(emojiUnicode);
}

// Check for `family_*`, `kiss_*`, `couple_*`
// For ex. Windows 8.1 Firefox 51.0.1, doesn't support these
var zwj = 8205; // parseInt('200D', 16)
var personStartCodePoint = 128102; // parseInt('1F466', 16)
var personEndCodePoint = 128105; // parseInt('1F469', 16)
function isPersonZwjEmoji(emojiUnicode) {
  var hasPersonEmoji = false;
  var hasZwj = false;
  Array.from(emojiUnicode).forEach(function (character) {
    var cp = character.codePointAt(0);
    if (cp === zwj) {
      hasZwj = true;
    } else if (cp >= personStartCodePoint && cp <= personEndCodePoint) {
      hasPersonEmoji = true;
    }
  });

  return hasPersonEmoji && hasZwj;
}

// Helper so we don't have to run `isFlagEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkFlagEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isFlagResult = isFlagEmoji(emojiUnicode);
  var isRainbowFlagResult = isRainbowFlagEmoji(emojiUnicode);
  return unicodeSupportMap.flag && isFlagResult || unicodeSupportMap.rainbowFlag && isRainbowFlagResult || !isFlagResult && !isRainbowFlagResult;
}

// Helper so we don't have to run `isSkinToneComboEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkSkinToneModifierSupport(unicodeSupportMap, emojiUnicode) {
  var isSkinToneResult = isSkinToneComboEmoji(emojiUnicode);
  return unicodeSupportMap.skinToneModifier && isSkinToneResult || !isSkinToneResult;
}

// Helper func so we don't have to run `isHorceRacingSkinToneComboEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkHorseRacingSkinToneComboEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isHorseRacingSkinToneResult = isHorceRacingSkinToneComboEmoji(emojiUnicode);
  return unicodeSupportMap.horseRacing && isHorseRacingSkinToneResult || !isHorseRacingSkinToneResult;
}

// Helper so we don't have to run `isPersonZwjEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkPersonEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isPersonZwjResult = isPersonZwjEmoji(emojiUnicode);
  return unicodeSupportMap.personZwj && isPersonZwjResult || !isPersonZwjResult;
}

// Takes in a support map and determines whether
// the given unicode emoji is supported on the platform.
//
// Combines all the edge case tests into a one-stop shop method
function isEmojiUnicodeSupported() {
  var unicodeSupportMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var emojiUnicode = arguments[1];
  var unicodeVersion = arguments[2];

  var isOlderThanChrome57 = unicodeSupportMap.meta && unicodeSupportMap.meta.isChrome && unicodeSupportMap.meta.chromeVersion < 57;

  // For comments about each scenario, see the comments above each individual respective function
  return unicodeSupportMap[unicodeVersion] && !(isOlderThanChrome57 && isKeycapEmoji(emojiUnicode)) && checkFlagEmojiSupport(unicodeSupportMap, emojiUnicode) && checkSkinToneModifierSupport(unicodeSupportMap, emojiUnicode) && checkHorseRacingSkinToneComboEmojiSupport(unicodeSupportMap, emojiUnicode) && checkPersonEmojiSupport(unicodeSupportMap, emojiUnicode);
}


// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./emoji/support/unicode_support_map.js


var GL_EMOJI_VERSION = '0.2.0';

var unicodeSupportTestMap = {
  // man, student (emojione does not have any of these yet), http://emojipedia.org/emoji-zwj-sequences/
  // occupationZwj: '\u{1F468}\u{200D}\u{1F393}',
  // woman, biking (emojione does not have any of these yet), http://emojipedia.org/emoji-zwj-sequences/
  // sexZwj: '\u{1F6B4}\u{200D}\u{2640}',
  // family_mwgb
  // Windows 8.1, Firefox 51.0.1 does not support `family_`, `kiss_`, `couple_`
  personZwj: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66',
  // horse_racing_tone5
  // Special case that is not supported on macOS 10.12 even though `skinToneModifier` succeeds
  horseRacing: '\uD83C\uDFC7\uD83C\uDFFF',
  // US flag, http://emojipedia.org/flags/
  flag: '\uD83C\uDDFA\uD83C\uDDF8',
  rainbowFlag: '\uD83C\uDFF3\uD83C\uDF08',
  // http://emojipedia.org/modifiers/
  skinToneModifier: [
  // spy_tone5
  '\uD83D\uDD75\uD83C\uDFFF',
  // person_with_ball_tone5
  '\u26F9\uD83C\uDFFF',
  // angel_tone5
  '\uD83D\uDC7C\uD83C\uDFFF'],
  // rofl, http://emojipedia.org/unicode-9.0/
  '9.0': '\uD83E\uDD23',
  // metal, http://emojipedia.org/unicode-8.0/
  '8.0': '\uD83E\uDD18',
  // spy, http://emojipedia.org/unicode-7.0/
  '7.0': '\uD83D\uDD75',
  // expressionless, http://emojipedia.org/unicode-6.1/
  6.1: '\uD83D\uDE11',
  // japanese_goblin, http://emojipedia.org/unicode-6.0/
  '6.0': '\uD83D\uDC7A',
  // sailboat, http://emojipedia.org/unicode-5.2/
  5.2: '\u26F5',
  // mahjong, http://emojipedia.org/unicode-5.1/
  5.1: '\uD83C\uDC04',
  // gear, http://emojipedia.org/unicode-4.1/
  4.1: '\u2699',
  // zap, http://emojipedia.org/unicode-4.0/
  '4.0': '\u26A1',
  // recycle, http://emojipedia.org/unicode-3.2/
  3.2: '\u267B',
  // information_source, http://emojipedia.org/unicode-3.0/
  '3.0': '\u2139',
  // heart, http://emojipedia.org/unicode-1.1/
  1.1: '\u2764'
};

function checkPixelInImageDataArray(pixelOffset, imageDataArray) {
  // `4 *` because RGBA
  var indexOffset = 4 * pixelOffset;
  var hasColor = imageDataArray[indexOffset + 0] || imageDataArray[indexOffset + 1] || imageDataArray[indexOffset + 2];
  var isVisible = imageDataArray[indexOffset + 3];
  // Check for some sort of color other than black
  if (hasColor && isVisible) {
    return true;
  }
  return false;
}

var chromeMatches = navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)\./);
var isChrome = chromeMatches && chromeMatches.length > 0;
var chromeVersion = chromeMatches && chromeMatches[1] && parseInt(chromeMatches[1], 10);

// We use 16px because mobile Safari (iOS 9.3) doesn't properly scale emojis :/
// See 32px, https://i.imgur.com/htY6Zym.png
// See 16px, https://i.imgur.com/FPPsIF8.png
var fontSize = 16;
function generateUnicodeSupportMap(testMap) {
  var testMapKeys = Object.keys(testMap);
  var numTestEntries = testMapKeys.reduce(function (list, testKey) {
    return list.concat(testMap[testKey]);
  }, []).length;

  var canvas = document.createElement('canvas');
  (window.gl || window).testEmojiUnicodeSupportMapCanvas = canvas;
  var ctx = canvas.getContext('2d');
  canvas.width = 2 * fontSize;
  canvas.height = numTestEntries * fontSize;
  ctx.fillStyle = '#000000';
  ctx.textBaseline = 'middle';
  ctx.font = fontSize + 'px "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
  // Write each emoji to the canvas vertically
  var writeIndex = 0;
  testMapKeys.forEach(function (testKey) {
    var testEntry = testMap[testKey];
    [].concat(testEntry).forEach(function (emojiUnicode) {
      ctx.fillText(emojiUnicode, 0, writeIndex * fontSize + fontSize / 2);
      writeIndex += 1;
    });
  });

  // Read from the canvas
  var resultMap = {};
  var readIndex = 0;
  testMapKeys.forEach(function (testKey) {
    var testEntry = testMap[testKey];
    // This needs to be a `reduce` instead of `every` because we need to
    // keep the `readIndex` in sync from the writes by running all entries
    var isTestSatisfied = [].concat(testEntry).reduce(function (isSatisfied) {
      // Sample along the vertical-middle for a couple of characters
      var imageData = ctx.getImageData(0, readIndex * fontSize + fontSize / 2, 2 * fontSize, 1).data;

      var isValidEmoji = false;
      for (var currentPixel = 0; currentPixel < 64; currentPixel += 1) {
        var isLookingAtFirstChar = currentPixel < fontSize;
        var isLookingAtSecondChar = currentPixel >= fontSize + fontSize / 2;
        // Check for the emoji somewhere along the row
        if (isLookingAtFirstChar && checkPixelInImageDataArray(currentPixel, imageData)) {
          isValidEmoji = true;

          // Check to see that nothing is rendered next to the first character
          // to ensure that the ZWJ sequence rendered as one piece
        } else if (isLookingAtSecondChar && checkPixelInImageDataArray(currentPixel, imageData)) {
          isValidEmoji = false;
          break;
        }
      }

      readIndex += 1;
      return isSatisfied && isValidEmoji;
    }, true);

    resultMap[testKey] = isTestSatisfied;
  });

  resultMap.meta = {
    isChrome: isChrome,
    chromeVersion: chromeVersion
  };

  return resultMap;
}

function getUnicodeSupportMap() {
  var isLocalStorageAvailable = accessor["a" /* default */].isLocalStorageAccessSafe();

  var glEmojiVersionFromCache = void 0;
  var userAgentFromCache = void 0;
  if (isLocalStorageAvailable) {
    glEmojiVersionFromCache = window.localStorage.getItem('gl-emoji-version');
    userAgentFromCache = window.localStorage.getItem('gl-emoji-user-agent');
  }

  var unicodeSupportMap = void 0;
  try {
    unicodeSupportMap = JSON.parse(window.localStorage.getItem('gl-emoji-unicode-support-map'));
  } catch (err) {
    // swallow
  }

  if (!unicodeSupportMap || glEmojiVersionFromCache !== GL_EMOJI_VERSION || userAgentFromCache !== navigator.userAgent) {
    unicodeSupportMap = generateUnicodeSupportMap(unicodeSupportTestMap);

    if (isLocalStorageAvailable) {
      window.localStorage.setItem('gl-emoji-version', GL_EMOJI_VERSION);
      window.localStorage.setItem('gl-emoji-user-agent', navigator.userAgent);
      window.localStorage.setItem('gl-emoji-unicode-support-map', JSON.stringify(unicodeSupportMap));
    }
  }

  return unicodeSupportMap;
}
// CONCATENATED MODULE: ./emoji/support/index.js



// cache browser support map between calls
var browserUnicodeSupportMap = void 0;

function isEmojiUnicodeSupportedByBrowser(emojiUnicode, unicodeVersion) {
  browserUnicodeSupportMap = browserUnicodeSupportMap || getUnicodeSupportMap();
  return isEmojiUnicodeSupported(browserUnicodeSupportMap, emojiUnicode, unicodeVersion);
}
// CONCATENATED MODULE: ./behaviors/gl_emoji.js



document_register_element_node_default()(window);

function installGlEmojiElement() {
  var GlEmojiElementProto = Object.create(HTMLElement.prototype);
  GlEmojiElementProto.createdCallback = function createdCallback() {
    var _this = this;

    var emojiUnicode = this.textContent.trim();
    var _dataset = this.dataset,
        name = _dataset.name,
        unicodeVersion = _dataset.unicodeVersion,
        fallbackSrc = _dataset.fallbackSrc,
        fallbackSpriteClass = _dataset.fallbackSpriteClass;


    var isEmojiUnicode = this.childNodes && Array.prototype.every.call(this.childNodes, function (childNode) {
      return childNode.nodeType === 3;
    });
    var hasImageFallback = fallbackSrc && fallbackSrc.length > 0;
    var hasCssSpriteFalback = fallbackSpriteClass && fallbackSpriteClass.length > 0;

    if (emojiUnicode && isEmojiUnicode && !isEmojiUnicodeSupportedByBrowser(emojiUnicode, unicodeVersion)) {
      // CSS sprite fallback takes precedence over image fallback
      if (hasCssSpriteFalback) {
        // IE 11 doesn't like adding multiple at once :(
        this.classList.add('emoji-icon');
        this.classList.add(fallbackSpriteClass);
      } else {
        __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (_ref) {
          var emojiImageTag = _ref.emojiImageTag,
              emojiFallbackImageSrc = _ref.emojiFallbackImageSrc;

          if (hasImageFallback) {
            _this.innerHTML = emojiImageTag(name, fallbackSrc);
          } else {
            var src = emojiFallbackImageSrc(name);
            _this.innerHTML = emojiImageTag(name, src);
          }
        }).catch(function () {
          // do nothing
        });
      }
    }
  };

  document.registerElement('gl-emoji', {
    prototype: GlEmojiElementProto
  });
}
// EXTERNAL MODULE: ./commons/bootstrap.js
var bootstrap = __webpack_require__("./commons/bootstrap.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: ./behaviors/quick_submit.js




// Quick Submit behavior
//
// When a child field of a form with a `js-quick-submit` class receives a
// "Meta+Enter" (Mac) or "Ctrl+Enter" (Linux/Windows) key combination, the form
// is submitted.
//
// ### Example Markup
//
//   <form action="/foo" class="js-quick-submit">
//     <input type="text" />
//     <textarea></textarea>
//     <input type="submit" value="Submit" />
//   </form>
//

function isMac() {
  return navigator.userAgent.match(/Macintosh/);
}

function keyCodeIs(e, keyCode) {
  if (e.originalEvent && e.originalEvent.repeat || e.repeat) {
    return false;
  }
  return e.keyCode === keyCode;
}

jquery_default()(document).on('keydown.quick_submit', '.js-quick-submit', function (e) {
  // Enter
  if (!keyCodeIs(e, 13)) {
    return;
  }

  var onlyMeta = e.metaKey && !e.altKey && !e.ctrlKey && !e.shiftKey;
  var onlyCtrl = e.ctrlKey && !e.altKey && !e.metaKey && !e.shiftKey;
  if (!onlyMeta && !onlyCtrl) {
    return;
  }

  e.preventDefault();
  var $form = jquery_default()(e.target).closest('form');
  var $submitButton = $form.find('input[type=submit], button[type=submit]').first();

  if (!$submitButton.prop('disabled')) {
    $submitButton.trigger('click', [e]);

    if (!Object(common_utils["s" /* isInIssuePage */])()) {
      $submitButton.disable();
    }
  }
});

// If the user tabs to a submit button on a `js-quick-submit` form, display a
// tooltip to let them know they could've used the hotkey
jquery_default()(document).on('keyup.quick_submit', '.js-quick-submit input[type=submit], .js-quick-submit button[type=submit]', function displayTooltip(e) {
  // Tab
  if (!keyCodeIs(e, 9)) {
    return;
  }

  var $this = jquery_default()(this);
  var title = isMac() ? 'You can also press &#8984;-Enter' : 'You can also press Ctrl-Enter';

  $this.tooltip({
    container: 'body',
    html: 'true',
    placement: 'auto top',
    title: title,
    trigger: 'manual'
  });
  $this.tooltip('show').one('blur click', function () {
    return $this.tooltip('hide');
  });
});
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./behaviors/requires_input.js




// Requires Input behavior
//
// When called on a form with input fields with the `required` attribute, the
// form's submit button will be disabled until all required fields have values.
//
// ### Example Markup
//
//   <form class="js-requires-input">
//     <input type="text" required="required">
//     <input type="submit" value="Submit">
//   </form>
//

jquery_default.a.fn.requiresInput = function requiresInput() {
  var $form = jquery_default()(this);
  var $button = jquery_default()('button[type=submit], input[type=submit]', $form);
  var fieldSelector = 'input[required=required], select[required=required], textarea[required=required]';

  function requireInput() {
    // Collect the input values of *all* required fields
    var values = underscore_default.a.map(jquery_default()(fieldSelector, $form), function (field) {
      return field.value;
    });

    // Disable the button if any required fields are empty
    if (values.length && underscore_default.a.any(values, underscore_default.a.isEmpty)) {
      $button.disable();
    } else {
      $button.enable();
    }
  }

  // Set initial button state
  requireInput();
  $form.on('change input', fieldSelector, requireInput);
};

// Hide or Show the help block when creating a new project
// based on the option selected
function hideOrShowHelpBlock(form) {
  var selected = jquery_default()('.js-select-namespace option:selected');
  if (selected.length && selected.data('optionsParent') === 'groups') {
    form.find('.help-block').hide();
  } else if (selected.length) {
    form.find('.help-block').show();
  }
}

jquery_default()(function () {
  var $form = jquery_default()('form.js-requires-input');
  if ($form) {
    $form.requiresInput();
    hideOrShowHelpBlock($form);
    jquery_default()('.select2.js-select-namespace').change(function () {
      return hideOrShowHelpBlock($form);
    });
  }
});
// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// CONCATENATED MODULE: ./behaviors/toggler_behavior.js



// Toggle button. Show/hide content inside parent container.
// Button does not change visibility. If button has icon - it changes chevron style.
//
// %div.js-toggle-container
//   %button.js-toggle-button
//   %div.js-toggle-content
//

jquery_default()(function () {
  function toggleContainer(container, toggleState) {
    var $container = jquery_default()(container);

    $container.find('.js-toggle-button .fa-chevron-up, .js-toggle-button .fa-chevron-down').toggleClass('fa-chevron-up', toggleState).toggleClass('fa-chevron-down', toggleState !== undefined ? !toggleState : undefined);

    $container.find('.js-toggle-content').toggle(toggleState);
  }

  jquery_default()('body').on('click', '.js-toggle-button', function toggleButton(e) {
    e.currentTarget.classList.toggle(e.currentTarget.dataset.toggleOpenClass || 'open');
    toggleContainer(jquery_default()(this).closest('.js-toggle-container'));

    var targetTag = e.currentTarget.tagName.toLowerCase();
    if (targetTag === 'a' || targetTag === 'button') {
      e.preventDefault();
    }
  });

  // If we're accessing a permalink, ensure it is not inside a
  // closed js-toggle-container!
  var hash = Object(url_utility["a" /* getLocationHash */])();
  var anchor = hash && document.getElementById(hash);
  var container = anchor && jquery_default()(anchor).closest('.js-toggle-container');

  if (container) {
    toggleContainer(container, true);
    anchor.scrollIntoView();
  }
});
// EXTERNAL MODULE: ./preview_markdown.js
var preview_markdown = __webpack_require__("./preview_markdown.js");

// CONCATENATED MODULE: ./behaviors/index.js












installGlEmojiElement();
Object(copy_as_gfm["b" /* default */])();
initCopyToClipboard();

/***/ }),

/***/ "./behaviors/markdown/copy_as_gfm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CopyAsGFM; });
/* harmony export (immutable) */ __webpack_exports__["b"] = initCopyAsGFM;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lazy_loader__ = __webpack_require__("./lazy_loader.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, object-shorthand, no-unused-vars, no-use-before-define, no-new, max-len, no-restricted-syntax, guard-for-in, no-continue */






var gfmRules = {
  // The filters referenced in lib/banzai/pipeline/gfm_pipeline.rb convert
  // GitLab Flavored Markdown (GFM) to HTML.
  // These handlers consequently convert that same HTML to GFM to be copied to the clipboard.
  // Every filter in lib/banzai/pipeline/gfm_pipeline.rb that generates HTML
  // from GFM should have a handler here, in reverse order.
  // The GFM-to-HTML-to-GFM cycle is tested in spec/features/copy_as_gfm_spec.rb.
  InlineDiffFilter: {
    'span.idiff.addition': function spanIdiffAddition(el, text) {
      return '{+' + text + '+}';
    },
    'span.idiff.deletion': function spanIdiffDeletion(el, text) {
      return '{-' + text + '-}';
    }
  },
  TaskListFilter: {
    'input[type=checkbox].task-list-item-checkbox': function inputTypeCheckboxTaskListItemCheckbox(el) {
      return '[' + (el.checked ? 'x' : ' ') + ']';
    }
  },
  ReferenceFilter: {
    '.tooltip': function tooltip(el) {
      return '';
    },
    'a.gfm:not([data-link=true])': function aGfmNotDataLinkTrue(el, text) {
      return el.dataset.original || text;
    }
  },
  AutolinkFilter: {
    'a': function a(el, text) {
      // Fallback on the regular MarkdownFilter's `a` handler.
      if (text !== el.getAttribute('href')) return false;

      return text;
    }
  },
  TableOfContentsFilter: {
    'ul.section-nav': function ulSectionNav(el) {
      return '[[_TOC_]]';
    }
  },
  EmojiFilter: {
    'img.emoji': function imgEmoji(el) {
      return el.getAttribute('alt');
    },
    'gl-emoji': function glEmoji(el) {
      return ':' + el.getAttribute('data-name') + ':';
    }
  },
  ImageLinkFilter: {
    'a.no-attachment-icon': function aNoAttachmentIcon(el, text) {
      return text;
    }
  },
  ImageLazyLoadFilter: {
    'img': function img(el, text) {
      return '![' + el.getAttribute('alt') + '](' + el.getAttribute('src') + ')';
    }
  },
  VideoLinkFilter: {
    '.video-container': function videoContainer(el) {
      var videoEl = el.querySelector('video');
      if (!videoEl) return false;

      return CopyAsGFM.nodeToGFM(videoEl);
    },
    'video': function video(el) {
      return '![' + el.dataset.title + '](' + el.getAttribute('src') + ')';
    }
  },
  MermaidFilter: {
    'svg.mermaid': function svgMermaid(el, text) {
      var sourceEl = el.querySelector('text.source');
      if (!sourceEl) return false;

      return '```mermaid\n' + CopyAsGFM.nodeToGFM(sourceEl) + '\n```';
    },
    'svg.mermaid style, svg.mermaid g': function svgMermaidStyleSvgMermaidG(el, text) {
      // We don't want to include the content of these elements in the copied text.
      return '';
    }
  },
  MathFilter: {
    'pre.code.math[data-math-style=display]': function preCodeMathDataMathStyleDisplay(el, text) {
      return '```math\n' + text.trim() + '\n```';
    },
    'code.code.math[data-math-style=inline]': function codeCodeMathDataMathStyleInline(el, text) {
      return '$`' + text + '`$';
    },
    'span.katex-display span.katex-mathml': function spanKatexDisplaySpanKatexMathml(el) {
      var mathAnnotation = el.querySelector('annotation[encoding="application/x-tex"]');
      if (!mathAnnotation) return false;

      return '```math\n' + CopyAsGFM.nodeToGFM(mathAnnotation) + '\n```';
    },
    'span.katex-mathml': function spanKatexMathml(el) {
      var mathAnnotation = el.querySelector('annotation[encoding="application/x-tex"]');
      if (!mathAnnotation) return false;

      return '$`' + CopyAsGFM.nodeToGFM(mathAnnotation) + '`$';
    },
    'span.katex-html': function spanKatexHtml(el) {
      // We don't want to include the content of this element in the copied text.
      return '';
    },
    'annotation[encoding="application/x-tex"]': function annotationEncodingApplicationXTex(el, text) {
      return text.trim();
    }
  },
  SanitizationFilter: {
    'a[name]:not([href]):empty': function aNameNotHrefEmpty(el) {
      return el.outerHTML;
    },
    'dl': function dl(el, text) {
      var lines = text.trim().split('\n');
      // Add two spaces to the front of subsequent list items lines,
      // or leave the line entirely blank.
      lines = lines.map(function (l) {
        var line = l.trim();
        if (line.length === 0) return '';

        return '  ' + line;
      });

      return '<dl>\n' + lines.join('\n') + '\n</dl>';
    },
    'sub, dt, dd, kbd, q, samp, var, ruby, rt, rp, abbr, summary, details': function subDtDdKbdQSampVarRubyRtRpAbbrSummaryDetails(el, text) {
      var tag = el.nodeName.toLowerCase();
      return '<' + tag + '>' + text + '</' + tag + '>';
    }
  },
  SyntaxHighlightFilter: {
    'pre.code.highlight': function preCodeHighlight(el, t) {
      var text = t.trimRight();

      var lang = el.getAttribute('lang');
      if (!lang || lang === 'plaintext') {
        lang = '';
      }

      // Prefixes lines with 4 spaces if the code contains triple backticks
      if (lang === '' && text.match(/^```/gm)) {
        return text.split('\n').map(function (l) {
          var line = l.trim();
          if (line.length === 0) return '';

          return '    ' + line;
        }).join('\n');
      }

      return '```' + lang + '\n' + text + '\n```';
    },
    'pre > code': function preCode(el, text) {
      // Don't wrap code blocks in ``
      return text;
    }
  },
  MarkdownFilter: {
    'br': function br(el) {
      // Two spaces at the end of a line are turned into a BR
      return '  ';
    },
    'code': function code(el, text) {
      var backtickCount = 1;
      var backtickMatch = text.match(/`+/);
      if (backtickMatch) {
        backtickCount = backtickMatch[0].length + 1;
      }

      var backticks = Array(backtickCount + 1).join('`');
      var spaceOrNoSpace = backtickCount > 1 ? ' ' : '';

      return backticks + spaceOrNoSpace + text.trim() + spaceOrNoSpace + backticks;
    },
    'blockquote': function blockquote(el, text) {
      return text.trim().split('\n').map(function (s) {
        return ('> ' + s).trim();
      }).join('\n');
    },
    'img': function img(el) {
      var imageSrc = el.src;
      var imageUrl = imageSrc && imageSrc !== __WEBPACK_IMPORTED_MODULE_3__lazy_loader__["b" /* placeholderImage */] ? imageSrc : el.dataset.src || '';
      return '![' + el.getAttribute('alt') + '](' + imageUrl + ')';
    },
    'a.anchor': function aAnchor(el, text) {
      // Don't render a Markdown link for the anchor link inside a heading
      return text;
    },
    'a': function a(el, text) {
      return '[' + text + '](' + el.getAttribute('href') + ')';
    },
    'li': function li(el, text) {
      var lines = text.trim().split('\n');
      var firstLine = '- ' + lines.shift();
      // Add four spaces to the front of subsequent list items lines,
      // or leave the line entirely blank.
      var nextLines = lines.map(function (s) {
        if (s.trim().length === 0) return '';

        return '    ' + s;
      });

      return firstLine + '\n' + nextLines.join('\n');
    },
    'ul': function ul(el, text) {
      return text;
    },
    'ol': function ol(el, text) {
      // LIs get a `- ` prefix by default, which we replace by `1. ` for ordered lists.
      return text.replace(/^- /mg, '1. ');
    },
    'h1': function h1(el, text) {
      return '# ' + text.trim();
    },
    'h2': function h2(el, text) {
      return '## ' + text.trim();
    },
    'h3': function h3(el, text) {
      return '### ' + text.trim();
    },
    'h4': function h4(el, text) {
      return '#### ' + text.trim();
    },
    'h5': function h5(el, text) {
      return '##### ' + text.trim();
    },
    'h6': function h6(el, text) {
      return '###### ' + text.trim();
    },
    'strong': function strong(el, text) {
      return '**' + text + '**';
    },
    'em': function em(el, text) {
      return '_' + text + '_';
    },
    'del': function del(el, text) {
      return '~~' + text + '~~';
    },
    'sup': function sup(el, text) {
      return '^' + text;
    },
    'hr': function hr(el) {
      return '-----';
    },
    'table': function table(el) {
      var theadEl = el.querySelector('thead');
      var tbodyEl = el.querySelector('tbody');
      if (!theadEl || !tbodyEl) return false;

      var theadText = CopyAsGFM.nodeToGFM(theadEl);
      var tbodyText = CopyAsGFM.nodeToGFM(tbodyEl);

      return [theadText, tbodyText].join('\n');
    },
    'thead': function thead(el, text) {
      var cells = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.map(el.querySelectorAll('th'), function (cell) {
        var chars = CopyAsGFM.nodeToGFM(cell).length + 2;

        var before = '';
        var after = '';
        switch (cell.style.textAlign) {
          case 'center':
            before = ':';
            after = ':';
            chars -= 2;
            break;
          case 'right':
            after = ':';
            chars -= 1;
            break;
          default:
            break;
        }

        chars = Math.max(chars, 3);

        var middle = Array(chars + 1).join('-');

        return before + middle + after;
      });

      var separatorRow = '|' + cells.join('|') + '|';

      return [text, separatorRow].join('\n');
    },
    'tr': function tr(el) {
      var cellEls = el.querySelectorAll('td, th');
      if (cellEls.length === 0) return false;

      var cells = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.map(cellEls, function (cell) {
        return CopyAsGFM.nodeToGFM(cell);
      });
      return '| ' + cells.join(' | ') + ' |';
    }
  }
};

var CopyAsGFM = function () {
  function CopyAsGFM() {
    _classCallCheck(this, CopyAsGFM);

    // iOS currently does not support clipboardData.setData(). This bug should
    // be fixed in iOS 12, but for now we'll disable this for all iOS browsers
    // ref: https://trac.webkit.org/changeset/222228/webkit
    var userAgent = typeof navigator !== 'undefined' && navigator.userAgent || '';
    var isIOS = /\b(iPad|iPhone|iPod)(?=;)/.test(userAgent);
    if (isIOS) return;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('copy', '.md, .wiki', function (e) {
      CopyAsGFM.copyAsGFM(e, CopyAsGFM.transformGFMSelection);
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('copy', 'pre.code.highlight, .diff-content .line_content', function (e) {
      CopyAsGFM.copyAsGFM(e, CopyAsGFM.transformCodeSelection);
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('paste', '.js-gfm-input', CopyAsGFM.pasteGFM);
  }

  _createClass(CopyAsGFM, null, [{
    key: 'copyAsGFM',
    value: function copyAsGFM(e, transformer) {
      var clipboardData = e.originalEvent.clipboardData;
      if (!clipboardData) return;

      var documentFragment = Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["k" /* getSelectedFragment */])();
      if (!documentFragment) return;

      var el = transformer(documentFragment.cloneNode(true), e.currentTarget);
      if (!el) return;

      e.preventDefault();
      e.stopPropagation();

      clipboardData.setData('text/plain', el.textContent);
      clipboardData.setData('text/x-gfm', this.nodeToGFM(el));
    }
  }, {
    key: 'pasteGFM',
    value: function pasteGFM(e) {
      var clipboardData = e.originalEvent.clipboardData;
      if (!clipboardData) return;

      var text = clipboardData.getData('text/plain');
      var gfm = clipboardData.getData('text/x-gfm');
      if (!gfm) return;

      e.preventDefault();

      window.gl.utils.insertText(e.target, function (textBefore, textAfter) {
        // If the text before the cursor contains an odd number of backticks,
        // we are either inside an inline code span that starts with 1 backtick
        // or a code block that starts with 3 backticks.
        // This logic still holds when there are one or more _closed_ code spans
        // or blocks that will have 2 or 6 backticks.
        // This will break down when the actual code block contains an uneven
        // number of backticks, but this is a rare edge case.
        var backtickMatch = textBefore.match(/`/g);
        var insideCodeBlock = backtickMatch && backtickMatch.length % 2 === 1;

        if (insideCodeBlock) {
          return text;
        }

        return gfm;
      });
    }
  }, {
    key: 'transformGFMSelection',
    value: function transformGFMSelection(documentFragment) {
      var gfmElements = documentFragment.querySelectorAll('.md, .wiki');
      switch (gfmElements.length) {
        case 0:
          {
            return documentFragment;
          }
        case 1:
          {
            return gfmElements[0];
          }
        default:
          {
            var allGfmElement = document.createElement('div');

            for (var i = 0; i < gfmElements.length; i += 1) {
              var gfmElement = gfmElements[i];
              allGfmElement.appendChild(gfmElement);
              allGfmElement.appendChild(document.createTextNode('\n\n'));
            }

            return allGfmElement;
          }
      }
    }
  }, {
    key: 'transformCodeSelection',
    value: function transformCodeSelection(documentFragment, target) {
      var lineSelector = '.line';

      if (target) {
        var lineClass = ['left-side', 'right-side'].filter(function (name) {
          return target.classList.contains(name);
        })[0];
        if (lineClass) {
          lineSelector = '.line_content.' + lineClass + ' ' + lineSelector;
        }
      }

      var lineElements = documentFragment.querySelectorAll(lineSelector);

      var codeElement = void 0;
      if (lineElements.length > 1) {
        codeElement = document.createElement('pre');
        codeElement.className = 'code highlight';

        var lang = lineElements[0].getAttribute('lang');
        if (lang) {
          codeElement.setAttribute('lang', lang);
        }
      } else {
        codeElement = document.createElement('code');
      }

      if (lineElements.length > 0) {
        for (var i = 0; i < lineElements.length; i += 1) {
          var lineElement = lineElements[i];
          codeElement.appendChild(lineElement);
          codeElement.appendChild(document.createTextNode('\n'));
        }
      } else {
        codeElement.appendChild(documentFragment);
      }

      return codeElement;
    }
  }, {
    key: 'nodeToGFM',
    value: function nodeToGFM(node) {
      var respectWhitespaceParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (node.nodeType === Node.COMMENT_NODE) {
        return '';
      }

      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
      }

      var respectWhitespace = respectWhitespaceParam || node.nodeName === 'PRE' || node.nodeName === 'CODE';

      var text = this.innerGFM(node, respectWhitespace);

      if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        return text;
      }

      for (var filter in gfmRules) {
        var rules = gfmRules[filter];

        for (var selector in rules) {
          var func = rules[selector];

          if (!Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_common_utils__["y" /* nodeMatchesSelector */])(node, selector)) continue;

          var result = void 0;
          if (func.length === 2) {
            // if `func` takes 2 arguments, it depends on text.
            // if there is no text, we don't need to generate GFM for this node.
            if (text.length === 0) continue;

            result = func(node, text);
          } else {
            result = func(node);
          }

          if (result === false) continue;

          return result;
        }
      }

      return text;
    }
  }, {
    key: 'innerGFM',
    value: function innerGFM(parentNode) {
      var respectWhitespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var nodes = parentNode.childNodes;

      var clonedParentNode = parentNode.cloneNode(true);
      var clonedNodes = Array.prototype.slice.call(clonedParentNode.childNodes, 0);

      for (var i = 0; i < nodes.length; i += 1) {
        var node = nodes[i];
        var clonedNode = clonedNodes[i];

        var text = this.nodeToGFM(node, respectWhitespace);

        // `clonedNode.replaceWith(text)` is not yet widely supported
        clonedNode.parentNode.replaceChild(document.createTextNode(text), clonedNode);
      }

      var nodeText = clonedParentNode.innerText || clonedParentNode.textContent;

      if (!respectWhitespace) {
        nodeText = nodeText.trim();
      }

      return nodeText;
    }
  }]);

  return CopyAsGFM;
}();

// Export CopyAsGFM as a global for rspec to access
// see /spec/features/copy_as_gfm_spec.rb
if (false) {
  window.CopyAsGFM = CopyAsGFM;
}

function initCopyAsGFM() {
  return new CopyAsGFM();
}

/***/ }),

/***/ "./breadcrumb.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addTooltipToEl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var addTooltipToEl = function addTooltipToEl(el) {
  var textEl = el.querySelector('.js-breadcrumb-item-text');

  if (textEl && textEl.scrollWidth > textEl.offsetWidth) {
    el.setAttribute('title', el.textContent);
    el.setAttribute('data-container', 'body');
    el.classList.add('has-tooltip');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var breadcrumbs = document.querySelector('.js-breadcrumbs-list');

  if (breadcrumbs) {
    var topLevelLinks = [].concat(_toConsumableArray(breadcrumbs.children)).filter(function (el) {
      return !el.classList.contains('dropdown');
    }).map(function (el) {
      return el.querySelector('a');
    }).filter(function (el) {
      return el;
    });
    var $expander = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-breadcrumbs-collapsed-expander');

    topLevelLinks.forEach(function (el) {
      return addTooltipToEl(el);
    });

    $expander.closest('.dropdown').on('show.bs.dropdown hide.bs.dropdown', function (e) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-breadcrumbs-collapsed-expander', e.currentTarget).toggleClass('open').tooltip('hide');
    });
  }
});

/***/ }),

/***/ "./breakpoints.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export breakpoints */
var breakpoints = {
  lg: 1200,
  md: 992,
  sm: 768,
  xs: 0
};

var BreakpointInstance = {
  windowWidth: function windowWidth() {
    return window.innerWidth;
  },
  getBreakpointSize: function getBreakpointSize() {
    var windowWidth = this.windowWidth();

    var breakpoint = Object.keys(breakpoints).find(function (key) {
      return windowWidth > breakpoints[key];
    });

    return breakpoint;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (BreakpointInstance);

/***/ }),

/***/ "./dispatcher.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./gfm_auto_complete.js + 1 modules
var gfm_auto_complete = __webpack_require__("./gfm_auto_complete.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./gl_field_errors.js + 1 modules
var gl_field_errors = __webpack_require__("./gl_field_errors.js");

// EXTERNAL MODULE: ./shortcuts.js
var shortcuts = __webpack_require__("./shortcuts.js");

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// EXTERNAL MODULE: ./filtered_search/dropdown_utils.js
var dropdown_utils = __webpack_require__("./filtered_search/dropdown_utils.js");

// CONCATENATED MODULE: ./search_autocomplete.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-return-assign, one-var, no-var, no-underscore-dangle, one-var-declaration-per-line, no-unused-vars, no-cond-assign, consistent-return, object-shorthand, prefer-arrow-callback, func-names, space-before-function-paren, prefer-template, quotes, class-methods-use-this, no-sequences, wrap-iife, no-lonely-if, no-else-return, no-param-reassign, vars-on-top, max-len */






/**
 * Search input in top navigation bar.
 * On click, opens a dropdown
 * As the user types it filters the results
 * When the user clicks `x` button it cleans the input and closes the dropdown.
 */

var KEYCODE = {
  ESCAPE: 27,
  BACKSPACE: 8,
  ENTER: 13,
  UP: 38,
  DOWN: 40
};

function setSearchOptions() {
  var $projectOptionsDataEl = jquery_default()('.js-search-project-options');
  var $groupOptionsDataEl = jquery_default()('.js-search-group-options');
  var $dashboardOptionsDataEl = jquery_default()('.js-search-dashboard-options');

  if ($projectOptionsDataEl.length) {
    gl.projectOptions = gl.projectOptions || {};

    var projectPath = $projectOptionsDataEl.data('projectPath');

    gl.projectOptions[projectPath] = {
      name: $projectOptionsDataEl.data('name'),
      issuesPath: $projectOptionsDataEl.data('issuesPath'),
      issuesDisabled: $projectOptionsDataEl.data('issuesDisabled'),
      mrPath: $projectOptionsDataEl.data('mrPath')
    };
  }

  if ($groupOptionsDataEl.length) {
    gl.groupOptions = gl.groupOptions || {};

    var groupPath = $groupOptionsDataEl.data('groupPath');

    gl.groupOptions[groupPath] = {
      name: $groupOptionsDataEl.data('name'),
      issuesPath: $groupOptionsDataEl.data('issuesPath'),
      mrPath: $groupOptionsDataEl.data('mrPath')
    };
  }

  if ($dashboardOptionsDataEl.length) {
    gl.dashboardOptions = {
      issuesPath: $dashboardOptionsDataEl.data('issuesPath'),
      mrPath: $dashboardOptionsDataEl.data('mrPath')
    };
  }
}

var search_autocomplete_SearchAutocomplete = function () {
  function SearchAutocomplete() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        wrap = _ref.wrap,
        optsEl = _ref.optsEl,
        autocompletePath = _ref.autocompletePath,
        projectId = _ref.projectId,
        projectRef = _ref.projectRef;

    _classCallCheck(this, SearchAutocomplete);

    setSearchOptions();
    this.bindEventContext();
    this.wrap = wrap || jquery_default()('.search');
    this.optsEl = optsEl || this.wrap.find('.search-autocomplete-opts');
    this.autocompletePath = autocompletePath || this.optsEl.data('autocompletePath');
    this.projectId = projectId || this.optsEl.data('autocompleteProjectId') || '';
    this.projectRef = projectRef || this.optsEl.data('autocompleteProjectRef') || '';
    this.dropdown = this.wrap.find('.dropdown');
    this.dropdownToggle = this.wrap.find('.js-dropdown-search-toggle');
    this.dropdownContent = this.dropdown.find('.dropdown-content');
    this.locationBadgeEl = this.getElement('.location-badge');
    this.scopeInputEl = this.getElement('#scope');
    this.searchInput = this.getElement('.search-input');
    this.projectInputEl = this.getElement('#search_project_id');
    this.groupInputEl = this.getElement('#group_id');
    this.searchCodeInputEl = this.getElement('#search_code');
    this.repositoryInputEl = this.getElement('#repository_ref');
    this.clearInput = this.getElement('.js-clear-input');
    this.saveOriginalState();

    // Only when user is logged in
    if (gon.current_user_id) {
      this.createAutocomplete();
    }

    this.searchInput.addClass('disabled');
    this.saveTextLength();
    this.bindEvents();
    this.dropdownToggle.dropdown();
  }

  // Finds an element inside wrapper element


  _createClass(SearchAutocomplete, [{
    key: 'bindEventContext',
    value: function bindEventContext() {
      this.onSearchInputBlur = this.onSearchInputBlur.bind(this);
      this.onClearInputClick = this.onClearInputClick.bind(this);
      this.onSearchInputFocus = this.onSearchInputFocus.bind(this);
      this.onSearchInputKeyUp = this.onSearchInputKeyUp.bind(this);
      this.onSearchInputKeyDown = this.onSearchInputKeyDown.bind(this);
    }
  }, {
    key: 'getElement',
    value: function getElement(selector) {
      return this.wrap.find(selector);
    }
  }, {
    key: 'saveOriginalState',
    value: function saveOriginalState() {
      return this.originalState = this.serializeState();
    }
  }, {
    key: 'saveTextLength',
    value: function saveTextLength() {
      return this.lastTextLength = this.searchInput.val().length;
    }
  }, {
    key: 'createAutocomplete',
    value: function createAutocomplete() {
      return this.searchInput.glDropdown({
        filterInputBlur: false,
        filterable: true,
        filterRemote: true,
        highlight: true,
        enterCallback: false,
        filterInput: 'input#search',
        search: {
          fields: ['text']
        },
        id: this.getSearchText,
        data: this.getData.bind(this),
        selectable: true,
        clicked: this.onClick.bind(this)
      });
    }
  }, {
    key: 'getSearchText',
    value: function getSearchText(selectedObject, el) {
      return selectedObject.id ? selectedObject.text : '';
    }
  }, {
    key: 'getData',
    value: function getData(term, callback) {
      var _this = this;

      if (!term) {
        var contents = this.getCategoryContents();
        if (contents) {
          this.searchInput.data('glDropdown').filter.options.callback(contents);
          this.enableAutocomplete();
        }
        return;
      }

      // Prevent multiple ajax calls
      if (this.loadingSuggestions) {
        return;
      }

      this.loadingSuggestions = true;

      return axios_utils["a" /* default */].get(this.autocompletePath, {
        params: {
          project_id: this.projectId,
          project_ref: this.projectRef,
          term: term
        }
      }).then(function (response) {
        // Hide dropdown menu if no suggestions returns
        if (!response.data.length) {
          _this.disableAutocomplete();
          return;
        }

        var data = [];
        // List results
        var firstCategory = true;
        var lastCategory = void 0;
        for (var i = 0, len = response.data.length; i < len; i += 1) {
          var suggestion = response.data[i];
          // Add group header before list each group
          if (lastCategory !== suggestion.category) {
            if (!firstCategory) {
              data.push('separator');
            }
            if (firstCategory) {
              firstCategory = false;
            }
            data.push({
              header: suggestion.category
            });
            lastCategory = suggestion.category;
          }
          data.push({
            id: suggestion.category.toLowerCase() + '-' + suggestion.id,
            category: suggestion.category,
            text: suggestion.label,
            url: suggestion.url
          });
        }
        // Add option to proceed with the search
        if (data.length) {
          data.push('separator');
          data.push({
            text: 'Result name contains "' + term + '"',
            url: '/search?search=' + term + '&project_id=' + _this.projectInputEl.val() + '&group_id=' + _this.groupInputEl.val()
          });
        }

        callback(data);

        _this.loadingSuggestions = false;
      }).catch(function () {
        _this.loadingSuggestions = false;
      });
    }
  }, {
    key: 'getCategoryContents',
    value: function getCategoryContents() {
      var userId = gon.current_user_id;
      var userName = gon.current_username;
      var _gl = gl,
          projectOptions = _gl.projectOptions,
          groupOptions = _gl.groupOptions,
          dashboardOptions = _gl.dashboardOptions;

      // Get options

      var options = void 0;
      if (Object(common_utils["r" /* isInGroupsPage */])() && groupOptions) {
        options = groupOptions[Object(common_utils["g" /* getGroupSlug */])()];
      } else if (Object(common_utils["u" /* isInProjectPage */])() && projectOptions) {
        options = projectOptions[Object(common_utils["j" /* getProjectSlug */])()];
      } else if (dashboardOptions) {
        options = dashboardOptions;
      }

      var _options = options,
          issuesPath = _options.issuesPath,
          mrPath = _options.mrPath,
          name = _options.name,
          issuesDisabled = _options.issuesDisabled;

      var baseItems = [];

      if (name) {
        baseItems.push({
          header: '' + name
        });
      }

      var issueItems = [{
        text: 'Issues assigned to me',
        url: issuesPath + '/?assignee_id=' + userId
      }, {
        text: "Issues I've created",
        url: issuesPath + '/?author_id=' + userId
      }];
      var mergeRequestItems = [{
        text: 'Merge requests assigned to me',
        url: mrPath + '/?assignee_id=' + userId
      }, {
        text: "Merge requests I've created",
        url: mrPath + '/?author_id=' + userId
      }];

      var items = void 0;
      if (issuesDisabled) {
        items = baseItems.concat(mergeRequestItems);
      } else {
        items = baseItems.concat.apply(baseItems, issueItems.concat(['separator'], mergeRequestItems));
      }
      return items;
    }
  }, {
    key: 'serializeState',
    value: function serializeState() {
      return {
        // Search Criteria
        search_project_id: this.projectInputEl.val(),
        group_id: this.groupInputEl.val(),
        search_code: this.searchCodeInputEl.val(),
        repository_ref: this.repositoryInputEl.val(),
        scope: this.scopeInputEl.val(),
        // Location badge
        _location: this.locationBadgeEl.text()
      };
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this2 = this;

      this.searchInput.on('keydown', this.onSearchInputKeyDown);
      this.searchInput.on('keyup', this.onSearchInputKeyUp);
      this.searchInput.on('focus', this.onSearchInputFocus);
      this.searchInput.on('blur', this.onSearchInputBlur);
      this.clearInput.on('click', this.onClearInputClick);
      this.locationBadgeEl.on('click', function () {
        return _this2.searchInput.focus();
      });
    }
  }, {
    key: 'enableAutocomplete',
    value: function enableAutocomplete() {
      // No need to enable anything if user is not logged in
      if (!gon.current_user_id) {
        return;
      }

      // If the dropdown is closed, we'll open it
      if (!this.dropdown.hasClass('open')) {
        this.loadingSuggestions = false;
        this.dropdownToggle.dropdown('toggle');
        return this.searchInput.removeClass('disabled');
      }
    }

    // Saves last length of the entered text

  }, {
    key: 'onSearchInputKeyDown',
    value: function onSearchInputKeyDown() {
      return this.saveTextLength();
    }
  }, {
    key: 'onSearchInputKeyUp',
    value: function onSearchInputKeyUp(e) {
      switch (e.keyCode) {
        case KEYCODE.BACKSPACE:
          // when trying to remove the location badge
          if (this.lastTextLength === 0 && this.badgePresent()) {
            this.removeLocationBadge();
          }
          // When removing the last character and no badge is present
          if (this.lastTextLength === 1) {
            this.disableAutocomplete();
          }
          // When removing any character from existin value
          if (this.lastTextLength > 1) {
            this.enableAutocomplete();
          }
          break;
        case KEYCODE.ESCAPE:
          this.restoreOriginalState();
          break;
        case KEYCODE.ENTER:
          this.disableAutocomplete();
          break;
        case KEYCODE.UP:
        case KEYCODE.DOWN:
          return;
        default:
          // Handle the case when deleting the input value other than backspace
          // e.g. Pressing ctrl + backspace or ctrl + x
          if (this.searchInput.val() === '') {
            this.disableAutocomplete();
          } else {
            // We should display the menu only when input is not empty
            if (e.keyCode !== KEYCODE.ENTER) {
              this.enableAutocomplete();
            }
          }
      }
      this.wrap.toggleClass('has-value', !!e.target.value);
    }
  }, {
    key: 'onSearchInputFocus',
    value: function onSearchInputFocus() {
      this.isFocused = true;
      this.wrap.addClass('search-active');
      if (this.getValue() === '') {
        return this.getData();
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.searchInput.val();
    }
  }, {
    key: 'onClearInputClick',
    value: function onClearInputClick(e) {
      e.preventDefault();
      this.wrap.toggleClass('has-value', !!e.target.value);
      return this.searchInput.val('').focus();
    }
  }, {
    key: 'onSearchInputBlur',
    value: function onSearchInputBlur(e) {
      this.isFocused = false;
      this.wrap.removeClass('search-active');
      // If input is blank then restore state
      if (this.searchInput.val() === '') {
        return this.restoreOriginalState();
      }
    }
  }, {
    key: 'addLocationBadge',
    value: function addLocationBadge(item) {
      var badgeText, category, value;
      category = item.category != null ? item.category + ": " : '';
      value = item.value != null ? item.value : '';
      badgeText = "" + category + value;
      this.locationBadgeEl.text(badgeText).show();
      return this.wrap.addClass('has-location-badge');
    }
  }, {
    key: 'hasLocationBadge',
    value: function hasLocationBadge() {
      return this.wrap.is('.has-location-badge');
    }
  }, {
    key: 'restoreOriginalState',
    value: function restoreOriginalState() {
      var i, input, inputs, len;
      inputs = Object.keys(this.originalState);
      for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];
        this.getElement("#" + input).val(this.originalState[input]);
      }
      if (this.originalState._location === '') {
        return this.locationBadgeEl.hide();
      } else {
        return this.addLocationBadge({
          value: this.originalState._location
        });
      }
    }
  }, {
    key: 'badgePresent',
    value: function badgePresent() {
      return this.locationBadgeEl.length;
    }
  }, {
    key: 'resetSearchState',
    value: function resetSearchState() {
      var i, input, inputs, len, results;
      inputs = Object.keys(this.originalState);
      results = [];
      for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];
        // _location isnt a input
        if (input === '_location') {
          break;
        }
        results.push(this.getElement("#" + input).val(''));
      }
      return results;
    }
  }, {
    key: 'removeLocationBadge',
    value: function removeLocationBadge() {
      this.locationBadgeEl.hide();
      this.resetSearchState();
      this.wrap.removeClass('has-location-badge');
      return this.disableAutocomplete();
    }
  }, {
    key: 'disableAutocomplete',
    value: function disableAutocomplete() {
      if (!this.searchInput.hasClass('disabled') && this.dropdown.hasClass('open')) {
        this.searchInput.addClass('disabled');
        this.dropdown.removeClass('open').trigger('hidden.bs.dropdown');
        this.restoreMenu();
      }
    }
  }, {
    key: 'restoreMenu',
    value: function restoreMenu() {
      var html;
      html = '<ul><li class="dropdown-menu-empty-item"><a>Loading...</a></li></ul>';
      return this.dropdownContent.html(html);
    }
  }, {
    key: 'onClick',
    value: function onClick(item, $el, e) {
      if (location.pathname.indexOf(item.url) !== -1) {
        if (!e.metaKey) e.preventDefault();
        if (!this.badgePresent) {
          if (item.category === 'Projects') {
            this.projectInputEl.val(item.id);
            this.addLocationBadge({
              value: 'This project'
            });
          }
          if (item.category === 'Groups') {
            this.groupInputEl.val(item.id);
            this.addLocationBadge({
              value: 'This group'
            });
          }
        }
        $el.removeClass('is-active');
        this.disableAutocomplete();
        return this.searchInput.val('').focus();
      }
    }
  }]);

  return SearchAutocomplete;
}();

/* harmony default export */ var search_autocomplete = (search_autocomplete_SearchAutocomplete);
// CONCATENATED MODULE: ./dispatcher.js
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-arrow-callback, wrap-iife, no-shadow, consistent-return, one-var, one-var-declaration-per-line, camelcase, default-case, no-new, quotes, no-duplicate-case, no-case-declarations, no-fallthrough, max-len */









function initSearch() {
  // Only when search form is present
  if (jquery_default()('.search').length) {
    return new search_autocomplete();
  }
}

function initFieldErrors() {
  jquery_default()('.gl-show-field-errors').each(function (i, form) {
    new gl_field_errors["a" /* default */](form);
  });
}

function initPageShortcuts(page) {
  var pagesWithCustomShortcuts = ['projects:activity', 'projects:artifacts:browse', 'projects:artifacts:file', 'projects:blame:show', 'projects:blob:show', 'projects:commit:show', 'projects:commits:show', 'projects:find_file:show', 'projects:issues:edit', 'projects:issues:index', 'projects:issues:new', 'projects:issues:show', 'projects:merge_requests:creations:diffs', 'projects:merge_requests:creations:new', 'projects:merge_requests:edit', 'projects:merge_requests:index', 'projects:merge_requests:show', 'projects:network:show', 'projects:show', 'projects:tree:show', 'groups:show'];

  if (pagesWithCustomShortcuts.indexOf(page) === -1) {
    new shortcuts["a" /* default */]();
  }
}

function initGFMInput() {
  jquery_default()('.js-gfm-input:not(.js-vue-textarea)').each(function (i, el) {
    var gfm = new gfm_auto_complete["a" /* default */](gl.GfmAutoComplete && gl.GfmAutoComplete.dataSources);
    var enableGFM = Object(common_utils["f" /* convertPermissionToBoolean */])(el.dataset.supportsAutocomplete);
    gfm.setup(jquery_default()(el), {
      emojis: true,
      members: enableGFM,
      issues: enableGFM,
      milestones: enableGFM,
      mergeRequests: enableGFM,
      labels: enableGFM
    });
  });
}

function initPerformanceBar() {
  if (document.querySelector('#js-peek')) {
    __webpack_require__.e/* import() */("performance_bar_service.js-3ccd54").then(__webpack_require__.bind(null, "./performance_bar/index.js")).then(function (m) {
      return new m.default({ container: '#js-peek' });
    }) // eslint-disable-line new-cap
    .catch(function () {
      return Object(flash["a" /* default */])('Error loading performance bar module');
    });
  }
}

/* harmony default export */ var dispatcher = __webpack_exports__["a"] = (function () {
  initSearch();
  initFieldErrors();

  var page = jquery_default()('body').attr('data-page');
  if (page) {
    initPageShortcuts(page);
    initGFMInput();
    initPerformanceBar();
  }
});

/***/ }),

/***/ "./droplab/drop_lab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./droplab/constants.js
var DATA_TRIGGER = 'data-dropdown-trigger';
var DATA_DROPDOWN = 'data-dropdown';
var SELECTED_CLASS = 'droplab-item-selected';
var ACTIVE_CLASS = 'droplab-item-active';
var IGNORE_CLASS = 'droplab-item-ignore';
// Matches `{{anything}}` and `{{ everything }}`.
var TEMPLATE_REGEX = /\{\{(.+?)\}\}/g;


// CONCATENATED MODULE: ./droplab/utils.js
/* eslint-disable */




var utils = {
  toCamelCase: function toCamelCase(attr) {
    return this.camelize(attr.split('-').slice(1).join(' '));
  },
  template: function template(templateString, data) {
    var template = Object(underscore["template"])(templateString, {
      escape: TEMPLATE_REGEX
    });

    return template(data);
  },
  camelize: function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  },
  closest: function closest(thisTag, stopTag) {
    while (thisTag && thisTag.tagName !== stopTag && thisTag.tagName !== 'HTML') {
      thisTag = thisTag.parentNode;
    }
    return thisTag;
  },
  isDropDownParts: function isDropDownParts(target) {
    if (!target || !target.hasAttribute || target.tagName === 'HTML') return false;
    return target.hasAttribute(DATA_TRIGGER) || target.hasAttribute(DATA_DROPDOWN);
  }
};

/* harmony default export */ var droplab_utils = (utils);
// CONCATENATED MODULE: ./droplab/drop_down.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var drop_down_DropDown = function () {
  function DropDown(list) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DropDown);

    this.currentIndex = 0;
    this.hidden = true;
    this.list = typeof list === 'string' ? document.querySelector(list) : list;
    this.items = [];
    this.eventWrapper = {};
    this.hideOnClick = config.hideOnClick !== false;

    if (config.addActiveClassToDropdownButton) {
      this.dropdownToggle = this.list.parentNode.querySelector('.js-dropdown-toggle');
    }

    this.getItems();
    this.initTemplateString();
    this.addEvents();

    this.initialState = list.innerHTML;
  }

  _createClass(DropDown, [{
    key: 'getItems',
    value: function getItems() {
      this.items = [].slice.call(this.list.querySelectorAll('li'));
      return this.items;
    }
  }, {
    key: 'initTemplateString',
    value: function initTemplateString() {
      var items = this.items || this.getItems();

      var templateString = '';
      if (items.length > 0) templateString = items[items.length - 1].outerHTML;
      this.templateString = templateString;

      return this.templateString;
    }
  }, {
    key: 'clickEvent',
    value: function clickEvent(e) {
      if (e.target.tagName === 'UL') return;
      if (e.target.closest('.' + IGNORE_CLASS)) return;

      var selected = e.target.closest('li');
      if (!selected) return;

      this.addSelectedClass(selected);

      e.preventDefault();
      if (this.hideOnClick) {
        this.hide();
      }

      var listEvent = new CustomEvent('click.dl', {
        detail: {
          list: this,
          selected: selected,
          data: e.target.dataset
        }
      });
      this.list.dispatchEvent(listEvent);
    }
  }, {
    key: 'addSelectedClass',
    value: function addSelectedClass(selected) {
      this.removeSelectedClasses();
      selected.classList.add(SELECTED_CLASS);
    }
  }, {
    key: 'removeSelectedClasses',
    value: function removeSelectedClasses() {
      var items = this.items || this.getItems();

      items.forEach(function (item) {
        return item.classList.remove(SELECTED_CLASS);
      });
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.clickEvent = this.clickEvent.bind(this);
      this.eventWrapper.closeDropdown = this.closeDropdown.bind(this);

      this.list.addEventListener('click', this.eventWrapper.clickEvent);
      this.list.addEventListener('keyup', this.eventWrapper.closeDropdown);
    }
  }, {
    key: 'closeDropdown',
    value: function closeDropdown(event) {
      // `ESC` key closes the dropdown.
      if (event.keyCode === 27) {
        event.preventDefault();
        return this.toggle();
      }

      return true;
    }
  }, {
    key: 'setData',
    value: function setData(data) {
      this.data = data;
      this.render(data);
    }
  }, {
    key: 'addData',
    value: function addData(data) {
      this.data = (this.data || []).concat(data);
      this.render(this.data);
    }
  }, {
    key: 'render',
    value: function render(data) {
      var children = data ? data.map(this.renderChildren.bind(this)) : [];
      var renderableList = this.list.querySelector('ul[data-dynamic]') || this.list;

      renderableList.innerHTML = children.join('');

      var listEvent = new CustomEvent('render.dl', {
        detail: {
          list: this
        }
      });
      this.list.dispatchEvent(listEvent);
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren(data) {
      var html = droplab_utils.template(this.templateString, data);
      var template = document.createElement('div');

      template.innerHTML = html;
      DropDown.setImagesSrc(template);
      template.firstChild.style.display = data.droplab_hidden ? 'none' : 'block';

      return template.firstChild.outerHTML;
    }
  }, {
    key: 'show',
    value: function show() {
      if (!this.hidden) return;
      this.list.style.display = 'block';
      this.currentIndex = 0;
      this.hidden = false;

      if (this.dropdownToggle) this.dropdownToggle.classList.add('active');
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.hidden) return;
      this.list.style.display = 'none';
      this.currentIndex = 0;
      this.hidden = true;

      if (this.dropdownToggle) this.dropdownToggle.classList.remove('active');
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.hidden) return this.show();

      return this.hide();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.hide();
      this.list.removeEventListener('click', this.eventWrapper.clickEvent);
      this.list.removeEventListener('keyup', this.eventWrapper.closeDropdown);
    }
  }], [{
    key: 'setImagesSrc',
    value: function setImagesSrc(template) {
      var images = [].concat(_toConsumableArray(template.querySelectorAll('img[data-src]')));

      images.forEach(function (image) {
        var img = image;

        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    }
  }]);

  return DropDown;
}();

/* harmony default export */ var drop_down = (drop_down_DropDown);
// CONCATENATED MODULE: ./droplab/hook.js
function hook__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var hook_Hook = function Hook(trigger, list, plugins, config) {
  hook__classCallCheck(this, Hook);

  this.trigger = trigger;
  this.list = new drop_down(list, config);
  this.type = 'Hook';
  this.event = 'click';
  this.plugins = plugins || [];
  this.config = config || {};
  this.id = trigger.id;
};

/* harmony default export */ var droplab_hook = (hook_Hook);
// CONCATENATED MODULE: ./droplab/hook_button.js
var hook_button__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function hook_button__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var HookButton = function (_Hook) {
  _inherits(HookButton, _Hook);

  function HookButton(trigger, list, plugins, config) {
    hook_button__classCallCheck(this, HookButton);

    var _this = _possibleConstructorReturn(this, (HookButton.__proto__ || Object.getPrototypeOf(HookButton)).call(this, trigger, list, plugins, config));

    _this.type = 'button';
    _this.event = 'click';

    _this.eventWrapper = {};

    _this.addEvents();
    _this.addPlugins();
    return _this;
  }

  hook_button__createClass(HookButton, [{
    key: 'addPlugins',
    value: function addPlugins() {
      var _this2 = this;

      this.plugins.forEach(function (plugin) {
        return plugin.init(_this2);
      });
    }
  }, {
    key: 'clicked',
    value: function clicked(e) {
      var buttonEvent = new CustomEvent('click.dl', {
        detail: {
          hook: this
        },
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(buttonEvent);

      this.list.toggle();
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.clicked = this.clicked.bind(this);
      this.trigger.addEventListener('click', this.eventWrapper.clicked);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.trigger.removeEventListener('click', this.eventWrapper.clicked);
    }
  }, {
    key: 'restoreInitialState',
    value: function restoreInitialState() {
      this.list.list.innerHTML = this.list.initialState;
    }
  }, {
    key: 'removePlugins',
    value: function removePlugins() {
      this.plugins.forEach(function (plugin) {
        return plugin.destroy();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.restoreInitialState();

      this.removeEvents();
      this.removePlugins();
    }
  }]);

  return HookButton;
}(droplab_hook);

/* harmony default export */ var hook_button = (HookButton);
// CONCATENATED MODULE: ./droplab/hook_input.js
var hook_input__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function hook_input__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function hook_input__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function hook_input__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var HookInput = function (_Hook) {
  hook_input__inherits(HookInput, _Hook);

  function HookInput(trigger, list, plugins, config) {
    hook_input__classCallCheck(this, HookInput);

    var _this = hook_input__possibleConstructorReturn(this, (HookInput.__proto__ || Object.getPrototypeOf(HookInput)).call(this, trigger, list, plugins, config));

    _this.type = 'input';
    _this.event = 'input';

    _this.eventWrapper = {};

    _this.addEvents();
    _this.addPlugins();
    return _this;
  }

  hook_input__createClass(HookInput, [{
    key: 'addPlugins',
    value: function addPlugins() {
      var _this2 = this;

      this.plugins.forEach(function (plugin) {
        return plugin.init(_this2);
      });
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.mousedown = this.mousedown.bind(this);
      this.eventWrapper.input = this.input.bind(this);
      this.eventWrapper.keyup = this.keyup.bind(this);
      this.eventWrapper.keydown = this.keydown.bind(this);

      this.trigger.addEventListener('mousedown', this.eventWrapper.mousedown);
      this.trigger.addEventListener('input', this.eventWrapper.input);
      this.trigger.addEventListener('keyup', this.eventWrapper.keyup);
      this.trigger.addEventListener('keydown', this.eventWrapper.keydown);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.hasRemovedEvents = true;

      this.trigger.removeEventListener('mousedown', this.eventWrapper.mousedown);
      this.trigger.removeEventListener('input', this.eventWrapper.input);
      this.trigger.removeEventListener('keyup', this.eventWrapper.keyup);
      this.trigger.removeEventListener('keydown', this.eventWrapper.keydown);
    }
  }, {
    key: 'input',
    value: function input(e) {
      if (this.hasRemovedEvents) return;

      this.list.show();

      var inputEvent = new CustomEvent('input.dl', {
        detail: {
          hook: this,
          text: e.target.value
        },
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(inputEvent);
    }
  }, {
    key: 'mousedown',
    value: function mousedown(e) {
      if (this.hasRemovedEvents) return;

      var mouseEvent = new CustomEvent('mousedown.dl', {
        detail: {
          hook: this,
          text: e.target.value
        },
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(mouseEvent);
    }
  }, {
    key: 'keyup',
    value: function keyup(e) {
      if (this.hasRemovedEvents) return;

      this.keyEvent(e, 'keyup.dl');
    }
  }, {
    key: 'keydown',
    value: function keydown(e) {
      if (this.hasRemovedEvents) return;

      this.keyEvent(e, 'keydown.dl');
    }
  }, {
    key: 'keyEvent',
    value: function keyEvent(e, eventName) {
      this.list.show();

      var keyEvent = new CustomEvent(eventName, {
        detail: {
          hook: this,
          text: e.target.value,
          which: e.which,
          key: e.key
        },
        bubbles: true,
        cancelable: true
      });
      e.target.dispatchEvent(keyEvent);
    }
  }, {
    key: 'restoreInitialState',
    value: function restoreInitialState() {
      this.list.list.innerHTML = this.list.initialState;
    }
  }, {
    key: 'removePlugins',
    value: function removePlugins() {
      this.plugins.forEach(function (plugin) {
        return plugin.destroy();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.restoreInitialState();

      this.removeEvents();
      this.removePlugins();

      this.list.destroy();
    }
  }]);

  return HookInput;
}(droplab_hook);

/* harmony default export */ var hook_input = (HookInput);
// CONCATENATED MODULE: ./droplab/keyboard.js
/* eslint-disable */



var keyboard_Keyboard = function Keyboard() {
  var currentKey;
  var currentFocus;
  var isUpArrow = false;
  var isDownArrow = false;
  var removeHighlight = function removeHighlight(list) {
    var itemElements = Array.prototype.slice.call(list.list.querySelectorAll('li:not(.divider):not(.hidden)'), 0);
    var listItems = [];
    for (var i = 0; i < itemElements.length; i++) {
      var listItem = itemElements[i];
      listItem.classList.remove(ACTIVE_CLASS);

      if (listItem.style.display !== 'none') {
        listItems.push(listItem);
      }
    }
    return listItems;
  };

  var setMenuForArrows = function setMenuForArrows(list) {
    var listItems = removeHighlight(list);
    if (list.currentIndex > 0) {
      if (!listItems[list.currentIndex - 1]) {
        list.currentIndex = list.currentIndex - 1;
      }

      if (listItems[list.currentIndex - 1]) {
        var el = listItems[list.currentIndex - 1];
        var filterDropdownEl = el.closest('.filter-dropdown');
        el.classList.add(ACTIVE_CLASS);

        if (filterDropdownEl) {
          var filterDropdownBottom = filterDropdownEl.offsetHeight;
          var elOffsetTop = el.offsetTop - 30;

          if (elOffsetTop > filterDropdownBottom) {
            filterDropdownEl.scrollTop = elOffsetTop - filterDropdownBottom;
          }
        }
      }
    }
  };

  var mousedown = function mousedown(e) {
    var list = e.detail.hook.list;
    removeHighlight(list);
    list.show();
    list.currentIndex = 0;
    isUpArrow = false;
    isDownArrow = false;
  };
  var selectItem = function selectItem(list) {
    var listItems = removeHighlight(list);
    var currentItem = listItems[list.currentIndex - 1];
    var listEvent = new CustomEvent('click.dl', {
      detail: {
        list: list,
        selected: currentItem,
        data: currentItem.dataset
      }
    });
    list.list.dispatchEvent(listEvent);
    list.hide();
  };

  var keydown = function keydown(e) {
    var typedOn = e.target;
    var list = e.detail.hook.list;
    var currentIndex = list.currentIndex;
    isUpArrow = false;
    isDownArrow = false;

    if (e.detail.which) {
      currentKey = e.detail.which;
      if (currentKey === 13) {
        selectItem(e.detail.hook.list);
        return;
      }
      if (currentKey === 38) {
        isUpArrow = true;
      }
      if (currentKey === 40) {
        isDownArrow = true;
      }
    } else if (e.detail.key) {
      currentKey = e.detail.key;
      if (currentKey === 'Enter') {
        selectItem(e.detail.hook.list);
        return;
      }
      if (currentKey === 'ArrowUp') {
        isUpArrow = true;
      }
      if (currentKey === 'ArrowDown') {
        isDownArrow = true;
      }
    }
    if (isUpArrow) {
      currentIndex--;
    }
    if (isDownArrow) {
      currentIndex++;
    }
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    list.currentIndex = currentIndex;
    setMenuForArrows(e.detail.hook.list);
  };

  document.addEventListener('mousedown.dl', mousedown);
  document.addEventListener('keydown.dl', keydown);
};

/* harmony default export */ var keyboard = (keyboard_Keyboard);
// CONCATENATED MODULE: ./droplab/drop_lab.js
var drop_lab__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function drop_lab__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function drop_lab__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var drop_lab_DropLab = function () {
  function DropLab() {
    drop_lab__classCallCheck(this, DropLab);

    this.ready = false;
    this.hooks = [];
    this.queuedData = [];
    this.config = {};

    this.eventWrapper = {};
  }

  drop_lab__createClass(DropLab, [{
    key: 'loadStatic',
    value: function loadStatic() {
      var dropdownTriggers = [].slice.apply(document.querySelectorAll('[' + DATA_TRIGGER + ']'));
      this.addHooks(dropdownTriggers);
    }
  }, {
    key: 'addData',
    value: function addData() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.applyArgs(args, 'processAddData');
    }
  }, {
    key: 'setData',
    value: function setData() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      this.applyArgs(args, 'processSetData');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.hooks.forEach(function (hook) {
        return hook.destroy();
      });
      this.hooks = [];
      this.removeEvents();
    }
  }, {
    key: 'applyArgs',
    value: function applyArgs(args, methodName) {
      if (this.ready) return this[methodName].apply(this, drop_lab__toConsumableArray(args));

      this.queuedData = this.queuedData || [];
      this.queuedData.push(args);

      return this.ready;
    }
  }, {
    key: 'processAddData',
    value: function processAddData(trigger, data) {
      this.processData(trigger, data, 'addData');
    }
  }, {
    key: 'processSetData',
    value: function processSetData(trigger, data) {
      this.processData(trigger, data, 'setData');
    }
  }, {
    key: 'processData',
    value: function processData(trigger, data, methodName) {
      this.hooks.forEach(function (hook) {
        if (Array.isArray(trigger)) hook.list[methodName](trigger);

        if (hook.trigger.id === trigger) hook.list[methodName](data);
      });
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.documentClicked = this.documentClicked.bind(this);
      document.addEventListener('click', this.eventWrapper.documentClicked);
    }
  }, {
    key: 'documentClicked',
    value: function documentClicked(e) {
      var thisTag = e.target;

      if (thisTag.tagName !== 'UL') thisTag = droplab_utils.closest(thisTag, 'UL');
      if (droplab_utils.isDropDownParts(thisTag, this.hooks)) return;
      if (droplab_utils.isDropDownParts(e.target, this.hooks)) return;

      this.hooks.forEach(function (hook) {
        return hook.list.hide();
      });
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      document.removeEventListener('click', this.eventWrapper.documentClicked);
    }
  }, {
    key: 'changeHookList',
    value: function changeHookList(trigger, list, plugins, config) {
      var _this = this;

      var availableTrigger = typeof trigger === 'string' ? document.getElementById(trigger) : trigger;

      this.hooks.forEach(function (hook, i) {
        var aHook = hook;

        aHook.list.list.dataset.dropdownActive = false;

        if (aHook.trigger !== availableTrigger) return;

        aHook.destroy();
        _this.hooks.splice(i, 1);
        _this.addHook(availableTrigger, list, plugins, config);
      });
    }
  }, {
    key: 'addHook',
    value: function addHook(hook, list, plugins, config) {
      var availableHook = typeof hook === 'string' ? document.querySelector(hook) : hook;
      var availableList = void 0;

      if (typeof list === 'string') {
        availableList = document.querySelector(list);
      } else if (list instanceof Element) {
        availableList = list;
      } else {
        availableList = document.querySelector(hook.dataset[droplab_utils.toCamelCase(DATA_TRIGGER)]);
      }

      availableList.dataset.dropdownActive = true;

      var HookObject = availableHook.tagName === 'INPUT' ? hook_input : hook_button;
      this.hooks.push(new HookObject(availableHook, availableList, plugins, config));

      return this;
    }
  }, {
    key: 'addHooks',
    value: function addHooks(hooks, plugins, config) {
      var _this2 = this;

      hooks.forEach(function (hook) {
        return _this2.addHook(hook, null, plugins, config);
      });
      return this;
    }
  }, {
    key: 'setConfig',
    value: function setConfig(obj) {
      this.config = obj;
    }
  }, {
    key: 'fireReady',
    value: function fireReady() {
      var readyEvent = new CustomEvent('ready.dl', {
        detail: {
          dropdown: this
        }
      });
      document.dispatchEvent(readyEvent);

      this.ready = true;
    }
  }, {
    key: 'init',
    value: function init(hook, list, plugins, config) {
      var _this3 = this;

      if (hook) {
        this.addHook(hook, list, plugins, config);
      } else {
        this.loadStatic();
      }

      this.addEvents();

      keyboard();

      this.fireReady();

      this.queuedData.forEach(function (data) {
        return _this3.addData(data);
      });
      this.queuedData = [];

      return this;
    }
  }]);

  return DropLab;
}();

/* harmony default export */ var drop_lab = __webpack_exports__["a"] = (drop_lab_DropLab);

/***/ }),

/***/ "./feature_highlight/feature_highlight_options.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// CONCATENATED MODULE: ./feature_highlight/feature_highlight_helper.js






var getSelector = function getSelector(highlightId) {
  return '.js-feature-highlight[data-highlight=' + highlightId + ']';
};

function togglePopover(show) {
  var isAlreadyShown = this.hasClass('js-popover-show');
  if (show && isAlreadyShown || !show && !isAlreadyShown) {
    return false;
  }
  this.popover(show ? 'show' : 'hide');
  this.toggleClass('disable-animation js-popover-show', show);

  return true;
}

function dismiss(highlightId) {
  axios_utils["a" /* default */].post(this.attr('data-dismiss-endpoint'), {
    feature_name: highlightId
  }).catch(function () {
    return Object(flash["a" /* default */])(Object(locale["a" /* __ */])('An error occurred while dismissing the feature highlight. Refresh the page and try dismissing again.'));
  });

  togglePopover.call(this, false);
  this.hide();
}

function mouseleave() {
  if (!jquery_default()('.popover:hover').length > 0) {
    var $featureHighlight = jquery_default()(this);
    togglePopover.call($featureHighlight, false);
  }
}

function mouseenter() {
  var $featureHighlight = jquery_default()(this);

  var showedPopover = togglePopover.call($featureHighlight, true);
  if (showedPopover) {
    jquery_default()('.popover').on('mouseleave', mouseleave.bind($featureHighlight));
  }
}

function inserted() {
  var popoverId = this.getAttribute('aria-describedby');
  var highlightId = this.dataset.highlight;
  var $popover = jquery_default()(this);
  var dismissWrapper = dismiss.bind($popover, highlightId);

  jquery_default()('#' + popoverId + ' .dismiss-feature-highlight').on('click', dismissWrapper);

  var lazyImg = jquery_default()('#' + popoverId + ' .feature-highlight-illustration')[0];
  if (lazyImg) {
    lazy_loader["a" /* default */].loadImage(lazyImg);
  }
}
// CONCATENATED MODULE: ./feature_highlight/feature_highlight.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





function setupFeatureHighlightPopover(id) {
  var debounceTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var $selector = jquery_default()(getSelector(id));
  var $parent = $selector.parent();
  var $popoverContent = $parent.siblings('.feature-highlight-popover-content');
  var hideOnScroll = togglePopover.bind($selector, false);
  var debouncedMouseleave = underscore_default.a.debounce(mouseleave, debounceTimeout);

  $selector
  // Setup popover
  .data('content', $popoverContent.prop('outerHTML')).popover({
    html: true,
    // Override the existing template to add custom CSS classes
    template: '\n        <div class="popover feature-highlight-popover" role="tooltip">\n          <div class="arrow"></div>\n          <div class="popover-content"></div>\n        </div>\n      '
  }).on('mouseenter', mouseenter).on('mouseleave', debouncedMouseleave).on('inserted.bs.popover', inserted).on('show.bs.popover', function () {
    window.addEventListener('scroll', hideOnScroll);
  }).on('hide.bs.popover', function () {
    window.removeEventListener('scroll', hideOnScroll);
  })
  // Display feature highlight
  .removeAttr('disabled');
}

function findHighestPriorityFeature() {
  var priorityFeature = void 0;

  var sortedFeatureEls = [].slice.call(document.querySelectorAll('.js-feature-highlight')).sort(function (a, b) {
    return (a.dataset.highlightPriority || 0) < (b.dataset.highlightPriority || 0);
  });

  var _sortedFeatureEls = _slicedToArray(sortedFeatureEls, 1),
      priorityFeatureEl = _sortedFeatureEls[0];

  if (priorityFeatureEl) {
    priorityFeature = priorityFeatureEl.dataset.highlight;
  }

  return priorityFeature;
}

function highlightFeatures() {
  var priorityFeature = findHighestPriorityFeature();

  if (priorityFeature) {
    setupFeatureHighlightPopover(priorityFeature);
  }

  return priorityFeature;
}
// EXTERNAL MODULE: ./breakpoints.js
var breakpoints = __webpack_require__("./breakpoints.js");

// CONCATENATED MODULE: ./feature_highlight/feature_highlight_options.js
/* unused harmony export default */



function domContentLoaded() {
  if (breakpoints["a" /* default */].getBreakpointSize() === 'lg') {
    highlightFeatures();
    return true;
  }
  return false;
}

document.addEventListener('DOMContentLoaded', domContentLoaded);

/***/ }),

/***/ "./filtered_search/container.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */
var container = document;

var FilteredSearchContainerClass = function () {
  function FilteredSearchContainerClass() {
    _classCallCheck(this, FilteredSearchContainerClass);
  }

  _createClass(FilteredSearchContainerClass, [{
    key: "container",
    set: function set(containerParam) {
      container = containerParam;
    },
    get: function get() {
      return container;
    }
  }]);

  return FilteredSearchContainerClass;
}();

/* harmony default export */ __webpack_exports__["a"] = (new FilteredSearchContainerClass());

/***/ }),

/***/ "./filtered_search/dropdown_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__("./filtered_search/container.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filtered_search_tokenizer__ = __webpack_require__("./filtered_search/filtered_search_tokenizer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filtered_search_dropdown_manager__ = __webpack_require__("./filtered_search/filtered_search_dropdown_manager.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtered_search_visual_tokens__ = __webpack_require__("./filtered_search/filtered_search_visual_tokens.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var DropdownUtils = function () {
  function DropdownUtils() {
    _classCallCheck(this, DropdownUtils);
  }

  _createClass(DropdownUtils, null, [{
    key: 'getEscapedText',
    value: function getEscapedText(text) {
      var escapedText = text;
      var hasSpace = text.indexOf(' ') !== -1;
      var hasDoubleQuote = text.indexOf('"') !== -1;

      // Encapsulate value with quotes if it has spaces
      // Known side effect: values's with both single and double quotes
      // won't escape properly
      if (hasSpace) {
        if (hasDoubleQuote) {
          escapedText = '\'' + text + '\'';
        } else {
          // Encapsulate singleQuotes or if it hasSpace
          escapedText = '"' + text + '"';
        }
      }

      return escapedText;
    }
  }, {
    key: 'filterWithSymbol',
    value: function filterWithSymbol(filterSymbol, input, item) {
      var updatedItem = item;
      var searchInput = DropdownUtils.getSearchInput(input);

      var title = updatedItem.title.toLowerCase();
      var value = searchInput.toLowerCase();
      var symbol = '';

      // Remove the symbol for filter
      if (value[0] === filterSymbol) {
        symbol = value[0];
        value = value.slice(1);
      }

      // Removes the first character if it is a quotation so that we can search
      // with multiple words
      if ((value[0] === '"' || value[0] === '\'') && title.indexOf(' ') !== -1) {
        value = value.slice(1);
      }

      // Eg. filterSymbol = ~ for labels
      var matchWithoutSymbol = symbol === filterSymbol && title.indexOf(value) !== -1;
      var match = title.indexOf('' + symbol + value) !== -1;

      updatedItem.droplab_hidden = !match && !matchWithoutSymbol;

      return updatedItem;
    }
  }, {
    key: 'mergeDuplicateLabels',
    value: function mergeDuplicateLabels(dataMap, newLabel) {
      var updatedMap = dataMap;
      var key = newLabel.title;

      var hasKeyProperty = Object.prototype.hasOwnProperty.call(updatedMap, key);

      if (!hasKeyProperty) {
        updatedMap[key] = newLabel;
      } else {
        var existing = updatedMap[key];

        if (!existing.multipleColors) {
          existing.multipleColors = [existing.color];
        }

        existing.multipleColors.push(newLabel.color);
      }

      return updatedMap;
    }
  }, {
    key: 'duplicateLabelColor',
    value: function duplicateLabelColor(labelColors) {
      var colors = labelColors;
      var spacing = 100 / colors.length;

      // Reduce the colors to 4
      colors.length = Math.min(colors.length, 4);

      var color = colors.map(function (c, i) {
        var percentFirst = Math.floor(spacing * i);
        var percentSecond = Math.floor(spacing * (i + 1));
        return c + ' ' + percentFirst + '%, ' + c + ' ' + percentSecond + '%';
      }).join(', ');

      return 'linear-gradient(' + color + ')';
    }
  }, {
    key: 'duplicateLabelPreprocessing',
    value: function duplicateLabelPreprocessing(data) {
      var results = [];
      var dataMap = {};

      data.forEach(DropdownUtils.mergeDuplicateLabels.bind(null, dataMap));

      Object.keys(dataMap).forEach(function (key) {
        var label = dataMap[key];

        if (label.multipleColors) {
          label.color = DropdownUtils.duplicateLabelColor(label.multipleColors);
          label.text_color = '#000000';
        }

        results.push(label);
      });

      results.preprocessed = true;

      return results;
    }
  }, {
    key: 'filterHint',
    value: function filterHint(config, item) {
      var input = config.input,
          allowedKeys = config.allowedKeys;

      var updatedItem = item;
      var searchInput = DropdownUtils.getSearchQuery(input);

      var _FilteredSearchTokeni = __WEBPACK_IMPORTED_MODULE_2__filtered_search_tokenizer__["a" /* default */].processTokens(searchInput, allowedKeys),
          lastToken = _FilteredSearchTokeni.lastToken,
          tokens = _FilteredSearchTokeni.tokens;

      var lastKey = lastToken.key || lastToken || '';
      var allowMultiple = item.type === 'array';
      var itemInExistingTokens = tokens.some(function (t) {
        return t.key === item.hint;
      });

      if (!allowMultiple && itemInExistingTokens) {
        updatedItem.droplab_hidden = true;
      } else if (!lastKey || __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.last(searchInput.split('')) === ' ') {
        updatedItem.droplab_hidden = false;
      } else if (lastKey) {
        var split = lastKey.split(':');
        var tokenName = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.last(split[0].split(' '));

        var match = updatedItem.hint.indexOf(tokenName.toLowerCase()) === -1;
        updatedItem.droplab_hidden = tokenName ? match : false;
      }

      return updatedItem;
    }
  }, {
    key: 'setDataValueIfSelected',
    value: function setDataValueIfSelected(filter, selected) {
      var dataValue = selected.getAttribute('data-value');

      if (dataValue) {
        __WEBPACK_IMPORTED_MODULE_3__filtered_search_dropdown_manager__["a" /* default */].addWordToInput(filter, dataValue, true);
      }

      // Return boolean based on whether it was set
      return dataValue !== null;
    }
  }, {
    key: 'getVisualTokenValues',
    value: function getVisualTokenValues(visualToken) {
      var tokenName = visualToken && visualToken.querySelector('.name').textContent.trim();
      var tokenValue = visualToken && visualToken.querySelector('.value') && visualToken.querySelector('.value').textContent.trim();
      if (tokenName === 'label' && tokenValue) {
        // remove leading symbol and wrapping quotes
        tokenValue = tokenValue.replace(/^~("|')?(.*)/, '$2').replace(/("|')$/, '');
      }
      return { tokenName: tokenName, tokenValue: tokenValue };
    }

    // Determines the full search query (visual tokens + input)

  }, {
    key: 'getSearchQuery',
    value: function getSearchQuery() {
      var untilInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var container = __WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */].container;
      var tokens = [].slice.call(container.querySelectorAll('.tokens-container li'));
      var values = [];

      if (untilInput) {
        var inputIndex = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.findIndex(tokens, function (t) {
          return t.classList.contains('input-token');
        });
        // Add one to include input-token to the tokens array
        tokens.splice(inputIndex + 1);
      }

      tokens.forEach(function (token) {
        if (token.classList.contains('js-visual-token')) {
          var name = token.querySelector('.name');
          var value = token.querySelector('.value');
          var valueContainer = token.querySelector('.value-container');
          var symbol = value && value.dataset.symbol ? value.dataset.symbol : '';
          var valueText = '';

          if (valueContainer && valueContainer.dataset.originalValue) {
            valueText = valueContainer.dataset.originalValue;
          } else if (value && value.innerText) {
            valueText = value.innerText;
          }

          if (token.className.indexOf('filtered-search-token') !== -1) {
            values.push(name.innerText.toLowerCase() + ':' + symbol + valueText);
          } else {
            values.push(name.innerText);
          }
        } else if (token.classList.contains('input-token')) {
          var _FilteredSearchVisual = __WEBPACK_IMPORTED_MODULE_4__filtered_search_visual_tokens__["a" /* default */].getLastVisualTokenBeforeInput(),
              isLastVisualTokenValid = _FilteredSearchVisual.isLastVisualTokenValid;

          var input = __WEBPACK_IMPORTED_MODULE_1__container__["a" /* default */].container.querySelector('.filtered-search');
          var inputValue = input && input.value;

          if (isLastVisualTokenValid) {
            values.push(inputValue);
          } else {
            var previous = values.pop();
            values.push('' + previous + inputValue);
          }
        }
      });

      return values.map(function (value) {
        return value.trim();
      }).join(' ');
    }
  }, {
    key: 'getSearchInput',
    value: function getSearchInput(filteredSearchInput) {
      var inputValue = filteredSearchInput.value;

      var _DropdownUtils$getInp = DropdownUtils.getInputSelectionPosition(filteredSearchInput),
          right = _DropdownUtils$getInp.right;

      return inputValue.slice(0, right);
    }
  }, {
    key: 'getInputSelectionPosition',
    value: function getInputSelectionPosition(input) {
      var selectionStart = input.selectionStart;
      var inputValue = input.value;
      // Replace all spaces inside quote marks with underscores
      // (will continue to match entire string until an end quote is found if any)
      // This helps with matching the beginning & end of a token:key
      inputValue = inputValue.replace(/(('[^']*'{0,1})|("[^"]*"{0,1})|:\s+)/g, function (str) {
        return str.replace(/\s/g, '_');
      });

      // Get the right position for the word selected
      // Regex matches first space
      var right = inputValue.slice(selectionStart).search(/\s/);

      if (right >= 0) {
        right += selectionStart;
      } else if (right < 0) {
        right = inputValue.length;
      }

      // Get the left position for the word selected
      // Regex matches last non-whitespace character
      var left = inputValue.slice(0, right).search(/\S+$/);

      if (selectionStart === 0) {
        left = 0;
      } else if (selectionStart === inputValue.length && left < 0) {
        left = inputValue.length;
      } else if (left < 0) {
        left = selectionStart;
      }

      return {
        left: left,
        right: right
      };
    }
  }]);

  return DropdownUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (DropdownUtils);

/***/ }),

/***/ "./filtered_search/filtered_search_dropdown_manager.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./filtered_search/container.js
var container = __webpack_require__("./filtered_search/container.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_token_keys.js
var filtered_search_token_keys = __webpack_require__("./filtered_search/filtered_search_token_keys.js");

// EXTERNAL MODULE: ./filtered_search/dropdown_utils.js
var dropdown_utils = __webpack_require__("./filtered_search/dropdown_utils.js");

// CONCATENATED MODULE: ./droplab/plugins/filter.js
/* eslint-disable */

var Filter = {
  keydown: function keydown(e) {
    if (this.destroyed) return;

    var hiddenCount = 0;
    var dataHiddenCount = 0;

    var list = e.detail.hook.list;
    var data = list.data;
    var value = e.detail.hook.trigger.value.toLowerCase();
    var config = e.detail.hook.config.Filter;
    var matches = [];
    var filterFunction;
    // will only work on dynamically set data
    if (!data) {
      return;
    }

    if (config && config.filterFunction && typeof config.filterFunction === 'function') {
      filterFunction = config.filterFunction;
    } else {
      filterFunction = function filterFunction(o) {
        // cheap string search
        o.droplab_hidden = o[config.template].toLowerCase().indexOf(value) === -1;
        return o;
      };
    }

    dataHiddenCount = data.filter(function (o) {
      return !o.droplab_hidden;
    }).length;

    matches = data.map(function (o) {
      return filterFunction(o, value);
    });

    hiddenCount = matches.filter(function (o) {
      return !o.droplab_hidden;
    }).length;

    if (dataHiddenCount !== hiddenCount) {
      list.setData(matches);
      list.currentIndex = 0;
    }
  },

  debounceKeydown: function debounceKeydown(e) {
    if ([13, // enter
    16, // shift
    17, // ctrl
    18, // alt
    20, // caps lock
    37, // left arrow
    38, // up arrow
    39, // right arrow
    40, // down arrow
    91, // left window
    92, // right window
    93].indexOf(e.detail.which || e.detail.keyCode) > -1) return;

    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(this.keydown.bind(this, e), 200);
  },

  init: function init(hook) {
    var config = hook.config.Filter;

    if (!config || !config.template) return;

    this.hook = hook;
    this.destroyed = false;

    this.eventWrapper = {};
    this.eventWrapper.debounceKeydown = this.debounceKeydown.bind(this);

    this.hook.trigger.addEventListener('keydown.dl', this.eventWrapper.debounceKeydown);
    this.hook.trigger.addEventListener('mousedown.dl', this.eventWrapper.debounceKeydown);
  },

  destroy: function destroy() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyed = true;

    this.hook.trigger.removeEventListener('keydown.dl', this.eventWrapper.debounceKeydown);
    this.hook.trigger.removeEventListener('mousedown.dl', this.eventWrapper.debounceKeydown);
  }
};

/* harmony default export */ var filter = (Filter);
// CONCATENATED MODULE: ./filtered_search/filtered_search_dropdown.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var DATA_DROPDOWN_TRIGGER = 'data-dropdown-trigger';

var filtered_search_dropdown_FilteredSearchDropdown = function () {
  function FilteredSearchDropdown(_ref) {
    var droplab = _ref.droplab,
        dropdown = _ref.dropdown,
        input = _ref.input,
        filter = _ref.filter;

    _classCallCheck(this, FilteredSearchDropdown);

    this.droplab = droplab;
    this.hookId = input && input.id;
    this.input = input;
    this.filter = filter;
    this.dropdown = dropdown;
    this.loadingTemplate = '<div class="filter-dropdown-loading">\n      <i class="fa fa-spinner fa-spin"></i>\n    </div>';
    this.bindEvents();
  }

  _createClass(FilteredSearchDropdown, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.itemClickedWrapper = this.itemClicked.bind(this);
      this.dropdown.addEventListener('click.dl', this.itemClickedWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.dropdown.removeEventListener('click.dl', this.itemClickedWrapper);
    }
  }, {
    key: 'getCurrentHook',
    value: function getCurrentHook() {
      var _this = this;

      return this.droplab.hooks.filter(function (h) {
        return h.id === _this.hookId;
      })[0] || null;
    }
  }, {
    key: 'itemClicked',
    value: function itemClicked(e, getValueFunction) {
      var selected = e.detail.selected;


      if (selected.tagName === 'LI' && selected.innerHTML) {
        var dataValueSet = dropdown_utils["a" /* default */].setDataValueIfSelected(this.filter, selected);

        if (!dataValueSet) {
          var value = getValueFunction(selected);
          filtered_search_dropdown_manager.addWordToInput(this.filter, value, true);
        }

        this.resetFilters();
        this.dismissDropdown();
        this.dispatchInputEvent();
      }
    }
  }, {
    key: 'setAsDropdown',
    value: function setAsDropdown() {
      this.input.setAttribute(DATA_DROPDOWN_TRIGGER, '#' + this.dropdown.id);
    }
  }, {
    key: 'setOffset',
    value: function setOffset() {
      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (window.innerWidth > 480) {
        this.dropdown.style.left = offset + 'px';
      } else {
        this.dropdown.style.left = '0px';
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var currentHook = this.getCurrentHook();
      if (forceShowList && currentHook && currentHook.list.hidden) {
        currentHook.list.show();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var forceRenderContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var forceShowList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.setAsDropdown();

      var currentHook = this.getCurrentHook();
      var firstTimeInitialized = currentHook === null;

      if (firstTimeInitialized || forceRenderContent) {
        this.renderContent(forceShowList);
      } else if (currentHook.list.list.id !== this.dropdown.id) {
        this.renderContent(forceShowList);
      }
    }
  }, {
    key: 'dismissDropdown',
    value: function dismissDropdown() {
      // Focusing on the input will dismiss dropdown
      // (default droplab functionality)
      this.input.focus();
    }
  }, {
    key: 'dispatchInputEvent',
    value: function dispatchInputEvent() {
      // Propogate input change to FilteredSearchDropdownManager
      // so that it can determine which dropdowns to open
      this.input.dispatchEvent(new CustomEvent('input', {
        bubbles: true,
        cancelable: true
      }));
    }
  }, {
    key: 'dispatchFormSubmitEvent',
    value: function dispatchFormSubmitEvent() {
      // dispatchEvent() is necessary as form.submit() does not
      // trigger event handlers
      this.input.form.dispatchEvent(new Event('submit'));
    }
  }, {
    key: 'hideDropdown',
    value: function hideDropdown() {
      var currentHook = this.getCurrentHook();
      if (currentHook) {
        currentHook.list.hide();
      }
    }
  }, {
    key: 'resetFilters',
    value: function resetFilters() {
      var hook = this.getCurrentHook();

      if (hook) {
        var data = hook.list.data || [];

        if (!data) return;

        var results = data.map(function (o) {
          var updated = o;
          updated.droplab_hidden = false;
          return updated;
        });
        hook.list.render(results);
      }
    }
  }]);

  return FilteredSearchDropdown;
}();

/* harmony default export */ var filtered_search_dropdown = (filtered_search_dropdown_FilteredSearchDropdown);
// EXTERNAL MODULE: ./filtered_search/filtered_search_visual_tokens.js + 1 modules
var filtered_search_visual_tokens = __webpack_require__("./filtered_search/filtered_search_visual_tokens.js");

// CONCATENATED MODULE: ./filtered_search/dropdown_hint.js
var dropdown_hint__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function dropdown_hint__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var dropdown_hint_DropdownHint = function (_FilteredSearchDropdo) {
  _inherits(DropdownHint, _FilteredSearchDropdo);

  function DropdownHint() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    dropdown_hint__classCallCheck(this, DropdownHint);

    var input = options.input,
        tokenKeys = options.tokenKeys;

    var _this = _possibleConstructorReturn(this, (DropdownHint.__proto__ || Object.getPrototypeOf(DropdownHint)).call(this, options));

    _this.config = {
      Filter: {
        template: 'hint',
        filterFunction: dropdown_utils["a" /* default */].filterHint.bind(null, {
          input: input,
          allowedKeys: tokenKeys.getKeys()
        })
      }
    };
    _this.tokenKeys = tokenKeys;
    return _this;
  }

  dropdown_hint__createClass(DropdownHint, [{
    key: 'itemClicked',
    value: function itemClicked(e) {
      var selected = e.detail.selected;


      if (selected.tagName === 'LI') {
        if (selected.hasAttribute('data-value')) {
          this.dismissDropdown();
        } else if (selected.getAttribute('data-action') === 'submit') {
          this.dismissDropdown();
          this.dispatchFormSubmitEvent();
        } else {
          var token = selected.querySelector('.js-filter-hint').innerText.trim();
          var tag = selected.querySelector('.js-filter-tag').innerText.trim();

          if (tag.length) {
            // Get previous input values in the input field and convert them into visual tokens
            var previousInputValues = this.input.value.split(' ');
            var searchTerms = [];

            previousInputValues.forEach(function (value, index) {
              searchTerms.push(value);

              if (index === previousInputValues.length - 1 && token.indexOf(value.toLowerCase()) !== -1) {
                searchTerms.pop();
              }
            });

            if (searchTerms.length > 0) {
              filtered_search_visual_tokens["a" /* default */].addSearchVisualToken(searchTerms.join(' '));
            }

            filtered_search_dropdown_manager.addWordToInput(token.replace(':', ''), '', false, this.container);
          }
          this.dismissDropdown();
          this.dispatchInputEvent();
        }
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var dropdownData = this.tokenKeys.get().map(function (tokenKey) {
        return {
          icon: 'fa-' + tokenKey.icon,
          hint: tokenKey.key,
          tag: ':' + tokenKey.tag,
          type: tokenKey.type
        };
      });

      this.droplab.changeHookList(this.hookId, this.dropdown, [filter], this.config);
      this.droplab.setData(this.hookId, dropdownData);
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [filter], this.config).init();
    }
  }]);

  return DropdownHint;
}(filtered_search_dropdown);

/* harmony default export */ var dropdown_hint = (dropdown_hint_DropdownHint);
// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/ajax_cache.js
var ajax_cache = __webpack_require__("./lib/utils/ajax_cache.js");

// CONCATENATED MODULE: ./droplab/plugins/ajax.js
/* eslint-disable */



var Ajax = {
  _loadData: function _loadData(data, config, self) {
    if (config.loadingTemplate) {
      var dataLoadingTemplate = self.hook.list.list.querySelector('[data-loading-template]');
      if (dataLoadingTemplate) dataLoadingTemplate.outerHTML = self.listTemplate;
    }

    if (!self.destroyed) self.hook.list[config.method].call(self.hook.list, data);
  },
  preprocessing: function preprocessing(config, data) {
    var results = data;

    if (config.preprocessing && !data.preprocessed) {
      results = config.preprocessing(data);
      ajax_cache["a" /* default */].override(config.endpoint, results);
    }

    return results;
  },
  init: function init(hook) {
    var self = this;
    self.destroyed = false;
    var config = hook.config.Ajax;
    this.hook = hook;
    if (!config || !config.endpoint || !config.method) {
      return;
    }
    if (config.method !== 'setData' && config.method !== 'addData') {
      return;
    }
    if (config.loadingTemplate) {
      var dynamicList = hook.list.list.querySelector('[data-dynamic]');
      var loadingTemplate = document.createElement('div');
      loadingTemplate.innerHTML = config.loadingTemplate;
      loadingTemplate.setAttribute('data-loading-template', '');
      this.listTemplate = dynamicList.outerHTML;
      dynamicList.outerHTML = loadingTemplate.outerHTML;
    }

    return ajax_cache["a" /* default */].retrieve(config.endpoint).then(self.preprocessing.bind(null, config)).then(function (data) {
      return self._loadData(data, config, self);
    }).catch(config.onError);
  },
  destroy: function destroy() {
    this.destroyed = true;
  }
};

/* harmony default export */ var ajax = (Ajax);
// CONCATENATED MODULE: ./filtered_search/dropdown_emoji.js
var dropdown_emoji__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function dropdown_emoji__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown_emoji__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown_emoji__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var dropdown_emoji_DropdownEmoji = function (_FilteredSearchDropdo) {
  dropdown_emoji__inherits(DropdownEmoji, _FilteredSearchDropdo);

  function DropdownEmoji() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    dropdown_emoji__classCallCheck(this, DropdownEmoji);

    var _this = dropdown_emoji__possibleConstructorReturn(this, (DropdownEmoji.__proto__ || Object.getPrototypeOf(DropdownEmoji)).call(this, options));

    _this.config = {
      Ajax: {
        endpoint: (gon.relative_url_root || '') + '/autocomplete/award_emojis',
        method: 'setData',
        loadingTemplate: _this.loadingTemplate,
        onError: function onError() {
          /* eslint-disable no-new */
          new flash["a" /* default */]('An error occurred fetching the dropdown data.');
          /* eslint-enable no-new */
        }
      },
      Filter: {
        template: 'name'
      }
    };

    __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (_ref) {
      var glEmojiTag = _ref.glEmojiTag;
      _this.glEmojiTag = glEmojiTag;
    }).catch(function () {/* ignore error and leave emoji name in the search bar */});

    _this.unbindEvents();
    _this.bindEvents();
    return _this;
  }

  dropdown_emoji__createClass(DropdownEmoji, [{
    key: 'bindEvents',
    value: function bindEvents() {
      _get(DropdownEmoji.prototype.__proto__ || Object.getPrototypeOf(DropdownEmoji.prototype), 'bindEvents', this).call(this);

      this.listRenderedWrapper = this.listRendered.bind(this);
      this.dropdown.addEventListener('render.dl', this.listRenderedWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      this.dropdown.removeEventListener('render.dl', this.listRenderedWrapper);
      _get(DropdownEmoji.prototype.__proto__ || Object.getPrototypeOf(DropdownEmoji.prototype), 'unbindEvents', this).call(this);
    }
  }, {
    key: 'listRendered',
    value: function listRendered() {
      this.replaceEmojiElement();
    }
  }, {
    key: 'itemClicked',
    value: function itemClicked(e) {
      _get(DropdownEmoji.prototype.__proto__ || Object.getPrototypeOf(DropdownEmoji.prototype), 'itemClicked', this).call(this, e, function (selected) {
        var name = selected.querySelector('.js-data-value').innerText.trim();
        return dropdown_utils["a" /* default */].getEscapedText(name);
      });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.droplab.changeHookList(this.hookId, this.dropdown, [ajax, filter], this.config);
      _get(DropdownEmoji.prototype.__proto__ || Object.getPrototypeOf(DropdownEmoji.prototype), 'renderContent', this).call(this, forceShowList);
    }
  }, {
    key: 'replaceEmojiElement',
    value: function replaceEmojiElement() {
      var _this2 = this;

      if (!this.glEmojiTag) return;

      // Replace empty gl-emoji tag to real content
      var dropdownItems = [].concat(_toConsumableArray(this.dropdown.querySelectorAll('.filter-dropdown-item')));
      dropdownItems.forEach(function (dropdownItem) {
        var name = dropdownItem.querySelector('.js-data-value').innerText;
        var emojiTag = _this2.glEmojiTag(name);
        var emojiElement = dropdownItem.querySelector('gl-emoji');
        emojiElement.outerHTML = emojiTag;
      });
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [ajax, filter], this.config).init();
    }
  }]);

  return DropdownEmoji;
}(filtered_search_dropdown);

/* harmony default export */ var dropdown_emoji = (dropdown_emoji_DropdownEmoji);
// CONCATENATED MODULE: ./filtered_search/dropdown_non_user.js
var dropdown_non_user__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var dropdown_non_user__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function dropdown_non_user__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown_non_user__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown_non_user__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var dropdown_non_user_DropdownNonUser = function (_FilteredSearchDropdo) {
  dropdown_non_user__inherits(DropdownNonUser, _FilteredSearchDropdo);

  function DropdownNonUser() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    dropdown_non_user__classCallCheck(this, DropdownNonUser);

    var input = options.input,
        endpoint = options.endpoint,
        symbol = options.symbol,
        preprocessing = options.preprocessing;

    var _this = dropdown_non_user__possibleConstructorReturn(this, (DropdownNonUser.__proto__ || Object.getPrototypeOf(DropdownNonUser)).call(this, options));

    _this.symbol = symbol;
    _this.config = {
      Ajax: {
        endpoint: endpoint,
        method: 'setData',
        loadingTemplate: _this.loadingTemplate,
        preprocessing: preprocessing,
        onError: function onError() {
          /* eslint-disable no-new */
          new flash["a" /* default */]('An error occurred fetching the dropdown data.');
          /* eslint-enable no-new */
        }
      },
      Filter: {
        filterFunction: dropdown_utils["a" /* default */].filterWithSymbol.bind(null, _this.symbol, input),
        template: 'title'
      }
    };
    return _this;
  }

  dropdown_non_user__createClass(DropdownNonUser, [{
    key: 'itemClicked',
    value: function itemClicked(e) {
      var _this2 = this;

      dropdown_non_user__get(DropdownNonUser.prototype.__proto__ || Object.getPrototypeOf(DropdownNonUser.prototype), 'itemClicked', this).call(this, e, function (selected) {
        var title = selected.querySelector('.js-data-value').innerText.trim();
        return '' + _this2.symbol + dropdown_utils["a" /* default */].getEscapedText(title);
      });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.droplab.changeHookList(this.hookId, this.dropdown, [ajax, filter], this.config);
      dropdown_non_user__get(DropdownNonUser.prototype.__proto__ || Object.getPrototypeOf(DropdownNonUser.prototype), 'renderContent', this).call(this, forceShowList);
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [ajax, filter], this.config).init();
    }
  }]);

  return DropdownNonUser;
}(filtered_search_dropdown);

/* harmony default export */ var dropdown_non_user = (dropdown_non_user_DropdownNonUser);
// CONCATENATED MODULE: ./droplab/plugins/ajax_filter.js
/* eslint-disable */


var AjaxFilter = {
  init: function init(hook) {
    this.destroyed = false;
    this.hook = hook;
    this.notLoading();

    this.eventWrapper = {};
    this.eventWrapper.debounceTrigger = this.debounceTrigger.bind(this);
    this.hook.trigger.addEventListener('keydown.dl', this.eventWrapper.debounceTrigger);
    this.hook.trigger.addEventListener('focus', this.eventWrapper.debounceTrigger);

    this.trigger(true);
  },

  notLoading: function notLoading() {
    this.loading = false;
  },

  debounceTrigger: function debounceTrigger(e) {
    var NON_CHARACTER_KEYS = [16, 17, 18, 20, 37, 38, 39, 40, 91, 93];
    var invalidKeyPressed = NON_CHARACTER_KEYS.indexOf(e.detail.which || e.detail.keyCode) > -1;
    var focusEvent = e.type === 'focus';
    if (invalidKeyPressed || this.loading) {
      return;
    }
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(this.trigger.bind(this, focusEvent), 200);
  },

  trigger: function trigger(getEntireList) {
    var _this = this;

    var config = this.hook.config.AjaxFilter;
    var searchValue = this.trigger.value;
    if (!config || !config.endpoint || !config.searchKey) {
      return;
    }
    if (config.searchValueFunction) {
      searchValue = config.searchValueFunction();
    }
    if (config.loadingTemplate && this.hook.list.data === undefined || this.hook.list.data.length === 0) {
      var dynamicList = this.hook.list.list.querySelector('[data-dynamic]');
      var loadingTemplate = document.createElement('div');
      loadingTemplate.innerHTML = config.loadingTemplate;
      loadingTemplate.setAttribute('data-loading-template', true);
      this.listTemplate = dynamicList.outerHTML;
      dynamicList.outerHTML = loadingTemplate.outerHTML;
    }
    if (getEntireList) {
      searchValue = '';
    }
    if (config.searchKey === searchValue) {
      return this.list.show();
    }
    this.loading = true;
    var params = config.params || {};
    params[config.searchKey] = searchValue;
    var url = config.endpoint + this.buildParams(params);
    return ajax_cache["a" /* default */].retrieve(url).then(function (data) {
      _this._loadData(data, config);
      if (config.onLoadingFinished) {
        config.onLoadingFinished(data);
      }
    }).catch(config.onError);
  },

  _loadData: function _loadData(data, config) {
    var list = this.hook.list;
    if (config.loadingTemplate && list.data === undefined || list.data.length === 0) {
      var dataLoadingTemplate = list.list.querySelector('[data-loading-template]');
      if (dataLoadingTemplate) {
        dataLoadingTemplate.outerHTML = this.listTemplate;
      }
    }
    if (!this.destroyed) {
      var hookListChildren = list.list.children;
      var onlyDynamicList = hookListChildren.length === 1 && hookListChildren[0].hasAttribute('data-dynamic');
      if (onlyDynamicList && data.length === 0) {
        list.hide();
      }
      list.setData.call(list, data);
    }
    this.notLoading();
    list.currentIndex = 0;
  },


  buildParams: function buildParams(params) {
    if (!params) return '';
    var paramsArray = Object.keys(params).map(function (param) {
      return param + '=' + (params[param] || '');
    });
    return '?' + paramsArray.join('&');
  },

  destroy: function destroy() {
    if (this.timeout) clearTimeout(this.timeout);
    this.destroyed = true;

    this.hook.trigger.removeEventListener('keydown.dl', this.eventWrapper.debounceTrigger);
    this.hook.trigger.removeEventListener('focus', this.eventWrapper.debounceTrigger);
  }
};

/* harmony default export */ var ajax_filter = (AjaxFilter);
// EXTERNAL MODULE: ./lib/utils/dom_utils.js
var dom_utils = __webpack_require__("./lib/utils/dom_utils.js");

// EXTERNAL MODULE: ./filtered_search/filtered_search_tokenizer.js
var filtered_search_tokenizer = __webpack_require__("./filtered_search/filtered_search_tokenizer.js");

// CONCATENATED MODULE: ./filtered_search/dropdown_user.js
var dropdown_user__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var dropdown_user__get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function dropdown_user__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function dropdown_user__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function dropdown_user__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var dropdown_user_DropdownUser = function (_FilteredSearchDropdo) {
  dropdown_user__inherits(DropdownUser, _FilteredSearchDropdo);

  function DropdownUser() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    dropdown_user__classCallCheck(this, DropdownUser);

    var tokenKeys = options.tokenKeys;

    var _this = dropdown_user__possibleConstructorReturn(this, (DropdownUser.__proto__ || Object.getPrototypeOf(DropdownUser)).call(this, options));

    _this.config = {
      AjaxFilter: {
        endpoint: (gon.relative_url_root || '') + '/autocomplete/users.json',
        searchKey: 'search',
        params: {
          active: true,
          group_id: _this.getGroupId(),
          project_id: _this.getProjectId(),
          current_user: true
        },
        searchValueFunction: _this.getSearchInput.bind(_this),
        loadingTemplate: _this.loadingTemplate,
        onLoadingFinished: function onLoadingFinished() {
          _this.hideCurrentUser();
        },
        onError: function onError() {
          /* eslint-disable no-new */
          new flash["a" /* default */]('An error occurred fetching the dropdown data.');
          /* eslint-enable no-new */
        }
      }
    };
    _this.tokenKeys = tokenKeys;
    return _this;
  }

  dropdown_user__createClass(DropdownUser, [{
    key: 'hideCurrentUser',
    value: function hideCurrentUser() {
      Object(dom_utils["a" /* addClassIfElementExists */])(this.dropdown.querySelector('.js-current-user'), 'hidden');
    }
  }, {
    key: 'itemClicked',
    value: function itemClicked(e) {
      dropdown_user__get(DropdownUser.prototype.__proto__ || Object.getPrototypeOf(DropdownUser.prototype), 'itemClicked', this).call(this, e, function (selected) {
        return selected.querySelector('.dropdown-light-content').innerText.trim();
      });
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var forceShowList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.droplab.changeHookList(this.hookId, this.dropdown, [ajax_filter], this.config);
      dropdown_user__get(DropdownUser.prototype.__proto__ || Object.getPrototypeOf(DropdownUser.prototype), 'renderContent', this).call(this, forceShowList);
    }
  }, {
    key: 'getGroupId',
    value: function getGroupId() {
      return this.input.getAttribute('data-group-id');
    }
  }, {
    key: 'getProjectId',
    value: function getProjectId() {
      return this.input.getAttribute('data-project-id');
    }
  }, {
    key: 'getSearchInput',
    value: function getSearchInput() {
      var query = dropdown_utils["a" /* default */].getSearchInput(this.input);

      var _FilteredSearchTokeni = filtered_search_tokenizer["a" /* default */].processTokens(query, this.tokenKeys.get()),
          lastToken = _FilteredSearchTokeni.lastToken;

      var value = lastToken || '';

      if (value[0] === '@') {
        value = value.slice(1);
      }

      // Removes the first character if it is a quotation so that we can search
      // with multiple words
      if (value[0] === '"' || value[0] === '\'') {
        value = value.slice(1);
      }

      return value;
    }
  }, {
    key: 'init',
    value: function init() {
      this.droplab.addHook(this.input, this.dropdown, [ajax_filter], this.config).init();
    }
  }]);

  return DropdownUser;
}(filtered_search_dropdown);

/* harmony default export */ var dropdown_user = (dropdown_user_DropdownUser);
// CONCATENATED MODULE: ./filtered_search/filtered_search_dropdown_manager.js
var filtered_search_dropdown_manager__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_dropdown_manager__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var filtered_search_dropdown_manager_FilteredSearchDropdownManager = function () {
  function FilteredSearchDropdownManager(_ref) {
    var _ref$baseEndpoint = _ref.baseEndpoint,
        baseEndpoint = _ref$baseEndpoint === undefined ? '' : _ref$baseEndpoint,
        tokenizer = _ref.tokenizer,
        page = _ref.page,
        isGroup = _ref.isGroup,
        isGroupAncestor = _ref.isGroupAncestor,
        isGroupDecendent = _ref.isGroupDecendent,
        filteredSearchTokenKeys = _ref.filteredSearchTokenKeys;

    filtered_search_dropdown_manager__classCallCheck(this, FilteredSearchDropdownManager);

    this.container = container["a" /* default */].container;
    this.baseEndpoint = baseEndpoint.replace(/\/$/, '');
    this.tokenizer = tokenizer;
    this.filteredSearchTokenKeys = filteredSearchTokenKeys || filtered_search_token_keys["a" /* default */];
    this.filteredSearchInput = this.container.querySelector('.filtered-search');
    this.page = page;
    this.groupsOnly = isGroup;
    this.includeAncestorGroups = isGroupAncestor;
    this.includeDescendantGroups = isGroupDecendent;

    this.setupMapping();

    this.cleanupWrapper = this.cleanup.bind(this);
    document.addEventListener('beforeunload', this.cleanupWrapper);
  }

  filtered_search_dropdown_manager__createClass(FilteredSearchDropdownManager, [{
    key: 'cleanup',
    value: function cleanup() {
      if (this.droplab) {
        this.droplab.destroy();
        this.droplab = null;
      }

      this.setupMapping();

      document.removeEventListener('beforeunload', this.cleanupWrapper);
    }
  }, {
    key: 'setupMapping',
    value: function setupMapping() {
      var supportedTokens = this.filteredSearchTokenKeys.getKeys();
      var allowedMappings = {
        hint: {
          reference: null,
          gl: dropdown_hint,
          element: this.container.querySelector('#js-dropdown-hint')
        }
      };
      var availableMappings = {
        author: {
          reference: null,
          gl: dropdown_user,
          element: this.container.querySelector('#js-dropdown-author')
        },
        assignee: {
          reference: null,
          gl: dropdown_user,
          element: this.container.querySelector('#js-dropdown-assignee')
        },
        milestone: {
          reference: null,
          gl: dropdown_non_user,
          extraArguments: {
            endpoint: this.getMilestoneEndpoint(),
            symbol: '%'
          },
          element: this.container.querySelector('#js-dropdown-milestone')
        },
        label: {
          reference: null,
          gl: dropdown_non_user,
          extraArguments: {
            endpoint: this.getLabelsEndpoint(),
            symbol: '~',
            preprocessing: dropdown_utils["a" /* default */].duplicateLabelPreprocessing
          },
          element: this.container.querySelector('#js-dropdown-label')
        },
        'my-reaction': {
          reference: null,
          gl: dropdown_emoji,
          element: this.container.querySelector('#js-dropdown-my-reaction')
        }
      };

      supportedTokens.forEach(function (type) {
        if (availableMappings[type]) {
          allowedMappings[type] = availableMappings[type];
        }
      });

      this.mapping = allowedMappings;
    }
  }, {
    key: 'getMilestoneEndpoint',
    value: function getMilestoneEndpoint() {
      var endpoint = this.baseEndpoint + '/milestones.json';

      return endpoint;
    }
  }, {
    key: 'getLabelsEndpoint',
    value: function getLabelsEndpoint() {
      var endpoint = this.baseEndpoint + '/labels.json?';

      if (this.groupsOnly) {
        endpoint = endpoint + 'only_group_labels=true&';
      }

      if (this.includeAncestorGroups) {
        endpoint = endpoint + 'include_ancestor_groups=true&';
      }

      if (this.includeDescendantGroups) {
        endpoint = endpoint + 'include_descendant_groups=true';
      }

      return endpoint;
    }
  }, {
    key: 'updateCurrentDropdownOffset',
    value: function updateCurrentDropdownOffset() {
      this.updateDropdownOffset(this.currentDropdown);
    }
  }, {
    key: 'updateDropdownOffset',
    value: function updateDropdownOffset(key) {
      // Always align dropdown with the input field
      var offset = this.filteredSearchInput.getBoundingClientRect().left - this.container.querySelector('.scroll-container').getBoundingClientRect().left;

      var maxInputWidth = 240;
      var currentDropdownWidth = this.mapping[key].element.clientWidth || maxInputWidth;

      // Make sure offset never exceeds the input container
      var offsetMaxWidth = this.container.querySelector('.scroll-container').clientWidth - currentDropdownWidth;
      if (offsetMaxWidth < offset) {
        offset = offsetMaxWidth;
      }

      this.mapping[key].reference.setOffset(offset);
    }
  }, {
    key: 'load',
    value: function load(key) {
      var firstLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var mappingKey = this.mapping[key];
      var glClass = mappingKey.gl;
      var element = mappingKey.element;
      var forceShowList = false;

      if (!mappingKey.reference) {
        var defaultArguments = {
          droplab: this.droplab,
          dropdown: element,
          input: this.filteredSearchInput,
          tokenKeys: this.filteredSearchTokenKeys,
          filter: key
        };
        var extraArguments = mappingKey.extraArguments || {};
        var glArguments = Object.assign({}, defaultArguments, extraArguments);

        // Passing glArguments to `new glClass(<arguments>)`
        mappingKey.reference = new (Function.prototype.bind.apply(glClass, [null, glArguments]))();
      }

      if (firstLoad) {
        mappingKey.reference.init();
      }

      if (this.currentDropdown === 'hint') {
        // Force the dropdown to show if it was clicked from the hint dropdown
        forceShowList = true;
      }

      this.updateDropdownOffset(key);
      mappingKey.reference.render(firstLoad, forceShowList);

      this.currentDropdown = key;
    }
  }, {
    key: 'loadDropdown',
    value: function loadDropdown() {
      var dropdownName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var firstLoad = false;

      if (!this.droplab) {
        firstLoad = true;
        this.droplab = new drop_lab["a" /* default */]();
      }

      var match = this.filteredSearchTokenKeys.searchByKey(dropdownName.toLowerCase());
      var shouldOpenFilterDropdown = match && this.currentDropdown !== match.key && this.mapping[match.key];
      var shouldOpenHintDropdown = !match && this.currentDropdown !== 'hint';

      if (shouldOpenFilterDropdown || shouldOpenHintDropdown) {
        var key = match && match.key ? match.key : 'hint';
        this.load(key, firstLoad);
      }
    }
  }, {
    key: 'setDropdown',
    value: function setDropdown() {
      var query = dropdown_utils["a" /* default */].getSearchQuery(true);

      var _tokenizer$processTok = this.tokenizer.processTokens(query, this.filteredSearchTokenKeys.getKeys()),
          lastToken = _tokenizer$processTok.lastToken,
          searchToken = _tokenizer$processTok.searchToken;

      if (this.currentDropdown) {
        this.updateCurrentDropdownOffset();
      }

      if (lastToken === searchToken && lastToken !== null) {
        // Token is not fully initialized yet because it has no value
        // Eg. token = 'label:'

        var split = lastToken.split(':');
        var dropdownName = underscore_default.a.last(split[0].split(' '));
        this.loadDropdown(split.length > 1 ? dropdownName : '');
      } else if (lastToken) {
        // Token has been initialized into an object because it has a value
        this.loadDropdown(lastToken.key);
      } else {
        this.loadDropdown('hint');
      }
    }
  }, {
    key: 'resetDropdowns',
    value: function resetDropdowns() {
      if (!this.currentDropdown) {
        return;
      }

      // Force current dropdown to hide
      this.mapping[this.currentDropdown].reference.hideDropdown();

      // Re-Load dropdown
      this.setDropdown();

      // Reset filters for current dropdown
      this.mapping[this.currentDropdown].reference.resetFilters();

      // Reposition dropdown so that it is aligned with cursor
      this.updateDropdownOffset(this.currentDropdown);
    }
  }, {
    key: 'destroyDroplab',
    value: function destroyDroplab() {
      this.droplab.destroy();
    }
  }], [{
    key: 'addWordToInput',
    value: function addWordToInput(tokenName) {
      var tokenValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var clicked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var input = container["a" /* default */].container.querySelector('.filtered-search');

      filtered_search_visual_tokens["a" /* default */].addFilterVisualToken(tokenName, tokenValue);
      input.value = '';

      if (clicked) {
        filtered_search_visual_tokens["a" /* default */].moveInputToTheRight();
      }
    }
  }]);

  return FilteredSearchDropdownManager;
}();

/* harmony default export */ var filtered_search_dropdown_manager = __webpack_exports__["a"] = (filtered_search_dropdown_manager_FilteredSearchDropdownManager);

/***/ }),

/***/ "./filtered_search/filtered_search_token_keys.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var tokenKeys = [{
  key: 'author',
  type: 'string',
  param: 'username',
  symbol: '@',
  icon: 'pencil',
  tag: '@author'
}, {
  key: 'assignee',
  type: 'string',
  param: 'username',
  symbol: '@',
  icon: 'user',
  tag: '@assignee'
}, {
  key: 'milestone',
  type: 'string',
  param: 'title',
  symbol: '%',
  icon: 'clock-o',
  tag: '%milestone'
}, {
  key: 'label',
  type: 'array',
  param: 'name[]',
  symbol: '~',
  icon: 'tag',
  tag: '~label'
}];

if (gon.current_user_id) {
  // Appending tokenkeys only logged-in
  tokenKeys.push({
    key: 'my-reaction',
    type: 'string',
    param: 'emoji',
    symbol: '',
    icon: 'thumbs-up',
    tag: 'emoji'
  });
}

var alternativeTokenKeys = [{
  key: 'label',
  type: 'string',
  param: 'name',
  symbol: '~'
}];

var tokenKeysWithAlternative = tokenKeys.concat(alternativeTokenKeys);

var conditions = [{
  url: 'assignee_id=0',
  tokenKey: 'assignee',
  value: 'none'
}, {
  url: 'milestone_title=No+Milestone',
  tokenKey: 'milestone',
  value: 'none'
}, {
  url: 'milestone_title=%23upcoming',
  tokenKey: 'milestone',
  value: 'upcoming'
}, {
  url: 'milestone_title=%23started',
  tokenKey: 'milestone',
  value: 'started'
}, {
  url: 'label_name[]=No+Label',
  tokenKey: 'label',
  value: 'none'
}];

var FilteredSearchTokenKeys = function () {
  function FilteredSearchTokenKeys() {
    _classCallCheck(this, FilteredSearchTokenKeys);
  }

  _createClass(FilteredSearchTokenKeys, null, [{
    key: 'get',
    value: function get() {
      return tokenKeys;
    }
  }, {
    key: 'getKeys',
    value: function getKeys() {
      return tokenKeys.map(function (i) {
        return i.key;
      });
    }
  }, {
    key: 'getAlternatives',
    value: function getAlternatives() {
      return alternativeTokenKeys;
    }
  }, {
    key: 'getConditions',
    value: function getConditions() {
      return conditions;
    }
  }, {
    key: 'searchByKey',
    value: function searchByKey(key) {
      return tokenKeys.find(function (tokenKey) {
        return tokenKey.key === key;
      }) || null;
    }
  }, {
    key: 'searchBySymbol',
    value: function searchBySymbol(symbol) {
      return tokenKeys.find(function (tokenKey) {
        return tokenKey.symbol === symbol;
      }) || null;
    }
  }, {
    key: 'searchByKeyParam',
    value: function searchByKeyParam(keyParam) {
      return tokenKeysWithAlternative.find(function (tokenKey) {
        var tokenKeyParam = tokenKey.key;

        // Replace hyphen with underscore to compare keyParam with tokenKeyParam
        // e.g. 'my-reaction' => 'my_reaction'
        tokenKeyParam = tokenKeyParam.replace('-', '_');

        if (tokenKey.param) {
          tokenKeyParam += '_' + tokenKey.param;
        }

        return keyParam === tokenKeyParam;
      }) || null;
    }
  }, {
    key: 'searchByConditionUrl',
    value: function searchByConditionUrl(url) {
      return conditions.find(function (condition) {
        return condition.url === url;
      }) || null;
    }
  }, {
    key: 'searchByConditionKeyValue',
    value: function searchByConditionKeyValue(key, value) {
      return conditions.find(function (condition) {
        return condition.tokenKey === key && condition.value === value;
      }) || null;
    }
  }]);

  return FilteredSearchTokenKeys;
}();

/* harmony default export */ __webpack_exports__["a"] = (FilteredSearchTokenKeys);

/***/ }),

/***/ "./filtered_search/filtered_search_tokenizer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_token_keys__ = __webpack_require__("./filtered_search/filtered_search_token_keys.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var FilteredSearchTokenizer = function () {
  function FilteredSearchTokenizer() {
    _classCallCheck(this, FilteredSearchTokenizer);
  }

  _createClass(FilteredSearchTokenizer, null, [{
    key: 'processTokens',
    value: function processTokens(input, allowedKeys) {
      // Regex extracts `(token):(symbol)(value)`
      // Values that start with a double quote must end in a double quote (same for single)
      var tokenRegex = new RegExp('(' + allowedKeys.join('|') + '):([~%@]?)(?:(\'[^\']*\'{0,1})|("[^"]*"{0,1})|(\\S+))', 'g');
      var tokens = [];
      var tokenIndexes = []; // stores key+value for simple search
      var lastToken = null;
      var searchToken = input.replace(tokenRegex, function (match, key, symbol, v1, v2, v3) {
        var tokenValue = v1 || v2 || v3;
        var tokenSymbol = symbol;
        var tokenIndex = '';

        if (tokenValue === '~' || tokenValue === '%' || tokenValue === '@') {
          tokenSymbol = tokenValue;
          tokenValue = '';
        }

        tokenIndex = key + ':' + tokenValue;

        // Prevent adding duplicates
        if (tokenIndexes.indexOf(tokenIndex) === -1) {
          tokenIndexes.push(tokenIndex);

          tokens.push({
            key: key,
            value: tokenValue || '',
            symbol: tokenSymbol || ''
          });
        }

        return '';
      }).replace(/\s{2,}/g, ' ').trim() || '';

      if (tokens.length > 0) {
        var last = tokens[tokens.length - 1];
        var lastString = last.key + ':' + last.symbol + last.value;
        lastToken = input.lastIndexOf(lastString) === input.length - lastString.length ? last : searchToken;
      } else {
        lastToken = searchToken;
      }

      return {
        tokens: tokens,
        lastToken: lastToken,
        searchToken: searchToken
      };
    }
  }]);

  return FilteredSearchTokenizer;
}();

/* harmony default export */ __webpack_exports__["a"] = (FilteredSearchTokenizer);

/***/ }),

/***/ "./filtered_search/filtered_search_visual_tokens.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./lib/utils/ajax_cache.js
var ajax_cache = __webpack_require__("./lib/utils/ajax_cache.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./filtered_search/container.js
var container = __webpack_require__("./filtered_search/container.js");

// EXTERNAL MODULE: ./api.js
var api = __webpack_require__("./api.js");

// EXTERNAL MODULE: ./lib/utils/cache.js
var cache = __webpack_require__("./lib/utils/cache.js");

// CONCATENATED MODULE: ./lib/utils/users_cache.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var users_cache_UsersCache = function (_Cache) {
  _inherits(UsersCache, _Cache);

  function UsersCache() {
    _classCallCheck(this, UsersCache);

    return _possibleConstructorReturn(this, (UsersCache.__proto__ || Object.getPrototypeOf(UsersCache)).apply(this, arguments));
  }

  _createClass(UsersCache, [{
    key: 'retrieve',
    value: function retrieve(username) {
      var _this2 = this;

      if (this.hasData(username)) {
        return Promise.resolve(this.get(username));
      }

      return api["a" /* default */].users('', { username: username }).then(function (_ref) {
        var data = _ref.data;

        if (!data.length) {
          throw new Error('User "' + username + '" could not be found!');
        }

        if (data.length > 1) {
          throw new Error('Expected username "' + username + '" to be unique!');
        }

        var user = data[0];
        _this2.internalStorage[username] = user;
        return user;
      });
      // missing catch is intentional, error handling depends on use case
    }
  }]);

  return UsersCache;
}(cache["a" /* default */]);

/* harmony default export */ var users_cache = (new users_cache_UsersCache());
// EXTERNAL MODULE: ./filtered_search/dropdown_utils.js
var dropdown_utils = __webpack_require__("./filtered_search/dropdown_utils.js");

// CONCATENATED MODULE: ./filtered_search/filtered_search_visual_tokens.js
var filtered_search_visual_tokens__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function filtered_search_visual_tokens__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var filtered_search_visual_tokens_FilteredSearchVisualTokens = function () {
  function FilteredSearchVisualTokens() {
    filtered_search_visual_tokens__classCallCheck(this, FilteredSearchVisualTokens);
  }

  filtered_search_visual_tokens__createClass(FilteredSearchVisualTokens, null, [{
    key: 'getLastVisualTokenBeforeInput',
    value: function getLastVisualTokenBeforeInput() {
      var inputLi = container["a" /* default */].container.querySelector('.input-token');
      var lastVisualToken = inputLi && inputLi.previousElementSibling;

      return {
        lastVisualToken: lastVisualToken,
        isLastVisualTokenValid: lastVisualToken === null || lastVisualToken.className.indexOf('filtered-search-term') !== -1 || lastVisualToken && lastVisualToken.querySelector('.value') !== null
      };
    }

    /**
     * Returns a computed API endpoint
     * and query string composed of values from endpointQueryParams
     * @param {String} endpoint
     * @param {String} endpointQueryParams
     */

  }, {
    key: 'getEndpointWithQueryParams',
    value: function getEndpointWithQueryParams(endpoint, endpointQueryParams) {
      if (!endpointQueryParams) {
        return endpoint;
      }

      var queryString = Object(common_utils["A" /* objectToQueryString */])(JSON.parse(endpointQueryParams));
      return endpoint + '?' + queryString;
    }
  }, {
    key: 'unselectTokens',
    value: function unselectTokens() {
      var otherTokens = container["a" /* default */].container.querySelectorAll('.js-visual-token .selectable.selected');
      [].forEach.call(otherTokens, function (t) {
        return t.classList.remove('selected');
      });
    }
  }, {
    key: 'selectToken',
    value: function selectToken(tokenButton) {
      var forceSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = tokenButton.classList.contains('selected');
      FilteredSearchVisualTokens.unselectTokens();

      if (!selected || forceSelection) {
        tokenButton.classList.add('selected');
      }
    }
  }, {
    key: 'removeSelectedToken',
    value: function removeSelectedToken() {
      var selected = container["a" /* default */].container.querySelector('.js-visual-token .selected');

      if (selected) {
        var li = selected.closest('.js-visual-token');
        li.parentElement.removeChild(li);
      }
    }
  }, {
    key: 'createVisualTokenElementHTML',
    value: function createVisualTokenElementHTML() {
      var canEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      return '\n      <div class="' + (canEdit ? 'selectable' : 'hidden') + '" role="button">\n        <div class="name"></div>\n        <div class="value-container">\n          <div class="value"></div>\n          <div class="remove-token" role="button">\n            <i class="fa fa-close"></i>\n          </div>\n        </div>\n      </div>\n    ';
    }
  }, {
    key: 'setTokenStyle',
    value: function setTokenStyle(tokenContainer, backgroundColor, textColor) {
      var token = tokenContainer;

      // Labels with linear gradient should not override default background color
      if (backgroundColor.indexOf('linear-gradient') === -1) {
        token.style.backgroundColor = backgroundColor;
      }

      token.style.color = textColor;

      if (textColor === '#FFFFFF') {
        var removeToken = token.querySelector('.remove-token');
        removeToken.classList.add('inverted');
      }

      return token;
    }
  }, {
    key: 'preprocessLabel',
    value: function preprocessLabel(labelsEndpoint, labels) {
      var processed = labels;

      if (!labels.preprocessed) {
        processed = dropdown_utils["a" /* default */].duplicateLabelPreprocessing(labels);
        ajax_cache["a" /* default */].override(labelsEndpoint, processed);
        processed.preprocessed = true;
      }

      return processed;
    }
  }, {
    key: 'updateLabelTokenColor',
    value: function updateLabelTokenColor(tokenValueContainer, tokenValue) {
      var filteredSearchInput = container["a" /* default */].container.querySelector('.filtered-search');
      var baseEndpoint = filteredSearchInput.dataset.baseEndpoint;
      var labelsEndpoint = FilteredSearchVisualTokens.getEndpointWithQueryParams(baseEndpoint + '/labels.json', filteredSearchInput.dataset.endpointQueryParams);

      return ajax_cache["a" /* default */].retrieve(labelsEndpoint).then(FilteredSearchVisualTokens.preprocessLabel.bind(null, labelsEndpoint)).then(function (labels) {
        var matchingLabel = (labels || []).find(function (label) {
          return '~' + dropdown_utils["a" /* default */].getEscapedText(label.title) === tokenValue;
        });

        if (!matchingLabel) {
          return;
        }

        FilteredSearchVisualTokens.setTokenStyle(tokenValueContainer, matchingLabel.color, matchingLabel.text_color);
      }).catch(function () {
        return new flash["a" /* default */]('An error occurred while fetching label colors.');
      });
    }
  }, {
    key: 'updateUserTokenAppearance',
    value: function updateUserTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue) {
      if (tokenValue === 'none') {
        return Promise.resolve();
      }

      var username = tokenValue.replace(/^@/, '');
      return users_cache.retrieve(username).then(function (user) {
        if (!user) {
          return;
        }

        /* eslint-disable no-param-reassign */
        tokenValueContainer.dataset.originalValue = tokenValue;
        tokenValueElement.innerHTML = '\n          <img class="avatar s20" src="' + user.avatar_url + '" alt="">\n          ' + underscore_default.a.escape(user.name) + '\n        ';
        /* eslint-enable no-param-reassign */
      })
      // ignore error and leave username in the search bar
      .catch(function () {});
    }
  }, {
    key: 'updateEmojiTokenAppearance',
    value: function updateEmojiTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue) {
      var container = tokenValueContainer;
      var element = tokenValueElement;

      return __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (Emoji) {
        if (!Emoji.isEmojiNameValid(tokenValue)) {
          return;
        }

        container.dataset.originalValue = tokenValue;
        element.innerHTML = Emoji.glEmojiTag(tokenValue);
      })
      // ignore error and leave emoji name in the search bar
      .catch(function () {});
    }
  }, {
    key: 'renderVisualTokenValue',
    value: function renderVisualTokenValue(parentElement, tokenName, tokenValue) {
      var tokenValueContainer = parentElement.querySelector('.value-container');
      var tokenValueElement = tokenValueContainer.querySelector('.value');
      tokenValueElement.innerText = tokenValue;

      var tokenType = tokenName.toLowerCase();
      if (tokenType === 'label') {
        FilteredSearchVisualTokens.updateLabelTokenColor(tokenValueContainer, tokenValue);
      } else if (tokenType === 'author' || tokenType === 'assignee') {
        FilteredSearchVisualTokens.updateUserTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue);
      } else if (tokenType === 'my-reaction') {
        FilteredSearchVisualTokens.updateEmojiTokenAppearance(tokenValueContainer, tokenValueElement, tokenValue);
      }
    }
  }, {
    key: 'addVisualTokenElement',
    value: function addVisualTokenElement(name, value, isSearchTerm, canEdit) {
      var li = document.createElement('li');
      li.classList.add('js-visual-token');
      li.classList.add(isSearchTerm ? 'filtered-search-term' : 'filtered-search-token');

      if (value) {
        li.innerHTML = FilteredSearchVisualTokens.createVisualTokenElementHTML(canEdit);
        FilteredSearchVisualTokens.renderVisualTokenValue(li, name, value);
      } else {
        li.innerHTML = '<div class="name"></div>';
      }
      li.querySelector('.name').innerText = name;

      var tokensContainer = container["a" /* default */].container.querySelector('.tokens-container');
      var input = container["a" /* default */].container.querySelector('.filtered-search');
      tokensContainer.insertBefore(li, input.parentElement);
    }
  }, {
    key: 'addValueToPreviousVisualTokenElement',
    value: function addValueToPreviousVisualTokenElement(value) {
      var _FilteredSearchVisual = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual.lastVisualToken,
          isLastVisualTokenValid = _FilteredSearchVisual.isLastVisualTokenValid;

      if (!isLastVisualTokenValid && lastVisualToken.classList.contains('filtered-search-token')) {
        var name = FilteredSearchVisualTokens.getLastTokenPartial();
        lastVisualToken.innerHTML = FilteredSearchVisualTokens.createVisualTokenElementHTML();
        lastVisualToken.querySelector('.name').innerText = name;
        FilteredSearchVisualTokens.renderVisualTokenValue(lastVisualToken, name, value);
      }
    }
  }, {
    key: 'addFilterVisualToken',
    value: function addFilterVisualToken(tokenName, tokenValue, canEdit) {
      var _FilteredSearchVisual2 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual2.lastVisualToken,
          isLastVisualTokenValid = _FilteredSearchVisual2.isLastVisualTokenValid;

      var addVisualTokenElement = FilteredSearchVisualTokens.addVisualTokenElement;

      if (isLastVisualTokenValid) {
        addVisualTokenElement(tokenName, tokenValue, false, canEdit);
      } else {
        var previousTokenName = lastVisualToken.querySelector('.name').innerText;
        var tokensContainer = container["a" /* default */].container.querySelector('.tokens-container');
        tokensContainer.removeChild(lastVisualToken);

        var value = tokenValue || tokenName;
        addVisualTokenElement(previousTokenName, value, false, canEdit);
      }
    }
  }, {
    key: 'addSearchVisualToken',
    value: function addSearchVisualToken(searchTerm) {
      var _FilteredSearchVisual3 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual3.lastVisualToken;

      if (lastVisualToken && lastVisualToken.classList.contains('filtered-search-term')) {
        lastVisualToken.querySelector('.name').innerText += ' ' + searchTerm;
      } else {
        FilteredSearchVisualTokens.addVisualTokenElement(searchTerm, null, true);
      }
    }
  }, {
    key: 'getLastTokenPartial',
    value: function getLastTokenPartial() {
      var _FilteredSearchVisual4 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual4.lastVisualToken;

      if (!lastVisualToken) return '';

      var valueContainer = lastVisualToken.querySelector('.value-container');
      var originalValue = valueContainer && valueContainer.dataset.originalValue;
      if (originalValue) {
        return originalValue;
      }

      var value = lastVisualToken.querySelector('.value');
      var name = lastVisualToken.querySelector('.name');

      var valueText = value ? value.innerText : '';
      var nameText = name ? name.innerText : '';

      return valueText || nameText;
    }
  }, {
    key: 'removeLastTokenPartial',
    value: function removeLastTokenPartial() {
      var _FilteredSearchVisual5 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          lastVisualToken = _FilteredSearchVisual5.lastVisualToken;

      if (lastVisualToken) {
        var value = lastVisualToken.querySelector('.value');

        if (value) {
          var button = lastVisualToken.querySelector('.selectable');
          var valueContainer = lastVisualToken.querySelector('.value-container');
          button.removeChild(valueContainer);
          lastVisualToken.innerHTML = button.innerHTML;
        } else {
          lastVisualToken.closest('.tokens-container').removeChild(lastVisualToken);
        }
      }
    }
  }, {
    key: 'tokenizeInput',
    value: function tokenizeInput() {
      var input = container["a" /* default */].container.querySelector('.filtered-search');

      var _FilteredSearchVisual6 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
          isLastVisualTokenValid = _FilteredSearchVisual6.isLastVisualTokenValid;

      if (input.value) {
        if (isLastVisualTokenValid) {
          FilteredSearchVisualTokens.addSearchVisualToken(input.value);
        } else {
          FilteredSearchVisualTokens.addValueToPreviousVisualTokenElement(input.value);
        }

        input.value = '';
      }
    }
  }, {
    key: 'editToken',
    value: function editToken(token) {
      var input = container["a" /* default */].container.querySelector('.filtered-search');

      FilteredSearchVisualTokens.tokenizeInput();

      // Replace token with input field
      var tokenContainer = token.parentElement;
      var inputLi = input.parentElement;
      tokenContainer.replaceChild(inputLi, token);

      var nameElement = token.querySelector('.name');
      var value = void 0;

      if (token.classList.contains('filtered-search-token')) {
        FilteredSearchVisualTokens.addFilterVisualToken(nameElement.innerText);

        var valueContainerElement = token.querySelector('.value-container');
        value = valueContainerElement.dataset.originalValue;

        if (!value) {
          var valueElement = valueContainerElement.querySelector('.value');
          value = valueElement.innerText;
        }
      }

      // token is a search term
      if (!value) {
        value = nameElement.innerText;
      }

      input.value = value;

      // Opens dropdown
      var inputEvent = new Event('input');
      input.dispatchEvent(inputEvent);

      // Adds cursor to input
      input.focus();
    }
  }, {
    key: 'moveInputToTheRight',
    value: function moveInputToTheRight() {
      var input = container["a" /* default */].container.querySelector('.filtered-search');

      if (!input) return;

      var inputLi = input.parentElement;
      var tokenContainer = container["a" /* default */].container.querySelector('.tokens-container');

      FilteredSearchVisualTokens.tokenizeInput();

      if (!tokenContainer.lastElementChild.isEqualNode(inputLi)) {
        var _FilteredSearchVisual7 = FilteredSearchVisualTokens.getLastVisualTokenBeforeInput(),
            isLastVisualTokenValid = _FilteredSearchVisual7.isLastVisualTokenValid;

        if (!isLastVisualTokenValid) {
          var lastPartial = FilteredSearchVisualTokens.getLastTokenPartial();
          FilteredSearchVisualTokens.removeLastTokenPartial();
          FilteredSearchVisualTokens.addSearchVisualToken(lastPartial);
        }

        tokenContainer.removeChild(inputLi);
        tokenContainer.appendChild(inputLi);
      }
    }
  }]);

  return FilteredSearchVisualTokens;
}();

/* harmony default export */ var filtered_search_visual_tokens = __webpack_exports__["a"] = (filtered_search_visual_tokens_FilteredSearchVisualTokens);

/***/ }),

/***/ "./flash.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createFlash; });
/* unused harmony export createFlashEl */
/* unused harmony export createAction */
/* unused harmony export hideFlash */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeFlashClickListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);


var hideFlash = function hideFlash(flashEl) {
  var fadeTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (fadeTransition) {
    Object.assign(flashEl.style, {
      transition: 'opacity .3s',
      opacity: '0'
    });
  }

  flashEl.addEventListener('transitionend', function () {
    flashEl.remove();
    if (document.body.classList.contains('flash-shown')) document.body.classList.remove('flash-shown');
  }, {
    once: true,
    passive: true
  });

  if (!fadeTransition) flashEl.dispatchEvent(new Event('transitionend'));
};

var createAction = function createAction(config) {
  return '\n  <a\n    href="' + (config.href || '#') + '"\n    class="flash-action"\n    ' + (config.href ? '' : 'role="button"') + '\n  >\n    ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(config.title) + '\n  </a>\n';
};

var createFlashEl = function createFlashEl(message, type) {
  var isInContentWrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return '\n  <div\n    class="flash-' + type + '"\n  >\n    <div\n      class="flash-text ' + (isInContentWrapper ? 'container-fluid container-limited' : '') + '"\n    >\n      ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(message) + '\n    </div>\n  </div>\n';
};

var removeFlashClickListener = function removeFlashClickListener(flashEl, fadeTransition) {
  flashEl.addEventListener('click', function () {
    return hideFlash(flashEl, fadeTransition);
  });
};

/*
 *  Flash banner supports different types of Flash configurations
 *  along with ability to provide actionConfig which can be used to show
 *  additional action or link on banner next to message
 *
 *  @param {String} message           Flash message text
 *  @param {String} type              Type of Flash, it can be `notice` or `alert` (default)
 *  @param {Object} parent            Reference to parent element under which Flash needs to appear
 *  @param {Object} actonConfig       Map of config to show action on banner
 *    @param {String} href            URL to which action config should point to (default: '#')
 *    @param {String} title           Title of action
 *    @param {Function} clickHandler  Method to call when action is clicked on
 *  @param {Boolean} fadeTransition   Boolean to determine whether to fade the alert out
 */
var createFlash = function createFlash(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'alert';
  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  var actionConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var fadeTransition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var addBodyClass = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var flashContainer = parent.querySelector('.flash-container');

  if (!flashContainer) return null;

  var isInContentWrapper = flashContainer.parentNode.classList.contains('content-wrapper');

  flashContainer.innerHTML = createFlashEl(message, type, isInContentWrapper);

  var flashEl = flashContainer.querySelector('.flash-' + type);
  removeFlashClickListener(flashEl, fadeTransition);

  if (actionConfig) {
    flashEl.innerHTML += createAction(actionConfig);

    if (actionConfig.clickHandler) {
      flashEl.querySelector('.flash-action').addEventListener('click', function (e) {
        return actionConfig.clickHandler(e);
      });
    }
  }

  flashContainer.style.display = 'block';

  if (addBodyClass) document.body.classList.add('flash-shown');

  return flashContainer;
};


window.Flash = createFlash;

/***/ }),

/***/ "./gfm_auto_complete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./lib/utils/regexp.js
/**
 * Regexp utility for the convenience of working with regular expressions.
 *
 */

// Inspired by https://github.com/mishoo/UglifyJS/blob/2bc1d02363db3798d5df41fb5059a19edca9b7eb/lib/parse-js.js#L203
// Unicode 6.1
var unicodeLetters = '\\u0041-\\u005A\\u0061-\\u007A\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u0527\\u0531-\\u0556\\u0559\\u0561-\\u0587\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u08A0\\u08A2-\\u08AC\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0977\\u0979-\\u097F\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C33\\u0C35-\\u0C39\\u0C3D\\u0C58\\u0C59\\u0C60\\u0C61\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D60\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F4\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16EE-\\u16F0\\u1700-\\u170C\\u170E-\\u1711\\u1720-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1877\\u1880-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191C\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19C1-\\u19C7\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4B\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1CE9-\\u1CEC\\u1CEE-\\u1CF1\\u1CF5\\u1CF6\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2160-\\u2188\\u2C00-\\u2C2E\\u2C30-\\u2C5E\\u2C60-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005-\\u3007\\u3021-\\u3029\\u3031-\\u3035\\u3038-\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312D\\u3131-\\u318E\\u31A0-\\u31BA\\u31F0-\\u31FF\\u3400-\\u4DB5\\u4E00-\\u9FCC\\uA000-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA697\\uA6A0-\\uA6EF\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA78E\\uA790-\\uA793\\uA7A0-\\uA7AA\\uA7F8-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA80-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uABC0-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC';

/* harmony default export */ var utils_regexp = ({ unicodeLetters: unicodeLetters });
// EXTERNAL MODULE: ./lib/utils/ajax_cache.js
var ajax_cache = __webpack_require__("./lib/utils/ajax_cache.js");

// CONCATENATED MODULE: ./gfm_auto_complete.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






function sanitize(str) {
  return str.replace(/<(?:.|\n)*?>/gm, '');
}

var gfm_auto_complete_GfmAutoComplete = function () {
  function GfmAutoComplete(dataSources) {
    _classCallCheck(this, GfmAutoComplete);

    this.dataSources = dataSources || {};
    this.cachedData = {};
    this.isLoadingData = {};
  }

  _createClass(GfmAutoComplete, [{
    key: 'setup',
    value: function setup(input) {
      var enableMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        emojis: true,
        members: true,
        issues: true,
        milestones: true,
        mergeRequests: true,
        labels: true
      };

      // Add GFM auto-completion to all input fields, that accept GFM input.
      this.input = input || jquery_default()('.js-gfm-input');
      this.enableMap = enableMap;
      this.setupLifecycle();
    }
  }, {
    key: 'setupLifecycle',
    value: function setupLifecycle() {
      var _this = this;

      this.input.each(function (i, input) {
        var $input = jquery_default()(input);
        $input.off('focus.setupAtWho').on('focus.setupAtWho', _this.setupAtWho.bind(_this, $input));
        $input.on('change.atwho', function () {
          return input.dispatchEvent(new Event('input'));
        });
        // This triggers at.js again
        // Needed for quick actions with suffixes (ex: /label ~)
        $input.on('inserted-commands.atwho', $input.trigger.bind($input, 'keyup'));
        $input.on('clear-commands-cache.atwho', function () {
          return _this.clearCache();
        });
      });
    }
  }, {
    key: 'setupAtWho',
    value: function setupAtWho($input) {
      if (this.enableMap.emojis) this.setupEmoji($input);
      if (this.enableMap.members) this.setupMembers($input);
      if (this.enableMap.issues) this.setupIssues($input);
      if (this.enableMap.milestones) this.setupMilestones($input);
      if (this.enableMap.mergeRequests) this.setupMergeRequests($input);
      if (this.enableMap.labels) this.setupLabels($input);

      // We don't instantiate the quick actions autocomplete for note and issue/MR edit forms
      $input.filter('[data-supports-quick-actions="true"]').atwho({
        at: '/',
        alias: 'commands',
        searchKey: 'search',
        skipSpecialCharacterTest: true,
        skipMarkdownCharacterTest: true,
        data: GfmAutoComplete.defaultLoadingData,
        displayTpl: function displayTpl(value) {
          if (GfmAutoComplete.isLoading(value)) return GfmAutoComplete.Loading.template;
          // eslint-disable-next-line no-template-curly-in-string
          var tpl = '<li><span class="name">/${name}</span>';
          if (value.aliases.length > 0) {
            tpl += ' <small class="aliases">(or /<%- aliases.join(", /") %>)</small>';
          }
          if (value.params.length > 0) {
            tpl += ' <small class="params"><%- params.join(" ") %></small>';
          }
          if (value.description !== '') {
            tpl += '<small class="description"><i><%- description %></i></small>';
          }
          tpl += '</li>';
          return underscore_default.a.template(tpl)(value);
        },
        insertTpl: function insertTpl(value) {
          // eslint-disable-next-line no-template-curly-in-string
          var tpl = '/${name} ';
          var referencePrefix = null;
          if (value.params.length > 0) {
            referencePrefix = value.params[0][0];
            if (/^[@%~]/.test(referencePrefix)) {
              tpl += '<%- referencePrefix %>';
            }
          }
          return underscore_default.a.template(tpl)({ referencePrefix: referencePrefix });
        },

        suffix: '',
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(commands) {
            if (GfmAutoComplete.isLoading(commands)) return commands;
            return jquery_default.a.map(commands, function (c) {
              var search = c.name;
              if (c.aliases.length > 0) {
                search = search + ' ' + c.aliases.join(' ');
              }
              return {
                name: c.name,
                aliases: c.aliases,
                params: c.params,
                description: c.description,
                search: search
              };
            });
          },
          matcher: function matcher(flag, subtext) {
            var regexp = /(?:^|\n)\/([A-Za-z_]*)$/gi;
            var match = regexp.exec(subtext);
            if (match) {
              return match[1];
            }
            return null;
          }
        })
      });
    }
  }, {
    key: 'setupEmoji',
    value: function setupEmoji($input) {
      // Emoji
      $input.atwho({
        at: ':',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value && value.name) {
            tmpl = GfmAutoComplete.Emoji.templateFunction(value.name);
          }
          return tmpl;
        },

        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: ':${name}:',
        skipSpecialCharacterTest: true,
        data: GfmAutoComplete.defaultLoadingData,
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          matcher: function matcher(flag, subtext) {
            var regexp = new RegExp('(?:[^' + utils_regexp.unicodeLetters + '0-9:]|\n|^):([^:]*)$', 'gi');
            var match = regexp.exec(subtext);

            return match && match.length ? match[1] : null;
          }
        })
      });
    }
  }, {
    key: 'setupMembers',
    value: function setupMembers($input) {
      // Team Members
      $input.atwho({
        at: '@',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value.username != null) {
            tmpl = GfmAutoComplete.Members.template;
          }
          return tmpl;
        },

        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${username}',
        searchKey: 'search',
        alwaysHighlightFirst: true,
        skipSpecialCharacterTest: true,
        data: GfmAutoComplete.defaultLoadingData,
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(members) {
            return jquery_default.a.map(members, function (m) {
              var title = '';
              if (m.username == null) {
                return m;
              }
              title = m.name;
              if (m.count) {
                title += ' (' + m.count + ')';
              }

              var autoCompleteAvatar = m.avatar_url || m.username.charAt(0).toUpperCase();
              var imgAvatar = '<img src="' + m.avatar_url + '" alt="' + m.username + '" class="avatar avatar-inline center s26"/>';
              var txtAvatar = '<div class="avatar center avatar-inline s26">' + autoCompleteAvatar + '</div>';

              return {
                username: m.username,
                avatarTag: autoCompleteAvatar.length === 1 ? txtAvatar : imgAvatar,
                title: sanitize(title),
                search: sanitize(m.username + ' ' + m.name)
              };
            });
          }
        })
      });
    }
  }, {
    key: 'setupIssues',
    value: function setupIssues($input) {
      $input.atwho({
        at: '#',
        alias: 'issues',
        searchKey: 'search',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value.title != null) {
            tmpl = GfmAutoComplete.Issues.template;
          }
          return tmpl;
        },

        data: GfmAutoComplete.defaultLoadingData,
        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${id}',
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(issues) {
            return jquery_default.a.map(issues, function (i) {
              if (i.title == null) {
                return i;
              }
              return {
                id: i.iid,
                title: sanitize(i.title),
                search: i.iid + ' ' + i.title
              };
            });
          }
        })
      });
    }
  }, {
    key: 'setupMilestones',
    value: function setupMilestones($input) {
      $input.atwho({
        at: '%',
        alias: 'milestones',
        searchKey: 'search',
        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${title}',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value.title != null) {
            tmpl = GfmAutoComplete.Milestones.template;
          }
          return tmpl;
        },

        data: GfmAutoComplete.defaultLoadingData,
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(milestones) {
            return jquery_default.a.map(milestones, function (m) {
              if (m.title == null) {
                return m;
              }
              return {
                id: m.iid,
                title: sanitize(m.title),
                search: m.title
              };
            });
          }
        })
      });
    }
  }, {
    key: 'setupMergeRequests',
    value: function setupMergeRequests($input) {
      $input.atwho({
        at: '!',
        alias: 'mergerequests',
        searchKey: 'search',
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Loading.template;
          if (value.title != null) {
            tmpl = GfmAutoComplete.Issues.template;
          }
          return tmpl;
        },

        data: GfmAutoComplete.defaultLoadingData,
        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${id}',
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(merges) {
            return jquery_default.a.map(merges, function (m) {
              if (m.title == null) {
                return m;
              }
              return {
                id: m.iid,
                title: sanitize(m.title),
                search: m.iid + ' ' + m.title
              };
            });
          }
        })
      });
    }
  }, {
    key: 'setupLabels',
    value: function setupLabels($input) {
      var fetchData = this.fetchData.bind(this);
      var LABEL_COMMAND = { LABEL: '/label', UNLABEL: '/unlabel', RELABEL: '/relabel' };
      var command = '';

      $input.atwho({
        at: '~',
        alias: 'labels',
        searchKey: 'search',
        data: GfmAutoComplete.defaultLoadingData,
        displayTpl: function displayTpl(value) {
          var tmpl = GfmAutoComplete.Labels.template;
          if (GfmAutoComplete.isLoading(value)) {
            tmpl = GfmAutoComplete.Loading.template;
          }
          return tmpl;
        },

        // eslint-disable-next-line no-template-curly-in-string
        insertTpl: '${atwho-at}${title}',
        callbacks: _extends({}, this.getDefaultCallbacks(), {
          beforeSave: function beforeSave(merges) {
            if (GfmAutoComplete.isLoading(merges)) return merges;
            return jquery_default.a.map(merges, function (m) {
              return {
                title: sanitize(m.title),
                color: m.color,
                search: m.title,
                set: m.set
              };
            });
          },
          matcher: function matcher(flag, subtext) {
            var match = GfmAutoComplete.defaultMatcher(flag, subtext, this.app.controllers);
            var subtextNodes = subtext.split(/\n+/g).pop().split(GfmAutoComplete.regexSubtext);

            // Check if ~ is followed by '/label', '/relabel' or '/unlabel' commands.
            command = subtextNodes.find(function (node) {
              if (node === LABEL_COMMAND.LABEL || node === LABEL_COMMAND.RELABEL || node === LABEL_COMMAND.UNLABEL) {
                return node;
              }
              return null;
            });

            return match && match.length ? match[1] : null;
          },
          filter: function filter(query, data, searchKey) {
            if (GfmAutoComplete.isLoading(data)) {
              fetchData(this.$inputor, this.at);
              return data;
            }

            if (data === GfmAutoComplete.defaultLoadingData) {
              return jquery_default.a.fn.atwho.default.callbacks.filter(query, data, searchKey);
            }

            // The `LABEL_COMMAND.RELABEL` is intentionally skipped
            // because we want to return all the labels (unfiltered) for that command.
            if (command === LABEL_COMMAND.LABEL) {
              // Return labels with set: undefined.
              return data.filter(function (label) {
                return !label.set;
              });
            } else if (command === LABEL_COMMAND.UNLABEL) {
              // Return labels with set: true.
              return data.filter(function (label) {
                return label.set;
              });
            }

            return data;
          }
        })
      });
    }
  }, {
    key: 'getDefaultCallbacks',
    value: function getDefaultCallbacks() {
      var fetchData = this.fetchData.bind(this);

      return {
        sorter: function sorter(query, items, searchKey) {
          this.setting.highlightFirst = this.setting.alwaysHighlightFirst || query.length > 0;
          if (GfmAutoComplete.isLoading(items)) {
            this.setting.highlightFirst = false;
            return items;
          }
          return jquery_default.a.fn.atwho.default.callbacks.sorter(query, items, searchKey);
        },
        filter: function filter(query, data, searchKey) {
          if (GfmAutoComplete.isLoading(data)) {
            fetchData(this.$inputor, this.at);
            return data;
          }
          return jquery_default.a.fn.atwho.default.callbacks.filter(query, data, searchKey);
        },
        beforeInsert: function beforeInsert(value) {
          var withoutAt = value.substring(1);
          var at = value.charAt();

          if (value && !this.setting.skipSpecialCharacterTest) {
            var regex = at === '~' ? /\W|^\d+$/ : /\W/;
            if (withoutAt && regex.test(withoutAt)) {
              withoutAt = '"' + withoutAt + '"';
            }
          }

          // We can ignore this for quick actions because they are processed
          // before Markdown.
          if (!this.setting.skipMarkdownCharacterTest) {
            withoutAt = withoutAt.replace(/([~\-_*`])/g, '\\$&');
          }

          return '' + at + withoutAt;
        },
        matcher: function matcher(flag, subtext) {
          var match = GfmAutoComplete.defaultMatcher(flag, subtext, this.app.controllers);

          if (match) {
            return match[1];
          }
          return null;
        }
      };
    }
  }, {
    key: 'fetchData',
    value: function fetchData($input, at) {
      var _this2 = this;

      if (this.isLoadingData[at]) return;
      this.isLoadingData[at] = true;
      if (this.cachedData[at]) {
        this.loadData($input, at, this.cachedData[at]);
      } else if (GfmAutoComplete.atTypeMap[at] === 'emojis') {
        __webpack_require__.e/* import() */("emoji").then(__webpack_require__.bind(null, "./emoji/index.js")).then(function (_ref) {
          var validEmojiNames = _ref.validEmojiNames,
              glEmojiTag = _ref.glEmojiTag;

          _this2.loadData($input, at, validEmojiNames);
          GfmAutoComplete.glEmojiTag = glEmojiTag;
        }).catch(function () {
          _this2.isLoadingData[at] = false;
        });
      } else {
        ajax_cache["a" /* default */].retrieve(this.dataSources[GfmAutoComplete.atTypeMap[at]], true).then(function (data) {
          _this2.loadData($input, at, data);
        }).catch(function () {
          _this2.isLoadingData[at] = false;
        });
      }
    }
  }, {
    key: 'loadData',
    value: function loadData($input, at, data) {
      this.isLoadingData[at] = false;
      this.cachedData[at] = data;
      $input.atwho('load', at, data);
      // This trigger at.js again
      // otherwise we would be stuck with loading until the user types
      return $input.trigger('keyup');
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      this.cachedData = {};
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.input.each(function (i, input) {
        var $input = jquery_default()(input);
        $input.atwho('destroy');
      });
    }
  }], [{
    key: 'isLoading',
    value: function isLoading(data) {
      var dataToInspect = data;
      if (data && data.length > 0) {
        dataToInspect = data[0];
      }

      var loadingState = GfmAutoComplete.defaultLoadingData[0];
      return dataToInspect && (dataToInspect === loadingState || dataToInspect.name === loadingState);
    }
  }, {
    key: 'defaultMatcher',
    value: function defaultMatcher(flag, subtext, controllers) {
      // The below is taken from At.js source
      // Tweaked to commands to start without a space only if char before is a non-word character
      // https://github.com/ichord/At.js
      var atSymbolsWithBar = Object.keys(controllers).join('|');
      var atSymbolsWithoutBar = Object.keys(controllers).join('');
      var targetSubtext = subtext.split(GfmAutoComplete.regexSubtext).pop();
      var resultantFlag = flag.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');

      var accentAChar = decodeURI('%C3%80');
      var accentYChar = decodeURI('%C3%BF');

      var regexp = new RegExp('^(?:\\B|[^a-zA-Z0-9_`' + atSymbolsWithoutBar + ']|\\s)' + resultantFlag + '(?!' + atSymbolsWithBar + ')((?:[A-Za-z' + accentAChar + '-' + accentYChar + '0-9_\'.+-]|[^\\x00-\\x7a])*)$', 'gi');

      return regexp.exec(targetSubtext);
    }
  }]);

  return GfmAutoComplete;
}();

gfm_auto_complete_GfmAutoComplete.regexSubtext = new RegExp(/\s+/g);

gfm_auto_complete_GfmAutoComplete.defaultLoadingData = ['loading'];

gfm_auto_complete_GfmAutoComplete.atTypeMap = {
  ':': 'emojis',
  '@': 'members',
  '#': 'issues',
  '!': 'mergeRequests',
  '~': 'labels',
  '%': 'milestones',
  '/': 'commands'
};

// Emoji
gfm_auto_complete_GfmAutoComplete.glEmojiTag = null;
gfm_auto_complete_GfmAutoComplete.Emoji = {
  templateFunction: function templateFunction(name) {
    // glEmojiTag helper is loaded on-demand in fetchData()
    if (gfm_auto_complete_GfmAutoComplete.glEmojiTag) {
      return '<li>' + name + ' ' + gfm_auto_complete_GfmAutoComplete.glEmojiTag(name) + '</li>';
    }
    return '<li>' + name + '</li>';
  }
};
// Team Members
gfm_auto_complete_GfmAutoComplete.Members = {
  // eslint-disable-next-line no-template-curly-in-string
  template: '<li>${avatarTag} ${username} <small>${title}</small></li>'
};
gfm_auto_complete_GfmAutoComplete.Labels = {
  // eslint-disable-next-line no-template-curly-in-string
  template: '<li><span class="dropdown-label-box" style="background: ${color}"></span> ${title}</li>'
};
// Issues and MergeRequests
gfm_auto_complete_GfmAutoComplete.Issues = {
  // eslint-disable-next-line no-template-curly-in-string
  template: '<li><small>${id}</small> ${title}</li>'
};
// Milestones
gfm_auto_complete_GfmAutoComplete.Milestones = {
  // eslint-disable-next-line no-template-curly-in-string
  template: '<li>${title}</li>'
};
gfm_auto_complete_GfmAutoComplete.Loading = {
  template: '<li style="pointer-events: none;"><i class="fa fa-spinner fa-spin"></i> Loading...</li>'
};

/* harmony default export */ var gfm_auto_complete = __webpack_exports__["a"] = (gfm_auto_complete_GfmAutoComplete);

/***/ }),

/***/ "./gl_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/fuzzaldrin-plus/lib/fuzzaldrin.js
var fuzzaldrin = __webpack_require__("../../../node_modules/fuzzaldrin-plus/lib/fuzzaldrin.js");
var fuzzaldrin_default = /*#__PURE__*/__webpack_require__.n(fuzzaldrin);

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// CONCATENATED MODULE: ./lib/utils/type_utility.js
// eslint-disable-next-line import/prefer-default-export
var isObject = function isObject(obj) {
  return obj && obj.constructor === Object;
};
// CONCATENATED MODULE: ./gl_dropdown.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable func-names, no-underscore-dangle, space-before-function-paren, no-var, one-var, one-var-declaration-per-line, prefer-rest-params, max-len, vars-on-top, wrap-iife, no-unused-vars, quotes, no-shadow, no-cond-assign, prefer-arrow-callback, no-return-assign, no-else-return, camelcase, comma-dangle, no-lonely-if, guard-for-in, no-restricted-syntax, consistent-return, prefer-template, no-param-reassign, no-loop-func, no-mixed-operators */
/* global fuzzaldrinPlus */








var gl_dropdown_GitLabDropdown, gl_dropdown_GitLabDropdownFilter, gl_dropdown_GitLabDropdownRemote, GitLabDropdownInput;

GitLabDropdownInput = function () {
  function GitLabDropdownInput(input, options) {
    var $inputContainer, $clearButton;
    var _this = this;
    this.input = input;
    this.options = options;
    this.fieldName = this.options.fieldName || 'field-name';
    $inputContainer = this.input.parent();
    $clearButton = $inputContainer.find('.js-dropdown-input-clear');
    $clearButton.on('click', function (_this) {
      // Clear click
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        return _this.input.val('').trigger('input').focus();
      };
    }(this));

    this.input.on('keydown', function (e) {
      var keyCode = e.which;
      if (keyCode === 13 && !options.elIsInput) {
        e.preventDefault();
      }
    }).on('input', function (e) {
      var val = e.currentTarget.value || _this.options.inputFieldName;
      val = val.split(' ').join('-') // replaces space with dash
      .replace(/[^a-zA-Z0-9 -]/g, '').toLowerCase() // replace non alphanumeric
      .replace(/(-)\1+/g, '-'); // replace repeated dashes
      _this.cb(_this.options.fieldName, val, {}, true);
      _this.input.closest('.dropdown').find('.dropdown-toggle-text').text(val);
    });
  }

  GitLabDropdownInput.prototype.onInput = function (cb) {
    this.cb = cb;
  };

  return GitLabDropdownInput;
}();

gl_dropdown_GitLabDropdownFilter = function () {
  var ARROW_KEY_CODES, BLUR_KEYCODES, HAS_VALUE_CLASS;

  BLUR_KEYCODES = [27, 40];

  ARROW_KEY_CODES = [38, 40];

  HAS_VALUE_CLASS = "has-value";

  function GitLabDropdownFilter(input, options) {
    var $clearButton, $inputContainer, ref, timeout;
    this.input = input;
    this.options = options;
    this.filterInputBlur = (ref = this.options.filterInputBlur) != null ? ref : true;
    $inputContainer = this.input.parent();
    $clearButton = $inputContainer.find('.js-dropdown-input-clear');
    $clearButton.on('click', function (_this) {
      // Clear click
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        return _this.input.val('').trigger('input').focus();
      };
    }(this));
    // Key events
    timeout = "";
    this.input.on('keydown', function (e) {
      var keyCode = e.which;
      if (keyCode === 13 && !options.elIsInput) {
        e.preventDefault();
      }
    }).on('input', function () {
      if (this.input.val() !== "" && !$inputContainer.hasClass(HAS_VALUE_CLASS)) {
        $inputContainer.addClass(HAS_VALUE_CLASS);
      } else if (this.input.val() === "" && $inputContainer.hasClass(HAS_VALUE_CLASS)) {
        $inputContainer.removeClass(HAS_VALUE_CLASS);
      }
      // Only filter asynchronously only if option remote is set
      if (this.options.remote) {
        clearTimeout(timeout);
        return timeout = setTimeout(function () {
          $inputContainer.parent().addClass('is-loading');

          return this.options.query(this.input.val(), function (data) {
            $inputContainer.parent().removeClass('is-loading');
            return this.options.callback(data);
          }.bind(this));
        }.bind(this), 250);
      } else {
        return this.filter(this.input.val());
      }
    }.bind(this));
  }

  GitLabDropdownFilter.prototype.shouldBlur = function (keyCode) {
    return BLUR_KEYCODES.indexOf(keyCode) !== -1;
  };

  GitLabDropdownFilter.prototype.filter = function (search_text) {
    var data, elements, group, key, results, tmp;
    if (this.options.onFilter) {
      this.options.onFilter(search_text);
    }
    data = this.options.data();
    if (data != null && !this.options.filterByText) {
      results = data;
      if (search_text !== '') {
        // When data is an array of objects therefore [object Array] e.g.
        // [
        //   { prop: 'foo' },
        //   { prop: 'baz' }
        // ]
        if (underscore_default.a.isArray(data)) {
          results = fuzzaldrin_default.a.filter(data, search_text, {
            key: this.options.keys
          });
        } else {
          // If data is grouped therefore an [object Object]. e.g.
          // {
          //   groupName1: [
          //     { prop: 'foo' },
          //     { prop: 'baz' }
          //   ],
          //   groupName2: [
          //     { prop: 'abc' },
          //     { prop: 'def' }
          //   ]
          // }
          if (isObject(data)) {
            results = {};
            for (key in data) {
              group = data[key];
              tmp = fuzzaldrin_default.a.filter(group, search_text, {
                key: this.options.keys
              });
              if (tmp.length) {
                results[key] = tmp.map(function (item) {
                  return item;
                });
              }
            }
          }
        }
      }
      return this.options.callback(results);
    } else {
      elements = this.options.elements();
      if (search_text) {
        elements.each(function () {
          var $el, matches;
          $el = jquery_default()(this);
          matches = fuzzaldrin_default.a.match($el.text().trim(), search_text);
          if (!$el.is('.dropdown-header')) {
            if (matches.length) {
              return $el.show().removeClass('option-hidden');
            } else {
              return $el.hide().addClass('option-hidden');
            }
          }
        });
      } else {
        elements.show().removeClass('option-hidden');
      }

      elements.parent().find('.dropdown-menu-empty-item').toggleClass('hidden', elements.is(':visible'));
    }
  };

  return GitLabDropdownFilter;
}();

gl_dropdown_GitLabDropdownRemote = function () {
  function GitLabDropdownRemote(dataEndpoint, options) {
    this.dataEndpoint = dataEndpoint;
    this.options = options;
  }

  GitLabDropdownRemote.prototype.execute = function () {
    if (typeof this.dataEndpoint === "string") {
      return this.fetchData();
    } else if (typeof this.dataEndpoint === "function") {
      if (this.options.beforeSend) {
        this.options.beforeSend();
      }
      return this.dataEndpoint("", function (_this) {
        // Fetch the data by calling the data funcfion
        return function (data) {
          if (_this.options.success) {
            _this.options.success(data);
          }
          if (_this.options.beforeSend) {
            return _this.options.beforeSend();
          }
        };
      }(this));
    }
  };

  GitLabDropdownRemote.prototype.fetchData = function () {
    var _this2 = this;

    if (this.options.beforeSend) {
      this.options.beforeSend();
    }

    // Fetch the data through ajax if the data is a string
    return axios_utils["a" /* default */].get(this.dataEndpoint).then(function (_ref) {
      var data = _ref.data;

      if (_this2.options.success) {
        return _this2.options.success(data);
      }
    });
  };

  return GitLabDropdownRemote;
}();

gl_dropdown_GitLabDropdown = function () {
  var ACTIVE_CLASS, FILTER_INPUT, NO_FILTER_INPUT, INDETERMINATE_CLASS, LOADING_CLASS, PAGE_TWO_CLASS, NON_SELECTABLE_CLASSES, SELECTABLE_CLASSES, CURSOR_SELECT_SCROLL_PADDING, currentIndex;

  LOADING_CLASS = "is-loading";

  PAGE_TWO_CLASS = "is-page-two";

  ACTIVE_CLASS = "is-active";

  INDETERMINATE_CLASS = "is-indeterminate";

  currentIndex = -1;

  NON_SELECTABLE_CLASSES = '.divider, .separator, .dropdown-header, .dropdown-menu-empty-item';

  SELECTABLE_CLASSES = ".dropdown-content li:not(" + NON_SELECTABLE_CLASSES + ", .option-hidden)";

  CURSOR_SELECT_SCROLL_PADDING = 5;

  FILTER_INPUT = '.dropdown-input .dropdown-input-field:not(.dropdown-no-filter)';

  NO_FILTER_INPUT = '.dropdown-input .dropdown-input-field.dropdown-no-filter';

  function GitLabDropdown(el1, options) {
    var searchFields, selector, self;
    this.el = el1;
    this.options = options;
    this.updateLabel = this.updateLabel.bind(this);
    this.hidden = this.hidden.bind(this);
    this.opened = this.opened.bind(this);
    this.shouldPropagate = this.shouldPropagate.bind(this);
    self = this;
    selector = jquery_default()(this.el).data("target");
    this.dropdown = selector != null ? jquery_default()(selector) : jquery_default()(this.el).parent();
    // Set Defaults
    this.filterInput = this.options.filterInput || this.getElement(FILTER_INPUT);
    this.noFilterInput = this.options.noFilterInput || this.getElement(NO_FILTER_INPUT);
    this.highlight = !!this.options.highlight;
    this.filterInputBlur = this.options.filterInputBlur != null ? this.options.filterInputBlur : true;
    // If no input is passed create a default one
    self = this;
    // If selector was passed
    if (underscore_default.a.isString(this.filterInput)) {
      this.filterInput = this.getElement(this.filterInput);
    }
    searchFields = this.options.search ? this.options.search.fields : [];
    if (this.options.data) {
      // If we provided data
      // data could be an array of objects or a group of arrays
      if (underscore_default.a.isObject(this.options.data) && !underscore_default.a.isFunction(this.options.data)) {
        this.fullData = this.options.data;
        currentIndex = -1;
        this.parseData(this.options.data);
        this.focusTextInput();
      } else {
        this.remote = new gl_dropdown_GitLabDropdownRemote(this.options.data, {
          dataType: this.options.dataType,
          beforeSend: this.toggleLoading.bind(this),
          success: function (_this) {
            return function (data) {
              _this.fullData = data;
              _this.parseData(_this.fullData);
              _this.focusTextInput();
              if (_this.options.filterable && _this.filter && _this.filter.input && _this.filter.input.val() && _this.filter.input.val().trim() !== '') {
                return _this.filter.input.trigger('input');
              }
            };
            // Remote data
          }(this),
          instance: this
        });
      }
    }
    if (this.noFilterInput.length) {
      this.plainInput = new GitLabDropdownInput(this.noFilterInput, this.options);
      this.plainInput.onInput(this.addInput.bind(this));
    }
    // Init filterable
    if (this.options.filterable) {
      this.filter = new gl_dropdown_GitLabDropdownFilter(this.filterInput, {
        elIsInput: jquery_default()(this.el).is('input'),
        filterInputBlur: this.filterInputBlur,
        filterByText: this.options.filterByText,
        onFilter: this.options.onFilter,
        remote: this.options.filterRemote,
        query: this.options.data,
        keys: searchFields,
        instance: this,
        elements: function (_this) {
          return function () {
            selector = '.dropdown-content li:not(' + NON_SELECTABLE_CLASSES + ')';
            if (_this.dropdown.find('.dropdown-toggle-page').length) {
              selector = ".dropdown-page-one " + selector;
            }
            return jquery_default()(selector, this.instance.dropdown);
          };
        }(this),
        data: function (_this) {
          return function () {
            return _this.fullData;
          };
        }(this),
        callback: function (_this) {
          return function (data) {
            _this.parseData(data);
            if (_this.filterInput.val() !== '') {
              selector = SELECTABLE_CLASSES;
              if (_this.dropdown.find('.dropdown-toggle-page').length) {
                selector = ".dropdown-page-one " + selector;
              }
              if (jquery_default()(_this.el).is('input')) {
                currentIndex = -1;
              } else {
                jquery_default()(selector, _this.dropdown).first().find('a').addClass('is-focused');
                currentIndex = 0;
              }
            }
          };
        }(this)
      });
    }
    // Event listeners
    this.dropdown.on("shown.bs.dropdown", this.opened);
    this.dropdown.on("hidden.bs.dropdown", this.hidden);
    jquery_default()(this.el).on("update.label", this.updateLabel);
    this.dropdown.on("click", ".dropdown-menu, .dropdown-menu-close", this.shouldPropagate);
    this.dropdown.on('keyup', function (_this) {
      return function (e) {
        // Escape key
        if (e.which === 27) {
          return jquery_default()('.dropdown-menu-close', _this.dropdown).trigger('click');
        }
      };
    }(this));
    this.dropdown.on('blur', 'a', function (_this) {
      return function (e) {
        var $dropdownMenu, $relatedTarget;
        if (e.relatedTarget != null) {
          $relatedTarget = jquery_default()(e.relatedTarget);
          $dropdownMenu = $relatedTarget.closest('.dropdown-menu');
          if ($dropdownMenu.length === 0) {
            return _this.dropdown.removeClass('open');
          }
        }
      };
    }(this));
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      this.dropdown.find(".dropdown-toggle-page, .dropdown-menu-back").on("click", function (_this) {
        return function (e) {
          e.preventDefault();
          e.stopPropagation();
          return _this.togglePage();
        };
      }(this));
    }
    if (this.options.selectable) {
      selector = ".dropdown-content a";
      if (this.dropdown.find(".dropdown-toggle-page").length) {
        selector = ".dropdown-page-one .dropdown-content a";
      }
      this.dropdown.on("click", selector, function (e) {
        var $el, selected, selectedObj, isMarking;
        $el = jquery_default()(e.currentTarget);
        selected = self.rowClicked($el);
        selectedObj = selected ? selected[0] : null;
        isMarking = selected ? selected[1] : null;
        if (this.options.clicked) {
          this.options.clicked.call(this, {
            selectedObj: selectedObj,
            $el: $el,
            e: e,
            isMarking: isMarking
          });
        }

        // Update label right after all modifications in dropdown has been done
        if (this.options.toggleLabel) {
          this.updateLabel(selectedObj, $el, this);
        }

        $el.trigger('blur');
      }.bind(this));
    }
  }

  // Finds an element inside wrapper element
  GitLabDropdown.prototype.getElement = function (selector) {
    return this.dropdown.find(selector);
  };

  GitLabDropdown.prototype.toggleLoading = function () {
    return jquery_default()('.dropdown-menu', this.dropdown).toggleClass(LOADING_CLASS);
  };

  GitLabDropdown.prototype.togglePage = function () {
    var menu;
    menu = jquery_default()('.dropdown-menu', this.dropdown);
    if (menu.hasClass(PAGE_TWO_CLASS)) {
      if (this.remote) {
        this.remote.execute();
      }
    }
    menu.toggleClass(PAGE_TWO_CLASS);
    // Focus first visible input on active page
    return this.dropdown.find('[class^="dropdown-page-"]:visible :text:visible:first').focus();
  };

  GitLabDropdown.prototype.parseData = function (data) {
    var full_html, groupData, html, name;
    this.renderedData = data;
    if (this.options.filterable && data.length === 0) {
      // render no matching results
      html = [this.noResults()];
    } else {
      // Handle array groups
      if (isObject(data)) {
        html = [];
        for (name in data) {
          groupData = data[name];
          html.push(this.renderItem({
            header: name
            // Add header for each group
          }, name));
          this.renderData(groupData, name).map(function (item) {
            return html.push(item);
          });
        }
      } else {
        // Render each row
        html = this.renderData(data);
      }
    }
    // Render the full menu
    full_html = this.renderMenu(html);
    return this.appendMenu(full_html);
  };

  GitLabDropdown.prototype.renderData = function (data, group) {
    if (group == null) {
      group = false;
    }
    return data.map(function (_this) {
      return function (obj, index) {
        return _this.renderItem(obj, group, index);
      };
    }(this));
  };

  GitLabDropdown.prototype.shouldPropagate = function (e) {
    var $target;
    if (this.options.multiSelect || this.options.shouldPropagate === false) {
      $target = jquery_default()(e.target);
      if ($target && !$target.hasClass('dropdown-menu-close') && !$target.hasClass('dropdown-menu-close-icon') && !$target.data('isLink')) {
        e.stopPropagation();
        return false;
      } else {
        return true;
      }
    }
  };

  GitLabDropdown.prototype.filteredFullData = function () {
    return this.fullData.filter(function (r) {
      return (typeof r === 'undefined' ? 'undefined' : _typeof(r)) === 'object' && !Object.prototype.hasOwnProperty.call(r, 'beforeDivider') && !Object.prototype.hasOwnProperty.call(r, 'header');
    });
  };

  GitLabDropdown.prototype.opened = function (e) {
    var contentHtml;
    this.resetRows();
    this.addArrowKeyEvent();

    var dropdownToggle = this.dropdown.find('.dropdown-menu-toggle');
    var hasFilterBulkUpdate = dropdownToggle.hasClass('js-filter-bulk-update');
    var shouldRefreshOnOpen = dropdownToggle.hasClass('js-gl-dropdown-refresh-on-open');
    var hasMultiSelect = dropdownToggle.hasClass('js-multiselect');

    // Makes indeterminate items effective
    if (this.fullData && (shouldRefreshOnOpen || hasFilterBulkUpdate)) {
      this.parseData(this.fullData);
    }

    // Process the data to make sure rendered data
    // matches the correct layout
    var inputValue = this.filterInput.val();
    if (this.fullData && hasMultiSelect && this.options.processData && inputValue.length === 0) {
      this.options.processData.call(this.options, inputValue, this.filteredFullData(), this.parseData.bind(this));
    }

    contentHtml = jquery_default()('.dropdown-content', this.dropdown).html();
    if (this.remote && contentHtml === "") {
      this.remote.execute();
    } else {
      this.focusTextInput();
    }

    if (this.options.showMenuAbove) {
      this.positionMenuAbove();
    }

    if (this.options.opened) {
      this.options.opened.call(this, e);
    }

    return this.dropdown.trigger('shown.gl.dropdown');
  };

  GitLabDropdown.prototype.positionMenuAbove = function () {
    var $menu = this.dropdown.find('.dropdown-menu');

    $menu.addClass('dropdown-open-top');
    $menu.css('top', 'initial');
    $menu.css('bottom', '100%');
  };

  GitLabDropdown.prototype.hidden = function (e) {
    var $input;
    this.resetRows();
    this.removeArrayKeyEvent();
    $input = this.dropdown.find(".dropdown-input-field");
    if (this.options.filterable) {
      $input.blur();
    }
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      jquery_default()('.dropdown-menu', this.dropdown).removeClass(PAGE_TWO_CLASS);
    }
    if (this.options.hidden) {
      this.options.hidden.call(this, e);
    }
    return this.dropdown.trigger('hidden.gl.dropdown');
  };

  // Render the full menu
  GitLabDropdown.prototype.renderMenu = function (html) {
    if (this.options.renderMenu) {
      return this.options.renderMenu(html);
    } else {
      var ul = document.createElement('ul');

      for (var i = 0; i < html.length; i += 1) {
        var el = html[i];

        if (el instanceof jquery_default.a) {
          el = el.get(0);
        }

        if (typeof el === 'string') {
          ul.innerHTML += el;
        } else {
          ul.appendChild(el);
        }
      }

      return ul;
    }
  };

  // Append the menu into the dropdown
  GitLabDropdown.prototype.appendMenu = function (html) {
    return this.clearMenu().append(html);
  };

  GitLabDropdown.prototype.clearMenu = function () {
    var selector;
    selector = '.dropdown-content';
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one .dropdown-content";
    }

    return jquery_default()(selector, this.dropdown).empty();
  };

  GitLabDropdown.prototype.renderItem = function (data, group, index) {
    var field, fieldName, html, selected, text, url, value, rowHidden;

    if (!this.options.renderRow) {
      value = this.options.id ? this.options.id(data) : data.id;

      if (value) {
        value = value.toString().replace(/'/g, '\\\'');
      }
    }

    // Hide element
    if (this.options.hideRow && this.options.hideRow(value)) {
      rowHidden = true;
    }
    if (group == null) {
      group = false;
    }
    if (index == null) {
      // Render the row
      index = false;
    }
    html = document.createElement('li');

    if (data === 'divider' || data === 'separator') {
      html.className = data;
      return html;
    }
    // Header
    if (data.header != null) {
      html.className = 'dropdown-header';
      html.innerHTML = data.header;
      return html;
    }
    if (this.options.renderRow) {
      // Call the render function
      html = this.options.renderRow.call(this.options, data, this);
    } else {
      if (!selected) {
        fieldName = this.options.fieldName;

        if (value) {
          field = this.dropdown.parent().find('input[name=\'' + fieldName + '\'][value=\'' + value + '\']');
          if (field.length) {
            selected = true;
          }
        } else {
          field = this.dropdown.parent().find('input[name=\'' + fieldName + '\']');
          selected = !field.length;
        }
      }
      // Set URL
      if (this.options.url != null) {
        url = this.options.url(data);
      } else {
        url = data.url != null ? data.url : '#';
      }
      // Set Text
      if (this.options.text != null) {
        text = this.options.text(data);
      } else {
        text = data.text != null ? data.text : '';
      }
      if (this.highlight) {
        text = this.highlightTextMatches(text, this.filterInput.val());
      }
      // Create the list item & the link
      var link = document.createElement('a');

      link.href = url;

      if (this.highlight) {
        link.innerHTML = text;
      } else {
        link.textContent = text;
      }

      if (selected) {
        link.className = 'is-active';
      }

      if (group) {
        link.dataset.group = group;
        link.dataset.index = index;
      }

      html.appendChild(link);
    }
    return html;
  };

  GitLabDropdown.prototype.highlightTextMatches = function (text, term) {
    var occurrences = fuzzaldrin_default.a.match(text, term);
    var indexOf = [].indexOf;
    return text.split('').map(function (character, i) {
      if (indexOf.call(occurrences, i) !== -1) {
        return "<b>" + character + "</b>";
      } else {
        return character;
      }
    }).join('');
  };

  GitLabDropdown.prototype.noResults = function () {
    var html;
    return '<li class="dropdown-menu-empty-item"><a>No matching results</a></li>';
  };

  GitLabDropdown.prototype.rowClicked = function (el) {
    var field, fieldName, groupName, isInput, selectedIndex, selectedObject, value, isMarking;

    fieldName = this.options.fieldName;
    isInput = jquery_default()(this.el).is('input');
    if (this.renderedData) {
      groupName = el.data('group');
      if (groupName) {
        selectedIndex = el.data('index');
        selectedObject = this.renderedData[groupName][selectedIndex];
      } else {
        selectedIndex = el.closest('li').index();
        selectedObject = this.renderedData[selectedIndex];
      }
    }

    if (this.options.vue) {
      if (el.hasClass(ACTIVE_CLASS)) {
        el.removeClass(ACTIVE_CLASS);
      } else {
        el.addClass(ACTIVE_CLASS);
      }

      return [selectedObject];
    }

    field = [];
    value = this.options.id ? this.options.id(selectedObject, el) : selectedObject.id;
    if (isInput) {
      field = jquery_default()(this.el);
    } else if (value != null) {
      field = this.dropdown.parent().find("input[name='" + fieldName + "'][value='" + value.toString().replace(/'/g, '\\\'') + "']");
    }

    if (this.options.isSelectable && !this.options.isSelectable(selectedObject, el)) {
      return [selectedObject];
    }

    if (el.hasClass(ACTIVE_CLASS) && value !== 0) {
      isMarking = false;
      el.removeClass(ACTIVE_CLASS);
      if (field && field.length) {
        this.clearField(field, isInput);
      }
    } else if (el.hasClass(INDETERMINATE_CLASS)) {
      isMarking = true;
      el.addClass(ACTIVE_CLASS);
      el.removeClass(INDETERMINATE_CLASS);
      if (field && field.length && value == null) {
        this.clearField(field, isInput);
      }
      if ((!field || !field.length) && fieldName) {
        this.addInput(fieldName, value, selectedObject);
      }
    } else {
      isMarking = true;
      if (!this.options.multiSelect || el.hasClass('dropdown-clear-active')) {
        this.dropdown.find("." + ACTIVE_CLASS).removeClass(ACTIVE_CLASS);
        if (!isInput) {
          this.dropdown.parent().find("input[name='" + fieldName + "']").remove();
        }
      }
      if (field && field.length && value == null) {
        this.clearField(field, isInput);
      }
      // Toggle active class for the tick mark
      el.addClass(ACTIVE_CLASS);
      if (value != null) {
        if ((!field || !field.length) && fieldName) {
          this.addInput(fieldName, value, selectedObject);
        } else if (field && field.length) {
          field.val(value).trigger('change');
        }
      }
    }

    return [selectedObject, isMarking];
  };

  GitLabDropdown.prototype.focusTextInput = function () {
    if (this.options.filterable) {
      var initialScrollTop = jquery_default()(window).scrollTop();

      if (this.dropdown.is('.open')) {
        this.filterInput.focus();
      }

      if (jquery_default()(window).scrollTop() < initialScrollTop) {
        jquery_default()(window).scrollTop(initialScrollTop);
      }
    }
  };

  GitLabDropdown.prototype.addInput = function (fieldName, value, selectedObject, single) {
    var $input;
    // Create hidden input for form
    if (single) {
      jquery_default()('input[name="' + fieldName + '"]').remove();
    }

    $input = jquery_default()('<input>').attr('type', 'hidden').attr('name', fieldName).val(value);
    if (this.options.inputId != null) {
      $input.attr('id', this.options.inputId);
    }

    if (this.options.multiSelect) {
      Object.keys(selectedObject).forEach(function (attribute) {
        $input.attr('data-' + attribute, selectedObject[attribute]);
      });
    }

    if (this.options.inputMeta) {
      $input.attr('data-meta', selectedObject[this.options.inputMeta]);
    }

    this.dropdown.before($input).trigger('change');
  };

  GitLabDropdown.prototype.selectRowAtIndex = function (index) {
    var $el, selector;
    // If we pass an option index
    if (typeof index !== "undefined") {
      selector = SELECTABLE_CLASSES + ":eq(" + index + ") a";
    } else {
      selector = ".dropdown-content .is-focused";
    }
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one " + selector;
    }
    // simulate a click on the first link
    $el = jquery_default()(selector, this.dropdown);
    if ($el.length) {
      var href = $el.attr('href');
      if (href && href !== '#') {
        Object(url_utility["g" /* visitUrl */])(href);
      } else {
        $el.trigger('click');
      }
    }
  };

  GitLabDropdown.prototype.addArrowKeyEvent = function () {
    var $input, ARROW_KEY_CODES, selector;
    ARROW_KEY_CODES = [38, 40];
    $input = this.dropdown.find(".dropdown-input-field");
    selector = SELECTABLE_CLASSES;
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one " + selector;
    }
    return jquery_default()('body').on('keydown', function (_this) {
      return function (e) {
        var $listItems, PREV_INDEX, currentKeyCode;
        currentKeyCode = e.which;
        if (ARROW_KEY_CODES.indexOf(currentKeyCode) !== -1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          PREV_INDEX = currentIndex;
          $listItems = jquery_default()(selector, _this.dropdown);
          // if @options.filterable
          //   $input.blur()
          if (currentKeyCode === 40) {
            // Move down
            if (currentIndex < $listItems.length - 1) {
              currentIndex += 1;
            }
          } else if (currentKeyCode === 38) {
            // Move up
            if (currentIndex > 0) {
              currentIndex -= 1;
            }
          }
          if (currentIndex !== PREV_INDEX) {
            _this.highlightRowAtIndex($listItems, currentIndex);
          }
          return false;
        }
        if (currentKeyCode === 13 && currentIndex !== -1) {
          e.preventDefault();
          _this.selectRowAtIndex();
        }
      };
    }(this));
  };

  GitLabDropdown.prototype.removeArrayKeyEvent = function () {
    return jquery_default()('body').off('keydown');
  };

  GitLabDropdown.prototype.resetRows = function resetRows() {
    currentIndex = -1;
    jquery_default()('.is-focused', this.dropdown).removeClass('is-focused');
  };

  GitLabDropdown.prototype.highlightRowAtIndex = function ($listItems, index) {
    var $dropdownContent, $listItem, dropdownContentBottom, dropdownContentHeight, dropdownContentTop, dropdownScrollTop, listItemBottom, listItemHeight, listItemTop;
    // Remove the class for the previously focused row
    jquery_default()('.is-focused', this.dropdown).removeClass('is-focused');
    // Update the class for the row at the specific index
    $listItem = $listItems.eq(index);
    $listItem.find('a:first-child').addClass("is-focused");
    // Dropdown content scroll area
    $dropdownContent = $listItem.closest('.dropdown-content');
    dropdownScrollTop = $dropdownContent.scrollTop();
    dropdownContentHeight = $dropdownContent.outerHeight();
    dropdownContentTop = $dropdownContent.prop('offsetTop');
    dropdownContentBottom = dropdownContentTop + dropdownContentHeight;
    // Get the offset bottom of the list item
    listItemHeight = $listItem.outerHeight();
    listItemTop = $listItem.prop('offsetTop');
    listItemBottom = listItemTop + listItemHeight;
    if (!index) {
      // Scroll the dropdown content to the top
      $dropdownContent.scrollTop(0);
    } else if (index === $listItems.length - 1) {
      // Scroll the dropdown content to the bottom
      $dropdownContent.scrollTop($dropdownContent.prop('scrollHeight'));
    } else if (listItemBottom > dropdownContentBottom + dropdownScrollTop) {
      // Scroll the dropdown content down
      $dropdownContent.scrollTop(listItemBottom - dropdownContentBottom + CURSOR_SELECT_SCROLL_PADDING);
    } else if (listItemTop < dropdownContentTop + dropdownScrollTop) {
      // Scroll the dropdown content up
      return $dropdownContent.scrollTop(listItemTop - dropdownContentTop - CURSOR_SELECT_SCROLL_PADDING);
    }
  };

  GitLabDropdown.prototype.updateLabel = function (selected, el, instance) {
    if (selected == null) {
      selected = null;
    }
    if (el == null) {
      el = null;
    }
    if (instance == null) {
      instance = null;
    }

    var toggleText = this.options.toggleLabel(selected, el, instance);
    if (this.options.updateLabel) {
      // Option to override the dropdown label text
      toggleText = this.options.updateLabel;
    }

    return jquery_default()(this.el).find(".dropdown-toggle-text").text(toggleText);
  };

  GitLabDropdown.prototype.clearField = function (field, isInput) {
    return isInput ? field.val('') : field.remove();
  };

  return GitLabDropdown;
}();

jquery_default.a.fn.glDropdown = function (opts) {
  return this.each(function () {
    if (!jquery_default.a.data(this, 'glDropdown')) {
      return jquery_default.a.data(this, 'glDropdown', new gl_dropdown_GitLabDropdown(this, opts));
    }
  });
};

/***/ }),

/***/ "./gl_field_errors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./gl_field_error.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * This class overrides the browser's validation error bubbles, displaying custom
 * error messages for invalid fields instead. To begin validating any form, add the
 * class `gl-show-field-errors` to the form element, and ensure error messages are
 * declared in each inputs' `title` attribute. If no title is declared for an invalid
 * field the user attempts to submit, "This field is required." will be shown by default.
 *
 * Opt not to validate certain fields by adding the class `gl-field-error-ignore` to the input.
 *
 * Set a custom error anchor for error message to be injected after with the
 * class `gl-field-error-anchor`
 *
 * Examples:
 *
 * Basic:
 *
 * <form class='gl-show-field-errors'>
 *  <input type='text' name='username' title='Username is required.'/>
 * </form>
 *
 * Ignore specific inputs (e.g. UsernameValidator):
 *
 * <form class='gl-show-field-errors'>
 *   <div class="form-group>
 *     <input type='text' class='gl-field-errors-ignore' pattern='[a-zA-Z0-9-_]+'/>
 *   </div>
 *   <div class="form-group">
 *      <input type='text' name='username' title='Username is required.'/>
 *    </div>
 * </form>
 *
 * Custom Error Anchor (allows error message to be injected after specified element):
 *
 * <form class='gl-show-field-errors'>
 *  <div class="form-group gl-field-error-anchor">
 *    <input type='text' name='username' title='Username is required.'/>
 *    // Error message typically injected here
 *  </div>
 *  // Error message now injected here
 * </form>
 *
 */

/**
 * Regex Patterns in use:
 *
 * Only alphanumeric: : "[a-zA-Z0-9]+"
 * No special characters : "[a-zA-Z0-9-_]+",
 *
 */

var errorMessageClass = 'gl-field-error';
var inputErrorClass = 'gl-field-error-outline';
var errorAnchorSelector = '.gl-field-error-anchor';
var ignoreInputSelector = '.gl-field-error-ignore';

var gl_field_error_GlFieldError = function () {
  function GlFieldError(_ref) {
    var input = _ref.input,
        formErrors = _ref.formErrors;

    _classCallCheck(this, GlFieldError);

    this.inputElement = jquery_default()(input);
    this.inputDomElement = this.inputElement.get(0);
    this.form = formErrors;
    this.errorMessage = this.inputElement.attr('title') || 'This field is required.';
    this.fieldErrorElement = jquery_default()('<p class=\'' + errorMessageClass + ' hide\'>' + this.errorMessage + '</p>');

    this.state = {
      valid: false,
      empty: true,
      submitted: false
    };

    this.initFieldValidation();
  }

  _createClass(GlFieldError, [{
    key: 'initFieldValidation',
    value: function initFieldValidation() {
      var customErrorAnchor = this.inputElement.parents(errorAnchorSelector);
      var errorAnchor = customErrorAnchor.length ? customErrorAnchor : this.inputElement;

      // hidden when injected into DOM
      errorAnchor.after(this.fieldErrorElement);
      this.inputElement.off('invalid').on('invalid', this.handleInvalidSubmit.bind(this));
      this.scopedSiblings = this.safelySelectSiblings();
    }
  }, {
    key: 'safelySelectSiblings',
    value: function safelySelectSiblings() {
      // Apply `ignoreSelector` in markup to siblings whose visibility should not be toggled
      var unignoredSiblings = this.inputElement.siblings('p:not(' + ignoreInputSelector + ')');
      var parentContainer = this.inputElement.parent('.form-group');

      // Only select siblings when they're scoped within a form-group with one input
      var safelyScoped = parentContainer.length && parentContainer.find('input').length === 1;

      return safelyScoped ? unignoredSiblings : this.fieldErrorElement;
    }
  }, {
    key: 'renderValidity',
    value: function renderValidity() {
      this.renderClear();

      if (this.state.valid) {
        this.renderValid();
      } else if (this.state.empty) {
        this.renderEmpty();
      } else if (!this.state.valid) {
        this.renderInvalid();
      }
    }
  }, {
    key: 'handleInvalidSubmit',
    value: function handleInvalidSubmit(event) {
      event.preventDefault();
      var currentValue = this.accessCurrentValue();
      this.state.valid = false;
      this.state.empty = currentValue === '';
      this.state.submitted = true;
      this.renderValidity();
      this.form.focusOnFirstInvalid.apply(this.form);

      // For UX, wait til after first invalid submission to check each keyup
      this.inputElement.off('keyup.fieldValidator').on('keyup.fieldValidator', this.updateValidity.bind(this));
    }

    /* Get or set current input value */

  }, {
    key: 'accessCurrentValue',
    value: function accessCurrentValue(newVal) {
      return newVal ? this.inputElement.val(newVal) : this.inputElement.val();
    }
  }, {
    key: 'getInputValidity',
    value: function getInputValidity() {
      return this.inputDomElement.validity.valid;
    }
  }, {
    key: 'updateValidity',
    value: function updateValidity() {
      var inputVal = this.accessCurrentValue();
      this.state.empty = !inputVal.length;
      this.state.valid = this.getInputValidity();
      this.renderValidity();
    }
  }, {
    key: 'renderValid',
    value: function renderValid() {
      return this.renderClear();
    }
  }, {
    key: 'renderEmpty',
    value: function renderEmpty() {
      return this.renderInvalid();
    }
  }, {
    key: 'renderInvalid',
    value: function renderInvalid() {
      this.inputElement.addClass(inputErrorClass);
      this.scopedSiblings.hide();
      return this.fieldErrorElement.show();
    }
  }, {
    key: 'renderClear',
    value: function renderClear() {
      var inputVal = this.accessCurrentValue();
      if (!inputVal.split(' ').length) {
        var trimmedInput = inputVal.trim();
        this.accessCurrentValue(trimmedInput);
      }
      this.inputElement.removeClass(inputErrorClass);
      this.scopedSiblings.hide();
      this.fieldErrorElement.hide();
    }
  }]);

  return GlFieldError;
}();

/* harmony default export */ var gl_field_error = (gl_field_error_GlFieldError);
// CONCATENATED MODULE: ./gl_field_errors.js
var gl_field_errors__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function gl_field_errors__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var customValidationFlag = 'gl-field-error-ignore';

var gl_field_errors_GlFieldErrors = function () {
  function GlFieldErrors(form) {
    gl_field_errors__classCallCheck(this, GlFieldErrors);

    this.form = jquery_default()(form);
    this.state = {
      inputs: [],
      valid: false
    };
    this.initValidators();
  }

  gl_field_errors__createClass(GlFieldErrors, [{
    key: 'initValidators',
    value: function initValidators() {
      var _this = this;

      // register selectors here as needed
      var validateSelectors = [':text', ':password', '[type=email]'].map(function (selector) {
        return 'input' + selector;
      }).join(',');

      this.state.inputs = this.form.find(validateSelectors).toArray().filter(function (input) {
        return !input.classList.contains(customValidationFlag);
      }).map(function (input) {
        return new gl_field_error({ input: input, formErrors: _this });
      });

      this.form.on('submit', GlFieldErrors.catchInvalidFormSubmit);
    }

    /* Neccessary to prevent intercept and override invalid form submit
     * because Safari & iOS quietly allow form submission when form is invalid
     * and prevents disabling of invalid submit button by application.js */

  }, {
    key: 'updateFormValidityState',


    /* Public method for triggering validity updates manually  */
    value: function updateFormValidityState() {
      this.state.inputs.forEach(function (field) {
        if (field.state.submitted) {
          field.updateValidity();
        }
      });
    }
  }, {
    key: 'focusOnFirstInvalid',
    value: function focusOnFirstInvalid() {
      var firstInvalid = this.state.inputs.filter(function (input) {
        return !input.inputDomElement.validity.valid;
      })[0];
      firstInvalid.inputElement.focus();
    }
  }], [{
    key: 'catchInvalidFormSubmit',
    value: function catchInvalidFormSubmit(e) {
      var $form = jquery_default()(e.currentTarget);

      if (!$form.attr('novalidate')) {
        if (!e.currentTarget.checkValidity()) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  }]);

  return GlFieldErrors;
}();

/* harmony default export */ var gl_field_errors = __webpack_exports__["a"] = (gl_field_errors_GlFieldErrors);

/***/ }),

/***/ "./header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initTodoToggle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");



/**
 * Updates todo counter when todos are toggled.
 * When count is 0, we hide the badge.
 *
 * @param {jQuery.Event} e
 * @param {String} count
 */
function initTodoToggle() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('todo:toggle', function (e, count) {
    var parsedCount = parseInt(count, 10);
    var $todoPendingCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.todos-count');

    $todoPendingCount.text(Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__["f" /* highCountTrim */])(parsedCount));
    $todoPendingCount.toggleClass('hidden', parsedCount === 0);
  });
}

/***/ }),

/***/ "./importer_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initImporterStatus; });
/* unused harmony export ImporterStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var ImporterStatus = function () {
  function ImporterStatus(_ref) {
    var jobsUrl = _ref.jobsUrl,
        importUrl = _ref.importUrl,
        ciCdOnly = _ref.ciCdOnly;

    _classCallCheck(this, ImporterStatus);

    this.jobsUrl = jobsUrl;
    this.importUrl = importUrl;
    this.ciCdOnly = ciCdOnly;
    this.initStatusPage();
    this.setAutoUpdate();
  }

  _createClass(ImporterStatus, [{
    key: 'initStatusPage',
    value: function initStatusPage() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-import').off('click').on('click', this.addToImport.bind(this));

      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-import-all').off('click').on('click', function onClickImportAll() {
        var $btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        $btn.disable().addClass('is-loading');
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-import').each(function triggerAddImport() {
          return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).trigger('click');
        });
      });
    }
  }, {
    key: 'addToImport',
    value: function addToImport(event) {
      var _this = this;

      var $btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.currentTarget);
      var $tr = $btn.closest('tr');
      var $targetField = $tr.find('.import-target');
      var $namespaceInput = $targetField.find('.js-select-namespace option:selected');
      var id = $tr.attr('id').replace('repo_', '');
      var targetNamespace = void 0;
      var newName = void 0;
      if ($namespaceInput.length > 0) {
        targetNamespace = $namespaceInput[0].innerHTML;
        newName = $targetField.find('#path').prop('value');
        $targetField.empty().append(targetNamespace + '/' + newName);
      }
      $btn.disable().addClass('is-loading');

      return __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */].post(this.importUrl, {
        repo_id: id,
        target_namespace: targetNamespace,
        new_name: newName,
        ci_cd_only: this.ciCdOnly
      }).then(function (_ref2) {
        var data = _ref2.data;

        var job = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('tr#repo_' + id);
        job.attr('id', 'project_' + data.id);

        job.find('.import-target').html('<a href="' + data.full_path + '">' + data.full_path + '</a>');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('table.import-jobs tbody').prepend(job);

        job.addClass('active');
        var connectingVerb = _this.ciCdOnly ? Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('connecting') : Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('importing');
        job.find('.import-actions').html(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["f" /* sprintf */])(__WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('%{loadingIcon} Started')), {
          loadingIcon: '<i class="fa fa-spinner fa-spin" aria-label="' + __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(connectingVerb) + '"></i>'
        }, false));
      }).catch(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_4__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('An error occurred while importing project'));
      });
    }
  }, {
    key: 'autoUpdate',
    value: function autoUpdate() {
      return __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */].get(this.jobsUrl).then(function (_ref3) {
        var _ref3$data = _ref3.data,
            data = _ref3$data === undefined ? [] : _ref3$data;

        data.forEach(function (job) {
          var jobItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#project_' + job.id);
          var statusField = jobItem.find('.job-status');

          var spinner = '<i class="fa fa-spinner fa-spin"></i>';

          switch (job.import_status) {
            case 'finished':
              jobItem.removeClass('active').addClass('success');
              statusField.html('<span><i class="fa fa-check"></i> ' + Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('Done') + '</span>');
              break;
            case 'scheduled':
              statusField.html(spinner + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('Scheduled'));
              break;
            case 'started':
              statusField.html(spinner + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('Started'));
              break;
            case 'failed':
              statusField.html(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('Failed'));
              break;
            default:
              statusField.html(job.import_status);
              break;
          }
        });
      });
    }
  }, {
    key: 'setAutoUpdate',
    value: function setAutoUpdate() {
      setInterval(this.autoUpdate.bind(this), 4000);
    }
  }]);

  return ImporterStatus;
}();

// eslint-disable-next-line consistent-return


function initImporterStatus() {
  var importerStatus = document.querySelector('.js-importer-status');

  if (importerStatus) {
    var data = importerStatus.dataset;
    return new ImporterStatus({
      jobsUrl: data.jobsImportPath,
      importUrl: data.importPath,
      ciCdOnly: Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_common_utils__["f" /* convertPermissionToBoolean */])(data.ciCdOnly)
    });
  }
}



/***/ }),

/***/ "./layout_nav.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: ./breakpoints.js
var breakpoints = __webpack_require__("./breakpoints.js");

// CONCATENATED MODULE: ./contextual_sidebar.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var contextual_sidebar_ContextualSidebar = function () {
  function ContextualSidebar() {
    _classCallCheck(this, ContextualSidebar);

    this.initDomElements();
    this.render();
  }

  _createClass(ContextualSidebar, [{
    key: 'initDomElements',
    value: function initDomElements() {
      this.$page = jquery_default()('.layout-page');
      this.$sidebar = jquery_default()('.nav-sidebar');
      this.$innerScroll = jquery_default()('.nav-sidebar-inner-scroll', this.$sidebar);
      this.$overlay = jquery_default()('.mobile-overlay');
      this.$openSidebar = jquery_default()('.toggle-mobile-nav');
      this.$closeSidebar = jquery_default()('.close-nav-button');
      this.$sidebarToggle = jquery_default()('.js-toggle-sidebar');
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      document.addEventListener('click', function (e) {
        if (!e.target.closest('.nav-sidebar') && (breakpoints["a" /* default */].getBreakpointSize() === 'sm' || breakpoints["a" /* default */].getBreakpointSize() === 'md')) {
          _this.toggleCollapsedSidebar(true);
        }
      });
      this.$openSidebar.on('click', function () {
        return _this.toggleSidebarNav(true);
      });
      this.$closeSidebar.on('click', function () {
        return _this.toggleSidebarNav(false);
      });
      this.$overlay.on('click', function () {
        return _this.toggleSidebarNav(false);
      });
      this.$sidebarToggle.on('click', function () {
        var value = !_this.$sidebar.hasClass('sidebar-collapsed-desktop');
        _this.toggleCollapsedSidebar(value);
      });

      jquery_default()(window).on('resize', function () {
        return underscore_default.a.debounce(_this.render(), 100);
      });
    }
  }, {
    key: 'toggleSidebarNav',
    value: function toggleSidebarNav(show) {
      this.$sidebar.toggleClass('sidebar-expanded-mobile', show);
      this.$overlay.toggleClass('mobile-nav-open', show);
      this.$sidebar.removeClass('sidebar-collapsed-desktop');
    }
  }, {
    key: 'toggleCollapsedSidebar',
    value: function toggleCollapsedSidebar(collapsed) {
      var breakpoint = breakpoints["a" /* default */].getBreakpointSize();

      if (this.$sidebar.length) {
        this.$sidebar.toggleClass('sidebar-collapsed-desktop', collapsed);
        this.$page.toggleClass('page-with-icon-sidebar', breakpoint === 'sm' ? true : collapsed);
      }
      ContextualSidebar.setCollapsedCookie(collapsed);

      this.toggleSidebarOverflow();
    }
  }, {
    key: 'toggleSidebarOverflow',
    value: function toggleSidebarOverflow() {
      if (this.$innerScroll.prop('scrollHeight') > this.$innerScroll.prop('offsetHeight')) {
        this.$innerScroll.css('overflow-y', 'scroll');
      } else {
        this.$innerScroll.css('overflow-y', '');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var breakpoint = breakpoints["a" /* default */].getBreakpointSize();

      if (breakpoint === 'sm' || breakpoint === 'md') {
        this.toggleCollapsedSidebar(true);
      } else if (breakpoint === 'lg') {
        var collapse = js_cookie_default.a.get('sidebar_collapsed') === 'true';
        this.toggleCollapsedSidebar(collapse);
      }
    }
  }], [{
    key: 'setCollapsedCookie',
    value: function setCollapsedCookie(value) {
      if (breakpoints["a" /* default */].getBreakpointSize() !== 'lg') {
        return;
      }
      js_cookie_default.a.set('sidebar_collapsed', value, { expires: 365 * 10 });
    }
  }]);

  return ContextualSidebar;
}();

/* harmony default export */ var contextual_sidebar = (contextual_sidebar_ContextualSidebar);
// CONCATENATED MODULE: ./fly_out_nav.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var HIDE_INTERVAL_TIMEOUT = 300;
var IS_OVER_CLASS = 'is-over';
var IS_ABOVE_CLASS = 'is-above';
var IS_SHOWING_FLY_OUT_CLASS = 'is-showing-fly-out';
var currentOpenMenu = null;
var menuCornerLocs = void 0;
var timeoutId = void 0;
var sidebar = void 0;

var mousePos = [];

var setSidebar = function setSidebar(el) {
  sidebar = el;
};
var getOpenMenu = function getOpenMenu() {
  return currentOpenMenu;
};
var setOpenMenu = function setOpenMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  currentOpenMenu = menu;
};

var slope = function slope(a, b) {
  return (b.y - a.y) / (b.x - a.x);
};

var headerHeight = 50;

var getHeaderHeight = function getHeaderHeight() {
  return headerHeight;
};

var isSidebarCollapsed = function isSidebarCollapsed() {
  return sidebar && sidebar.classList.contains('sidebar-collapsed-desktop');
};

var canShowActiveSubItems = function canShowActiveSubItems(el) {
  if (el.classList.contains('active') && !isSidebarCollapsed()) {
    return false;
  }

  return true;
};

var fly_out_nav_canShowSubItems = function canShowSubItems() {
  return breakpoints["a" /* default */].getBreakpointSize() === 'sm' || breakpoints["a" /* default */].getBreakpointSize() === 'md' || breakpoints["a" /* default */].getBreakpointSize() === 'lg';
};

var getHideSubItemsInterval = function getHideSubItemsInterval() {
  if (!currentOpenMenu || !mousePos.length) return 0;

  var currentMousePos = mousePos[mousePos.length - 1];
  var prevMousePos = mousePos[0];
  var currentMousePosY = currentMousePos.y;

  var _menuCornerLocs = menuCornerLocs,
      _menuCornerLocs2 = _slicedToArray(_menuCornerLocs, 2),
      menuTop = _menuCornerLocs2[0],
      menuBottom = _menuCornerLocs2[1];

  if (currentMousePosY < menuTop.y || currentMousePosY > menuBottom.y) return 0;

  if (slope(prevMousePos, menuBottom) < slope(currentMousePos, menuBottom) && slope(prevMousePos, menuTop) > slope(currentMousePos, menuTop)) {
    return HIDE_INTERVAL_TIMEOUT;
  }

  return 0;
};

var calculateTop = function calculateTop(boundingRect, outerHeight) {
  var windowHeight = window.innerHeight;
  var bottomOverflow = windowHeight - (boundingRect.top + outerHeight);

  return bottomOverflow < 0 ? boundingRect.top - outerHeight + boundingRect.height : boundingRect.top;
};

var hideMenu = function hideMenu(el) {
  if (!el) return;

  var parentEl = el.parentNode;

  el.style.display = ''; // eslint-disable-line no-param-reassign
  el.style.transform = ''; // eslint-disable-line no-param-reassign
  el.classList.remove(IS_ABOVE_CLASS);
  parentEl.classList.remove(IS_OVER_CLASS);
  parentEl.classList.remove(IS_SHOWING_FLY_OUT_CLASS);

  setOpenMenu();
};

var moveSubItemsToPosition = function moveSubItemsToPosition(el, subItems) {
  var boundingRect = el.getBoundingClientRect();
  var top = calculateTop(boundingRect, subItems.offsetHeight);
  var left = sidebar ? sidebar.offsetWidth : 50;
  var isAbove = top < boundingRect.top;

  subItems.classList.add('fly-out-list');
  subItems.style.transform = 'translate3d(' + left + 'px, ' + (Math.floor(top) - headerHeight) + 'px, 0)'; // eslint-disable-line no-param-reassign

  var subItemsRect = subItems.getBoundingClientRect();

  menuCornerLocs = [{
    x: subItemsRect.left, // left position of the sub items
    y: subItemsRect.top // top position of the sub items
  }, {
    x: subItemsRect.left, // left position of the sub items
    y: subItemsRect.top + subItemsRect.height // bottom position of the sub items
  }];

  if (isAbove) {
    subItems.classList.add(IS_ABOVE_CLASS);
  }
};

var showSubLevelItems = function showSubLevelItems(el) {
  var subItems = el.querySelector('.sidebar-sub-level-items');
  var isIconOnly = subItems && subItems.classList.contains('is-fly-out-only');

  if (!fly_out_nav_canShowSubItems() || !canShowActiveSubItems(el)) return;

  el.classList.add(IS_OVER_CLASS);

  if (!subItems || !isSidebarCollapsed() && isIconOnly) return;

  subItems.style.display = 'block';
  el.classList.add(IS_SHOWING_FLY_OUT_CLASS);

  setOpenMenu(subItems);
  moveSubItemsToPosition(el, subItems);
};

var mouseEnterTopItems = function mouseEnterTopItems(el) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getHideSubItemsInterval();

  clearTimeout(timeoutId);

  timeoutId = setTimeout(function () {
    if (currentOpenMenu) hideMenu(currentOpenMenu);

    showSubLevelItems(el);
  }, timeout);
};

var mouseLeaveTopItem = function mouseLeaveTopItem(el) {
  var subItems = el.querySelector('.sidebar-sub-level-items');

  if (!fly_out_nav_canShowSubItems() || !canShowActiveSubItems(el) || subItems && subItems === currentOpenMenu) return;

  el.classList.remove(IS_OVER_CLASS);
};

var documentMouseMove = function documentMouseMove(e) {
  mousePos.push({
    x: e.clientX,
    y: e.clientY
  });

  if (mousePos.length > 6) mousePos.shift();
};

var subItemsMouseLeave = function subItemsMouseLeave(relatedTarget) {
  clearTimeout(timeoutId);

  if (relatedTarget && !relatedTarget.closest('.' + IS_OVER_CLASS)) {
    hideMenu(currentOpenMenu);
  }
};

/* harmony default export */ var fly_out_nav = (function () {
  sidebar = document.querySelector('.nav-sidebar');

  if (!sidebar) return;

  var items = [].concat(_toConsumableArray(sidebar.querySelectorAll('.sidebar-top-level-items > li')));

  var topItems = sidebar.querySelector('.sidebar-top-level-items');
  if (topItems) {
    sidebar.querySelector('.sidebar-top-level-items').addEventListener('mouseleave', function () {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(function () {
        if (currentOpenMenu) hideMenu(currentOpenMenu);
      }, getHideSubItemsInterval());
    });
  }

  headerHeight = document.querySelector('.nav-sidebar').offsetTop;

  items.forEach(function (el) {
    var subItems = el.querySelector('.sidebar-sub-level-items');

    if (subItems) {
      subItems.addEventListener('mouseleave', function (e) {
        return subItemsMouseLeave(e.relatedTarget);
      });
    }

    el.addEventListener('mouseenter', function (e) {
      return mouseEnterTopItems(e.currentTarget);
    });
    el.addEventListener('mouseleave', function (e) {
      return mouseLeaveTopItem(e.currentTarget);
    });
  });

  document.addEventListener('mousemove', documentMouseMove);
});
// CONCATENATED MODULE: ./layout_nav.js
/* harmony export (immutable) */ __webpack_exports__["a"] = initLayoutNav;




function hideEndFade($scrollingTabs) {
  $scrollingTabs.each(function scrollTabsLoop() {
    var $this = jquery_default()(this);
    $this.siblings('.fade-right').toggleClass('scrolling', Math.round($this.width()) < $this.prop('scrollWidth'));
  });
}

function initLayoutNav() {
  var contextualSidebar = new contextual_sidebar();
  contextualSidebar.bindEvents();

  fly_out_nav();

  jquery_default()(document).on('init.scrolling-tabs', function () {
    var $scrollingTabs = jquery_default()('.scrolling-tabs').not('.is-initialized');
    $scrollingTabs.addClass('is-initialized');

    jquery_default()(window).on('resize.nav', function () {
      hideEndFade($scrollingTabs);
    }).trigger('resize.nav');

    $scrollingTabs.on('scroll', function tabsScrollEvent() {
      var $this = jquery_default()(this);
      var currentPosition = $this.scrollLeft();
      var maxPosition = $this.prop('scrollWidth') - $this.outerWidth();

      $this.siblings('.fade-left').toggleClass('scrolling', currentPosition > 0);
      $this.siblings('.fade-right').toggleClass('scrolling', currentPosition < maxPosition - 1);
    });

    $scrollingTabs.each(function scrollTabsEachLoop() {
      var $this = jquery_default()(this);
      var scrollingTabWidth = $this.width();
      var $active = $this.find('.active');
      var activeWidth = $active.width();

      if ($active.length) {
        var offset = $active.offset().left + activeWidth;

        if (offset > scrollingTabWidth - 30) {
          var scrollLeft = offset - scrollingTabWidth / 2 - activeWidth / 2;

          $this.scrollLeft(scrollLeft);
        }
      }
    });
  }).trigger('init.scrolling-tabs');
}

/***/ }),

/***/ "./lazy_loader.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placeholderImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var placeholderImage = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
var SCROLL_THRESHOLD = 300;

var LazyLoader = function () {
  function LazyLoader() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LazyLoader);

    this.lazyImages = [];
    this.observerNode = options.observerNode || '#content-body';

    var throttledScrollCheck = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.throttle(function () {
      return _this.scrollCheck();
    }, 300);
    var debouncedElementsInView = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(function () {
      return _this.checkElementsInView();
    }, 300);

    window.addEventListener('scroll', throttledScrollCheck);
    window.addEventListener('resize', debouncedElementsInView);

    var scrollContainer = options.scrollContainer || window;
    scrollContainer.addEventListener('load', function () {
      return _this.loadCheck();
    });
  }

  _createClass(LazyLoader, [{
    key: 'searchLazyImages',
    value: function searchLazyImages() {
      this.lazyImages = [].slice.call(document.querySelectorAll('.lazy'));

      if (this.lazyImages.length) {
        this.checkElementsInView();
      }
    }
  }, {
    key: 'startContentObserver',
    value: function startContentObserver() {
      var _this2 = this;

      var contentNode = document.querySelector(this.observerNode) || document.querySelector('body');

      if (contentNode) {
        var observer = new MutationObserver(function () {
          return _this2.searchLazyImages();
        });

        observer.observe(contentNode, {
          childList: true,
          subtree: true
        });
      }
    }
  }, {
    key: 'loadCheck',
    value: function loadCheck() {
      this.searchLazyImages();
      this.startContentObserver();
    }
  }, {
    key: 'scrollCheck',
    value: function scrollCheck() {
      var _this3 = this;

      requestAnimationFrame(function () {
        return _this3.checkElementsInView();
      });
    }
  }, {
    key: 'checkElementsInView',
    value: function checkElementsInView() {
      var scrollTop = pageYOffset;
      var visHeight = scrollTop + innerHeight + SCROLL_THRESHOLD;

      // Loading Images which are in the current viewport or close to them
      this.lazyImages = this.lazyImages.filter(function (selectedImage) {
        if (selectedImage.getAttribute('data-src')) {
          var imgBoundRect = selectedImage.getBoundingClientRect();
          var imgTop = scrollTop + imgBoundRect.top;
          var imgBound = imgTop + imgBoundRect.height;

          if (scrollTop < imgBound && visHeight > imgTop) {
            LazyLoader.loadImage(selectedImage);
            return false;
          }

          return true;
        }
        return false;
      });
    }
  }], [{
    key: 'loadImage',
    value: function loadImage(img) {
      if (img.getAttribute('data-src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
        img.removeAttribute('data-src');
        img.classList.remove('lazy');
        img.classList.add('js-lazy-loaded');
      }
    }
  }]);

  return LazyLoader;
}();

/* harmony default export */ __webpack_exports__["a"] = (LazyLoader);

/***/ }),

/***/ "./lib/utils/accessor.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isPropertyAccessSafe(base, property) {
  var safe = void 0;

  try {
    safe = !!base[property];
  } catch (error) {
    safe = false;
  }

  return safe;
}

function isFunctionCallSafe(base, functionName) {
  var safe = true;

  try {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    base[functionName].apply(base, args);
  } catch (error) {
    safe = false;
  }

  return safe;
}

function isLocalStorageAccessSafe() {
  var safe = void 0;

  var TEST_KEY = 'isLocalStorageAccessSafe';
  var TEST_VALUE = 'true';

  safe = isPropertyAccessSafe(window, 'localStorage');
  if (!safe) return safe;

  safe = isFunctionCallSafe(window.localStorage, 'setItem', TEST_KEY, TEST_VALUE);

  if (safe) window.localStorage.removeItem(TEST_KEY);

  return safe;
}

var AccessorUtilities = {
  isPropertyAccessSafe: isPropertyAccessSafe,
  isFunctionCallSafe: isFunctionCallSafe,
  isLocalStorageAccessSafe: isLocalStorageAccessSafe
};

/* harmony default export */ __webpack_exports__["a"] = (AccessorUtilities);

/***/ }),

/***/ "./lib/utils/ajax_cache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cache__ = __webpack_require__("./lib/utils/cache.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AjaxCache = function (_Cache) {
  _inherits(AjaxCache, _Cache);

  function AjaxCache() {
    _classCallCheck(this, AjaxCache);

    var _this = _possibleConstructorReturn(this, (AjaxCache.__proto__ || Object.getPrototypeOf(AjaxCache)).call(this));

    _this.pendingRequests = {};
    return _this;
  }

  _createClass(AjaxCache, [{
    key: 'override',
    value: function override(endpoint, data) {
      this.internalStorage[endpoint] = data;
    }
  }, {
    key: 'retrieve',
    value: function retrieve(endpoint, forceRetrieve) {
      var _this2 = this;

      if (this.hasData(endpoint) && !forceRetrieve) {
        return Promise.resolve(this.get(endpoint));
      }

      var pendingRequest = this.pendingRequests[endpoint];

      if (!pendingRequest) {
        pendingRequest = __WEBPACK_IMPORTED_MODULE_0__axios_utils__["a" /* default */].get(endpoint).then(function (_ref) {
          var data = _ref.data;

          _this2.internalStorage[endpoint] = data;
          delete _this2.pendingRequests[endpoint];
        }).catch(function (e) {
          var error = new Error(endpoint + ': ' + e.message);
          error.textStatus = e.message;

          delete _this2.pendingRequests[endpoint];
          throw error;
        });

        this.pendingRequests[endpoint] = pendingRequest;
      }

      return pendingRequest.then(function () {
        return _this2.get(endpoint);
      });
    }
  }]);

  return AjaxCache;
}(__WEBPACK_IMPORTED_MODULE_1__cache__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new AjaxCache());

/***/ }),

/***/ "./lib/utils/cache.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cache = function () {
  function Cache() {
    _classCallCheck(this, Cache);

    this.internalStorage = {};
  }

  _createClass(Cache, [{
    key: "get",
    value: function get(key) {
      return this.internalStorage[key];
    }
  }, {
    key: "hasData",
    value: function hasData(key) {
      return Object.prototype.hasOwnProperty.call(this.internalStorage, key);
    }
  }, {
    key: "remove",
    value: function remove(key) {
      delete this.internalStorage[key];
    }
  }]);

  return Cache;
}();

/* harmony default export */ __webpack_exports__["a"] = (Cache);

/***/ }),

/***/ "./lib/utils/common_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPagePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isInGroupsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isInProjectPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getProjectSlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getGroupSlug; });
/* unused harmony export checkPageAndAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return isInIssuePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isInMRPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isInEpicPage; });
/* unused harmony export isInNoteablePage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasVueMRDiscussionsCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ajaxGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return rstrip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return updateTooltipTitle; });
/* unused harmony export disableButtonIfEmptyField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return handleLocationHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isInViewport; });
/* unused harmony export parseUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return parseUrlPathname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getUrlParamsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isMetaKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isMetaClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return scrollToElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getParameterByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getSelectedFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return insertText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return nodeMatchesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return normalizeHeaders; });
/* unused harmony export normalizeCRLFHeaders */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return parseIntPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return parseQueryStringIntoObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return objectToQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buildUrlWithCurrentLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return historyPushState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return convertPermissionToBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return setFavicon; });
/* unused harmony export resetFavicon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return setCiStatusFavicon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return spriteIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return convertObjectPropsToCamelCase; });
/* unused harmony export imagePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addSelectOnFocusBehaviour; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var getPagePath = function getPagePath() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').attr('data-page').split(':')[index];
};

var isInGroupsPage = function isInGroupsPage() {
  return getPagePath() === 'groups';
};

var isInProjectPage = function isInProjectPage() {
  return getPagePath() === 'projects';
};

var getProjectSlug = function getProjectSlug() {
  if (isInProjectPage()) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').data('project');
  }
  return null;
};

var getGroupSlug = function getGroupSlug() {
  if (isInGroupsPage()) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').data('group');
  }
  return null;
};

var checkPageAndAction = function checkPageAndAction(page, action) {
  var pagePath = getPagePath(1);
  var actionPath = getPagePath(2);

  return pagePath === page && actionPath === action;
};

var isInIssuePage = function isInIssuePage() {
  return checkPageAndAction('issues', 'show');
};
var isInMRPage = function isInMRPage() {
  return checkPageAndAction('merge_requests', 'show');
};
var isInEpicPage = function isInEpicPage() {
  return checkPageAndAction('epics', 'show');
};
var isInNoteablePage = function isInNoteablePage() {
  return isInIssuePage() || isInMRPage();
};
var hasVueMRDiscussionsCookie = function hasVueMRDiscussionsCookie() {
  return __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('vue_mr_discussions');
};

var ajaxGet = function ajaxGet(url) {
  return __WEBPACK_IMPORTED_MODULE_2__axios_utils__["a" /* default */].get(url, {
    params: { format: 'js' },
    responseType: 'text'
  }).then(function (_ref) {
    var data = _ref.data;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.globalEval(data);
  });
};

var rstrip = function rstrip(val) {
  if (val) {
    return val.replace(/\s+$/, '');
  }
  return val;
};

var updateTooltipTitle = function updateTooltipTitle($tooltipEl, newTitle) {
  return $tooltipEl.attr('title', newTitle).tooltip('fixTitle');
};

var disableButtonIfEmptyField = function disableButtonIfEmptyField(fieldSelector, buttonSelector) {
  var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'input';

  var field = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(fieldSelector);
  var closestSubmit = field.closest('form').find(buttonSelector);
  if (rstrip(field.val()) === '') {
    closestSubmit.disable();
  }
  // eslint-disable-next-line func-names
  return field.on(eventName, function () {
    if (rstrip(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val()) === '') {
      return closestSubmit.disable();
    }
    return closestSubmit.enable();
  });
};

// automatically adjust scroll position for hash urls taking the height of the navbar into account
// https://github.com/twitter/bootstrap/issues/1768
var handleLocationHash = function handleLocationHash() {
  var hash = Object(__WEBPACK_IMPORTED_MODULE_3__url_utility__["a" /* getLocationHash */])();
  if (!hash) return;

  // This is required to handle non-unicode characters in hash
  hash = decodeURIComponent(hash);

  var target = document.getElementById(hash) || document.getElementById('user-content-' + hash);
  var fixedTabs = document.querySelector('.js-tabs-affix');
  var fixedDiffStats = document.querySelector('.js-diff-files-changed.is-stuck');
  var fixedNav = document.querySelector('.navbar-gitlab');

  var adjustment = 0;
  if (fixedNav) adjustment -= fixedNav.offsetHeight;

  if (target && target.scrollIntoView) {
    target.scrollIntoView(true);
  }

  if (fixedTabs) {
    adjustment -= fixedTabs.offsetHeight;
  }

  if (fixedDiffStats) {
    adjustment -= fixedDiffStats.offsetHeight;
  }

  window.scrollBy(0, adjustment);
};

// Check if element scrolled into viewport from above or below
// Courtesy http://stackoverflow.com/a/7557433/414749
var isInViewport = function isInViewport(el) {
  var rect = el.getBoundingClientRect();

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;
};

var parseUrl = function parseUrl(url) {
  var parser = document.createElement('a');
  parser.href = url;
  return parser;
};

var parseUrlPathname = function parseUrlPathname(url) {
  var parsedUrl = parseUrl(url);
  // parsedUrl.pathname will return an absolute path for Firefox and a relative path for IE11
  // We have to make sure we always have an absolute path.
  return parsedUrl.pathname.charAt(0) === '/' ? parsedUrl.pathname : '/' + parsedUrl.pathname;
};

// We can trust that each param has one & since values containing & will be encoded
// Remove the first character of search as it is always ?
var getUrlParamsArray = function getUrlParamsArray() {
  return window.location.search.slice(1).split('&').map(function (param) {
    var split = param.split('=');
    return [decodeURI(split[0]), split[1]].join('=');
  });
};

var isMetaKey = function isMetaKey(e) {
  return e.metaKey || e.ctrlKey || e.altKey || e.shiftKey;
};

// Identify following special clicks
// 1) Cmd + Click on Mac (e.metaKey)
// 2) Ctrl + Click on PC (e.ctrlKey)
// 3) Middle-click or Mouse Wheel Click (e.which is 2)
var isMetaClick = function isMetaClick(e) {
  return e.metaKey || e.ctrlKey || e.which === 2;
};

var scrollToElement = function scrollToElement(element) {
  var $el = element;
  if (!(element instanceof __WEBPACK_IMPORTED_MODULE_0_jquery___default.a)) {
    $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
  }
  var top = $el.offset().top;
  var mrTabsHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.merge-request-tabs').height() || 0;
  var headerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.navbar-gitlab').height() || 0;

  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body, html').animate({
    scrollTop: top - mrTabsHeight - headerHeight
  }, 200);
};

/**
  this will take in the `name` of the param you want to parse in the url
  if the name does not exist this function will return `null`
  otherwise it will return the value of the param key provided
*/
var getParameterByName = function getParameterByName(name, urlToParse) {
  var url = urlToParse || window.location.href;
  var parsedName = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + parsedName + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

var getSelectedFragment = function getSelectedFragment() {
  var selection = window.getSelection();
  if (selection.rangeCount === 0) return null;
  var documentFragment = document.createDocumentFragment();
  for (var i = 0; i < selection.rangeCount; i += 1) {
    documentFragment.appendChild(selection.getRangeAt(i).cloneContents());
  }
  if (documentFragment.textContent.length === 0) return null;

  return documentFragment;
};

var insertText = function insertText(target, text) {
  // Firefox doesn't support `document.execCommand('insertText', false, text)` on textareas
  var selectionStart = target.selectionStart;
  var selectionEnd = target.selectionEnd;
  var value = target.value;

  var textBefore = value.substring(0, selectionStart);
  var textAfter = value.substring(selectionEnd, value.length);

  var insertedText = text instanceof Function ? text(textBefore, textAfter) : text;
  var newText = textBefore + insertedText + textAfter;

  // eslint-disable-next-line no-param-reassign
  target.value = newText;
  // eslint-disable-next-line no-param-reassign
  target.selectionStart = target.selectionEnd = selectionStart + insertedText.length;

  // Trigger autosave
  target.dispatchEvent(new Event('input'));

  // Trigger autosize
  var event = document.createEvent('Event');
  event.initEvent('autosize:update', true, false);
  target.dispatchEvent(event);
};

var nodeMatchesSelector = function nodeMatchesSelector(node, selector) {
  var matches = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;

  if (matches) {
    return matches.call(node, selector);
  }

  // IE11 doesn't support `node.matches(selector)`

  var parentNode = node.parentNode;
  if (!parentNode) {
    parentNode = document.createElement('div');
    // eslint-disable-next-line no-param-reassign
    node = node.cloneNode(true);
    parentNode.appendChild(node);
  }

  var matchingNodes = parentNode.querySelectorAll(selector);
  return Array.prototype.indexOf.call(matchingNodes, node) !== -1;
};

/**
  this will take in the headers from an API response and normalize them
  this way we don't run into production issues when nginx gives us lowercased header keys
*/
var normalizeHeaders = function normalizeHeaders(headers) {
  var upperCaseHeaders = {};

  Object.keys(headers || {}).forEach(function (e) {
    upperCaseHeaders[e.toUpperCase()] = headers[e];
  });

  return upperCaseHeaders;
};

/**
  this will take in the getAllResponseHeaders result and normalize them
  this way we don't run into production issues when nginx gives us lowercased header keys
*/
var normalizeCRLFHeaders = function normalizeCRLFHeaders(headers) {
  var headersObject = {};
  var headersArray = headers.split('\n');

  headersArray.forEach(function (header) {
    var keyValue = header.split(': ');
    headersObject[keyValue[0]] = keyValue[1];
  });

  return normalizeHeaders(headersObject);
};

/**
 * Parses pagination object string values into numbers.
 *
 * @param {Object} paginationInformation
 * @returns {Object}
 */
var parseIntPagination = function parseIntPagination(paginationInformation) {
  return {
    perPage: parseInt(paginationInformation['X-PER-PAGE'], 10),
    page: parseInt(paginationInformation['X-PAGE'], 10),
    total: parseInt(paginationInformation['X-TOTAL'], 10),
    totalPages: parseInt(paginationInformation['X-TOTAL-PAGES'], 10),
    nextPage: parseInt(paginationInformation['X-NEXT-PAGE'], 10),
    previousPage: parseInt(paginationInformation['X-PREV-PAGE'], 10)
  };
};

/**
 * Given a string of query parameters creates an object.
 *
 * @example
 * `scope=all&page=2` -> { scope: 'all', page: '2'}
 * `scope=all` -> { scope: 'all' }
 * ``-> {}
 * @param {String} query
 * @returns {Object}
 */
var parseQueryStringIntoObject = function parseQueryStringIntoObject() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (query === '') return {};

  return query.split('&').reduce(function (acc, element) {
    var val = element.split('=');
    Object.assign(acc, _defineProperty({}, val[0], decodeURIComponent(val[1])));
    return acc;
  }, {});
};

/**
 * Converts object with key-value pairs
 * into query-param string
 *
 * @param {Object} params
 */
var objectToQueryString = function objectToQueryString() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(params).map(function (param) {
    return param + '=' + params[param];
  }).join('&');
};

var buildUrlWithCurrentLocation = function buildUrlWithCurrentLocation(param) {
  return param ? '' + window.location.pathname + param : window.location.pathname;
};

/**
 * Based on the current location and the string parameters provided
 * creates a new entry in the history without reloading the page.
 *
 * @param {String} param
 */
var historyPushState = function historyPushState(newUrl) {
  window.history.pushState({}, document.title, newUrl);
};

/**
 * Converts permission provided as strings to booleans.
 *
 * @param  {String} string
 * @returns {Boolean}
 */
var convertPermissionToBoolean = function convertPermissionToBoolean(permission) {
  return permission === 'true';
};

/**
 * Back Off exponential algorithm
 * backOff :: (Function<next, stop>, Number) -> Promise<Any, Error>
 *
 * @param {Function<next, stop>} fn function to be called
 * @param {Number} timeout
 * @return {Promise<Any, Error>}
 * @example
 * ```
 *  backOff(function (next, stop) {
 *    // Let's perform this function repeatedly for 60s or for the timeout provided.
 *
 *    ourFunction()
 *      .then(function (result) {
 *        // continue if result is not what we need
 *        next();
 *
 *        // when result is what we need let's stop with the repetions and jump out of the cycle
 *        stop(result);
 *      })
 *      .catch(function (error) {
 *        // if there is an error, we need to stop this with an error.
 *        stop(error);
 *      })
 *  }, 60000)
 *  .then(function (result) {})
 *  .catch(function (error) {
 *    // deal with errors passed to stop()
 *  })
 * ```
 */
var backOff = function backOff(fn) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60000;

  var maxInterval = 32000;
  var nextInterval = 2000;
  var timeElapsed = 0;

  return new Promise(function (resolve, reject) {
    var stop = function stop(arg) {
      return arg instanceof Error ? reject(arg) : resolve(arg);
    };

    var next = function next() {
      if (timeElapsed < timeout) {
        setTimeout(function () {
          return fn(next, stop);
        }, nextInterval);
        timeElapsed += nextInterval;
        nextInterval = Math.min(nextInterval + nextInterval, maxInterval);
      } else {
        reject(new Error('BACKOFF_TIMEOUT'));
      }
    };

    fn(next, stop);
  });
};

var setFavicon = function setFavicon(faviconPath) {
  var faviconEl = document.getElementById('favicon');
  if (faviconEl && faviconPath) {
    faviconEl.setAttribute('href', faviconPath);
  }
};

var resetFavicon = function resetFavicon() {
  var faviconEl = document.getElementById('favicon');
  var originalFavicon = faviconEl ? faviconEl.getAttribute('href') : null;
  if (faviconEl) {
    faviconEl.setAttribute('href', originalFavicon);
  }
};

var setCiStatusFavicon = function setCiStatusFavicon(pageUrl) {
  return __WEBPACK_IMPORTED_MODULE_2__axios_utils__["a" /* default */].get(pageUrl).then(function (_ref2) {
    var data = _ref2.data;

    if (data && data.favicon) {
      setFavicon(data.favicon);
    } else {
      resetFavicon();
    }
  }).catch(resetFavicon);
};

var spriteIcon = function spriteIcon(icon) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var classAttribute = className.length > 0 ? 'class="' + className + '"' : '';

  return '<svg ' + classAttribute + '><use xlink:href="' + gon.sprite_icons + '#' + icon + '" /></svg>';
};

/**
 * This method takes in object with snake_case property names
 * and returns new object with camelCase property names
 *
 * Reasoning for this method is to ensure consistent property
 * naming conventions across JS code.
 */
var convertObjectPropsToCamelCase = function convertObjectPropsToCamelCase() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (obj === null) {
    return {};
  }

  return Object.keys(obj).reduce(function (acc, prop) {
    var result = acc;

    result[Object(__WEBPACK_IMPORTED_MODULE_4__text_utility__["c" /* convertToCamelCase */])(prop)] = obj[prop];
    return acc;
  }, {});
};

var imagePath = function imagePath(imgUrl) {
  return '' + (gon.asset_host || '') + (gon.relative_url_root || '') + '/assets/' + imgUrl;
};

var addSelectOnFocusBehaviour = function addSelectOnFocusBehaviour() {
  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-select-on-focus';

  // Click a .js-select-on-focus field, select the contents
  // Prevent a mouseup event from deselecting the input
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selector).on('focusin', function selectOnFocusCallback() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).select().one('mouseup', function (e) {
      e.preventDefault();
    });
  });
};

window.gl = window.gl || {};
window.gl.utils = _extends({}, window.gl.utils || {}, {
  getPagePath: getPagePath,
  isInGroupsPage: isInGroupsPage,
  isInProjectPage: isInProjectPage,
  getProjectSlug: getProjectSlug,
  getGroupSlug: getGroupSlug,
  isInIssuePage: isInIssuePage,
  ajaxGet: ajaxGet,
  rstrip: rstrip,
  updateTooltipTitle: updateTooltipTitle,
  disableButtonIfEmptyField: disableButtonIfEmptyField,
  handleLocationHash: handleLocationHash,
  isInViewport: isInViewport,
  parseUrl: parseUrl,
  parseUrlPathname: parseUrlPathname,
  getUrlParamsArray: getUrlParamsArray,
  isMetaKey: isMetaKey,
  isMetaClick: isMetaClick,
  scrollToElement: scrollToElement,
  getParameterByName: getParameterByName,
  getSelectedFragment: getSelectedFragment,
  insertText: insertText,
  nodeMatchesSelector: nodeMatchesSelector,
  spriteIcon: spriteIcon,
  imagePath: imagePath
});

/***/ }),

/***/ "./lib/utils/datetime_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatDate; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getTimeago;
/* unused harmony export renderTimeago */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return localTimeAgo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return timeFor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDayDifference; });
/* harmony export (immutable) */ __webpack_exports__["g"] = timeIntervalInWords;
/* unused harmony export dateInWords */
/* unused harmony export monthInWords */
/* unused harmony export totalDaysInMonth */
/* unused harmony export getSundays */
/* unused harmony export getTimeframeWindow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_timeago_js__ = __webpack_require__("../../../node_modules/timeago.js/dist/timeago.min.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_timeago_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_timeago_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vendor_date_format__ = __webpack_require__("../../../vendor/assets/javascripts/date.format.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vendor_date_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vendor_date_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale__ = __webpack_require__("./locale/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







window.timeago = __WEBPACK_IMPORTED_MODULE_1_timeago_js___default.a;
window.dateFormat = __WEBPACK_IMPORTED_MODULE_2_vendor_date_format___default.a;

/**
 * Returns i18n month names array.
 * If `abbreviated` is provided, returns abbreviated
 * name.
 *
 * @param {Boolean} abbreviated
 */
var getMonthNames = function getMonthNames(abbreviated) {
  if (abbreviated) {
    return [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Jan'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Feb'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Mar'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Apr'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('May'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Jun'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Jul'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Aug'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Sep'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Oct'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Nov'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Dec')];
  }
  return [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('January'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('February'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('March'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('April'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('May'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('June'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('July'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('August'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('September'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('October'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('November'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('December')];
};

/**
 * Given a date object returns the day of the week in English
 * @param {date} date
 * @returns {String}
 */
var getDayName = function getDayName(date) {
  return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][date.getDay()];
};

/**
 * @example
 * dateFormat('2017-12-05','mmm d, yyyy h:MMtt Z' ) -> "Dec 5, 2017 12:00am GMT+0000"
 * @param {date} datetime
 * @returns {String}
 */
var formatDate = function formatDate(datetime) {
  return __WEBPACK_IMPORTED_MODULE_2_vendor_date_format___default()(datetime, 'mmm d, yyyy h:MMtt Z');
};

/**
 * Timeago uses underscores instead of dashes to separate language from country code.
 *
 * see https://github.com/hustcc/timeago.js/tree/v3.0.0/locales
 */
var timeagoLanguageCode = Object(__WEBPACK_IMPORTED_MODULE_4__locale__["c" /* languageCode */])().replace(/-/g, '_');

var timeagoInstance = void 0;

/**
 * Sets a timeago Instance
 */
function getTimeago() {
  if (!timeagoInstance) {
    var localeRemaining = function getLocaleRemaining(number, index) {
      return [[Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|less than a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in a while')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|less than a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s seconds remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|about a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|1 minute remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s minutes ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s minutes remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|about an hour ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|1 hour remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|about %s hours ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s hours remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|a day ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|1 day remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s days ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s days remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|a week ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|1 week remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s weeks ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s weeks remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|a month ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|1 month remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s months ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s months remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|a year ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|1 year remaining')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s years ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s years remaining')]][index];
    };
    var locale = function getLocale(number, index) {
      return [[Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|less than a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in a while')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|less than a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in %s seconds')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|about a minute ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in 1 minute')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s minutes ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in %s minutes')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|about an hour ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in 1 hour')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|about %s hours ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in %s hours')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|a day ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in 1 day')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s days ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in %s days')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|a week ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in 1 week')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s weeks ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in %s weeks')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|a month ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in 1 month')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s months ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in %s months')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|a year ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in 1 year')], [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|%s years ago'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|in %s years')]][index];
    };

    __WEBPACK_IMPORTED_MODULE_1_timeago_js___default.a.register(timeagoLanguageCode, locale);
    __WEBPACK_IMPORTED_MODULE_1_timeago_js___default.a.register(timeagoLanguageCode + '-remaining', localeRemaining);
    timeagoInstance = __WEBPACK_IMPORTED_MODULE_1_timeago_js___default()();
  }

  return timeagoInstance;
}

/**
 * For the given element, renders a timeago instance.
 * @param {jQuery} $els
 */
var renderTimeago = function renderTimeago($els) {
  var timeagoEls = $els || document.querySelectorAll('.js-timeago-render');

  // timeago.js sets timeouts internally for each timeago value to be updated in real time
  getTimeago().render(timeagoEls, timeagoLanguageCode);
};

/**
 * For the given elements, sets a tooltip with a formatted date.
 * @param {jQuery}
 * @param {Boolean} setTimeago
 */
var localTimeAgo = function localTimeAgo($timeagoEls) {
  var setTimeago = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  $timeagoEls.each(function (i, el) {
    if (setTimeago) {
      // Recreate with custom template
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).tooltip({
        template: '<div class="tooltip local-timeago" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
      });
    }

    el.classList.add('js-timeago-render');
  });

  renderTimeago($timeagoEls);
};

/**
 * Returns remaining or passed time over the given time.
 * @param {*} time
 * @param {*} expiredLabel
 */
var timeFor = function timeFor(time, expiredLabel) {
  if (!time) {
    return '';
  }
  if (new Date(time) < new Date()) {
    return expiredLabel || Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Timeago|Past due');
  }
  return getTimeago().format(time, timeagoLanguageCode + '-remaining').trim();
};

var getDayDifference = function getDayDifference(a, b) {
  var millisecondsPerDay = 1000 * 60 * 60 * 24;
  var date1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  var date2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((date2 - date1) / millisecondsPerDay);
};

/**
 * Port of ruby helper time_interval_in_words.
 *
 * @param  {Number} seconds
 * @return {String}
 */
function timeIntervalInWords(intervalInSeconds) {
  var secondsInteger = parseInt(intervalInSeconds, 10);
  var minutes = Math.floor(secondsInteger / 60);
  var seconds = secondsInteger - minutes * 60;
  var text = '';

  if (minutes >= 1) {
    text = minutes + ' ' + Object(__WEBPACK_IMPORTED_MODULE_3__text_utility__["h" /* pluralize */])('minute', minutes) + ' ' + seconds + ' ' + Object(__WEBPACK_IMPORTED_MODULE_3__text_utility__["h" /* pluralize */])('second', seconds);
  } else {
    text = seconds + ' ' + Object(__WEBPACK_IMPORTED_MODULE_3__text_utility__["h" /* pluralize */])('second', seconds);
  }
  return text;
}

function dateInWords(date) {
  var abbreviated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var hideYear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!date) return date;

  var month = date.getMonth();
  var year = date.getFullYear();

  var monthNames = [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('January'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('February'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('March'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('April'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('May'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('June'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('July'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('August'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('September'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('October'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('November'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('December')];
  var monthNamesAbbr = [Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Jan'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Feb'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Mar'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Apr'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('May'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Jun'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Jul'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Aug'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Sep'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Oct'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Nov'), Object(__WEBPACK_IMPORTED_MODULE_4__locale__["e" /* s__ */])('Dec')];

  var monthName = abbreviated ? monthNamesAbbr[month] : monthNames[month];

  if (hideYear) {
    return monthName + ' ' + date.getDate();
  }

  return monthName + ' ' + date.getDate() + ', ' + year;
}

/**
 * Returns month name based on provided date.
 *
 * @param {Date} date
 * @param {Boolean} abbreviated
 */
var monthInWords = function monthInWords(date) {
  var abbreviated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!date) {
    return '';
  }

  return getMonthNames(abbreviated)[date.getMonth()];
};

/**
 * Returns number of days in a month for provided date.
 * courtesy: https://stacko(verflow.com/a/1185804/414749
 *
 * @param {Date} date
 */
var totalDaysInMonth = function totalDaysInMonth(date) {
  if (!date) {
    return 0;
  }
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};

/**
 * Returns list of Dates referring to Sundays of the month
 * based on provided date
 *
 * @param {Date} date
 */
var getSundays = function getSundays(date) {
  if (!date) {
    return [];
  }

  var daysToSunday = ['Saturday', 'Friday', 'Thursday', 'Wednesday', 'Tuesday', 'Monday', 'Sunday'];

  var month = date.getMonth();
  var year = date.getFullYear();
  var sundays = [];
  var dateOfMonth = new Date(year, month, 1);

  while (dateOfMonth.getMonth() === month) {
    var dayName = getDayName(dateOfMonth);
    if (dayName === 'Sunday') {
      sundays.push(new Date(dateOfMonth.getTime()));
    }

    var daysUntilNextSunday = daysToSunday.indexOf(dayName) + 1;
    dateOfMonth.setDate(dateOfMonth.getDate() + daysUntilNextSunday);
  }

  return sundays;
};

/**
 * Returns list of Dates representing a timeframe of Months from month of provided date (inclusive)
 * up to provided length
 *
 * For eg;
 *    If current month is January 2018 and `length` provided is `6`
 *    Then this method will return list of Date objects as follows;
 *
 *    [ October 2017, November 2017, December 2017, January 2018, February 2018, March 2018 ]
 *
 *    If current month is March 2018 and `length` provided is `3`
 *    Then this method will return list of Date objects as follows;
 *
 *    [ February 2018, March 2018, April 2018 ]
 *
 * @param {Number} length
 * @param {Date} date
 */
var getTimeframeWindow = function getTimeframeWindow(length, date) {
  if (!length) {
    return [];
  }

  var currentDate = date instanceof Date ? date : new Date();
  var currentMonthIndex = Math.floor(length / 2);
  var timeframe = [];

  // Move date object backward to the first month of timeframe
  currentDate.setDate(1);
  currentDate.setMonth(currentDate.getMonth() - currentMonthIndex);

  // Iterate and update date for the size of length
  // and push date reference to timeframe list
  for (var i = 0; i < length; i += 1) {
    timeframe.push(new Date(currentDate.getTime()));
    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  // Change date of last timeframe item to last date of the month
  timeframe[length - 1].setDate(totalDaysInMonth(timeframe[length - 1]));

  return timeframe;
};

window.gl = window.gl || {};
window.gl.utils = _extends({}, window.gl.utils || {}, {
  getTimeago: getTimeago,
  localTimeAgo: localTimeAgo
});

/***/ }),

/***/ "./lib/utils/dom_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addClassIfElementExists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isInVueNoteablePage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__("./lib/utils/common_utils.js");



var isVueMRDiscussions = function isVueMRDiscussions() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["t" /* isInMRPage */])() && Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["n" /* hasVueMRDiscussionsCookie */])() && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#diffs').is(':visible');
};

var addClassIfElementExists = function addClassIfElementExists(element, className) {
  if (element) {
    element.classList.add(className);
  }
};

var isInVueNoteablePage = function isInVueNoteablePage() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["s" /* isInIssuePage */])() || Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["q" /* isInEpicPage */])() || isVueMRDiscussions();
};

/***/ }),

/***/ "./lib/utils/text_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDelimiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return highCountTrim; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return humanize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return pluralize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dasherize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return slugify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return truncate; });
/* harmony export (immutable) */ __webpack_exports__["b"] = capitalizeFirstCharacter;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return stripHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertToCamelCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertToSentenceCase; });
/**
 * Adds a , to a string composed by numbers, at every 3 chars.
 *
 * 2333 -> 2,333
 * 232324 -> 232,324
 *
 * @param {String} text
 * @returns {String}
 */
var addDelimiter = function addDelimiter(text) {
  return text ? text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : text;
};

/**
 * Returns '99+' for numbers bigger than 99.
 *
 * @param {Number} count
 * @return {Number|String}
 */
var highCountTrim = function highCountTrim(count) {
  return count > 99 ? '99+' : count;
};

/**
 * Converts first char to uppercase and replaces undercores with spaces
 * @param {String} string
 * @requires {String}
 */
var humanize = function humanize(string) {
  return string.charAt(0).toUpperCase() + string.replace(/_/g, ' ').slice(1);
};

/**
 * Adds an 's' to the end of the string when count is bigger than 0
 * @param {String} str
 * @param {Number} count
 * @returns {String}
 */
var pluralize = function pluralize(str, count) {
  return str + (count > 1 || count === 0 ? 's' : '');
};

/**
 * Replaces underscores with dashes
 * @param {*} str
 * @returns {String}
 */
var dasherize = function dasherize(str) {
  return str.replace(/[_\s]+/g, '-');
};

/**
 * Removes accents and converts to lower case
 * @param {String} str
 * @returns {String}
 */
var slugify = function slugify(str) {
  return str.trim().toLowerCase();
};

/**
 * Truncates given text
 *
 * @param {String} string
 * @param {Number} maxLength
 * @returns {String}
 */
var truncate = function truncate(string, maxLength) {
  return string.substr(0, maxLength - 3) + '...';
};

/**
 * Capitalizes first character
 *
 * @param {String} text
 * @return {String}
 */
function capitalizeFirstCharacter(text) {
  return '' + text[0].toUpperCase() + text.slice(1);
}

/**
 * Replaces all html tags from a string with the given replacement.
 *
 * @param {String} string
 * @param {*} replace
 * @returns {String}
 */
var stripHtml = function stripHtml(string) {
  var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return string.replace(/<[^>]*>/g, replace);
};

/**
 * Converts snake_case string to camelCase
 *
 * @param {*} string
 */
var convertToCamelCase = function convertToCamelCase(string) {
  return string.replace(/(_\w)/g, function (s) {
    return s[1].toUpperCase();
  });
};

/**
 * Converts a sentence to lower case from the second word onwards
 * e.g. Hello World => Hello world
 *
 * @param {*} string
 */
var convertToSentenceCase = function convertToSentenceCase(string) {
  var splitWord = string.split(' ').map(function (word, index) {
    return index > 0 ? word.toLowerCase() : word;
  });

  return splitWord.join(' ');
};

/***/ }),

/***/ "./lib/utils/url_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getParameterValues;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeUrlParams;
/* unused harmony export removeParamQueryString */
/* harmony export (immutable) */ __webpack_exports__["f"] = removeParams;
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocationHash;
/* harmony export (immutable) */ __webpack_exports__["g"] = visitUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = refreshCurrentPage;
/* harmony export (immutable) */ __webpack_exports__["d"] = redirectTo;
/* harmony export (immutable) */ __webpack_exports__["h"] = webIDEUrl;
// Returns an array containing the value(s) of the
// of the key passed as an argument
function getParameterValues(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1));

  return sPageURL.split('&').reduce(function (acc, urlParam) {
    var sParameterName = urlParam.split('=');

    if (sParameterName[0] === sParam) {
      acc.push(sParameterName[1].replace(/\+/g, ' '));
    }

    return acc;
  }, []);
}

// @param {Object} params - url keys and value to merge
// @param {String} url
function mergeUrlParams(params, url) {
  var newUrl = Object.keys(params).reduce(function (acc, paramName) {
    var paramValue = encodeURIComponent(params[paramName]);
    var pattern = new RegExp('\\b(' + paramName + '=).*?(&|$)');

    if (paramValue === null) {
      return acc.replace(pattern, '');
    } else if (url.search(pattern) !== -1) {
      return acc.replace(pattern, '$1' + paramValue + '$2');
    }

    return '' + acc + (acc.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
  }, decodeURIComponent(url));

  // Remove a trailing ampersand
  var lastChar = newUrl[newUrl.length - 1];

  if (lastChar === '&') {
    newUrl = newUrl.slice(0, -1);
  }

  return newUrl;
}

function removeParamQueryString(url, param) {
  var decodedUrl = decodeURIComponent(url);
  var urlVariables = decodedUrl.split('&');

  return urlVariables.filter(function (variable) {
    return variable.indexOf(param) === -1;
  }).join('&');
}

function removeParams(params) {
  var url = document.createElement('a');
  url.href = window.location.href;

  params.forEach(function (param) {
    url.search = removeParamQueryString(url.search, param);
  });

  return url.href;
}

function getLocationHash() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;

  var hashIndex = url.indexOf('#');

  return hashIndex === -1 ? null : url.substring(hashIndex + 1);
}

function visitUrl(url) {
  var external = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (external) {
    // Simulate `target="blank" rel="noopener noreferrer"`
    // See https://mathiasbynens.github.io/rel-noopener/
    var otherWindow = window.open();
    otherWindow.opener = null;
    otherWindow.location = url;
  } else {
    window.location.href = url;
  }
}

function refreshCurrentPage() {
  visitUrl(window.location.href);
}

function redirectTo(url) {
  return window.location.assign(url);
}

function webIDEUrl() {
  var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  var returnUrl = gon.relative_url_root + '/-/ide/';
  if (route) {
    returnUrl += 'project' + route;
  }
  return returnUrl;
}

/***/ }),

/***/ "./locale/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jed/jed.js
var jed = __webpack_require__("../../../node_modules/jed/jed.js");
var jed_default = /*#__PURE__*/__webpack_require__.n(jed);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./locale/sprintf.js


/**
  Very limited implementation of sprintf supporting only named parameters.

  @param input (translated) text with parameters (e.g. '%{num_users} users use us')
  @param parameters object mapping parameter names to values (e.g. { num_users: 5 })
  @param escapeParameters whether parameter values should be escaped (see http://underscorejs.org/#escape)
  @returns {String} the text with parameters replaces (e.g. '5 users use us')

  @see https://ruby-doc.org/core-2.3.3/Kernel.html#method-i-sprintf
  @see https://gitlab.com/gitlab-org/gitlab-ce/issues/37992
**/
/* harmony default export */ var sprintf = (function (input, parameters) {
  var escapeParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var output = input;

  if (parameters) {
    Object.keys(parameters).forEach(function (parameterName) {
      var parameterValue = parameters[parameterName];
      var escapedParameterValue = escapeParameters ? underscore_default.a.escape(parameterValue) : parameterValue;
      output = output.replace(new RegExp('%{' + parameterName + '}', 'g'), escapedParameterValue);
    });
  }

  return output;
});
// CONCATENATED MODULE: ./locale/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return languageCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gettext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ngettext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pgettext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createDateTimeFormat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return sprintf; });



var languageCode = function languageCode() {
  return document.querySelector('html').getAttribute('lang') || 'en';
};
var locale = new jed_default.a(window.translations || {});
delete window.translations;

/**
  Translates `text`
  @param text The text to be translated
  @returns {String} The translated text
**/
var gettext = locale.gettext.bind(locale);

/**
  Translate the text with a number
  if the number is more than 1 it will use the `pluralText` translation.
  This method allows for contexts, see below re. contexts

  @param text Singular text to translate (eg. '%d day')
  @param pluralText Plural text to translate (eg. '%d days')
  @param count Number to decide which translation to use (eg. 2)
  @returns {String} Translated text with the number replaced (eg. '2 days')
**/
var ngettext = function ngettext(text, pluralText, count) {
  var translated = locale.ngettext(text, pluralText, count).replace(/%d/g, count).split('|');

  return translated[translated.length - 1];
};

/**
  Translate context based text
  Either pass in the context translation like `Context|Text to translate`
  or allow for dynamic text by doing passing in the context first & then the text to translate

  @param keyOrContext Can be either the key to translate including the context
                      (eg. 'Context|Text') or just the context for the translation
                      (eg. 'Context')
  @param key Is the dynamic variable you want to be translated
  @returns {String} Translated context based text
**/
var pgettext = function pgettext(keyOrContext, key) {
  var normalizedKey = key ? keyOrContext + '|' + key : keyOrContext;
  var translated = gettext(normalizedKey).split('|');

  return translated[translated.length - 1];
};

/**
  Creates an instance of Intl.DateTimeFormat for the current locale.

  @param formatOptions for available options, please see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
  @returns {Intl.DateTimeFormat}
*/
var createDateTimeFormat = function createDateTimeFormat(formatOptions) {
  return Intl.DateTimeFormat(languageCode(), formatOptions);
};







/* harmony default export */ var locale_0 = (locale);

/***/ }),

/***/ "./logo.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initLogoAnimation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


function initLogoAnimation() {
  window.addEventListener('beforeunload', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tanuki-logo').addClass('animate');
  });
}

/***/ }),

/***/ "./main.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg4everybody__ = __webpack_require__("../../../node_modules/svg4everybody/dist/svg4everybody.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg4everybody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg4everybody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__behaviors___ = __webpack_require__("./behaviors/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__awards_handler__ = __webpack_require__("./awards_handler.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__gl_dropdown__ = __webpack_require__("./gl_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__header__ = __webpack_require__("./header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__importer_status__ = __webpack_require__("./importer_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_nav__ = __webpack_require__("./layout_nav.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__feature_highlight_feature_highlight_options__ = __webpack_require__("./feature_highlight/feature_highlight_options.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lazy_loader__ = __webpack_require__("./lazy_loader.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__logo__ = __webpack_require__("./logo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__milestone_select__ = __webpack_require__("./milestone_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__projects_dropdown__ = __webpack_require__("./projects_dropdown/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__breadcrumb__ = __webpack_require__("./breadcrumb.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__dispatcher__ = __webpack_require__("./dispatcher.js");
/* eslint-disable import/first */
/* global $ */





// expose common libraries as globals (TODO: remove these)
window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.$ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

// lib/utils




// behaviors


// everything else
















// inject test utilities if necessary
if (false) {
  $.fx.off = true;
  import( /* webpackMode: "eager" */'./test_utils/');
}

__WEBPACK_IMPORTED_MODULE_2_svg4everybody___default()();

document.addEventListener('beforeunload', function () {
  // Unbind scroll events
  $(document).off('scroll');
  // Close any open tooltips
  $('.has-tooltip, [data-toggle="tooltip"]').tooltip('destroy');
  // Close any open popover
  $('[data-toggle="popover"]').popover('destroy');
});

window.addEventListener('hashchange', __WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["m" /* handleLocationHash */]);
window.addEventListener('load', function onLoad() {
  window.removeEventListener('load', onLoad, false);
  Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["m" /* handleLocationHash */])();
}, false);

gl.lazyLoader = new __WEBPACK_IMPORTED_MODULE_15__lazy_loader__["a" /* default */]({
  scrollContainer: window,
  observerNode: '#content-body'
});

document.addEventListener('DOMContentLoaded', function () {
  var $body = $('body');
  var $document = $(document);
  var $window = $(window);
  var $sidebarGutterToggle = $('.js-sidebar-toggle');
  var bootstrapBreakpoint = __WEBPACK_IMPORTED_MODULE_8__breakpoints__["a" /* default */].getBreakpointSize();

  Object(__WEBPACK_IMPORTED_MODULE_19__breadcrumb__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_13__layout_nav__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_12__importer_status__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_11__header__["a" /* default */])();
  Object(__WEBPACK_IMPORTED_MODULE_16__logo__["a" /* default */])();

  // Set the default path for all cookies to GitLab's root directory
  __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.defaults.path = gon.relative_url_root || '/';

  // `hashchange` is not triggered when link target is already in window.location
  $body.on('click', 'a[href^="#"]', function clickHashLinkCallback() {
    var href = this.getAttribute('href');
    if (href.substr(1) === Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_url_utility__["a" /* getLocationHash */])()) {
      setTimeout(__WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["m" /* handleLocationHash */], 1);
    }
  });

  if (bootstrapBreakpoint === 'xs') {
    var $rightSidebar = $('aside.right-sidebar, .layout-page');

    $rightSidebar.removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
  }

  // prevent default action for disabled buttons
  $('.btn').click(function clickDisabledButtonCallback(e) {
    if ($(this).hasClass('disabled')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }

    return true;
  });

  Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_common_utils__["a" /* addSelectOnFocusBehaviour */])('.js-select-on-focus');

  $('.remove-row').on('ajax:success', function removeRowAjaxSuccessCallback() {
    $(this).tooltip('destroy').closest('li').fadeOut();
  });

  $('.js-remove-tr').on('ajax:before', function removeTRAjaxBeforeCallback() {
    $(this).hide();
  });

  $('.js-remove-tr').on('ajax:success', function removeTRAjaxSuccessCallback() {
    $(this).closest('tr').fadeOut();
  });

  // Initialize select2 selects
  $('select.select2').select2({
    width: 'resolve',
    dropdownAutoWidth: true
  });

  // Close select2 on escape
  $('.js-select2').on('select2-close', function () {
    setTimeout(function () {
      $('.select2-container-active').removeClass('select2-container-active');
      $(':focus').blur();
    }, 1);
  });

  // Initialize tooltips
  $.fn.tooltip.Constructor.DEFAULTS.trigger = 'hover';
  $body.tooltip({
    selector: '.has-tooltip, [data-toggle="tooltip"]',
    placement: function placement(tip, el) {
      return $(el).data('placement') || 'bottom';
    }
  });

  // Initialize popovers
  $body.popover({
    selector: '[data-toggle="popover"]',
    trigger: 'focus',
    // set the viewport to the main content, excluding the navigation bar, so
    // the navigation can't overlap the popover
    viewport: '.layout-page'
  });

  // Form submitter
  $('.trigger-submit').on('change', function triggerSubmitCallback() {
    $(this).parents('form').submit();
  });

  Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_datetime_utility__["e" /* localTimeAgo */])($('abbr.timeago, .js-timeago'), true);

  // Disable form buttons while a form is submitting
  $body.on('ajax:complete, ajax:beforeSend, submit', 'form', function ajaxCompleteCallback(e) {
    var $buttons = $('[type="submit"], .js-disable-on-submit', this);
    switch (e.type) {
      case 'ajax:beforeSend':
      case 'submit':
        return $buttons.disable();
      default:
        return $buttons.enable();
    }
  });

  $(document).ajaxError(function (e, xhrObj) {
    var ref = xhrObj.status;

    if (ref === 401) {
      Object(__WEBPACK_IMPORTED_MODULE_9__flash__["a" /* default */])('You need to be logged in.');
    } else if (ref === 404 || ref === 500) {
      Object(__WEBPACK_IMPORTED_MODULE_9__flash__["a" /* default */])('Something went wrong on our end.');
    }
  });

  // Commit show suppressed diff
  $document.on('click', '.diff-content .js-show-suppressed-diff', function showDiffCallback() {
    var $container = $(this).parent();
    $container.next('table').show();
    $container.remove();
  });

  $('.navbar-toggle').on('click', function () {
    $('.header-content').toggleClass('menu-expanded');
    gl.lazyLoader.loadCheck();
  });

  // Show/hide comments on diff
  $body.on('click', '.js-toggle-diff-comments', function toggleDiffCommentsCallback(e) {
    var $this = $(this);
    var notesHolders = $this.closest('.diff-file').find('.notes_holder');

    e.preventDefault();

    $this.toggleClass('active');

    if ($this.hasClass('active')) {
      notesHolders.show().find('.hide, .content').show();
    } else {
      notesHolders.hide().find('.content').hide();
    }

    $(document).trigger('toggle.comments');
  });

  $document.on('breakpoint:change', function (e, breakpoint) {
    if (breakpoint === 'sm' || breakpoint === 'xs') {
      var $gutterIcon = $sidebarGutterToggle.find('i');
      if ($gutterIcon.hasClass('fa-angle-double-right')) {
        $sidebarGutterToggle.trigger('click');
      }
    }
  });

  function fitSidebarForSize() {
    var oldBootstrapBreakpoint = bootstrapBreakpoint;
    bootstrapBreakpoint = __WEBPACK_IMPORTED_MODULE_8__breakpoints__["a" /* default */].getBreakpointSize();

    if (bootstrapBreakpoint !== oldBootstrapBreakpoint) {
      $document.trigger('breakpoint:change', [bootstrapBreakpoint]);
    }
  }

  $window.on('resize.app', fitSidebarForSize);

  Object(__WEBPACK_IMPORTED_MODULE_7__awards_handler__["a" /* default */])();

  $('form.filter-form').on('submit', function filterFormSubmitCallback(event) {
    var link = document.createElement('a');
    link.href = this.action;

    var action = '' + this.action + (link.search === '' ? '?' : '&');

    event.preventDefault();
    Object(__WEBPACK_IMPORTED_MODULE_5__lib_utils_url_utility__["g" /* visitUrl */])('' + action + $(this).serialize());
  });

  var flashContainer = document.querySelector('.flash-container');

  if (flashContainer && flashContainer.children.length) {
    flashContainer.querySelectorAll('.flash-alert, .flash-notice, .flash-success').forEach(function (flashEl) {
      Object(__WEBPACK_IMPORTED_MODULE_9__flash__["b" /* removeFlashClickListener */])(flashEl);
    });
  }

  Object(__WEBPACK_IMPORTED_MODULE_20__dispatcher__["a" /* default */])();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./milestone_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, one-var-declaration-per-line, no-unused-vars, object-shorthand, comma-dangle, no-else-return, no-self-compare, consistent-return, no-param-reassign, no-shadow */
/* global Issuable */
/* global ListMilestone */






var MilestoneSelect = function () {
  function MilestoneSelect(currentProject, els) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, MilestoneSelect);

    if (currentProject !== null) {
      this.currentProject = typeof currentProject === 'string' ? JSON.parse(currentProject) : currentProject;
    }

    this.init(els, options);
  }

  _createClass(MilestoneSelect, [{
    key: 'init',
    value: function init(els, options) {
      var _this = this;

      var $els = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(els);

      if (!els) {
        $els = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-milestone-select');
      }

      $els.each(function (i, dropdown) {
        var collapsedSidebarLabelTemplate = void 0,
            milestoneLinkNoneTemplate = void 0,
            milestoneLinkTemplate = void 0,
            selectedMilestone = void 0,
            selectedMilestoneDefault = void 0;
        var $dropdown = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(dropdown);
        var projectId = $dropdown.data('projectId');
        var milestonesUrl = $dropdown.data('milestones');
        var issueUpdateURL = $dropdown.data('issueUpdate');
        var showNo = $dropdown.data('showNo');
        var showAny = $dropdown.data('showAny');
        var showMenuAbove = $dropdown.data('showMenuAbove');
        var showUpcoming = $dropdown.data('showUpcoming');
        var showStarted = $dropdown.data('showStarted');
        var useId = $dropdown.data('useId');
        var defaultLabel = $dropdown.data('defaultLabel');
        var defaultNo = $dropdown.data('defaultNo');
        var issuableId = $dropdown.data('issuableId');
        var abilityName = $dropdown.data('abilityName');
        var $selectBox = $dropdown.closest('.selectbox');
        var $block = $selectBox.closest('.block');
        var $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon');
        var $value = $block.find('.value');
        var $loading = $block.find('.block-loading').fadeOut();
        selectedMilestoneDefault = showAny ? '' : null;
        selectedMilestoneDefault = showNo && defaultNo ? 'No Milestone' : selectedMilestoneDefault;
        selectedMilestone = $dropdown.data('selected') || selectedMilestoneDefault;

        if (issueUpdateURL) {
          milestoneLinkTemplate = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.template('<a href="/<%- full_path %>/milestones/<%- iid %>" class="bold has-tooltip" data-container="body" title="<%- remaining %>"><%- title %></a>');
          milestoneLinkNoneTemplate = '<span class="no-value">None</span>';
          collapsedSidebarLabelTemplate = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.template('<span class="has-tooltip" data-container="body" title="<%- name %><br /><%- remaining %>" data-placement="left" data-html="true"> <%- title %> </span>');
        }
        return $dropdown.glDropdown({
          showMenuAbove: showMenuAbove,
          data: function data(term, callback) {
            return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(milestonesUrl).then(function (_ref) {
              var data = _ref.data;

              var extraOptions = [];
              if (showAny) {
                extraOptions.push({
                  id: 0,
                  name: '',
                  title: 'Any Milestone'
                });
              }
              if (showNo) {
                extraOptions.push({
                  id: -1,
                  name: 'No Milestone',
                  title: 'No Milestone'
                });
              }
              if (showUpcoming) {
                extraOptions.push({
                  id: -2,
                  name: '#upcoming',
                  title: 'Upcoming'
                });
              }
              if (showStarted) {
                extraOptions.push({
                  id: -3,
                  name: '#started',
                  title: 'Started'
                });
              }
              if (extraOptions.length) {
                extraOptions.push('divider');
              }

              callback(extraOptions.concat(data));
              if (showMenuAbove) {
                $dropdown.data('glDropdown').positionMenuAbove();
              }
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-milestone-id="' + __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(selectedMilestone) + '"] > a').addClass('is-active');
            });
          },
          renderRow: function renderRow(milestone) {
            return '\n          <li data-milestone-id="' + __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(milestone.name) + '">\n            <a href=\'#\' class=\'dropdown-menu-milestone-link\'>\n              ' + __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(milestone.title) + '\n            </a>\n          </li>\n        ';
          },
          filterable: true,
          search: {
            fields: ['title']
          },
          selectable: true,
          toggleLabel: function toggleLabel(selected, el, e) {
            if (selected && 'id' in selected && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).hasClass('is-active')) {
              return selected.title;
            } else {
              return defaultLabel;
            }
          },
          defaultLabel: defaultLabel,
          fieldName: $dropdown.data('fieldName'),
          text: function text(milestone) {
            return __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(milestone.title);
          },
          id: function id(milestone) {
            if (!useId && !$dropdown.is('.js-issuable-form-dropdown')) {
              return milestone.name;
            } else {
              return milestone.id;
            }
          },
          hidden: function hidden() {
            $selectBox.hide();
            // display:block overrides the hide-collapse rule
            return $value.css('display', '');
          },
          opened: function opened(e) {
            var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);
            if ($dropdown.hasClass('js-issue-board-sidebar') || options.handleClick) {
              selectedMilestone = $dropdown[0].dataset.selected || selectedMilestoneDefault;
            }
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('a.is-active', $el).removeClass('is-active');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-milestone-id="' + __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(selectedMilestone) + '"] > a', $el).addClass('is-active');
          },
          vue: $dropdown.hasClass('js-issue-board-sidebar'),
          clicked: function clicked(clickEvent) {
            var $el = clickEvent.$el,
                e = clickEvent.e;

            var selected = clickEvent.selectedObj;

            var data = void 0,
                boardsStore = void 0;
            if (!selected) return;

            if (options.handleClick) {
              e.preventDefault();
              options.handleClick(selected);
              return;
            }

            var page = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').attr('data-page');
            var isIssueIndex = page === 'projects:issues:index';
            var isMRIndex = page === page && page === 'projects:merge_requests:index';
            var isSelecting = selected.name !== selectedMilestone;
            selectedMilestone = isSelecting ? selected.name : selectedMilestoneDefault;

            if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
              e.preventDefault();
              return;
            }

            if ($dropdown.closest('.add-issues-modal').length) {
              boardsStore = gl.issueBoards.ModalStore.store.filter;
            }

            if (boardsStore) {
              boardsStore[$dropdown.data('fieldName')] = selected.name;
              e.preventDefault();
            } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              return Issuable.filterResults($dropdown.closest('form'));
            } else if ($dropdown.hasClass('js-filter-submit')) {
              return $dropdown.closest('form').submit();
            } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
              if (selected.id !== -1 && isSelecting) {
                gl.issueBoards.boardStoreIssueSet('milestone', new ListMilestone({
                  id: selected.id,
                  title: selected.name
                }));
              } else {
                gl.issueBoards.boardStoreIssueDelete('milestone');
              }

              $dropdown.trigger('loading.gl.dropdown');
              $loading.removeClass('hidden').fadeIn();

              gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(function () {
                $dropdown.trigger('loaded.gl.dropdown');
                $loading.fadeOut();
              }).catch(function () {
                $loading.fadeOut();
              });
            } else {
              selected = $selectBox.find('input[type="hidden"]').val();
              data = {};
              data[abilityName] = {};
              data[abilityName].milestone_id = selected != null ? selected : null;
              $loading.removeClass('hidden').fadeIn();
              $dropdown.trigger('loading.gl.dropdown');
              return __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].put(issueUpdateURL, data).then(function (_ref2) {
                var data = _ref2.data;

                $dropdown.trigger('loaded.gl.dropdown');
                $loading.fadeOut();
                $selectBox.hide();
                $value.css('display', '');
                if (data.milestone != null) {
                  data.milestone.full_path = _this.currentProject.full_path;
                  data.milestone.remaining = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_datetime_utility__["f" /* timeFor */])(data.milestone.due_date);
                  data.milestone.name = data.milestone.title;
                  $value.html(milestoneLinkTemplate(data.milestone));
                  return $sidebarCollapsedValue.find('span').html(collapsedSidebarLabelTemplate(data.milestone));
                } else {
                  $value.html(milestoneLinkNoneTemplate);
                  return $sidebarCollapsedValue.find('span').text('No');
                }
              }).catch(function () {
                $loading.fadeOut();
              });
            }
          }
        });
      });
    }
  }]);

  return MilestoneSelect;
}();

/* harmony default export */ __webpack_exports__["a"] = (MilestoneSelect);

/***/ }),

/***/ "./preview_markdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__("./locale/index.js");
/* eslint-disable func-names, no-var, object-shorthand, comma-dangle, prefer-arrow-callback */






// MarkdownPreview
//
// Handles toggling the "Write" and "Preview" tab clicks, rendering the preview
// (including the explanation of quick actions), and showing a warning when
// more than `x` users are referenced.
//

var lastTextareaPreviewed;
var lastTextareaHeight = null;
var markdownPreview;
var previewButtonSelector;
var writeButtonSelector;

function MarkdownPreview() {}

// Minimum number of users referenced before triggering a warning
MarkdownPreview.prototype.referenceThreshold = 10;
MarkdownPreview.prototype.emptyMessage = 'Nothing to preview.';

MarkdownPreview.prototype.ajaxCache = {};

MarkdownPreview.prototype.showPreview = function ($form) {
  var mdText;
  var preview = $form.find('.js-md-preview');
  var url = preview.data('url');
  if (preview.hasClass('md-preview-loading')) {
    return;
  }
  mdText = $form.find('textarea.markdown-area').val();

  if (mdText.trim().length === 0) {
    preview.text(this.emptyMessage);
    this.hideReferencedUsers($form);
  } else {
    preview.addClass('md-preview-loading').text('Loading...');
    this.fetchMarkdownPreview(mdText, url, function (response) {
      var body;
      if (response.body.length > 0) {
        body = response.body;
      } else {
        body = this.emptyMessage;
      }

      preview.removeClass('md-preview-loading').html(body);
      preview.renderGFM();
      this.renderReferencedUsers(response.references.users, $form);

      if (response.references.commands) {
        this.renderReferencedCommands(response.references.commands, $form);
      }
    }.bind(this));
  }
};

MarkdownPreview.prototype.fetchMarkdownPreview = function (text, url, success) {
  var _this = this;

  if (!url) {
    return;
  }
  if (text === this.ajaxCache.text) {
    success(this.ajaxCache.response);
    return;
  }
  __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].post(url, {
    text: text
  }).then(function (_ref) {
    var data = _ref.data;

    _this.ajaxCache = {
      text: text,
      response: data
    };
    success(data);
  }).catch(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__locale__["a" /* __ */])('An error occurred while fetching markdown preview'));
  });
};

MarkdownPreview.prototype.hideReferencedUsers = function ($form) {
  $form.find('.referenced-users').hide();
};

MarkdownPreview.prototype.renderReferencedUsers = function (users, $form) {
  var referencedUsers;
  referencedUsers = $form.find('.referenced-users');
  if (referencedUsers.length) {
    if (users.length >= this.referenceThreshold) {
      referencedUsers.show();
      referencedUsers.find('.js-referenced-users-count').text(users.length);
    } else {
      referencedUsers.hide();
    }
  }
};

MarkdownPreview.prototype.hideReferencedCommands = function ($form) {
  $form.find('.referenced-commands').hide();
};

MarkdownPreview.prototype.renderReferencedCommands = function (commands, $form) {
  var referencedCommands;
  referencedCommands = $form.find('.referenced-commands');
  if (commands.length > 0) {
    referencedCommands.html(commands);
    referencedCommands.show();
  } else {
    referencedCommands.html('');
    referencedCommands.hide();
  }
};

markdownPreview = new MarkdownPreview();

previewButtonSelector = '.js-md-preview-button';
writeButtonSelector = '.js-md-write-button';
lastTextareaPreviewed = null;
var markdownToolbar = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.md-header-toolbar');

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.setupMarkdownPreview = function () {
  var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
  $form.find('textarea.markdown-area').on('input', function () {
    markdownPreview.hideReferencedUsers($form);
  });
};

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('markdown-preview:show', function (e, $form) {
  if (!$form) {
    return;
  }

  lastTextareaPreviewed = $form.find('textarea.markdown-area');
  lastTextareaHeight = lastTextareaPreviewed.height();

  // toggle tabs
  $form.find(writeButtonSelector).parent().removeClass('active');
  $form.find(previewButtonSelector).parent().addClass('active');

  // toggle content
  $form.find('.md-write-holder').hide();
  $form.find('.md-preview-holder').show();
  markdownToolbar.removeClass('active');
  markdownPreview.showPreview($form);
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('markdown-preview:hide', function (e, $form) {
  if (!$form) {
    return;
  }
  lastTextareaPreviewed = null;

  if (lastTextareaHeight) {
    $form.find('textarea.markdown-area').height(lastTextareaHeight);
  }

  // toggle tabs
  $form.find(writeButtonSelector).parent().addClass('active');
  $form.find(previewButtonSelector).parent().removeClass('active');

  // toggle content
  $form.find('.md-write-holder').show();
  $form.find('textarea.markdown-area').focus();
  $form.find('.md-preview-holder').hide();
  markdownToolbar.addClass('active');

  markdownPreview.hideReferencedCommands($form);
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('markdown-preview:toggle', function (e, keyboardEvent) {
  var $target;
  $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(keyboardEvent.target);
  if ($target.is('textarea.markdown-area')) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).triggerHandler('markdown-preview:show', [$target.closest('form')]);
    keyboardEvent.preventDefault();
  } else if (lastTextareaPreviewed) {
    $target = lastTextareaPreviewed;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).triggerHandler('markdown-preview:hide', [$target.closest('form')]);
    keyboardEvent.preventDefault();
  }
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', previewButtonSelector, function (e) {
  var $form;
  e.preventDefault();
  $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('form');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).triggerHandler('markdown-preview:show', [$form]);
});

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click', writeButtonSelector, function (e) {
  var $form;
  e.preventDefault();
  $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('form');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).triggerHandler('markdown-preview:hide', [$form]);
});

/* unused harmony default export */ var _unused_webpack_default_export = (MarkdownPreview);

/***/ }),

/***/ "./projects_dropdown/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./vue_shared/translate.js
var translate = __webpack_require__("./vue_shared/translate.js");

// CONCATENATED MODULE: ./projects_dropdown/event_hub.js


/* harmony default export */ var event_hub = (new vue_esm["a" /* default */]());
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");

// EXTERNAL MODULE: ./breakpoints.js
var breakpoints = __webpack_require__("./breakpoints.js");

// EXTERNAL MODULE: ./api.js
var api = __webpack_require__("./api.js");

// EXTERNAL MODULE: ./lib/utils/accessor.js
var accessor = __webpack_require__("./lib/utils/accessor.js");

// CONCATENATED MODULE: ./projects_dropdown/constants.js
var FREQUENT_PROJECTS = {
  MAX_COUNT: 20,
  LIST_COUNT_DESKTOP: 5,
  LIST_COUNT_MOBILE: 3,
  ELIGIBLE_FREQUENCY: 3
};

var HOUR_IN_MS = 3600000;

var STORAGE_KEY = 'frequent-projects';
// CONCATENATED MODULE: ./projects_dropdown/service/projects_service.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }











vue_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);

var projects_service_ProjectsService = function () {
  function ProjectsService(currentUserName) {
    _classCallCheck(this, ProjectsService);

    this.isLocalStorageAvailable = accessor["a" /* default */].isLocalStorageAccessSafe();
    this.currentUserName = currentUserName;
    this.storageKey = this.currentUserName + '/' + STORAGE_KEY;
    this.projectsPath = vue_esm["a" /* default */].resource(api["a" /* default */].buildUrl(api["a" /* default */].projectsPath));
  }

  _createClass(ProjectsService, [{
    key: 'getSearchedProjects',
    value: function getSearchedProjects(searchQuery) {
      return this.projectsPath.get({
        simple: true,
        per_page: 20,
        membership: !!gon.current_user_id,
        order_by: 'last_activity_at',
        search: searchQuery
      });
    }
  }, {
    key: 'getFrequentProjects',
    value: function getFrequentProjects() {
      if (this.isLocalStorageAvailable) {
        return this.getTopFrequentProjects();
      }
      return null;
    }
  }, {
    key: 'logProjectAccess',
    value: function logProjectAccess(project) {
      var matchFound = false;
      var storedFrequentProjects = void 0;

      if (this.isLocalStorageAvailable) {
        var storedRawProjects = localStorage.getItem(this.storageKey);

        // Check if there's any frequent projects list set
        if (!storedRawProjects) {
          // No frequent projects list set, set one up.
          storedFrequentProjects = [];
          storedFrequentProjects.push(_extends({}, project, { frequency: 1 }));
        } else {
          // Check if project is already present in frequents list
          // When found, update metadata of it.
          storedFrequentProjects = JSON.parse(storedRawProjects).map(function (projectItem) {
            if (projectItem.id === project.id) {
              matchFound = true;
              var diff = Math.abs(project.lastAccessedOn - projectItem.lastAccessedOn) / HOUR_IN_MS;
              var updatedProject = _extends({}, project, {
                frequency: projectItem.frequency,
                lastAccessedOn: projectItem.lastAccessedOn
              });

              // Check if duration since last access of this project
              // is over an hour
              if (diff > 1) {
                return _extends({}, updatedProject, {
                  frequency: updatedProject.frequency + 1,
                  lastAccessedOn: Date.now()
                });
              }

              return _extends({}, updatedProject);
            }

            return projectItem;
          });

          // Check whether currently logged project is present in frequents list
          if (!matchFound) {
            // We always keep size of frequents collection to 20 projects
            // out of which only 5 projects with
            // highest value of `frequency` and most recent `lastAccessedOn`
            // are shown in projects dropdown
            if (storedFrequentProjects.length === FREQUENT_PROJECTS.MAX_COUNT) {
              storedFrequentProjects.shift(); // Remove an item from head of array
            }

            storedFrequentProjects.push(_extends({}, project, { frequency: 1 }));
          }
        }

        localStorage.setItem(this.storageKey, JSON.stringify(storedFrequentProjects));
      }
    }
  }, {
    key: 'getTopFrequentProjects',
    value: function getTopFrequentProjects() {
      var storedFrequentProjects = JSON.parse(localStorage.getItem(this.storageKey));
      var frequentProjectsCount = FREQUENT_PROJECTS.LIST_COUNT_DESKTOP;

      if (!storedFrequentProjects) {
        return [];
      }

      if (breakpoints["a" /* default */].getBreakpointSize() === 'sm' || breakpoints["a" /* default */].getBreakpointSize() === 'xs') {
        frequentProjectsCount = FREQUENT_PROJECTS.LIST_COUNT_MOBILE;
      }

      var frequentProjects = storedFrequentProjects.filter(function (project) {
        return project.frequency >= FREQUENT_PROJECTS.ELIGIBLE_FREQUENCY;
      });

      // Sort all frequent projects in decending order of frequency
      // and then by lastAccessedOn with recent most first
      frequentProjects.sort(function (projectA, projectB) {
        if (projectA.frequency < projectB.frequency) {
          return 1;
        } else if (projectA.frequency > projectB.frequency) {
          return -1;
        } else if (projectA.lastAccessedOn < projectB.lastAccessedOn) {
          return 1;
        } else if (projectA.lastAccessedOn > projectB.lastAccessedOn) {
          return -1;
        }

        return 0;
      });

      return underscore_default.a.first(frequentProjects, frequentProjectsCount);
    }
  }]);

  return ProjectsService;
}();

/* harmony default export */ var projects_service = (projects_service_ProjectsService);
// CONCATENATED MODULE: ./projects_dropdown/store/projects_store.js
var projects_store__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function projects_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProjectsStore = function () {
  function ProjectsStore() {
    projects_store__classCallCheck(this, ProjectsStore);

    this.state = {};
    this.state.frequentProjects = [];
    this.state.searchedProjects = [];
  }

  projects_store__createClass(ProjectsStore, [{
    key: "setFrequentProjects",
    value: function setFrequentProjects(rawProjects) {
      this.state.frequentProjects = rawProjects;
    }
  }, {
    key: "getFrequentProjects",
    value: function getFrequentProjects() {
      return this.state.frequentProjects;
    }
  }, {
    key: "setSearchedProjects",
    value: function setSearchedProjects(rawProjects) {
      this.state.searchedProjects = rawProjects.map(function (rawProject) {
        return {
          id: rawProject.id,
          name: rawProject.name,
          namespace: rawProject.name_with_namespace,
          webUrl: rawProject.web_url,
          avatarUrl: rawProject.avatar_url
        };
      });
    }
  }, {
    key: "getSearchedProjects",
    value: function getSearchedProjects() {
      return this.state.searchedProjects;
    }
  }, {
    key: "clearSearchedProjects",
    value: function clearSearchedProjects() {
      this.state.searchedProjects = [];
    }
  }]);

  return ProjectsStore;
}();

/* harmony default export */ var projects_store = (ProjectsStore);
// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/identicon.vue + 2 modules
var identicon = __webpack_require__("./vue_shared/components/identicon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_item.vue

/* eslint-disable vue/require-default-prop, vue/require-prop-types */


/* harmony default export */ var projects_list_item = ({
  components: {
    identicon: identicon["a" /* default */]
  },
  props: {
    matcher: {
      type: String,
      required: false
    },
    projectId: {
      type: Number,
      required: true
    },
    projectName: {
      type: String,
      required: true
    },
    namespace: {
      type: String,
      required: true
    },
    webUrl: {
      type: String,
      required: true
    },
    avatarUrl: {
      required: true,
      validator: function validator(value) {
        return value === null || typeof value === 'string';
      }
    }
  },
  computed: {
    hasAvatar: function hasAvatar() {
      return this.avatarUrl !== null;
    },
    highlightedProjectName: function highlightedProjectName() {
      if (this.matcher) {
        var matcherRegEx = new RegExp(this.matcher, 'gi');
        var matches = this.projectName.match(matcherRegEx);

        if (matches && matches.length > 0) {
          return this.projectName.replace(matches[0], '<b>' + matches[0] + '</b>');
        }
      }
      return this.projectName;
    },

    /**
     * Smartly truncates project namespace by doing two things;
     * 1. Only include Group names in path by removing project name
     * 2. Only include first and last group names in the path
     *    when namespace has more than 2 groups present
     *
     * First part (removal of project name from namespace) can be
     * done from backend but doing so involves migration of
     * existing project namespaces which is not wise thing to do.
     */
    truncatedNamespace: function truncatedNamespace() {
      var namespaceArr = this.namespace.split(' / ');
      namespaceArr.splice(-1, 1);
      var namespace = namespaceArr.join(' / ');

      if (namespaceArr.length > 2) {
        namespace = namespaceArr[0] + ' / ... / ' + namespaceArr.pop();
      }

      return namespace;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-809bd0d0","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"projects-list-item-container"},[_c('a',{staticClass:"clearfix",attrs:{"href":_vm.webUrl}},[_c('div',{staticClass:"project-item-avatar-container"},[(_vm.hasAvatar)?_c('img',{staticClass:"avatar s32",attrs:{"src":_vm.avatarUrl}}):_c('identicon',{attrs:{"size-class":"s32","entity-id":_vm.projectId,"entity-name":_vm.projectName}})],1),_vm._v(" "),_c('div',{staticClass:"project-item-metadata-container"},[_c('div',{staticClass:"project-title",attrs:{"title":_vm.projectName},domProps:{"innerHTML":_vm._s(_vm.highlightedProjectName)}}),_vm._v(" "),_c('div',{staticClass:"project-namespace",attrs:{"title":_vm.namespace}},[_vm._v(_vm._s(_vm.truncatedNamespace))])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./projects_dropdown/components/projects_list_item.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  projects_list_item,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_projects_list_item = (Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_frequent.vue




/* harmony default export */ var projects_list_frequent = ({
  components: {
    projectsListItem: components_projects_list_item
  },
  props: {
    projects: {
      type: Array,
      required: true
    },
    localStorageFailed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isListEmpty: function isListEmpty() {
      return this.projects.length === 0;
    },
    listEmptyMessage: function listEmptyMessage() {
      return this.localStorageFailed ? Object(locale["e" /* s__ */])('ProjectsDropdown|This feature requires browser localStorage support') : Object(locale["e" /* s__ */])('ProjectsDropdown|Projects you visit often will appear here');
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16d7450a","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_frequent.vue
var projects_list_frequent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects-list-frequent-container"},[_c('ul',{staticClass:"list-unstyled"},[(_vm.isListEmpty)?_c('li',{staticClass:"section-empty"},[_vm._v("\n      "+_vm._s(_vm.listEmptyMessage)+"\n    ")]):_vm._l((_vm.projects),function(project,index){return _c('projects-list-item',{key:index,attrs:{"project-id":project.id,"project-name":project.name,"namespace":project.namespace,"web-url":project.webUrl,"avatar-url":project.avatarUrl}})})],2)])}
var projects_list_frequent_staticRenderFns = []

// CONCATENATED MODULE: ./projects_dropdown/components/projects_list_frequent.vue
/* script */


/* template */

/* template functional */
var projects_list_frequent___vue_template_functional__ = false
/* styles */
var projects_list_frequent___vue_styles__ = null
/* scopeId */
var projects_list_frequent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var projects_list_frequent___vue_module_identifier__ = null

var projects_list_frequent_Component = Object(component_normalizer["a" /* default */])(
  projects_list_frequent,
  projects_list_frequent_render,
  projects_list_frequent_staticRenderFns,
  projects_list_frequent___vue_template_functional__,
  projects_list_frequent___vue_styles__,
  projects_list_frequent___vue_scopeId__,
  projects_list_frequent___vue_module_identifier__
)

/* harmony default export */ var components_projects_list_frequent = (projects_list_frequent_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/projects_list_search.vue




/* harmony default export */ var projects_list_search = ({
  components: {
    projectsListItem: components_projects_list_item
  },
  props: {
    matcher: {
      type: String,
      required: true
    },
    projects: {
      type: Array,
      required: true
    },
    searchFailed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isListEmpty: function isListEmpty() {
      return this.projects.length === 0;
    },
    listEmptyMessage: function listEmptyMessage() {
      return this.searchFailed ? Object(locale["e" /* s__ */])('ProjectsDropdown|Something went wrong on our end.') : Object(locale["e" /* s__ */])('ProjectsDropdown|Sorry, no projects matched your search');
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cb67a3a","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/projects_list_search.vue
var projects_list_search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"projects-list-search-container"},[_c('ul',{staticClass:"list-unstyled"},[(_vm.isListEmpty)?_c('li',{staticClass:"section-empty",class:{ 'section-failure': _vm.searchFailed }},[_vm._v("\n      "+_vm._s(_vm.listEmptyMessage)+"\n    ")]):_vm._l((_vm.projects),function(project,index){return _c('projects-list-item',{key:index,attrs:{"project-id":project.id,"project-name":project.name,"namespace":project.namespace,"web-url":project.webUrl,"avatar-url":project.avatarUrl,"matcher":_vm.matcher}})})],2)])}
var projects_list_search_staticRenderFns = []

// CONCATENATED MODULE: ./projects_dropdown/components/projects_list_search.vue
/* script */


/* template */

/* template functional */
var projects_list_search___vue_template_functional__ = false
/* styles */
var projects_list_search___vue_styles__ = null
/* scopeId */
var projects_list_search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var projects_list_search___vue_module_identifier__ = null

var projects_list_search_Component = Object(component_normalizer["a" /* default */])(
  projects_list_search,
  projects_list_search_render,
  projects_list_search_staticRenderFns,
  projects_list_search___vue_template_functional__,
  projects_list_search___vue_styles__,
  projects_list_search___vue_scopeId__,
  projects_list_search___vue_module_identifier__
)

/* harmony default export */ var components_projects_list_search = (projects_list_search_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/search.vue




/* harmony default export */ var search = ({
  data: function data() {
    return {
      searchQuery: ''
    };
  },

  watch: {
    searchQuery: function searchQuery() {
      this.handleInput();
    }
  },
  mounted: function mounted() {
    event_hub.$on('dropdownOpen', this.setFocus);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub.$off('dropdownOpen', this.setFocus);
  },

  methods: {
    setFocus: function setFocus() {
      this.$refs.search.focus();
    },
    emitSearchEvents: function emitSearchEvents() {
      if (this.searchQuery) {
        event_hub.$emit('searchProjects', this.searchQuery);
      } else {
        event_hub.$emit('searchCleared');
      }
    },

    /**
     * Callback function within _.debounce is intentionally
     * kept as ES5 `function() {}` instead of ES6 `() => {}`
     * as it otherwise messes up function context
     * and component reference is no longer accessible via `this`
     */
    // eslint-disable-next-line func-names
    handleInput: underscore_default.a.debounce(function () {
      this.emitSearchEvents();
    }, 500)
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93d44b6e","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/search.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-input-container hidden-xs"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],ref:"search",staticClass:"form-control",attrs:{"type":"search","placeholder":_vm.s__('ProjectsDropdown|Search your projects')},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}}),_vm._v(" "),(!_vm.searchQuery)?_c('i',{staticClass:"search-icon fa fa-fw fa-search",attrs:{"aria-hidden":"true"}}):_vm._e()])}
var search_staticRenderFns = []

// CONCATENATED MODULE: ./projects_dropdown/components/search.vue
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = null
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null

var search_Component = Object(component_normalizer["a" /* default */])(
  search,
  search_render,
  search_staticRenderFns,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)

/* harmony default export */ var components_search = (search_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./projects_dropdown/components/app.vue










/* harmony default export */ var app = ({
  components: {
    search: components_search,
    loadingIcon: loading_icon["a" /* default */],
    projectsListFrequent: components_projects_list_frequent,
    projectsListSearch: components_projects_list_search
  },
  props: {
    currentProject: {
      type: Object,
      required: true
    },
    store: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isLoadingProjects: false,
      isFrequentsListVisible: false,
      isSearchListVisible: false,
      isLocalStorageFailed: false,
      isSearchFailed: false,
      searchQuery: ''
    };
  },

  computed: {
    frequentProjects: function frequentProjects() {
      return this.store.getFrequentProjects();
    },
    searchProjects: function searchProjects() {
      return this.store.getSearchedProjects();
    }
  },
  created: function created() {
    if (this.currentProject.id) {
      this.logCurrentProjectAccess();
    }

    event_hub.$on('dropdownOpen', this.fetchFrequentProjects);
    event_hub.$on('searchProjects', this.fetchSearchedProjects);
    event_hub.$on('searchCleared', this.handleSearchClear);
    event_hub.$on('searchFailed', this.handleSearchFailure);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub.$off('dropdownOpen', this.fetchFrequentProjects);
    event_hub.$off('searchProjects', this.fetchSearchedProjects);
    event_hub.$off('searchCleared', this.handleSearchClear);
    event_hub.$off('searchFailed', this.handleSearchFailure);
  },

  methods: {
    toggleFrequentProjectsList: function toggleFrequentProjectsList(state) {
      this.isLoadingProjects = !state;
      this.isSearchListVisible = !state;
      this.isFrequentsListVisible = state;
    },
    toggleSearchProjectsList: function toggleSearchProjectsList(state) {
      this.isLoadingProjects = !state;
      this.isFrequentsListVisible = !state;
      this.isSearchListVisible = state;
    },
    toggleLoader: function toggleLoader(state) {
      this.isFrequentsListVisible = !state;
      this.isSearchListVisible = !state;
      this.isLoadingProjects = state;
    },
    fetchFrequentProjects: function fetchFrequentProjects() {
      var screenSize = breakpoints["a" /* default */].getBreakpointSize();
      if (this.searchQuery && screenSize !== 'sm' && screenSize !== 'xs') {
        this.toggleSearchProjectsList(true);
      } else {
        this.toggleLoader(true);
        this.isLocalStorageFailed = false;
        var projects = this.service.getFrequentProjects();
        if (projects) {
          this.toggleFrequentProjectsList(true);
          this.store.setFrequentProjects(projects);
        } else {
          this.isLocalStorageFailed = true;
          this.toggleFrequentProjectsList(true);
          this.store.setFrequentProjects([]);
        }
      }
    },
    fetchSearchedProjects: function fetchSearchedProjects(searchQuery) {
      var _this = this;

      this.searchQuery = searchQuery;
      this.toggleLoader(true);
      this.service.getSearchedProjects(this.searchQuery).then(function (res) {
        return res.json();
      }).then(function (results) {
        _this.toggleSearchProjectsList(true);
        _this.store.setSearchedProjects(results);
      }).catch(function () {
        _this.isSearchFailed = true;
        _this.toggleSearchProjectsList(true);
      });
    },
    logCurrentProjectAccess: function logCurrentProjectAccess() {
      this.service.logProjectAccess(this.currentProject);
    },
    handleSearchClear: function handleSearchClear() {
      this.searchQuery = '';
      this.toggleFrequentProjectsList(true);
      this.store.clearSearchedProjects();
    },
    handleSearchFailure: function handleSearchFailure() {
      this.isSearchFailed = true;
      this.toggleSearchProjectsList(true);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d5e68f","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./projects_dropdown/components/app.vue
var app_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('search'),_vm._v(" "),(_vm.isLoadingProjects)?_c('loading-icon',{staticClass:"loading-animation prepend-top-20",attrs:{"size":"2","label":_vm.s__('ProjectsDropdown|Loading projects')}}):_vm._e(),_vm._v(" "),(_vm.isFrequentsListVisible)?_c('div',{staticClass:"section-header"},[_vm._v("\n    "+_vm._s(_vm.s__('ProjectsDropdown|Frequently visited'))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isFrequentsListVisible)?_c('projects-list-frequent',{attrs:{"local-storage-failed":_vm.isLocalStorageFailed,"projects":_vm.frequentProjects}}):_vm._e(),_vm._v(" "),(_vm.isSearchListVisible)?_c('projects-list-search',{attrs:{"search-failed":_vm.isSearchFailed,"matcher":_vm.searchQuery,"projects":_vm.searchProjects}}):_vm._e()],1)}
var app_staticRenderFns = []

// CONCATENATED MODULE: ./projects_dropdown/components/app.vue
/* script */


/* template */

/* template functional */
var app___vue_template_functional__ = false
/* styles */
var app___vue_styles__ = null
/* scopeId */
var app___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var app___vue_module_identifier__ = null

var app_Component = Object(component_normalizer["a" /* default */])(
  app,
  app_render,
  app_staticRenderFns,
  app___vue_template_functional__,
  app___vue_styles__,
  app___vue_scopeId__,
  app___vue_module_identifier__
)

/* harmony default export */ var components_app = (app_Component.exports);

// CONCATENATED MODULE: ./projects_dropdown/index.js










vue_esm["a" /* default */].use(translate["a" /* default */]);

document.addEventListener('DOMContentLoaded', function () {
  var el = document.getElementById('js-projects-dropdown');
  var navEl = document.getElementById('nav-projects-dropdown');

  // Don't do anything if element doesn't exist (No projects dropdown)
  // This is for when the user accesses GitLab without logging in
  if (!el || !navEl) {
    return;
  }

  jquery_default()(navEl).on('shown.bs.dropdown', function () {
    event_hub.$emit('dropdownOpen');
  });

  // eslint-disable-next-line no-new
  new vue_esm["a" /* default */]({
    el: el,
    components: {
      projectsDropdownApp: components_app
    },
    data: function data() {
      var dataset = this.$options.el.dataset;
      var store = new projects_store();
      var service = new projects_service(dataset.userName);

      var project = {
        id: Number(dataset.projectId),
        name: dataset.projectName,
        namespace: dataset.projectNamespace,
        webUrl: dataset.projectWebUrl,
        avatarUrl: dataset.projectAvatarUrl || null,
        lastAccessedOn: Date.now()
      };

      return {
        store: store,
        service: service,
        state: store.state,
        currentUserName: dataset.userName,
        currentProject: project
      };
    },
    render: function render(createElement) {
      return createElement('projects-dropdown-app', {
        props: {
          currentUserName: this.currentUserName,
          currentProject: this.currentProject,
          store: this.store,
          service: this.service
        }
      });
    }
  });
});

/***/ }),

/***/ "./shortcuts.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var defaultStopCallback = __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.stopCallback;
__WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.stopCallback = function (e, element, combo) {
  if (['ctrl+shift+p', 'command+shift+p'].indexOf(combo) !== -1) {
    return false;
  }

  return defaultStopCallback(e, element, combo);
};

var Shortcuts = function () {
  function Shortcuts() {
    _classCallCheck(this, Shortcuts);

    this.onToggleHelp = this.onToggleHelp.bind(this);
    this.enabledHelp = [];

    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('?', this.onToggleHelp);
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('s', Shortcuts.focusSearch);
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('f', this.focusFilter.bind(this));
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('p b', Shortcuts.onTogglePerfBar);

    var findFileURL = document.body.dataset.findFile;

    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('shift+t', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
    });
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('shift+a', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-activity');
    });
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('shift+i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-issues');
    });
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('shift+m', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-merge_requests');
    });
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('shift+p', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-projects');
    });
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('shift+g', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-groups');
    });
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('shift+l', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-milestones');
    });
    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('shift+s', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-snippets');
    });

    __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind(['ctrl+shift+p', 'command+shift+p'], Shortcuts.toggleMarkdownPreview);

    if (typeof findFileURL !== 'undefined' && findFileURL !== null) {
      __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.bind('t', function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_url_utility__["g" /* visitUrl */])(findFileURL);
      });
    }

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.more_help', '.js-more-help-button', function clickMoreHelp(e) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).remove();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hidden-shortcut').show();
      e.preventDefault();
    });
  }

  _createClass(Shortcuts, [{
    key: 'onToggleHelp',
    value: function onToggleHelp(e) {
      if (e.preventDefault) {
        e.preventDefault();
      }

      Shortcuts.toggleHelp(this.enabledHelp);
    }
  }, {
    key: 'focusFilter',
    value: function focusFilter(e) {
      if (!this.filterInput) {
        this.filterInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[type=search]', '.nav-controls');
      }
      this.filterInput.focus();
      e.preventDefault();
    }
  }], [{
    key: 'onTogglePerfBar',
    value: function onTogglePerfBar(e) {
      e.preventDefault();
      var performanceBarCookieName = 'perf_bar_enabled';
      if (__WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get(performanceBarCookieName) === 'true') {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(performanceBarCookieName, 'false', { path: '/' });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set(performanceBarCookieName, 'true', { path: '/' });
      }
      Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_url_utility__["e" /* refreshCurrentPage */])();
    }
  }, {
    key: 'toggleMarkdownPreview',
    value: function toggleMarkdownPreview(e) {
      // Check if short-cut was triggered while in Write Mode
      var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
      var $form = $target.closest('form');

      if ($target.hasClass('js-note-text')) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-md-preview-button', $form).focus();
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).triggerHandler('markdown-preview:toggle', [e]);
    }
  }, {
    key: 'toggleHelp',
    value: function toggleHelp(location) {
      var $modal = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#modal-shortcuts');

      if ($modal.length) {
        $modal.modal('toggle');
      }

      return __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */].get(gon.shortcuts_path, {
        responseType: 'text'
      }).then(function (_ref) {
        var data = _ref.data;

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.globalEval(data);

        if (location && location.length > 0) {
          var results = [];
          for (var i = 0, len = location.length; i < len; i += 1) {
            results.push(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(location[i]).show());
          }
          return results;
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.hidden-shortcut').show();
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-more-help-button').remove();
      });
    }
  }, {
    key: 'focusSearch',
    value: function focusSearch(e) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#search').focus();

      if (e.preventDefault) {
        e.preventDefault();
      }
    }
  }]);

  return Shortcuts;
}();

/* harmony default export */ __webpack_exports__["a"] = (Shortcuts);

/***/ }),

/***/ "./shortcuts_dashboard_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Helper function that finds the href of the fiven selector and updates the location.
 *
 * @param  {String} selector
 */
/* harmony default export */ __webpack_exports__["a"] = (function (selector) {
  var link = document.querySelector(selector).getAttribute('href');

  if (link) {
    window.location = link;
  }
});

/***/ }),

/***/ "./syntax_highlight.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = syntaxHighlight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-else-return, prefer-arrow-callback, max-len */



// Syntax Highlighter
//
// Applies a syntax highlighting color scheme CSS class to any element with the
// `js-syntax-highlight` class
//
// ### Example Markup
//
//   <div class="js-syntax-highlight"></div>
//

function syntaxHighlight(el) {
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).hasClass('js-syntax-highlight')) {
    // Given the element itself, apply highlighting
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).addClass(gon.user_color_scheme);
  } else {
    // Given a parent element, recurse to any of its applicable children
    var $children = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).find('.js-syntax-highlight');
    if ($children.length) {
      return syntaxHighlight($children);
    }
  }
}

/***/ }),

/***/ "./vue_shared/components/identicon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/identicon.vue

/* harmony default export */ var identicon = ({
  props: {
    entityId: {
      type: Number,
      required: true
    },
    entityName: {
      type: String,
      required: true
    },
    sizeClass: {
      type: String,
      required: false,
      default: 's40'
    }
  },
  computed: {
    /**
     * This method is based on app/helpers/avatars_helper.rb#project_identicon
     */
    identiconStyles: function identiconStyles() {
      var allowedColors = ['#FFEBEE', '#F3E5F5', '#E8EAF6', '#E3F2FD', '#E0F2F1', '#FBE9E7', '#EEEEEE'];

      var backgroundColor = allowedColors[this.entityId % 7];

      return 'background-color: ' + backgroundColor + '; color: #555;';
    },
    identiconTitle: function identiconTitle() {
      return this.entityName.charAt(0).toUpperCase();
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cad7ca8","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/identicon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar identicon",class:_vm.sizeClass,style:(_vm.identiconStyles)},[_vm._v("\n  "+_vm._s(_vm.identiconTitle)+"\n")])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/identicon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  identicon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_identicon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/loading_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/loading_icon.vue

/* harmony default export */ var loading_icon = ({
  props: {
    label: {
      type: String,
      required: false,
      default: 'Loading'
    },

    size: {
      type: String,
      required: false,
      default: '1'
    },

    inline: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    rootElementType: function rootElementType() {
      return this.inline ? 'span' : 'div';
    },
    cssClass: function cssClass() {
      return 'fa-' + this.size + 'x';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f46572f","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/loading_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.rootElementType,{tag:"component",staticClass:"loading-container text-center"},[_c('i',{staticClass:"fa fa-spin fa-spinner",class:_vm.cssClass,attrs:{"aria-hidden":"true","aria-label":_vm.label}})])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/loading_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  loading_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_loading_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/translate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");


/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
  Vue.mixin({
    methods: {
      /**
        Translates `text`
         @param text The text to be translated
        @returns {String} The translated text
      **/
      __: __WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */],
      /**
        Translate the text with a number
        if the number is more than 1 it will use the `pluralText` translation.
        This method allows for contexts, see below re. contexts
         @param text Singular text to translate (eg. '%d day')
        @param pluralText Plural text to translate (eg. '%d days')
        @param count Number to decide which translation to use (eg. 2)
        @returns {String} Translated text with the number replaced (eg. '2 days')
      **/
      n__: __WEBPACK_IMPORTED_MODULE_0__locale__["d" /* n__ */],
      /**
        Translate context based text
        Either pass in the context translation like `Context|Text to translate`
        or allow for dynamic text by doing passing in the context first & then the text to translate
         @param keyOrContext Can be either the key to translate including the context
                            (eg. 'Context|Text') or just the context for the translation
                            (eg. 'Context')
        @param key Is the dynamic variable you want to be translated
        @returns {String} Translated context based text
      **/
      s__: __WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */],
      sprintf: __WEBPACK_IMPORTED_MODULE_0__locale__["f" /* sprintf */]
    }
  });
});

/***/ })

},["./main.js"]);


// WEBPACK FOOTER //
// main.e8c7fa2317821f699820.bundle.js